export const bryoatt=[
  {
    "Name_new": "Kindbergia praelonga",
    "Concept": "Bry_249",
    "Taxon_name": "Eurhynchium praelongum",
    "BRC_num": "0820   249",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 10,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 13,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 2384,
    "IRno": 371,
    "CIno": 7,
    "TJan": 3.5,
    "TJul": 14.6,
    "Prec": 1076,
    "Alt": 1050,
    "L": 5,
    "F": 6,
    "R": 5,
    "N": 5,
    "S": 1,
    "HM": 1,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": 1,
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Calliergonella cuspidata",
    "Concept": "Bry_4",
    "Taxon_name": "Calliergonella cuspidata",
    "BRC_num": "0820     4",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 5,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 76,
    "GBno": 2337,
    "IRno": 416,
    "CIno": 9,
    "TJan": 3.4,
    "TJul": 14.5,
    "Prec": 1108,
    "Alt": 900,
    "L": 7,
    "F": 7,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 1,
    "RH": "",
    "RS": "",
    "RW": 2,
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Brachythecium rutabulum",
    "Concept": "Bry_81",
    "Taxon_name": "Brachythecium rutabulum",
    "BRC_num": "0820    81",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 11,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 2330,
    "IRno": 376,
    "CIno": 7,
    "TJan": 3.5,
    "TJul": 14.7,
    "Prec": 1058,
    "Alt": 1344,
    "L": 6,
    "F": 6,
    "R": 6,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Rhytidiadelphus squarrosus",
    "Concept": "Bry_533",
    "Taxon_name": "Rhytidiadelphus squarrosus",
    "BRC_num": "0820   533",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 138,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 2,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 17,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 53,
    "GBno": 2321,
    "IRno": 386,
    "CIno": 7,
    "TJan": 3.4,
    "TJul": 14.5,
    "Prec": 1121,
    "Alt": 1225,
    "L": 7,
    "F": 5,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 2,
    "RH": "",
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Mnium hornum",
    "Concept": "Bry_382",
    "Taxon_name": "Mnium hornum",
    "BRC_num": "0820   382",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 70,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 3,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 26,
    "Sp2": 35,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 2304,
    "IRno": 301,
    "CIno": 8,
    "TJan": 3.4,
    "TJul": 14.5,
    "Prec": 1129,
    "Alt": 976,
    "L": 4,
    "F": 5,
    "R": 4,
    "N": 4,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 3,
    "DV": 2,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Ceratodon purpureus",
    "Concept": "Bry_151",
    "Taxon_name": "Ceratodon purpureus",
    "BRC_num": "0820   151",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 35,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 36,
    "GBno": 2301,
    "IRno": 282,
    "CIno": 9,
    "TJan": 3.4,
    "TJul": 14.6,
    "Prec": 1085,
    "Alt": 1344,
    "L": 7,
    "F": 5,
    "R": 5,
    "N": 3,
    "S": 1,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 3,
    "DV": 3,
    "DA": 1,
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Lophocolea bidentata",
    "Concept": "Bry_1056",
    "Taxon_name": "Lophocolea bidentata",
    "BRC_num": "0810  1056",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "We",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 1,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 2265,
    "IRno": 320,
    "CIno": 9,
    "TJan": 3.4,
    "TJul": 14.6,
    "Prec": 1094,
    "Alt": 850,
    "L": 5,
    "F": 6,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Hypnum cupressiforme",
    "Concept": "Bry_4143",
    "Taxon_name": "Hypnum cupressiforme",
    "BRC_num": "0820  3901",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 11,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 13,
    "Sp2": 19,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 66,
    "GBno": 2250,
    "IRno": 354,
    "CIno": 3,
    "TJan": 3.4,
    "TJul": 14.6,
    "Prec": 1098,
    "Alt": 679,
    "L": 6,
    "F": 4,
    "R": 4,
    "N": 4,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
    {
    "Name_new": "Bryum capillare",
    "Concept": "Bry_94",
    "Taxon_name": "Bryum capillare",
    "BRC_num": "0820    94",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Cu",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": 5,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 2246,
    "IRno": 347,
    "CIno": 4,
    "TJan": 3.5,
    "TJul": 14.7,
    "Prec": 1080,
    "Alt": 900,
    "L": 6,
    "F": 4,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Plagiomnium undulatum",
    "Concept": "Bry_395",
    "Taxon_name": "Plagiomnium undulatum",
    "BRC_num": "0820   395",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "De",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 5,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 32,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 2182,
    "IRno": 324,
    "CIno": 3,
    "TJan": 3.4,
    "TJul": 14.6,
    "Prec": 1099,
    "Alt": 850,
    "L": 5,
    "F": 6,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Dicranum scoparium",
    "Concept": "Bry_206",
    "Taxon_name": "Dicranum scoparium",
    "BRC_num": "0820   206",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 90,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 12,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 36,
    "GBno": 2176,
    "IRno": 376,
    "CIno": 2,
    "TJan": 3.4,
    "TJul": 14.4,
    "Prec": 1150,
    "Alt": 1220,
    "L": 6,
    "F": 5,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 2,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 3,
    "DV": 2,
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Pseudoscleropodium purum",
    "Concept": "Bry_507",
    "Taxon_name": "Scleropodium purum",
    "BRC_num": "0820   507",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 10,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 2164,
    "IRno": 382,
    "CIno": 6,
    "TJan": 3.4,
    "TJul": 14.5,
    "Prec": 1116,
    "Alt": 1000,
    "L": 7,
    "F": 5,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 2,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Dicranella heteromalla",
    "Concept": "Bry_184",
    "Taxon_name": "Dicranella heteromalla",
    "BRC_num": "0820   184",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": 11,
    "Spend": 5,
    "Spbeg2": 8,
    "Spend2": 8,
    "Sp1": 12,
    "Sp2": 17,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 2139,
    "IRno": 270,
    "CIno": 3,
    "TJan": 3.4,
    "TJul": 14.6,
    "Prec": 1121,
    "Alt": 1100,
    "L": 4,
    "F": 5,
    "R": 3,
    "N": 3,
    "S": 0,
    "HM": 2,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 3,
    "DV": 2,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Tortula muralis",
    "Concept": "Bry_614",
    "Taxon_name": "Tortula muralis",
    "BRC_num": "0820   614",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 5,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 7,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 86,
    "GBno": 2101,
    "IRno": 354,
    "CIno": 3,
    "TJan": 3.5,
    "TJul": 14.8,
    "Prec": 1052,
    "Alt": 950,
    "L": 6,
    "F": 2,
    "R": 8,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 2,
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Atrichum undulatum",
    "Concept": "Bry_40",
    "Taxon_name": "Atrichum undulatum",
    "BRC_num": "0820    40",
    "ML": "M",
    "Ord": "Polytrichales",
    "Stat": "N",
    "Len": 70,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "X",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M(D)",
    "Fr": "A",
    "Spbeg": 11,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 2087,
    "IRno": 283,
    "CIno": 3,
    "TJan": 3.3,
    "TJul": 14.6,
    "Prec": 1121,
    "Alt": 1000,
    "L": 4,
    "F": 6,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Homalothecium sericeum",
    "Concept": "Bry_128",
    "Taxon_name": "Homalothecium sericeum",
    "BRC_num": "0820   128",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 10,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 84,
    "GBno": 2079,
    "IRno": 342,
    "CIno": 7,
    "TJan": 3.5,
    "TJul": 14.7,
    "Prec": 1085,
    "Alt": 610,
    "L": 7,
    "F": 3,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": 1,
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Ceratodon purpureus",
    "Concept": "Bry_151.2",
    "Taxon_name": "Ceratodon purpureus",
    "BRC_num": "0820   151.2",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 35,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "R",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": 5,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 36,
    "GBno": 2030,
    "IRno": 244,
    "CIno": 3,
    "TJan": 3.4,
    "TJul": 14.6,
    "Prec": 1078,
    "Alt": 1344,
    "L": 7,
    "F": 4,
    "R": 5,
    "N": 3,
    "S": 1,
    "HM": 3,
    "RH": 2,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 3,
    "DV": 3,
    "DA": 1,
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Thuidium tamariscinum",
    "Concept": "Bry_599",
    "Taxon_name": "Thuidium tamariscinum",
    "BRC_num": "0820   599",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 140,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 1,
    "Spend": 2,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 2011,
    "IRno": 395,
    "CIno": 6,
    "TJan": 3.4,
    "TJul": 14.4,
    "Prec": 1160,
    "Alt": 880,
    "L": 5,
    "F": 6,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 3,
    "DV": 2,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Barbula convoluta",
    "Concept": "Bry_45",
    "Taxon_name": "Barbula convoluta",
    "BRC_num": "0820    45",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 6,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 66,
    "GBno": 2009,
    "IRno": 313,
    "CIno": 3,
    "TJan": 3.6,
    "TJul": 14.8,
    "Prec": 1032,
    "Alt": 580,
    "L": 7,
    "F": 4,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 1,
    "RH": "",
    "RS": 2,
    "RW": 2,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fissidens taxifolius",
    "Concept": "Bry_274",
    "Taxon_name": "Fissidens taxifolius",
    "BRC_num": "0820   274",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "O",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": 1,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 7,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 83,
    "GBno": 1995,
    "IRno": 285,
    "CIno": 3,
    "TJan": 3.5,
    "TJul": 14.8,
    "Prec": 1075,
    "Alt": 580,
    "L": 4,
    "F": 5,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 1,
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Bryum argenteum",
    "Concept": "Bry_89",
    "Taxon_name": "Bryum argenteum",
    "BRC_num": "0820    89",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "X",
    "Gem": "",
    "Bul": "F",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 11,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 36,
    "GBno": 1971,
    "IRno": 225,
    "CIno": 9,
    "TJan": 3.6,
    "TJul": 14.9,
    "Prec": 1012,
    "Alt": 893,
    "L": 8,
    "F": 4,
    "R": 6,
    "N": 7,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Barbula unguiculata",
    "Concept": "Bry_62",
    "Taxon_name": "Barbula unguiculata",
    "BRC_num": "0820    62",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "X",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 11,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 66,
    "GBno": 1948,
    "IRno": 266,
    "CIno": 3,
    "TJan": 3.6,
    "TJul": 14.9,
    "Prec": 1012,
    "Alt": 580,
    "L": 7,
    "F": 5,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 2,
    "RH": "",
    "RS": "",
    "RW": 2,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Amblystegium serpens",
    "Concept": "Bry_19",
    "Taxon_name": "Amblystegium serpens",
    "BRC_num": "0820    19",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 30,
    "Per": "PA",
    "LF1": "Mr",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 3,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1944,
    "IRno": 221,
    "CIno": 8,
    "TJan": 3.6,
    "TJul": 15,
    "Prec": 987,
    "Alt": 580,
    "L": 5,
    "F": 6,
    "R": 7,
    "N": 6,
    "S": 2,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Funaria hygrometrica",
    "Concept": "Bry_284",
    "Taxon_name": "Funaria hygrometrica",
    "BRC_num": "0820   284",
    "ML": "M",
    "Ord": "Funariales",
    "Stat": "N",
    "Len": 30,
    "Per": "AP",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 66,
    "GBno": 1943,
    "IRno": 216,
    "CIno": 10,
    "TJan": 3.5,
    "TJul": 14.9,
    "Prec": 1034,
    "Alt": 715,
    "L": 7,
    "F": 5,
    "R": 6,
    "N": 7,
    "S": 0,
    "HM": 1,
    "RH": "",
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": 2,
    "GS": 3,
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Grimmia pulvinata",
    "Concept": "Bry_312",
    "Taxon_name": "Grimmia pulvinata",
    "BRC_num": "0820   312",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 3,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 86,
    "GBno": 1911,
    "IRno": 261,
    "CIno": 6,
    "TJan": 3.5,
    "TJul": 14.9,
    "Prec": 1026,
    "Alt": 950,
    "L": 8,
    "F": 1,
    "R": 8,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Rhizomnium punctatum",
    "Concept": "Bry_389",
    "Taxon_name": "Rhizomnium punctatum",
    "BRC_num": "0820   389",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 70,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tp",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 2,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 25,
    "Sp2": 50,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1909,
    "IRno": 206,
    "CIno": 5,
    "TJan": 3.2,
    "TJul": 14.4,
    "Prec": 1170,
    "Alt": 1165,
    "L": 5,
    "F": 8,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": 2,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Bryum dichotomum",
    "Concept": "Bry_90",
    "Taxon_name": "Bryum dichotomum",
    "BRC_num": "0820    90",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 15,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "F",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 63,
    "GBno": 1889,
    "IRno": 245,
    "CIno": 9,
    "TJan": 3.6,
    "TJul": 14.9,
    "Prec": 1013,
    "Alt": 440,
    "L": 7,
    "F": 5,
    "R": 7,
    "N": 7,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pellia epiphylla",
    "Concept": "Bry_867",
    "Taxon_name": "Pellia epiphylla",
    "BRC_num": "0810   867",
    "ML": "L",
    "Ord": "Fossombroniales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 2,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 70,
    "Sp2": 116,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1879,
    "IRno": 245,
    "CIno": 5,
    "TJan": 3.3,
    "TJul": 14.3,
    "Prec": 1188,
    "Alt": 1230,
    "L": 4,
    "F": 8,
    "R": 4,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 2,
    "SR": 3,
    "SO": 3,
    "PT": 2,
    "GS": "",
    "DW": "",
    "DV": 1,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cratoneuron filicinum",
    "Concept": "Bry_163",
    "Taxon_name": "Cratoneuron filicinum",
    "BRC_num": "0820   163",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 66,
    "GBno": 1870,
    "IRno": 272,
    "CIno": 5,
    "TJan": 3.5,
    "TJul": 14.6,
    "Prec": 1081,
    "Alt": 1060,
    "L": 6,
    "F": 7,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 2,
    "RH": 2,
    "RS": 2,
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Schistidium apocarpum",
    "Concept": "Bry_291",
    "Taxon_name": "Schistidium apocarpum",
    "BRC_num": "0820   291",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 66,
    "GBno": 1870,
    "IRno": 312,
    "CIno": 3,
    "TJan": 3.4,
    "TJul": 14.5,
    "Prec": 1123,
    "Alt": 1205,
    "L": 7,
    "F": 2,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": 1,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Isothecium myosuroides",
    "Concept": "Bry_362",
    "Taxon_name": "Isothecium myosuroides",
    "BRC_num": "0820   362",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "De",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 11,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 52,
    "GBno": 1848,
    "IRno": 303,
    "CIno": 8,
    "TJan": 3.4,
    "TJul": 14.4,
    "Prec": 1178,
    "Alt": 980,
    "L": 4,
    "F": 6,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Polytrichum juniperinum",
    "Concept": "Bry_485",
    "Taxon_name": "Polytrichum juniperinum",
    "BRC_num": "0820   485",
    "ML": "M",
    "Ord": "Polytrichales",
    "Stat": "N",
    "Len": 70,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": 6,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 36,
    "GBno": 1806,
    "IRno": 241,
    "CIno": 9,
    "TJan": 3.4,
    "TJul": 14.4,
    "Prec": 1146,
    "Alt": 910,
    "L": 8,
    "F": 5,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 2,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Oxyrrhynchium hians",
    "Concept": "Bry_256",
    "Taxon_name": "Eurhynchium hians",
    "BRC_num": "0820   256",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 110,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 11,
    "Spend": 1,
    "Spbeg2": 4,
    "Spend2": 5,
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 76,
    "GBno": 1774,
    "IRno": 192,
    "CIno": 6,
    "TJan": 3.6,
    "TJul": 15,
    "Prec": 991,
    "Alt": 950,
    "L": 6,
    "F": 5,
    "R": 6,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Metzgeria furcata",
    "Concept": "Bry_845",
    "Taxon_name": "Metzgeria furcata",
    "BRC_num": "0810   845",
    "ML": "L",
    "Ord": "Metzgeriales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 21,
    "Sp2": 32,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 53,
    "GBno": 1772,
    "IRno": 303,
    "CIno": 9,
    "TJan": 3.5,
    "TJul": 14.7,
    "Prec": 1122,
    "Alt": 600,
    "L": 5,
    "F": 4,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 2,
    "SR": 3,
    "SO": 2,
    "PT": "",
    "GS": 2,
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Platyhypnidium riparioides",
    "Concept": "Bry_251",
    "Taxon_name": "Rhynchostegium riparioides",
    "BRC_num": "0820   251",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 112,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "At",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 9,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 86,
    "GBno": 1770,
    "IRno": 180,
    "CIno": 7,
    "TJan": 3.4,
    "TJul": 14.6,
    "Prec": 1113,
    "Alt": 1100,
    "L": 4,
    "F": 10,
    "R": 6,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 1,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Hypnum cupressiforme var. resupinatum",
    "Concept": "Bry_351.6",
    "Taxon_name": "Hypnum resupinatum",
    "BRC_num": "0820   351.6",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 9,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 83,
    "GBno": 1769,
    "IRno": 255,
    "CIno": 8,
    "TJan": 3.6,
    "TJul": 14.8,
    "Prec": 1070,
    "Alt": 580,
    "L": 4,
    "F": 4,
    "R": 4,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": 1,
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Polytrichastrum formosum",
    "Concept": "Bry_483",
    "Taxon_name": "Polytrichum formosum",
    "BRC_num": "0820   483",
    "ML": "M",
    "Ord": "Polytrichales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1755,
    "IRno": 253,
    "CIno": 6,
    "TJan": 3.4,
    "TJul": 14.5,
    "Prec": 1164,
    "Alt": 700,
    "L": 4,
    "F": 6,
    "R": 3,
    "N": 3,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Didymodon insulanus",
    "Concept": "Bry_47",
    "Taxon_name": "Didymodon insulanus",
    "BRC_num": "0820    47",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 50,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "R",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 7,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 13,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 85,
    "GBno": 1753,
    "IRno": 214,
    "CIno": 3,
    "TJan": 3.6,
    "TJul": 14.8,
    "Prec": 1028,
    "Alt": 580,
    "L": 6,
    "F": 5,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 2,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Fissidens bryoides var. bryoides",
    "Concept": "Bry_260",
    "Taxon_name": "Fissidens bryoides",
    "BRC_num": "0820   260",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 10,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 76,
    "GBno": 1748,
    "IRno": 163,
    "CIno": 7,
    "TJan": 3.6,
    "TJul": 14.9,
    "Prec": 1057,
    "Alt": 580,
    "L": 4,
    "F": 5,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": 1,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hypnum jutlandicum",
    "Concept": "Bry_351.2",
    "Taxon_name": "Hypnum jutlandicum",
    "BRC_num": "0820   351.2",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 75,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 11,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 13,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 72,
    "GBno": 1748,
    "IRno": 329,
    "CIno": 11,
    "TJan": 3.4,
    "TJul": 14.2,
    "Prec": 1206,
    "Alt": 1220,
    "L": 6,
    "F": 5,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Pohlia nutans",
    "Concept": "Bry_475",
    "Taxon_name": "Pohlia nutans",
    "BRC_num": "0820   475",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 68,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "O",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 5,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 36,
    "GBno": 1737,
    "IRno": 153,
    "CIno": 1,
    "TJan": 3.2,
    "TJul": 14.4,
    "Prec": 1151,
    "Alt": 1340,
    "L": 5,
    "F": 5,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 3,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 3,
    "DV": 3,
    "DA": 1,
    "BR": 3,
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Brachythecium rivulare",
    "Concept": "Bry_80",
    "Taxon_name": "Brachythecium rivulare",
    "BRC_num": "0820    80",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 11,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1722,
    "IRno": 154,
    "CIno": 7,
    "TJan": 3.3,
    "TJul": 14.4,
    "Prec": 1162,
    "Alt": 960,
    "L": 6,
    "F": 8,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 2,
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Dicranoweisia cirrata",
    "Concept": "Bry_193",
    "Taxon_name": "Dicranoweisia cirrata",
    "BRC_num": "0820   193",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 11,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 1720,
    "IRno": 37,
    "CIno": 1,
    "TJan": 3.4,
    "TJul": 15.1,
    "Prec": 985,
    "Alt": 700,
    "L": 5,
    "F": 4,
    "R": 4,
    "N": 4,
    "S": 0,
    "HM": 3,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Conocephalum conicum",
    "Concept": "Bry_745",
    "Taxon_name": "Conocephalum conicum",
    "BRC_num": "0810   745",
    "ML": "L",
    "Ord": "Marchantiales",
    "Stat": "N",
    "Len": 110,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "",
    "Tub": "O",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 2,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 53,
    "Sp2": 97,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1706,
    "IRno": 190,
    "CIno": 2,
    "TJan": 3.4,
    "TJul": 14.6,
    "Prec": 1140,
    "Alt": 1000,
    "L": 3,
    "F": 7,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": 1,
    "GS": 2,
    "DW": "",
    "DV": 1,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Pellia endiviifolia",
    "Concept": "Bry_868",
    "Taxon_name": "Pellia endiviifolia",
    "BRC_num": "0810   868",
    "ML": "L",
    "Ord": "Fossombroniales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 2,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 70,
    "Sp2": 80,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 86,
    "GBno": 1690,
    "IRno": 221,
    "CIno": 6,
    "TJan": 3.5,
    "TJul": 14.7,
    "Prec": 1097,
    "Alt": 915,
    "L": 4,
    "F": 8,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Eurhynchium striatum",
    "Concept": "Bry_255",
    "Taxon_name": "Eurhynchium striatum",
    "BRC_num": "0820   255",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 12,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 1667,
    "IRno": 288,
    "CIno": 7,
    "TJan": 3.6,
    "TJul": 14.7,
    "Prec": 1100,
    "Alt": 777,
    "L": 4,
    "F": 6,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Pleurozium schreberi",
    "Concept": "Bry_463",
    "Taxon_name": "Pleurozium schreberi",
    "BRC_num": "0820   463",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1646,
    "IRno": 257,
    "CIno": 1,
    "TJan": 3.2,
    "TJul": 14,
    "Prec": 1253,
    "Alt": 1210,
    "L": 6,
    "F": 5,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": 1,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Plagiochila asplenioides",
    "Concept": "Bry_872",
    "Taxon_name": "Plagiochila asplenioides",
    "BRC_num": "0810   872",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "We",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 4,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1628,
    "IRno": 258,
    "CIno": 2,
    "TJan": 3.3,
    "TJul": 14.3,
    "Prec": 1206,
    "Alt": 1220,
    "L": 5,
    "F": 6,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Ctenidium molluscum",
    "Concept": "Bry_166",
    "Taxon_name": "Ctenidium molluscum",
    "BRC_num": "0820   166",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 3,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 13,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 53,
    "GBno": 1623,
    "IRno": 317,
    "CIno": 2,
    "TJan": 3.3,
    "TJul": 14.2,
    "Prec": 1216,
    "Alt": 1205,
    "L": 7,
    "F": 6,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Pseudotaxiphyllum elegans",
    "Concept": "Bry_357",
    "Taxon_name": "Pseudotaxiphyllum elegans",
    "BRC_num": "0820   357",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 4,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 52,
    "GBno": 1620,
    "IRno": 154,
    "CIno": 3,
    "TJan": 3.3,
    "TJul": 14.5,
    "Prec": 1178,
    "Alt": 950,
    "L": 3,
    "F": 6,
    "R": 3,
    "N": 4,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Cephalozia bicuspidata",
    "Concept": "Bry_714",
    "Taxon_name": "Cephalozia bicuspidata",
    "BRC_num": "0810   714",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1606,
    "IRno": 219,
    "CIno": 6,
    "TJan": 3.3,
    "TJul": 14.2,
    "Prec": 1220,
    "Alt": 1220,
    "L": 4,
    "F": 7,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": 1,
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Fontinalis antipyretica",
    "Concept": "Bry_276",
    "Taxon_name": "Fontinalis antipyretica",
    "BRC_num": "0820   276",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 500,
    "Per": "P",
    "LF1": "At",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 5,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1602,
    "IRno": 287,
    "CIno": 7,
    "TJan": 3.3,
    "TJul": 14.3,
    "Prec": 1158,
    "Alt": 880,
    "L": 6,
    "F": 12,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": 2,
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Thamnobryum alopecurum",
    "Concept": "Bry_592",
    "Taxon_name": "Thamnobryum alopecurum",
    "BRC_num": "0820   592",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "De",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 10,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 1596,
    "IRno": 262,
    "CIno": 4,
    "TJan": 3.5,
    "TJul": 14.7,
    "Prec": 1128,
    "Alt": 715,
    "L": 3,
    "F": 6,
    "R": 7,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Rhytidiadelphus triquetrus",
    "Concept": "Bry_534",
    "Taxon_name": "Rhytidiadelphus triquetrus",
    "BRC_num": "0820   534",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 2,
    "Spend": 2,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 21,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1591,
    "IRno": 286,
    "CIno": 4,
    "TJan": 3.3,
    "TJul": 14.2,
    "Prec": 1194,
    "Alt": 980,
    "L": 6,
    "F": 6,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 1,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Calypogeia fissa",
    "Concept": "Bry_706",
    "Taxon_name": "Calypogeia fissa",
    "BRC_num": "0810   706",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 3,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 72,
    "GBno": 1589,
    "IRno": 254,
    "CIno": 2,
    "TJan": 3.4,
    "TJul": 14.4,
    "Prec": 1201,
    "Alt": 850,
    "L": 3,
    "F": 7,
    "R": 3,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": 2,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 1,
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Polytrichum commune",
    "Concept": "Bry_482",
    "Taxon_name": "Polytrichum commune",
    "BRC_num": "0820   482",
    "ML": "M",
    "Ord": "Polytrichales",
    "Stat": "N",
    "Len": 250,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 7,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 36,
    "GBno": 1580,
    "IRno": 241,
    "CIno": 1,
    "TJan": 3.1,
    "TJul": 14,
    "Prec": 1255,
    "Alt": 1220,
    "L": 6,
    "F": 7,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Didymodon fallax",
    "Concept": "Bry_48",
    "Taxon_name": "Didymodon fallax",
    "BRC_num": "0820    48",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 11,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 86,
    "GBno": 1570,
    "IRno": 222,
    "CIno": 2,
    "TJan": 3.6,
    "TJul": 14.8,
    "Prec": 1034,
    "Alt": 580,
    "L": 7,
    "F": 4,
    "R": 7,
    "N": 3,
    "S": 0,
    "HM": 2,
    "RH": "",
    "RS": "",
    "RW": 1,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Rhynchostegium confertum",
    "Concept": "Bry_245",
    "Taxon_name": "Rhynchostegium confertum",
    "BRC_num": "0820   245",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 11,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 1570,
    "IRno": 93,
    "CIno": 8,
    "TJan": 3.7,
    "TJul": 15.4,
    "Prec": 932,
    "Alt": 500,
    "L": 4,
    "F": 5,
    "R": 7,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Diplophyllum albicans",
    "Concept": "Bry_747",
    "Taxon_name": "Diplophyllum albicans",
    "BRC_num": "0810   747",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "We",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 2,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 52,
    "GBno": 1561,
    "IRno": 281,
    "CIno": 6,
    "TJan": 3.3,
    "TJul": 14,
    "Prec": 1286,
    "Alt": 1340,
    "L": 5,
    "F": 6,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 3,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 2,
    "DV": 2,
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Bryoerythrophyllum recurvirostrum",
    "Concept": "Bry_54",
    "Taxon_name": "Bryoerythrophyllum recurvirostrum",
    "BRC_num": "0820    54",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 28,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "X",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 11,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1545,
    "IRno": 186,
    "CIno": 3,
    "TJan": 3.4,
    "TJul": 14.6,
    "Prec": 1117,
    "Alt": 1180,
    "L": 5,
    "F": 5,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 1,
    "RH": "",
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 2,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Hylocomium splendens",
    "Concept": "Bry_346",
    "Taxon_name": "Hylocomium splendens",
    "BRC_num": "0820   346",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 175,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 4,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 17,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 36,
    "GBno": 1541,
    "IRno": 332,
    "CIno": 1,
    "TJan": 3.2,
    "TJul": 13.9,
    "Prec": 1271,
    "Alt": 1220,
    "L": 6,
    "F": 5,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 2,
    "RH": "",
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum pseudotriquetrum",
    "Concept": "Bry_113",
    "Taxon_name": "Bryum pseudotriquetrum",
    "BRC_num": "0820   113",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "R",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D(M)",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 25,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 36,
    "GBno": 1540,
    "IRno": 245,
    "CIno": 5,
    "TJan": 3.2,
    "TJul": 14.1,
    "Prec": 1245,
    "Alt": 1170,
    "L": 8,
    "F": 9,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Frullania dilatata",
    "Concept": "Bry_764",
    "Taxon_name": "Frullania dilatata",
    "BRC_num": "0810   764",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 35,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 40,
    "Sp2": 60,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 85,
    "GBno": 1538,
    "IRno": 349,
    "CIno": 9,
    "TJan": 3.6,
    "TJul": 14.6,
    "Prec": 1144,
    "Alt": 610,
    "L": 6,
    "F": 4,
    "R": 6,
    "N": 4,
    "S": 1,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 1,
    "PT": "",
    "GS": "",
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Orthotrichum diaphanum",
    "Concept": "Bry_417",
    "Taxon_name": "Orthotrichum diaphanum",
    "BRC_num": "0820   417",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "O",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 83,
    "GBno": 1528,
    "IRno": 81,
    "CIno": 9,
    "TJan": 3.7,
    "TJul": 15.3,
    "Prec": 929,
    "Alt": 380,
    "L": 7,
    "F": 3,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Plagiothecium undulatum",
    "Concept": "Bry_459",
    "Taxon_name": "Plagiothecium undulatum",
    "BRC_num": "0820   459",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 52,
    "GBno": 1512,
    "IRno": 162,
    "CIno": 1,
    "TJan": 3,
    "TJul": 14,
    "Prec": 1272,
    "Alt": 1100,
    "L": 4,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Zygodon viridissimus",
    "Concept": "Bry_653",
    "Taxon_name": "Zygodon viridissimus",
    "BRC_num": "0820   653",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 1509,
    "IRno": 198,
    "CIno": 9,
    "TJan": 3.6,
    "TJul": 14.9,
    "Prec": 1051,
    "Alt": 560,
    "L": 6,
    "F": 4,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Tortula truncata",
    "Concept": "Bry_501",
    "Taxon_name": "Tortula truncata",
    "BRC_num": "0820   501",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "AP",
    "LF1": "Tf",
    "LF2": "Ts",
    "Tub": "O",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 36,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 76,
    "GBno": 1508,
    "IRno": 169,
    "CIno": 8,
    "TJan": 3.7,
    "TJul": 15.1,
    "Prec": 951,
    "Alt": 360,
    "L": 8,
    "F": 5,
    "R": 6,
    "N": 6,
    "S": 0,
    "HM": 1,
    "RH": 1,
    "RS": "",
    "RW": 2,
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ulota crispa",
    "Concept": "Bry_1052",
    "Taxon_name": "Ulota crispa",
    "BRC_num": "0820  1052",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 26,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 1506,
    "IRno": 273,
    "CIno": 4,
    "TJan": 3.4,
    "TJul": 14.5,
    "Prec": 1176,
    "Alt": 480,
    "L": 6,
    "F": 4,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Lophocolea heterophylla",
    "Concept": "Bry_814",
    "Taxon_name": "Lophocolea heterophylla",
    "BRC_num": "0810   814",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "O",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 76,
    "GBno": 1499,
    "IRno": 41,
    "CIno": 7,
    "TJan": 3.6,
    "TJul": 15.4,
    "Prec": 907,
    "Alt": 360,
    "L": 4,
    "F": 5,
    "R": 4,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": 3,
    "RW": 1,
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Aneura pinguis",
    "Concept": "Bry_901",
    "Taxon_name": "Aneura pinguis",
    "BRC_num": "0810   901",
    "ML": "L",
    "Ord": "Metzgeriales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "St",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 2,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 25,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 36,
    "GBno": 1495,
    "IRno": 227,
    "CIno": 2,
    "TJan": 3.3,
    "TJul": 14.2,
    "Prec": 1220,
    "Alt": 1070,
    "L": 8,
    "F": 9,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 2,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": 2,
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Orthotrichum affine",
    "Concept": "Bry_414",
    "Taxon_name": "Orthotrichum affine",
    "BRC_num": "0820   414",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "O",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 4,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 53,
    "GBno": 1494,
    "IRno": 134,
    "CIno": 4,
    "TJan": 3.5,
    "TJul": 15,
    "Prec": 991,
    "Alt": 530,
    "L": 6,
    "F": 4,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Barbula convoluta var. convoluta",
    "Concept": "Bry_45.2",
    "Taxon_name": "Barbula convoluta var. convoluta",
    "BRC_num": "0820    45.2",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 5,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 66,
    "GBno": 1483,
    "IRno": 262,
    "CIno": 3,
    "TJan": 3.6,
    "TJul": 14.8,
    "Prec": 1053,
    "Alt": 510,
    "L": 7,
    "F": 4,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 2,
    "RW": 2,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Chiloscyphus polyanthos",
    "Concept": "Bry_986",
    "Taxon_name": "Chiloscyphus polyanthos",
    "BRC_num": "0810   986",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "At",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1480,
    "IRno": 172,
    "CIno": 4,
    "TJan": 3.3,
    "TJul": 14.3,
    "Prec": 1191,
    "Alt": 1040,
    "L": 6,
    "F": 9,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Polytrichum piliferum",
    "Concept": "Bry_488",
    "Taxon_name": "Polytrichum piliferum",
    "BRC_num": "0820   488",
    "ML": "M",
    "Ord": "Polytrichales",
    "Stat": "N",
    "Len": 45,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": 6,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 36,
    "GBno": 1479,
    "IRno": 155,
    "CIno": 7,
    "TJan": 3.2,
    "TJul": 14.1,
    "Prec": 1238,
    "Alt": 1170,
    "L": 9,
    "F": 3,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 2,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Campylopus flexuosus",
    "Concept": "Bry_139",
    "Taxon_name": "Campylopus flexuosus",
    "BRC_num": "0820   139",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 57,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "U",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "F",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 3,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 17,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 72,
    "GBno": 1476,
    "IRno": 249,
    "CIno": 2,
    "TJan": 3.3,
    "TJul": 14.2,
    "Prec": 1255,
    "Alt": 800,
    "L": 6,
    "F": 6,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 2,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 3,
    "DV": 2,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Dicranella varia",
    "Concept": "Bry_189",
    "Taxon_name": "Dicranella varia",
    "BRC_num": "0820   189",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 10,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "O",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": 10,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1448,
    "IRno": 209,
    "CIno": 2,
    "TJan": 3.6,
    "TJul": 14.9,
    "Prec": 1011,
    "Alt": 580,
    "L": 7,
    "F": 5,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 3,
    "RH": "",
    "RS": 2,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Plagiochila porelloides",
    "Concept": "Bry_872.1",
    "Taxon_name": "Plagiochila porelloides",
    "BRC_num": "0810   872.1",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 4,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1447,
    "IRno": 235,
    "CIno": 2,
    "TJan": 3.2,
    "TJul": 14.1,
    "Prec": 1252,
    "Alt": 1220,
    "L": 4,
    "F": 6,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 2,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Pohlia melanodon",
    "Concept": "Bry_470",
    "Taxon_name": "Pohlia melanodon",
    "BRC_num": "0820   470",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 10,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "Ts",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 2,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 86,
    "GBno": 1429,
    "IRno": 103,
    "CIno": 3,
    "TJan": 3.6,
    "TJul": 15.1,
    "Prec": 949,
    "Alt": 580,
    "L": 6,
    "F": 7,
    "R": 7,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 1,
    "RW": 2,
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Plagiothecium succulentum",
    "Concept": "Bry_458",
    "Taxon_name": "Plagiothecium succulentum",
    "BRC_num": "0820   458",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "O",
    "Spbeg": 2,
    "Spend": 2,
    "Spbeg2": 5,
    "Spend2": 8,
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 54,
    "GBno": 1425,
    "IRno": 77,
    "CIno": 4,
    "TJan": 3.3,
    "TJul": 14.6,
    "Prec": 1156,
    "Alt": 1165,
    "L": 3,
    "F": 6,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": 2,
    "SR": 3,
    "SO": 3,
    "PT": 2,
    "GS": "",
    "DW": 2,
    "DV": 1,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Campylopus introflexus",
    "Concept": "Bry_141",
    "Taxon_name": "Campylopus introflexus",
    "BRC_num": "0820   141",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "AN",
    "Len": 50,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "F",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 72,
    "GBno": 1420,
    "IRno": 238,
    "CIno": 2,
    "TJan": 3.6,
    "TJul": 14.8,
    "Prec": 1094,
    "Alt": 640,
    "L": 7,
    "F": 5,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 2,
    "RH": 2,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Bryum rubens",
    "Concept": "Bry_115",
    "Taxon_name": "Bryum rubens",
    "BRC_num": "0820   115",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 15,
    "Per": "AP",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 6,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 1418,
    "IRno": 82,
    "CIno": 8,
    "TJan": 3.7,
    "TJul": 15.3,
    "Prec": 927,
    "Alt": 450,
    "L": 8,
    "F": 5,
    "R": 6,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 2,
    "SO": 3,
    "PT": 2,
    "GS": 3,
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Isothecium alopecuroides",
    "Concept": "Bry_363",
    "Taxon_name": "Isothecium alopecuroides",
    "BRC_num": "0820   363",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "De",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 12,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 53,
    "GBno": 1415,
    "IRno": 198,
    "CIno": 2,
    "TJan": 3.4,
    "TJul": 14.5,
    "Prec": 1159,
    "Alt": 930,
    "L": 4,
    "F": 6,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": 1,
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Hypnum cupressiforme var. lacunosum",
    "Concept": "Bry_351.8",
    "Taxon_name": "Hypnum lacunosum",
    "BRC_num": "0820   351.4",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 11,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 66,
    "GBno": 1395,
    "IRno": 197,
    "CIno": 4,
    "TJan": 3.5,
    "TJul": 14.6,
    "Prec": 1118,
    "Alt": 760,
    "L": 7,
    "F": 4,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 2,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Lunularia cruciata",
    "Concept": "Bry_826",
    "Taxon_name": "Lunularia cruciata",
    "BRC_num": "0810   826",
    "ML": "L",
    "Ord": "Marchantiales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 8,
    "Spend": 11,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 21,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 92,
    "GBno": 1392,
    "IRno": 111,
    "CIno": 8,
    "TJan": 3.7,
    "TJul": 15.3,
    "Prec": 931,
    "Alt": 390,
    "L": 4,
    "F": 7,
    "R": 7,
    "N": 7,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 1,
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Neckera complanata",
    "Concept": "Bry_401",
    "Taxon_name": "Neckera complanata",
    "BRC_num": "0820   401",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Fa",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 1,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 26,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 53,
    "GBno": 1392,
    "IRno": 304,
    "CIno": 3,
    "TJan": 3.6,
    "TJul": 14.7,
    "Prec": 1104,
    "Alt": 600,
    "L": 5,
    "F": 4,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Didymodon rigidulus",
    "Concept": "Bry_57",
    "Taxon_name": "Didymodon rigidulus",
    "BRC_num": "0820    57",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 2,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1388,
    "IRno": 148,
    "CIno": 1,
    "TJan": 3.5,
    "TJul": 14.8,
    "Prec": 1086,
    "Alt": 841,
    "L": 5,
    "F": 4,
    "R": 8,
    "N": 4,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Plagiothecium denticulatum",
    "Concept": "Bry_449",
    "Taxon_name": "Plagiothecium denticulatum",
    "BRC_num": "0820   449",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1385,
    "IRno": 38,
    "CIno": 3,
    "TJan": 3.3,
    "TJul": 14.8,
    "Prec": 1086,
    "Alt": 1205,
    "L": 4,
    "F": 6,
    "R": 4,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Aulacomnium palustre",
    "Concept": "Bry_42",
    "Taxon_name": "Aulacomnium palustre",
    "BRC_num": "0820    42",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 90,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "O",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 6,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 36,
    "GBno": 1359,
    "IRno": 215,
    "CIno": 2,
    "TJan": 3.1,
    "TJul": 14,
    "Prec": 1263,
    "Alt": 975,
    "L": 7,
    "F": 8,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": 2,
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pogonatum aloides",
    "Concept": "Bry_479",
    "Taxon_name": "Pogonatum aloides",
    "BRC_num": "0820   479",
    "ML": "M",
    "Ord": "Polytrichales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tp",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 13,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 53,
    "GBno": 1359,
    "IRno": 206,
    "CIno": 9,
    "TJan": 3.3,
    "TJul": 14.1,
    "Prec": 1287,
    "Alt": 700,
    "L": 4,
    "F": 6,
    "R": 3,
    "N": 3,
    "S": 0,
    "HM": 2,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Orthotrichum anomalum",
    "Concept": "Bry_415",
    "Taxon_name": "Orthotrichum anomalum",
    "BRC_num": "0820   415",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 32,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 4,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 63,
    "GBno": 1357,
    "IRno": 187,
    "CIno": 6,
    "TJan": 3.5,
    "TJul": 14.9,
    "Prec": 1036,
    "Alt": 634,
    "L": 8,
    "F": 2,
    "R": 8,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum palustre",
    "Concept": "Bry_566",
    "Taxon_name": "Sphagnum palustre",
    "BRC_num": "0820   566",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 250,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 7,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 26,
    "Sp2": 32,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1342,
    "IRno": 199,
    "CIno": 1,
    "TJan": 3.1,
    "TJul": 13.9,
    "Prec": 1292,
    "Alt": 1000,
    "L": 7,
    "F": 8,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fissidens adianthoides",
    "Concept": "Bry_257",
    "Taxon_name": "Fissidens adianthoides",
    "BRC_num": "0820   257",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 78,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "F",
    "Spbeg": 11,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1320,
    "IRno": 229,
    "CIno": 1,
    "TJan": 3.3,
    "TJul": 14.1,
    "Prec": 1267,
    "Alt": 950,
    "L": 7,
    "F": 7,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 2,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Zygodon viridissimus var. viridissimus",
    "Concept": "Bry_653.2",
    "Taxon_name": "Zygodon viridissimus var. viridissimus",
    "BRC_num": "0820   653.2",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 3,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 1319,
    "IRno": 169,
    "CIno": 9,
    "TJan": 3.7,
    "TJul": 15,
    "Prec": 1047,
    "Alt": 400,
    "L": 6,
    "F": 4,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 1,
    "PT": "",
    "GS": "",
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Campylopus pyriformis",
    "Concept": "Bry_142",
    "Taxon_name": "Campylopus pyriformis",
    "BRC_num": "0820   142",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "U",
    "Gem": "",
    "Bul": "",
    "Bra": "R",
    "Lvs": "O",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 2,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 17,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 72,
    "GBno": 1312,
    "IRno": 182,
    "CIno": 8,
    "TJan": 3.3,
    "TJul": 14.4,
    "Prec": 1191,
    "Alt": 910,
    "L": 6,
    "F": 5,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Lepidozia reptans",
    "Concept": "Bry_807",
    "Taxon_name": "Lepidozia reptans",
    "BRC_num": "0810   807",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "We",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 2,
    "Spend": 11,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1306,
    "IRno": 124,
    "CIno": 1,
    "TJan": 3.2,
    "TJul": 14.2,
    "Prec": 1262,
    "Alt": 1000,
    "L": 3,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Brachytheciastrum velutinum",
    "Concept": "Bry_84",
    "Taxon_name": "Brachythecium velutinum",
    "BRC_num": "0820    84",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 1,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 13,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 76,
    "GBno": 1290,
    "IRno": 15,
    "CIno": 5,
    "TJan": 3.5,
    "TJul": 15.3,
    "Prec": 907,
    "Alt": 580,
    "L": 4,
    "F": 5,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Cirriphyllum piliferum",
    "Concept": "Bry_157",
    "Taxon_name": "Cirriphyllum piliferum",
    "BRC_num": "0820   157",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 125,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1287,
    "IRno": 104,
    "CIno": 2,
    "TJan": 3.5,
    "TJul": 14.9,
    "Prec": 1043,
    "Alt": 1010,
    "L": 4,
    "F": 6,
    "R": 6,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": 1,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pohlia wahlenbergii",
    "Concept": "Bry_465",
    "Taxon_name": "Pohlia wahlenbergii",
    "BRC_num": "0820   465",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 75,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 36,
    "GBno": 1283,
    "IRno": 241,
    "CIno": "",
    "TJan": 3.2,
    "TJul": 14.2,
    "Prec": 1223,
    "Alt": 1200,
    "L": 6,
    "F": 8,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 1,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Brachythecium albicans",
    "Concept": "Bry_72",
    "Taxon_name": "Brachythecium albicans",
    "BRC_num": "0820    72",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1281,
    "IRno": 55,
    "CIno": 10,
    "TJan": 3.7,
    "TJul": 15.2,
    "Prec": 935,
    "Alt": 705,
    "L": 8,
    "F": 3,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Campylium stellatum",
    "Concept": "Bry_1078",
    "Taxon_name": "Campylium stellatum",
    "BRC_num": "0820  1078",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1277,
    "IRno": 191,
    "CIno": 3,
    "TJan": 3.2,
    "TJul": 14,
    "Prec": 1270,
    "Alt": 1070,
    "L": 8,
    "F": 8,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum subsecundum",
    "Concept": "Bry_1755",
    "Taxon_name": "Sphagnum subsecundum",
    "BRC_num": "0820  1755",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 27,
    "Sp2": 34,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1261,
    "IRno": 225,
    "CIno": 3,
    "TJan": 3.2,
    "TJul": 13.9,
    "Prec": 1332,
    "Alt": 1220,
    "L": 7,
    "F": 9,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Frullania tamarisci",
    "Concept": "Bry_768",
    "Taxon_name": "Frullania tamarisci",
    "BRC_num": "0810   768",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 40,
    "Sp2": 56,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 52,
    "GBno": 1258,
    "IRno": 273,
    "CIno": 7,
    "TJan": 3.4,
    "TJul": 13.9,
    "Prec": 1339,
    "Alt": 1000,
    "L": 6,
    "F": 5,
    "R": 4,
    "N": 2,
    "S": 1,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Lophozia ventricosa",
    "Concept": "Bry_824",
    "Taxon_name": "Lophozia ventricosa",
    "BRC_num": "0810   824",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 1,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 33,
    "GBno": 1252,
    "IRno": 192,
    "CIno": 3,
    "TJan": 3,
    "TJul": 13.8,
    "Prec": 1334,
    "Alt": 1280,
    "L": 5,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Philonotis fontana",
    "Concept": "Bry_439",
    "Taxon_name": "Philonotis fontana",
    "BRC_num": "0820   439",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "R",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 6,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 26,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 66,
    "GBno": 1245,
    "IRno": 193,
    "CIno": 1,
    "TJan": 3,
    "TJul": 13.7,
    "Prec": 1362,
    "Alt": 1335,
    "L": 7,
    "F": 9,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 2,
    "RH": 3,
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Radula complanata",
    "Concept": "Bry_892",
    "Taxon_name": "Radula complanata",
    "BRC_num": "0810   892",
    "ML": "L",
    "Ord": "Radulales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 28,
    "Sp2": 42,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1238,
    "IRno": 232,
    "CIno": 4,
    "TJan": 3.4,
    "TJul": 14.5,
    "Prec": 1165,
    "Alt": 760,
    "L": 5,
    "F": 4,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 2,
    "SR": 1,
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Nardia scalaris",
    "Concept": "Bry_858",
    "Taxon_name": "Nardia scalaris",
    "BRC_num": "0810   858",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 2,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 53,
    "GBno": 1231,
    "IRno": 163,
    "CIno": 5,
    "TJan": 3.1,
    "TJul": 13.8,
    "Prec": 1354,
    "Alt": 1340,
    "L": 6,
    "F": 6,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 3,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Scapania undulata",
    "Concept": "Bry_939",
    "Taxon_name": "Scapania undulata",
    "BRC_num": "0810   939",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "At",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 2,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 21,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 53,
    "GBno": 1229,
    "IRno": 184,
    "CIno": 1,
    "TJan": 3,
    "TJul": 13.6,
    "Prec": 1382,
    "Alt": 1220,
    "L": 6,
    "F": 10,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Phascum cuspidatum",
    "Concept": "Bry_434",
    "Taxon_name": "Tortula acaulon",
    "BRC_num": "0820   434",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 5,
    "Per": "AP",
    "LF1": "Ts",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 25,
    "Sp2": 40,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 86,
    "GBno": 1222,
    "IRno": 81,
    "CIno": 9,
    "TJan": 3.8,
    "TJul": 15.6,
    "Prec": 816,
    "Alt": 300,
    "L": 8,
    "F": 5,
    "R": 7,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum denticulatum",
    "Concept": "Bry_578",
    "Taxon_name": "Sphagnum denticulatum",
    "BRC_num": "0820   578",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Ac",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 30,
    "Sp2": 34,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 53,
    "GBno": 1217,
    "IRno": 220,
    "CIno": 3,
    "TJan": 3.2,
    "TJul": 13.9,
    "Prec": 1340,
    "Alt": 1220,
    "L": 7,
    "F": 8,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Weissia controversa",
    "Concept": "Bry_639",
    "Taxon_name": "Weissia controversa",
    "BRC_num": "0820   639",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 66,
    "GBno": 1215,
    "IRno": 186,
    "CIno": 8,
    "TJan": 3.6,
    "TJul": 14.7,
    "Prec": 1117,
    "Alt": 580,
    "L": 7,
    "F": 4,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 3,
    "RH": "",
    "RS": 2,
    "RW": 2,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 2,
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum recurvum",
    "Concept": "Bry_571",
    "Taxon_name": "Sphagnum recurvum",
    "BRC_num": "0820   571",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 7,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 27,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 1206,
    "IRno": 162,
    "CIno": "",
    "TJan": 2.9,
    "TJul": 13.8,
    "Prec": 1325,
    "Alt": 1000,
    "L": 7,
    "F": 9,
    "R": 2,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Syntrichia ruralis",
    "Concept": "Bry_1758",
    "Taxon_name": "Syntrichia ruralis",
    "BRC_num": "0820  1758",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 66,
    "GBno": 1206,
    "IRno": 94,
    "CIno": 9,
    "TJan": 3.7,
    "TJul": 15.2,
    "Prec": 922,
    "Alt": 380,
    "L": 8,
    "F": 3,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Marchantia polymorpha",
    "Concept": "Bry_827",
    "Taxon_name": "Marchantia polymorpha",
    "BRC_num": "0810   827",
    "ML": "L",
    "Ord": "Marchantiales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 6,
    "Spend": 11,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1200,
    "IRno": 78,
    "CIno": 1,
    "TJan": 3.2,
    "TJul": 14.7,
    "Prec": 998,
    "Alt": 1100,
    "L": 7,
    "F": 8,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 1,
    "RH": 2,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Leptodictyum riparium",
    "Concept": "Bry_366",
    "Taxon_name": "Leptodictyum riparium",
    "BRC_num": "0820   366",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 133,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "At",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 76,
    "GBno": 1196,
    "IRno": 54,
    "CIno": 3,
    "TJan": 3.7,
    "TJul": 15.5,
    "Prec": 854,
    "Alt": 300,
    "L": 6,
    "F": 9,
    "R": 7,
    "N": 7,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": 2,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum subnitens",
    "Concept": "Bry_568",
    "Taxon_name": "Sphagnum subnitens",
    "BRC_num": "0820   568",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 5,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 26,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 52,
    "GBno": 1195,
    "IRno": 254,
    "CIno": 1,
    "TJan": 3.2,
    "TJul": 13.8,
    "Prec": 1332,
    "Alt": 1050,
    "L": 7,
    "F": 8,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Rhytidiadelphus loreus",
    "Concept": "Bry_532",
    "Taxon_name": "Rhytidiadelphus loreus",
    "BRC_num": "0820   532",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 217,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 2,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 52,
    "GBno": 1191,
    "IRno": 190,
    "CIno": 2,
    "TJan": 3,
    "TJul": 13.6,
    "Prec": 1389,
    "Alt": 1225,
    "L": 5,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tetraphis pellucida",
    "Concept": "Bry_589",
    "Taxon_name": "Tetraphis pellucida",
    "BRC_num": "0820   589",
    "ML": "M",
    "Ord": "Tetraphidales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": 12,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 1191,
    "IRno": 65,
    "CIno": "",
    "TJan": 3.1,
    "TJul": 14.6,
    "Prec": 1176,
    "Alt": 700,
    "L": 3,
    "F": 6,
    "R": 3,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Dichodontium pellucidum",
    "Concept": "Bry_180",
    "Taxon_name": "Dichodontium pellucidum",
    "BRC_num": "0820   180",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 70,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "O",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 1185,
    "IRno": 166,
    "CIno": "",
    "TJan": 2.9,
    "TJul": 13.7,
    "Prec": 1346,
    "Alt": 1170,
    "L": 6,
    "F": 8,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": 3,
    "SO": 2,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Chiloscyphus polyanthos",
    "Concept": "Bry_738",
    "Taxon_name": "Chiloscyphus polyanthos",
    "BRC_num": "0810   738",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "At",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 3,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 21,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1176,
    "IRno": 140,
    "CIno": 4,
    "TJan": 3.3,
    "TJul": 14.2,
    "Prec": 1230,
    "Alt": 1040,
    "L": 6,
    "F": 9,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": 3,
    "PT": 1,
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Dicranum majus",
    "Concept": "Bry_203",
    "Taxon_name": "Dicranum majus",
    "BRC_num": "0820   203",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 108,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 12,
    "Spend": 1,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 26,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1175,
    "IRno": 121,
    "CIno": 3,
    "TJan": 3.1,
    "TJul": 13.9,
    "Prec": 1357,
    "Alt": 1080,
    "L": 4,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 2,
    "GS": 1,
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Sciuro-hypnum plumosum",
    "Concept": "Bry_77",
    "Taxon_name": "Brachythecium plumosum",
    "BRC_num": "0820    77",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 2,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1173,
    "IRno": 157,
    "CIno": 2,
    "TJan": 3,
    "TJul": 13.7,
    "Prec": 1366,
    "Alt": 1205,
    "L": 5,
    "F": 8,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 1,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Plagiochila asplenioides",
    "Concept": "Bry_872.2",
    "Taxon_name": "Plagiochila asplenioides",
    "BRC_num": "0810   872.2",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "We",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 5,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 1161,
    "IRno": 123,
    "CIno": 1,
    "TJan": 3.4,
    "TJul": 14.6,
    "Prec": 1182,
    "Alt": 610,
    "L": 5,
    "F": 6,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ctenidium molluscum var. molluscum",
    "Concept": "Bry_166.3",
    "Taxon_name": "Ctenidium molluscum var. molluscum",
    "BRC_num": "0820   166.3",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 13,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 53,
    "GBno": 1155,
    "IRno": 266,
    "CIno": "",
    "TJan": 3.2,
    "TJul": 14.1,
    "Prec": 1246,
    "Alt": 940,
    "L": 7,
    "F": 6,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Calypogeia muelleriana",
    "Concept": "Bry_707",
    "Taxon_name": "Calypogeia muelleriana",
    "BRC_num": "0810   707",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 3,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1154,
    "IRno": 191,
    "CIno": 1,
    "TJan": 3.1,
    "TJul": 14,
    "Prec": 1293,
    "Alt": 920,
    "L": 3,
    "F": 7,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum denticulatum",
    "Concept": "Bry_578.1",
    "Taxon_name": "Sphagnum denticulatum",
    "BRC_num": "0820   578.1",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Ac",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 6,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 30,
    "Sp2": 33,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 53,
    "GBno": 1153,
    "IRno": 200,
    "CIno": 3,
    "TJan": 3.2,
    "TJul": 13.9,
    "Prec": 1353,
    "Alt": 1220,
    "L": 7,
    "F": 9,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Orthodontium lineare",
    "Concept": "Bry_411",
    "Taxon_name": "Orthodontium lineare",
    "BRC_num": "0820   411",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "AN",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 5,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 1137,
    "IRno": 19,
    "CIno": 1,
    "TJan": 3.4,
    "TJul": 15.4,
    "Prec": 873,
    "Alt": 700,
    "L": 4,
    "F": 5,
    "R": 3,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 3,
    "DV": 1,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Racomitrium aciculare",
    "Concept": "Bry_519",
    "Taxon_name": "Racomitrium aciculare",
    "BRC_num": "0820   519",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Cu",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 1,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 52,
    "GBno": 1131,
    "IRno": 202,
    "CIno": "",
    "TJan": 2.9,
    "TJul": 13.5,
    "Prec": 1414,
    "Alt": 1220,
    "L": 6,
    "F": 8,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum capillifolium",
    "Concept": "Bry_564",
    "Taxon_name": "Sphagnum capillifolium",
    "BRC_num": "0820   564",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "O",
    "Spbeg": 8,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 27,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 1131,
    "IRno": 261,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.6,
    "Prec": 1387,
    "Alt": 1220,
    "L": 7,
    "F": 7,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ulota crispa",
    "Concept": "Bry_632",
    "Taxon_name": "Ulota crispa",
    "BRC_num": "0820   632",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 26,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 1130,
    "IRno": 225,
    "CIno": 4,
    "TJan": 3.5,
    "TJul": 14.4,
    "Prec": 1226,
    "Alt": 480,
    "L": 6,
    "F": 4,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Riccardia chamedryfolia",
    "Concept": "Bry_902",
    "Taxon_name": "Riccardia chamedryfolia",
    "BRC_num": "0810   902",
    "ML": "L",
    "Ord": "Metzgeriales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "O",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 2,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 53,
    "GBno": 1128,
    "IRno": 177,
    "CIno": 4,
    "TJan": 3.5,
    "TJul": 14.4,
    "Prec": 1203,
    "Alt": 950,
    "L": 6,
    "F": 9,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": 2,
    "RW": 3,
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Plagiomnium rostratum",
    "Concept": "Bry_383",
    "Taxon_name": "Plagiomnium rostratum",
    "BRC_num": "0820   383",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 53,
    "GBno": 1124,
    "IRno": 104,
    "CIno": 1,
    "TJan": 3.3,
    "TJul": 14.8,
    "Prec": 1039,
    "Alt": 580,
    "L": 5,
    "F": 7,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Bryum dichotomum",
    "Concept": "Bry_1054",
    "Taxon_name": "Bryum dichotomum",
    "BRC_num": "0820  1054",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 15,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "F",
    "Gem": "",
    "Bul": "F",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 63,
    "GBno": 1115,
    "IRno": 39,
    "CIno": 6,
    "TJan": 3.8,
    "TJul": 15.5,
    "Prec": 897,
    "Alt": 440,
    "L": 7,
    "F": 5,
    "R": 7,
    "N": 7,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum pallens",
    "Concept": "Bry_110",
    "Taxon_name": "Bryum pallens",
    "BRC_num": "0820   110",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Ts",
    "Tub": "",
    "Gem": "O",
    "Bul": "",
    "Bra": "",
    "Lvs": "O",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 5,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 26,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 36,
    "GBno": 1115,
    "IRno": 167,
    "CIno": "",
    "TJan": 3.1,
    "TJul": 14,
    "Prec": 1247,
    "Alt": 1180,
    "L": 7,
    "F": 7,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 3,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fissidens viridulus",
    "Concept": "Bry_1055",
    "Taxon_name": "Fissidens viridulus",
    "BRC_num": "0820  1055",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 6,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 19,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 66,
    "GBno": 1114,
    "IRno": 98,
    "CIno": 7,
    "TJan": 3.7,
    "TJul": 15.2,
    "Prec": 1004,
    "Alt": 920,
    "L": 3,
    "F": 5,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 2,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Campylium stellatum s.str.",
    "Concept": "Bry_136",
    "Taxon_name": "Campylium stellatum var. stellatum",
    "BRC_num": "0820   136",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 6,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1108,
    "IRno": 176,
    "CIno": 3,
    "TJan": 3.1,
    "TJul": 13.8,
    "Prec": 1328,
    "Alt": 1070,
    "L": 8,
    "F": 9,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Didymodon tophaceus",
    "Concept": "Bry_60",
    "Taxon_name": "Didymodon tophaceus",
    "BRC_num": "0820    60",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "R",
    "Gem": "O",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 11,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 83,
    "GBno": 1099,
    "IRno": 86,
    "CIno": 3,
    "TJan": 3.8,
    "TJul": 15.1,
    "Prec": 970,
    "Alt": 580,
    "L": 5,
    "F": 8,
    "R": 8,
    "N": 4,
    "S": 0,
    "HM": 2,
    "RH": "",
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Plagiothecium nemorale",
    "Concept": "Bry_456",
    "Taxon_name": "Plagiothecium nemorale",
    "BRC_num": "0820   456",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 1,
    "Spend": 11,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 1099,
    "IRno": 43,
    "CIno": 9,
    "TJan": 3.7,
    "TJul": 15.3,
    "Prec": 1015,
    "Alt": 425,
    "L": 3,
    "F": 6,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": 2,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Dicranella staphylina",
    "Concept": "Bry_674",
    "Taxon_name": "Dicranella staphylina",
    "BRC_num": "0820   674",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "NA",
    "Len": 10,
    "Per": "A",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 1087,
    "IRno": 68,
    "CIno": 3,
    "TJan": 3.7,
    "TJul": 15.3,
    "Prec": 898,
    "Alt": 490,
    "L": 8,
    "F": 5,
    "R": 6,
    "N": 6,
    "S": 0,
    "HM": 1,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ulota bruchii",
    "Concept": "Bry_631",
    "Taxon_name": "Ulota bruchii",
    "BRC_num": "0820   631",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 9,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 26,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 1069,
    "IRno": 138,
    "CIno": 1,
    "TJan": 3.4,
    "TJul": 14.5,
    "Prec": 1197,
    "Alt": 450,
    "L": 5,
    "F": 5,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Syntrichia montana",
    "Concept": "Bry_610",
    "Taxon_name": "Syntrichia intermedia",
    "BRC_num": "0820   610",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 3,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 92,
    "GBno": 1068,
    "IRno": 51,
    "CIno": 6,
    "TJan": 3.7,
    "TJul": 15.5,
    "Prec": 918,
    "Alt": 625,
    "L": 8,
    "F": 1,
    "R": 8,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 1,
    "SO": 1,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Calypogeia arguta",
    "Concept": "Bry_705",
    "Taxon_name": "Calypogeia arguta",
    "BRC_num": "0810   705",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 3,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 92,
    "GBno": 1064,
    "IRno": 170,
    "CIno": 8,
    "TJan": 3.7,
    "TJul": 14.6,
    "Prec": 1218,
    "Alt": 610,
    "L": 1,
    "F": 7,
    "R": 4,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": 2,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Palustriella commutata",
    "Concept": "Bry_161",
    "Taxon_name": "Palustriella commutata",
    "BRC_num": "0820   161",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "(CI)",
    "Elem": 56,
    "GBno": 1063,
    "IRno": 134,
    "CIno": "",
    "TJan": 2.9,
    "TJul": 13.7,
    "Prec": 1318,
    "Alt": 1070,
    "L": 7,
    "F": 9,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Rhynchostegiella tenella",
    "Concept": "Bry_531",
    "Taxon_name": "Rhynchostegiella tenella",
    "BRC_num": "0820   531",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 92,
    "GBno": 1057,
    "IRno": 177,
    "CIno": 5,
    "TJan": 3.9,
    "TJul": 15.4,
    "Prec": 980,
    "Alt": 350,
    "L": 3,
    "F": 4,
    "R": 8,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Plagiothecium denticulatum var. denticulatum",
    "Concept": "Bry_449.1",
    "Taxon_name": "Plagiothecium denticulatum var. denticulatum",
    "BRC_num": "0820   449.1",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 1,
    "Spbeg2": 5,
    "Spend2": 9,
    "Sp1": 8,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1054,
    "IRno": 24,
    "CIno": 1,
    "TJan": 3.3,
    "TJul": 14.8,
    "Prec": 1091,
    "Alt": 1085,
    "L": 4,
    "F": 6,
    "R": 4,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Racomitrium lanuginosum",
    "Concept": "Bry_525",
    "Taxon_name": "Racomitrium lanuginosum",
    "BRC_num": "0820   525",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 3,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 1051,
    "IRno": 218,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.4,
    "Prec": 1450,
    "Alt": 1340,
    "L": 7,
    "F": 4,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 2,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Trichodon cylindricus",
    "Concept": "Bry_215",
    "Taxon_name": "Ditrichum cylindricum",
    "BRC_num": "0820   215",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 5,
    "Per": "PA",
    "LF1": "Tuft",
    "LF2": "Ts",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1048,
    "IRno": 82,
    "CIno": 2,
    "TJan": 3.4,
    "TJul": 14.7,
    "Prec": 1065,
    "Alt": 700,
    "L": 7,
    "F": 5,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fissidens dubius",
    "Concept": "Bry_262",
    "Taxon_name": "Fissidens dubius",
    "BRC_num": "0820   262",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 35,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "X",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "O",
    "Spbeg": 1,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 1046,
    "IRno": 195,
    "CIno": 2,
    "TJan": 3.4,
    "TJul": 14.3,
    "Prec": 1268,
    "Alt": 760,
    "L": 7,
    "F": 4,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Solenostoma gracillimum",
    "Concept": "Bry_943",
    "Taxon_name": "Solenostoma gracillimum",
    "BRC_num": "0810   943",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 1,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 53,
    "GBno": 1046,
    "IRno": 131,
    "CIno": 2,
    "TJan": 3.2,
    "TJul": 14,
    "Prec": 1311,
    "Alt": 800,
    "L": 6,
    "F": 6,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 3,
    "RH": "",
    "RS": 2,
    "RW": "",
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Syntrichia ruralis var. ruralis",
    "Concept": "Bry_619",
    "Taxon_name": "Syntrichia ruralis",
    "BRC_num": "0820   619",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 66,
    "GBno": 1043,
    "IRno": 58,
    "CIno": 5,
    "TJan": 3.6,
    "TJul": 15.4,
    "Prec": 879,
    "Alt": 380,
    "L": 8,
    "F": 3,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Pseudocrossidium hornschuchianum",
    "Concept": "Bry_51",
    "Taxon_name": "Pseudocrossidium hornschuchianum",
    "BRC_num": "0820    51",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 84,
    "GBno": 1027,
    "IRno": 57,
    "CIno": 2,
    "TJan": 3.8,
    "TJul": 15.3,
    "Prec": 927,
    "Alt": 510,
    "L": 8,
    "F": 3,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 2,
    "RH": "",
    "RS": "",
    "RW": 2,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum papillosum",
    "Concept": "Bry_567",
    "Taxon_name": "Sphagnum papillosum",
    "BRC_num": "0820   567",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 5,
    "Spend": 8,
    "Spbeg2": 12,
    "Spend2": 12,
    "Sp1": 27,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 1025,
    "IRno": 247,
    "CIno": "",
    "TJan": 3.1,
    "TJul": 13.6,
    "Prec": 1393,
    "Alt": 1050,
    "L": 8,
    "F": 8,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Dicranella schreberiana",
    "Concept": "Bry_186",
    "Taxon_name": "Dicranella schreberiana",
    "BRC_num": "0820   186",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 10,
    "Per": "AP",
    "LF1": "Tf",
    "LF2": "Ts",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 11,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 1023,
    "IRno": 88,
    "CIno": 1,
    "TJan": 3.6,
    "TJul": 15.2,
    "Prec": 923,
    "Alt": 490,
    "L": 7,
    "F": 6,
    "R": 6,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Leucobryum glaucum",
    "Concept": "Bry_374",
    "Taxon_name": "Leucobryum glaucum",
    "BRC_num": "0820   374",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "F",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 11,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 1018,
    "IRno": 179,
    "CIno": 1,
    "TJan": 3.2,
    "TJul": 14,
    "Prec": 1333,
    "Alt": 1030,
    "L": 5,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Encalypta streptocarpa",
    "Concept": "Bry_233",
    "Taxon_name": "Encalypta streptocarpa",
    "BRC_num": "0820   233",
    "ML": "M",
    "Ord": "Encalyptales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 55,
    "GBno": 998,
    "IRno": 176,
    "CIno": "",
    "TJan": 3.2,
    "TJul": 14.4,
    "Prec": 1195,
    "Alt": 760,
    "L": 6,
    "F": 4,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ulota phyllantha",
    "Concept": "Bry_637",
    "Taxon_name": "Ulota phyllantha",
    "BRC_num": "0820   637",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 51,
    "GBno": 994,
    "IRno": 302,
    "CIno": 6,
    "TJan": 3.8,
    "TJul": 14.3,
    "Prec": 1232,
    "Alt": 420,
    "L": 6,
    "F": 5,
    "R": 5,
    "N": 4,
    "S": 3,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Aulacomnium androgynum",
    "Concept": "Bry_41",
    "Taxon_name": "Aulacomnium androgynum",
    "BRC_num": "0820    41",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 11,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 993,
    "IRno": 3,
    "CIno": "",
    "TJan": 3.3,
    "TJul": 15.5,
    "Prec": 812,
    "Alt": 450,
    "L": 5,
    "F": 6,
    "R": 3,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Pogonatum urnigerum",
    "Concept": "Bry_489",
    "Taxon_name": "Pogonatum urnigerum",
    "BRC_num": "0820   489",
    "ML": "M",
    "Ord": "Polytrichales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "R",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 5,
    "Spbeg2": 10,
    "Spend2": 10,
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 26,
    "GBno": 988,
    "IRno": 151,
    "CIno": 1,
    "TJan": 2.9,
    "TJul": 13.5,
    "Prec": 1432,
    "Alt": 1330,
    "L": 7,
    "F": 5,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 1,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 1,
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Homalia trichomanoides",
    "Concept": "Bry_333",
    "Taxon_name": "Homalia trichomanoides",
    "BRC_num": "0820   333",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Fa",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 12,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "(CI)",
    "Elem": 56,
    "GBno": 972,
    "IRno": 70,
    "CIno": "",
    "TJan": 3.5,
    "TJul": 15,
    "Prec": 1056,
    "Alt": 480,
    "L": 5,
    "F": 6,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Racomitrium fasciculare",
    "Concept": "Bry_523",
    "Taxon_name": "Racomitrium fasciculare",
    "BRC_num": "0820   523",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 2,
    "Spend": 4,
    "Spbeg2": 8,
    "Spend2": 8,
    "Sp1": 13,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 962,
    "IRno": 145,
    "CIno": "",
    "TJan": 2.8,
    "TJul": 13.3,
    "Prec": 1478,
    "Alt": 1330,
    "L": 7,
    "F": 2,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fontinalis antipyretica var. antipyretica",
    "Concept": "Bry_276.1",
    "Taxon_name": "Fontinalis antipyretica var. antipyretica",
    "BRC_num": "0820   276.1",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 500,
    "Per": "P",
    "LF1": "At",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 959,
    "IRno": 136,
    "CIno": "",
    "TJan": 3.3,
    "TJul": 14.4,
    "Prec": 1183,
    "Alt": 820,
    "L": 6,
    "F": 12,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": 2,
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": 1
  },
  {
    "Name_new": "Hookeria lucens",
    "Concept": "Bry_335",
    "Taxon_name": "Hookeria lucens",
    "BRC_num": "0820   335",
    "ML": "M",
    "Ord": "Hookeriales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "O",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 11,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 72,
    "GBno": 957,
    "IRno": 184,
    "CIno": 2,
    "TJan": 3.4,
    "TJul": 13.9,
    "Prec": 1375,
    "Alt": 1000,
    "L": 3,
    "F": 7,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 2,
    "DV": 2,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Pohlia annotina",
    "Concept": "Bry_466",
    "Taxon_name": "Pohlia annotina",
    "BRC_num": "0820   466",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 30,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "Ts",
    "Tub": "",
    "Gem": "",
    "Bul": "F",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 7,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 53,
    "GBno": 952,
    "IRno": 100,
    "CIno": 4,
    "TJan": 3.1,
    "TJul": 14,
    "Prec": 1289,
    "Alt": 700,
    "L": 6,
    "F": 6,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 3,
    "RH": 1,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Dichodontium pellucidum s.str.",
    "Concept": "Bry_180.3",
    "Taxon_name": "Dichodontium pellucidum",
    "BRC_num": "0820   180.3",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 70,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "O",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": 3,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 939,
    "IRno": 132,
    "CIno": "",
    "TJan": 2.9,
    "TJul": 13.7,
    "Prec": 1362,
    "Alt": 900,
    "L": 6,
    "F": 8,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 2,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": 3,
    "SO": 2,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Oxyrrhynchium pumilum",
    "Concept": "Bry_529",
    "Taxon_name": "Eurhynchium pumilum",
    "BRC_num": "0820   529",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 11,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 92,
    "GBno": 929,
    "IRno": 41,
    "CIno": 6,
    "TJan": 3.9,
    "TJul": 15.5,
    "Prec": 945,
    "Alt": 580,
    "L": 3,
    "F": 5,
    "R": 7,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": 2,
    "RW": 2,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Bryum caespiticium",
    "Concept": "Bry_91",
    "Taxon_name": "Bryum caespiticium",
    "BRC_num": "0820    91",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 921,
    "IRno": 12,
    "CIno": 1,
    "TJan": 3.5,
    "TJul": 15.5,
    "Prec": 831,
    "Alt": 270,
    "L": 7,
    "F": 4,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Trichostomum brachydontium",
    "Concept": "Bry_624",
    "Taxon_name": "Trichostomum brachydontium",
    "BRC_num": "0820   624",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 92,
    "GBno": 918,
    "IRno": 135,
    "CIno": 10,
    "TJan": 3.7,
    "TJul": 14,
    "Prec": 1337,
    "Alt": 700,
    "L": 8,
    "F": 5,
    "R": 7,
    "N": 3,
    "S": 2,
    "HM": 2,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Rhynchostegiella tenella",
    "Concept": "Bry_531.2",
    "Taxon_name": "Rhynchostegiella tenella",
    "BRC_num": "0820   531.2",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 10,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 92,
    "GBno": 903,
    "IRno": 123,
    "CIno": "",
    "TJan": 4,
    "TJul": 15.4,
    "Prec": 984,
    "Alt": 350,
    "L": 3,
    "F": 4,
    "R": 8,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum cuspidatum",
    "Concept": "Bry_556",
    "Taxon_name": "Sphagnum cuspidatum",
    "BRC_num": "0820   556",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Ac",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 6,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 32,
    "Sp2": 37,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 902,
    "IRno": 222,
    "CIno": "",
    "TJan": 3.1,
    "TJul": 13.7,
    "Prec": 1361,
    "Alt": 1030,
    "L": 8,
    "F": 10,
    "R": 1,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 2,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tortella tortuosa",
    "Concept": "Bry_607",
    "Taxon_name": "Tortella tortuosa",
    "BRC_num": "0820   607",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Cu",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "O",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 881,
    "IRno": 221,
    "CIno": 1,
    "TJan": 3.1,
    "TJul": 13.7,
    "Prec": 1378,
    "Alt": 1205,
    "L": 7,
    "F": 4,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 2,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Homalothecium lutescens",
    "Concept": "Bry_126",
    "Taxon_name": "Homalothecium lutescens",
    "BRC_num": "0820   126",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 1,
    "Spend": 2,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 83,
    "GBno": 878,
    "IRno": 156,
    "CIno": 6,
    "TJan": 3.7,
    "TJul": 15,
    "Prec": 969,
    "Alt": 800,
    "L": 8,
    "F": 3,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": 1,
    "RS": "",
    "RW": 1,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Plagiomnium affine",
    "Concept": "Bry_379",
    "Taxon_name": "Plagiomnium affine",
    "BRC_num": "0820   379",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 876,
    "IRno": 14,
    "CIno": 2,
    "TJan": 3.6,
    "TJul": 15.3,
    "Prec": 975,
    "Alt": 660,
    "L": 6,
    "F": 6,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 1,
    "RH": "",
    "RS": "",
    "RW": 1,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Syntrichia laevipila",
    "Concept": "Bry_611",
    "Taxon_name": "Syntrichia laevipila",
    "BRC_num": "0820   611",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "O",
    "Sex": "MD",
    "Fr": "O",
    "Spbeg": 2,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 92,
    "GBno": 866,
    "IRno": 54,
    "CIno": 7,
    "TJan": 3.8,
    "TJul": 15.4,
    "Prec": 962,
    "Alt": 350,
    "L": 6,
    "F": 4,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Palustriella commutata s.str.",
    "Concept": "Bry_161.1",
    "Taxon_name": "Palustriella commutata var. commutata",
    "BRC_num": "0820   161.1",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "(CI)",
    "Elem": 54,
    "GBno": 858,
    "IRno": 88,
    "CIno": "",
    "TJan": 2.8,
    "TJul": 13.7,
    "Prec": 1361,
    "Alt": 900,
    "L": 6,
    "F": 9,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Heterocladium heteropterum",
    "Concept": "Bry_331",
    "Taxon_name": "Heterocladium heteropterum",
    "BRC_num": "0820   331",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 72,
    "GBno": 850,
    "IRno": 144,
    "CIno": 1,
    "TJan": 3.2,
    "TJul": 13.8,
    "Prec": 1460,
    "Alt": 1150,
    "L": 3,
    "F": 6,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Climacium dendroides",
    "Concept": "Bry_158",
    "Taxon_name": "Climacium dendroides",
    "BRC_num": "0820   158",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "De",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 36,
    "GBno": 846,
    "IRno": 156,
    "CIno": "",
    "TJan": 3,
    "TJul": 14,
    "Prec": 1208,
    "Alt": 914,
    "L": 7,
    "F": 7,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 2,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Racomitrium canescens",
    "Concept": "Bry_521",
    "Taxon_name": "Racomitrium canescens",
    "BRC_num": "0820   521",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 36,
    "GBno": 842,
    "IRno": 111,
    "CIno": 2,
    "TJan": 2.8,
    "TJul": 13.3,
    "Prec": 1447,
    "Alt": 1340,
    "L": 7,
    "F": 5,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Metzgeria fruticulosa",
    "Concept": "Bry_844",
    "Taxon_name": "Metzgeria fruticulosa",
    "BRC_num": "0810   844",
    "ML": "L",
    "Ord": "Metzgeriales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 5,
    "Spend": 5,
    "Spbeg2": 8,
    "Spend2": 9,
    "Sp1": 19,
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 72,
    "GBno": 841,
    "IRno": 120,
    "CIno": 1,
    "TJan": 3.8,
    "TJul": 15,
    "Prec": 1105,
    "Alt": 480,
    "L": 5,
    "F": 5,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": 1,
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Hypnum andoi",
    "Concept": "Bry_351.5",
    "Taxon_name": "Hypnum andoi",
    "BRC_num": "0820   351.5",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": 9,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 72,
    "GBno": 839,
    "IRno": 53,
    "CIno": 1,
    "TJan": 3.5,
    "TJul": 14.7,
    "Prec": 1249,
    "Alt": 700,
    "L": 3,
    "F": 5,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Porella platyphylla",
    "Concept": "Bry_885",
    "Taxon_name": "Porella platyphylla",
    "BRC_num": "0810   885",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Fa",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 6,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": 55,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 838,
    "IRno": 56,
    "CIno": 2,
    "TJan": 3.5,
    "TJul": 15.2,
    "Prec": 968,
    "Alt": 700,
    "L": 6,
    "F": 4,
    "R": 8,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Marsupella emarginata",
    "Concept": "Bry_831",
    "Taxon_name": "Marsupella emarginata",
    "BRC_num": "0810   831",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "At",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 1,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 53,
    "GBno": 834,
    "IRno": 126,
    "CIno": 2,
    "TJan": 2.8,
    "TJul": 13.3,
    "Prec": 1538,
    "Alt": 1220,
    "L": 6,
    "F": 8,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 2,
    "RH": 3,
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Scorpidium revolvens",
    "Concept": "Bry_226",
    "Taxon_name": "Drepanocladus revolvens",
    "BRC_num": "0820   226",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 833,
    "IRno": 154,
    "CIno": "",
    "TJan": 2.9,
    "TJul": 13.3,
    "Prec": 1445,
    "Alt": 975,
    "L": 8,
    "F": 9,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bartramia pomiformis",
    "Concept": "Bry_66",
    "Taxon_name": "Bartramia pomiformis",
    "BRC_num": "0820    66",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 65,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 5,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 26,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 829,
    "IRno": 45,
    "CIno": 7,
    "TJan": 2.9,
    "TJul": 13.8,
    "Prec": 1406,
    "Alt": 900,
    "L": 4,
    "F": 6,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sciuro-hypnum populeum",
    "Concept": "Bry_78",
    "Taxon_name": "Brachythecium populeum",
    "BRC_num": "0820    78",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 55,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 12,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 76,
    "GBno": 823,
    "IRno": 61,
    "CIno": 2,
    "TJan": 3.5,
    "TJul": 14.6,
    "Prec": 1168,
    "Alt": 580,
    "L": 5,
    "F": 5,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Pseudephemerum nitidum",
    "Concept": "Bry_503",
    "Taxon_name": "Pseudephemerum nitidum",
    "BRC_num": "0820   503",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 5,
    "Per": "A",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "R",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 32,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 821,
    "IRno": 89,
    "CIno": 4,
    "TJan": 3.8,
    "TJul": 15,
    "Prec": 1048,
    "Alt": 400,
    "L": 7,
    "F": 7,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 2,
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Didymodon vinealis",
    "Concept": "Bry_63",
    "Taxon_name": "Didymodon vinealis",
    "BRC_num": "0820    63",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 83,
    "GBno": 818,
    "IRno": 21,
    "CIno": 2,
    "TJan": 3.8,
    "TJul": 15.8,
    "Prec": 803,
    "Alt": 320,
    "L": 6,
    "F": 3,
    "R": 8,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Pleuridium acuminatum",
    "Concept": "Bry_460",
    "Taxon_name": "Pleuridium acuminatum",
    "BRC_num": "0820   460",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 10,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "X",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 22,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 814,
    "IRno": 27,
    "CIno": 7,
    "TJan": 3.7,
    "TJul": 15.2,
    "Prec": 1018,
    "Alt": 580,
    "L": 6,
    "F": 5,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 2,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Didymodon luridus",
    "Concept": "Bry_61",
    "Taxon_name": "Didymodon luridus",
    "BRC_num": "0820    61",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 3,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 92,
    "GBno": 809,
    "IRno": 19,
    "CIno": 1,
    "TJan": 3.9,
    "TJul": 15.7,
    "Prec": 850,
    "Alt": 510,
    "L": 4,
    "F": 4,
    "R": 8,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Lejeunea cavifolia",
    "Concept": "Bry_797",
    "Taxon_name": "Lejeunea cavifolia",
    "BRC_num": "0810   797",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 3,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 805,
    "IRno": 72,
    "CIno": "",
    "TJan": 3.1,
    "TJul": 14.1,
    "Prec": 1348,
    "Alt": 1020,
    "L": 4,
    "F": 5,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": 3,
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Gymnocolea inflata",
    "Concept": "Bry_772",
    "Taxon_name": "Gymnocolea inflata",
    "BRC_num": "0810   772",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 1,
    "Spend": 7,
    "Spbeg2": 10,
    "Spend2": 10,
    "Sp1": 12,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 804,
    "IRno": 79,
    "CIno": 1,
    "TJan": 3.1,
    "TJul": 14.1,
    "Prec": 1266,
    "Alt": 1220,
    "L": 7,
    "F": 7,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 3,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 2,
    "DV": 2,
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cephaloziella divaricata",
    "Concept": "Bry_732",
    "Taxon_name": "Cephaloziella divaricata",
    "BRC_num": "0810   732",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 6,
    "Sp2": 9,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 802,
    "IRno": 82,
    "CIno": 8,
    "TJan": 3.4,
    "TJul": 14.5,
    "Prec": 1207,
    "Alt": 1200,
    "L": 7,
    "F": 5,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 2,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum fimbriatum",
    "Concept": "Bry_557",
    "Taxon_name": "Sphagnum fimbriatum",
    "BRC_num": "0820   557",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 6,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 25,
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 36,
    "GBno": 802,
    "IRno": 38,
    "CIno": "",
    "TJan": 3.2,
    "TJul": 14.4,
    "Prec": 1154,
    "Alt": 700,
    "L": 6,
    "F": 8,
    "R": 3,
    "N": 3,
    "S": 0,
    "HM": 2,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Grimmia trichophylla",
    "Concept": "Bry_1079",
    "Taxon_name": "Grimmia trichophylla",
    "BRC_num": "0820  1079",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 35,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 6,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 66,
    "GBno": 796,
    "IRno": 77,
    "CIno": 6,
    "TJan": 3.4,
    "TJul": 14.1,
    "Prec": 1279,
    "Alt": 990,
    "L": 7,
    "F": 1,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Dichodontium palustre",
    "Concept": "Bry_187",
    "Taxon_name": "Dicranella palustris",
    "BRC_num": "0820   187",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 90,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 795,
    "IRno": 113,
    "CIno": "",
    "TJan": 2.5,
    "TJul": 13.1,
    "Prec": 1521,
    "Alt": 1100,
    "L": 7,
    "F": 9,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Riccardia multifida",
    "Concept": "Bry_899",
    "Taxon_name": "Riccardia multifida",
    "BRC_num": "0810   899",
    "ML": "L",
    "Ord": "Metzgeriales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "",
    "Tub": "",
    "Gem": "R",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 2,
    "Spend": 7,
    "Spbeg2": 10,
    "Spend2": 10,
    "Sp1": 14,
    "Sp2": 19,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 791,
    "IRno": 106,
    "CIno": 3,
    "TJan": 3.1,
    "TJul": 13.8,
    "Prec": 1379,
    "Alt": 975,
    "L": 7,
    "F": 9,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": "",
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": 2,
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pseudocrossidium revolutum",
    "Concept": "Bry_56",
    "Taxon_name": "Pseudocrossidium revolutum",
    "BRC_num": "0820    56",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 92,
    "GBno": 788,
    "IRno": 134,
    "CIno": 3,
    "TJan": 3.8,
    "TJul": 15.1,
    "Prec": 1004,
    "Alt": 600,
    "L": 6,
    "F": 3,
    "R": 8,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 2,
    "SO": 1,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Rhynchostegium murale",
    "Concept": "Bry_248",
    "Taxon_name": "Rhynchostegium murale",
    "BRC_num": "0820   248",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 11,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 784,
    "IRno": 28,
    "CIno": 2,
    "TJan": 3.5,
    "TJul": 15.4,
    "Prec": 907,
    "Alt": 730,
    "L": 4,
    "F": 5,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Marsupella emarginata var. emarginata",
    "Concept": "Bry_834",
    "Taxon_name": "Marsupella emarginata var. emarginata",
    "BRC_num": "0810   834",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 1,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 13,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 53,
    "GBno": 782,
    "IRno": 120,
    "CIno": 2,
    "TJan": 2.8,
    "TJul": 13.3,
    "Prec": 1552,
    "Alt": 1220,
    "L": 6,
    "F": 8,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 2,
    "RH": 3,
    "RS": "",
    "RW": 1,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cratoneuron filicinum",
    "Concept": "Bry_163.3",
    "Taxon_name": "Cratoneuron filicinum",
    "BRC_num": "0820   163.3",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 5,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 66,
    "GBno": 772,
    "IRno": 18,
    "CIno": "",
    "TJan": 3.7,
    "TJul": 15.1,
    "Prec": 1016,
    "Alt": 950,
    "L": 6,
    "F": 8,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 2,
    "RH": 2,
    "RS": 2,
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Hygrohypnum luridum",
    "Concept": "Bry_340",
    "Taxon_name": "Hygrohypnum luridum",
    "BRC_num": "0820   340",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 70,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 3,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 21,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 766,
    "IRno": 60,
    "CIno": "",
    "TJan": 2.7,
    "TJul": 13.9,
    "Prec": 1277,
    "Alt": 1030,
    "L": 6,
    "F": 9,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Scapania gracilis",
    "Concept": "Bry_927",
    "Taxon_name": "Scapania gracilis",
    "BRC_num": "0810   927",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 3,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 80,
    "GBno": 763,
    "IRno": 187,
    "CIno": 3,
    "TJan": 3.2,
    "TJul": 13.4,
    "Prec": 1542,
    "Alt": 850,
    "L": 5,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": 3,
    "RW": 2,
    "SR": 2,
    "SO": 2,
    "PT": 3,
    "GS": "",
    "DW": 3,
    "DV": 1,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Riccia sorocarpa",
    "Concept": "Bry_915",
    "Taxon_name": "Riccia sorocarpa",
    "BRC_num": "0810   915",
    "ML": "L",
    "Ord": "Ricciales",
    "Stat": "N",
    "Len": 20,
    "Per": "AP",
    "LF1": "St",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 64,
    "Sp2": 95,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 64,
    "GBno": 761,
    "IRno": 73,
    "CIno": 6,
    "TJan": 3.7,
    "TJul": 15,
    "Prec": 1002,
    "Alt": 830,
    "L": 7,
    "F": 5,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 1,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Jungermannia atrovirens",
    "Concept": "Bry_947",
    "Taxon_name": "Jungermannia atrovirens",
    "BRC_num": "0810   947",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 3,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 19,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 33,
    "GBno": 756,
    "IRno": 104,
    "CIno": "",
    "TJan": 2.7,
    "TJul": 13.5,
    "Prec": 1419,
    "Alt": 1070,
    "L": 5,
    "F": 8,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 2,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Scapania nemorea",
    "Concept": "Bry_930",
    "Taxon_name": "Scapania nemorea",
    "BRC_num": "0810   930",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "We",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 3,
    "Spend": 4,
    "Spbeg2": 11,
    "Spend2": 11,
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 53,
    "GBno": 755,
    "IRno": 122,
    "CIno": 2,
    "TJan": 3.2,
    "TJul": 14,
    "Prec": 1402,
    "Alt": 670,
    "L": 5,
    "F": 7,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 2,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": 2,
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum squarrosum",
    "Concept": "Bry_575",
    "Taxon_name": "Sphagnum squarrosum",
    "BRC_num": "0820   575",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 5,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 27,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 36,
    "GBno": 753,
    "IRno": 55,
    "CIno": "",
    "TJan": 3,
    "TJul": 14.1,
    "Prec": 1246,
    "Alt": 1030,
    "L": 6,
    "F": 9,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Orthotrichum lyellii",
    "Concept": "Bry_418",
    "Taxon_name": "Orthotrichum lyellii",
    "BRC_num": "0820   418",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 6,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 26,
    "Sp2": 40,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 72,
    "GBno": 747,
    "IRno": 64,
    "CIno": 1,
    "TJan": 3.5,
    "TJul": 15,
    "Prec": 1042,
    "Alt": 450,
    "L": 6,
    "F": 4,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Amphidium mougeotii",
    "Concept": "Bry_22",
    "Taxon_name": "Amphidium mougeotii",
    "BRC_num": "0820    22",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 745,
    "IRno": 107,
    "CIno": "",
    "TJan": 2.7,
    "TJul": 13.2,
    "Prec": 1555,
    "Alt": 1180,
    "L": 4,
    "F": 7,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Scapania irrigua",
    "Concept": "Bry_929",
    "Taxon_name": "Scapania irrigua",
    "BRC_num": "0810   929",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 2,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 741,
    "IRno": 111,
    "CIno": "",
    "TJan": 3.1,
    "TJul": 13.8,
    "Prec": 1349,
    "Alt": 980,
    "L": 7,
    "F": 8,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 2,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Anomodon viticulosus",
    "Concept": "Bry_33",
    "Taxon_name": "Anomodon viticulosus",
    "BRC_num": "0820    33",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 740,
    "IRno": 90,
    "CIno": 1,
    "TJan": 3.6,
    "TJul": 15.1,
    "Prec": 1029,
    "Alt": 460,
    "L": 5,
    "F": 5,
    "R": 8,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Tortula subulata",
    "Concept": "Bry_620",
    "Taxon_name": "Tortula subulata",
    "BRC_num": "0820   620",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 7,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 84,
    "GBno": 732,
    "IRno": 26,
    "CIno": "",
    "TJan": 3,
    "TJul": 14.6,
    "Prec": 1023,
    "Alt": 700,
    "L": 5,
    "F": 4,
    "R": 7,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Bryum ruderale",
    "Concept": "Bry_667",
    "Taxon_name": "Bryum ruderale",
    "BRC_num": "0820   667",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "NA",
    "Len": 8,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 11,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 726,
    "IRno": 43,
    "CIno": 2,
    "TJan": 3.9,
    "TJul": 15.5,
    "Prec": 915,
    "Alt": 370,
    "L": 7,
    "F": 4,
    "R": 7,
    "N": 6,
    "S": 0,
    "HM": 1,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Heterocladium heteropterum var. heteropterum",
    "Concept": "Bry_331.2",
    "Taxon_name": "Heterocladium heteropterum var. heteropterum",
    "BRC_num": "0820   331.2",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 12,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 72,
    "GBno": 726,
    "IRno": 120,
    "CIno": "",
    "TJan": 3.1,
    "TJul": 13.7,
    "Prec": 1525,
    "Alt": 1150,
    "L": 3,
    "F": 6,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Microlejeunea ulicina",
    "Concept": "Bry_804",
    "Taxon_name": "Microlejeunea ulicina",
    "BRC_num": "0810   804",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 6,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 72,
    "GBno": 725,
    "IRno": 139,
    "CIno": 3,
    "TJan": 3.9,
    "TJul": 14.7,
    "Prec": 1336,
    "Alt": 460,
    "L": 5,
    "F": 5,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 1,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": 3,
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Trichostomum crispulum",
    "Concept": "Bry_625",
    "Taxon_name": "Trichostomum crispulum",
    "BRC_num": "0820   625",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 5,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 86,
    "GBno": 723,
    "IRno": 136,
    "CIno": 1,
    "TJan": 3.7,
    "TJul": 14.4,
    "Prec": 1235,
    "Alt": 1175,
    "L": 7,
    "F": 4,
    "R": 8,
    "N": 3,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Didymodon sinuosus",
    "Concept": "Bry_627",
    "Taxon_name": "Didymodon sinuosus",
    "BRC_num": "0820   627",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "F",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 92,
    "GBno": 717,
    "IRno": 39,
    "CIno": 1,
    "TJan": 3.8,
    "TJul": 15.8,
    "Prec": 849,
    "Alt": 300,
    "L": 4,
    "F": 6,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Cirriphyllum crassinervium",
    "Concept": "Bry_156",
    "Taxon_name": "Eurhynchium crassinervium",
    "BRC_num": "0820   156",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 2,
    "Spend": 2,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 716,
    "IRno": 72,
    "CIno": 1,
    "TJan": 3.7,
    "TJul": 15.2,
    "Prec": 1000,
    "Alt": 380,
    "L": 4,
    "F": 6,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Dicranum bonjeanii",
    "Concept": "Bry_197",
    "Taxon_name": "Dicranum bonjeanii",
    "BRC_num": "0820   197",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 108,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "O",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 699,
    "IRno": 55,
    "CIno": 1,
    "TJan": 3.2,
    "TJul": 14.2,
    "Prec": 1208,
    "Alt": 1000,
    "L": 7,
    "F": 7,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 2,
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hyocomium armoricum",
    "Concept": "Bry_348",
    "Taxon_name": "Hyocomium armoricum",
    "BRC_num": "0820   348",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": 11,
    "Spend": 11,
    "Spbeg2": 3,
    "Spend2": 4,
    "Sp1": 16,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 71,
    "GBno": 699,
    "IRno": 135,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.5,
    "Prec": 1562,
    "Alt": 770,
    "L": 3,
    "F": 8,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 2,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cryphaea heteromalla",
    "Concept": "Bry_164",
    "Taxon_name": "Cryphaea heteromalla",
    "BRC_num": "0820   164",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "Fa",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 92,
    "GBno": 697,
    "IRno": 155,
    "CIno": 5,
    "TJan": 4.1,
    "TJul": 15.4,
    "Prec": 995,
    "Alt": 360,
    "L": 6,
    "F": 5,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Drepanocladus aduncus",
    "Concept": "Bry_222",
    "Taxon_name": "Drepanocladus aduncus",
    "BRC_num": "0820   222",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 127,
    "Per": "P",
    "LF1": "We",
    "LF2": "Ac",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 689,
    "IRno": 35,
    "CIno": 4,
    "TJan": 3.7,
    "TJul": 15.2,
    "Prec": 916,
    "Alt": 430,
    "L": 7,
    "F": 10,
    "R": 7,
    "N": 6,
    "S": 2,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": 3
  },
  {
    "Name_new": "Ptychomitrium polyphyllum",
    "Concept": "Bry_514",
    "Taxon_name": "Ptychomitrium polyphyllum",
    "BRC_num": "0820   514",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 81,
    "GBno": 689,
    "IRno": 208,
    "CIno": 1,
    "TJan": 3.5,
    "TJul": 13.8,
    "Prec": 1457,
    "Alt": 760,
    "L": 7,
    "F": 3,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum radiculosum",
    "Concept": "Bry_107",
    "Taxon_name": "Bryum radiculosum",
    "BRC_num": "0820   107",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 6,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 92,
    "GBno": 688,
    "IRno": 28,
    "CIno": 8,
    "TJan": 4,
    "TJul": 15.5,
    "Prec": 951,
    "Alt": 305,
    "L": 6,
    "F": 3,
    "R": 8,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ditrichum heteromallum",
    "Concept": "Bry_217",
    "Taxon_name": "Ditrichum heteromallum",
    "BRC_num": "0820   217",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "R",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 686,
    "IRno": 96,
    "CIno": 2,
    "TJan": 2.9,
    "TJul": 13.7,
    "Prec": 1447,
    "Alt": 820,
    "L": 5,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum klinggraeffii",
    "Concept": "Bry_664",
    "Taxon_name": "Bryum klinggraeffii",
    "BRC_num": "0820   664",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 5,
    "Per": "AP",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 683,
    "IRno": 46,
    "CIno": "",
    "TJan": 3.7,
    "TJul": 15.6,
    "Prec": 835,
    "Alt": 350,
    "L": 8,
    "F": 6,
    "R": 6,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Dicranella rufescens",
    "Concept": "Bry_185",
    "Taxon_name": "Dicranella rufescens",
    "BRC_num": "0820   185",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 8,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "Ts",
    "Tub": "O",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 10,
    "Spend": 2,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 681,
    "IRno": 61,
    "CIno": 1,
    "TJan": 3.2,
    "TJul": 14.1,
    "Prec": 1301,
    "Alt": 580,
    "L": 7,
    "F": 6,
    "R": 3,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 2,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum pseudotriquetrum var. pseudotriquetrum",
    "Concept": "Bry_113.2",
    "Taxon_name": "Bryum pseudotriquetrum var. pseudotriquetrum",
    "BRC_num": "0820   113.2",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "R",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 6,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 36,
    "GBno": 679,
    "IRno": 70,
    "CIno": "",
    "TJan": 3.1,
    "TJul": 14,
    "Prec": 1264,
    "Alt": 580,
    "L": 8,
    "F": 9,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Chiloscyphus pallescens",
    "Concept": "Bry_737",
    "Taxon_name": "Chiloscyphus pallescens",
    "BRC_num": "0810   737",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 2,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 678,
    "IRno": 59,
    "CIno": "",
    "TJan": 3.5,
    "TJul": 14.6,
    "Prec": 1201,
    "Alt": 850,
    "L": 6,
    "F": 9,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": 2,
    "RW": "",
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 3,
    "DV": 2,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum subapiculatum",
    "Concept": "Bry_665",
    "Taxon_name": "Bryum subapiculatum",
    "BRC_num": "0820   665",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 10,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 7,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 677,
    "IRno": 25,
    "CIno": 3,
    "TJan": 3.7,
    "TJul": 15.2,
    "Prec": 965,
    "Alt": 470,
    "L": 8,
    "F": 4,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Blindia acuta",
    "Concept": "Bry_69",
    "Taxon_name": "Blindia acuta",
    "BRC_num": "0820    69",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 671,
    "IRno": 92,
    "CIno": "",
    "TJan": 2.6,
    "TJul": 12.8,
    "Prec": 1606,
    "Alt": 1205,
    "L": 7,
    "F": 9,
    "R": 5,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Breutelia chrysocoma",
    "Concept": "Bry_85",
    "Taxon_name": "Breutelia chrysocoma",
    "BRC_num": "0820    85",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "We",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 70,
    "GBno": 669,
    "IRno": 185,
    "CIno": "",
    "TJan": 2.9,
    "TJul": 13.1,
    "Prec": 1607,
    "Alt": 760,
    "L": 7,
    "F": 7,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 2,
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Nowellia curvifolia",
    "Concept": "Bry_859",
    "Taxon_name": "Nowellia curvifolia",
    "BRC_num": "0810   859",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "F",
    "Spbeg": 3,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 669,
    "IRno": 74,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.8,
    "Prec": 1443,
    "Alt": 800,
    "L": 4,
    "F": 7,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": 1,
    "RW": "",
    "SR": 1,
    "SO": 1,
    "PT": 3,
    "GS": "",
    "DW": 3,
    "DV": 2,
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Pellia neesiana",
    "Concept": "Bry_869",
    "Taxon_name": "Pellia neesiana",
    "BRC_num": "0810   869",
    "ML": "L",
    "Ord": "Fossombroniales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 3,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 76,
    "Sp2": 96,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 666,
    "IRno": 93,
    "CIno": 1,
    "TJan": 3.1,
    "TJul": 13.8,
    "Prec": 1374,
    "Alt": 1000,
    "L": 6,
    "F": 8,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 2,
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Leskea polycarpa",
    "Concept": "Bry_373",
    "Taxon_name": "Leskea polycarpa",
    "BRC_num": "0820   373",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 5,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "(CI)",
    "Elem": 76,
    "GBno": 665,
    "IRno": 39,
    "CIno": "",
    "TJan": 3.6,
    "TJul": 15.4,
    "Prec": 890,
    "Alt": 365,
    "L": 6,
    "F": 5,
    "R": 7,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 1,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Straminergon stramineum",
    "Concept": "Bry_7",
    "Taxon_name": "Calliergon stramineum",
    "BRC_num": "0820     7",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Sc",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 664,
    "IRno": 46,
    "CIno": "",
    "TJan": 2.8,
    "TJul": 13.8,
    "Prec": 1338,
    "Alt": 1280,
    "L": 7,
    "F": 9,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ptilidium ciliare",
    "Concept": "Bry_888",
    "Taxon_name": "Ptilidium ciliare",
    "BRC_num": "0810   888",
    "ML": "L",
    "Ord": "Lepicoleales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 9,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 36,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 664,
    "IRno": 10,
    "CIno": "",
    "TJan": 2.4,
    "TJul": 13.5,
    "Prec": 1402,
    "Alt": 1340,
    "L": 6,
    "F": 5,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 1,
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Metzgeria violacea",
    "Concept": "Bry_1043",
    "Taxon_name": "Metzgeria fruticulosa",
    "BRC_num": "0810  1043",
    "ML": "L",
    "Ord": "Metzgeriales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 5,
    "Spend": 5,
    "Spbeg2": 8,
    "Spend2": 9,
    "Sp1": 19,
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 72,
    "GBno": 658,
    "IRno": 90,
    "CIno": 1,
    "TJan": 3.9,
    "TJul": 15.2,
    "Prec": 1006,
    "Alt": 450,
    "L": 5,
    "F": 5,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": 1,
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Sanionia uncinata",
    "Concept": "Bry_228",
    "Taxon_name": "Sanionia uncinata",
    "BRC_num": "0820   228",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 4,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 654,
    "IRno": 44,
    "CIno": "",
    "TJan": 2.5,
    "TJul": 13.4,
    "Prec": 1345,
    "Alt": 1230,
    "L": 6,
    "F": 6,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": 1,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Physcomitrium pyriforme",
    "Concept": "Bry_443",
    "Taxon_name": "Physcomitrium pyriforme",
    "BRC_num": "0820   443",
    "ML": "M",
    "Ord": "Funariales",
    "Stat": "N",
    "Len": 5,
    "Per": "A",
    "LF1": "Tuft",
    "LF2": "Ts",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 4,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 28,
    "Sp2": 36,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 76,
    "GBno": 652,
    "IRno": 35,
    "CIno": 4,
    "TJan": 4,
    "TJul": 15.6,
    "Prec": 882,
    "Alt": 275,
    "L": 7,
    "F": 8,
    "R": 7,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum tenellum",
    "Concept": "Bry_579",
    "Taxon_name": "Sphagnum tenellum",
    "BRC_num": "0820   579",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 4,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 35,
    "Sp2": 40,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 52,
    "GBno": 652,
    "IRno": 189,
    "CIno": 3,
    "TJan": 3.2,
    "TJul": 13.6,
    "Prec": 1428,
    "Alt": 1100,
    "L": 8,
    "F": 8,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Saccogyna viticulosa",
    "Concept": "Bry_918",
    "Taxon_name": "Saccogyna viticulosa",
    "BRC_num": "0810   918",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 4,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 81,
    "GBno": 645,
    "IRno": 158,
    "CIno": 4,
    "TJan": 3.7,
    "TJul": 13.8,
    "Prec": 1545,
    "Alt": 800,
    "L": 3,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Ditrichum flexicaule",
    "Concept": "Bry_216",
    "Taxon_name": "Ditrichum flexicaule",
    "BRC_num": "0820   216",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 110,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 7,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 66,
    "GBno": 641,
    "IRno": 99,
    "CIno": 2,
    "TJan": 3.2,
    "TJul": 14.1,
    "Prec": 1231,
    "Alt": 1214,
    "L": 7,
    "F": 5,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Barbilophozia floerkei",
    "Concept": "Bry_695",
    "Taxon_name": "Barbilophozia floerkei",
    "BRC_num": "0810   695",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 8,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 13,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 638,
    "IRno": 30,
    "CIno": "",
    "TJan": 2.2,
    "TJul": 13.1,
    "Prec": 1482,
    "Alt": 1250,
    "L": 5,
    "F": 5,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": 2,
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 1,
    "DV": 2,
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum inundatum",
    "Concept": "Bry_578.3",
    "Taxon_name": "Sphagnum inundatum",
    "BRC_num": "0820   578.3",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 31,
    "Sp2": 34,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 637,
    "IRno": 94,
    "CIno": "",
    "TJan": 3.1,
    "TJul": 13.7,
    "Prec": 1426,
    "Alt": 930,
    "L": 7,
    "F": 9,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Plagiothecium curvifolium",
    "Concept": "Bry_448",
    "Taxon_name": "Plagiothecium curvifolium",
    "BRC_num": "0820   448",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 33,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 6,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "CI",
    "Elem": 73,
    "GBno": 634,
    "IRno": 2,
    "CIno": 3,
    "TJan": 3.3,
    "TJul": 15.6,
    "Prec": 801,
    "Alt": 490,
    "L": 3,
    "F": 5,
    "R": 3,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Fossombronia pusilla",
    "Concept": "Bry_762",
    "Taxon_name": "Fossombronia pusilla",
    "BRC_num": "0810   762",
    "ML": "L",
    "Ord": "Fossombroniales",
    "Stat": "N",
    "Len": 15,
    "Per": "AP",
    "LF1": "Sc",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 38,
    "Sp2": 64,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 92,
    "GBno": 629,
    "IRno": 66,
    "CIno": 3,
    "TJan": 3.9,
    "TJul": 15.2,
    "Prec": 1020,
    "Alt": 460,
    "L": 6,
    "F": 7,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 2,
    "RW": "",
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum compactum",
    "Concept": "Bry_554",
    "Taxon_name": "Sphagnum compactum",
    "BRC_num": "0820   554",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 6,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 30,
    "Sp2": 35,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 628,
    "IRno": 106,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.4,
    "Prec": 1466,
    "Alt": 1050,
    "L": 8,
    "F": 8,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Campylopus fragilis",
    "Concept": "Bry_140",
    "Taxon_name": "Campylopus fragilis",
    "BRC_num": "0820   140",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 45,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "U",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "F",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 6,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 72,
    "GBno": 623,
    "IRno": 114,
    "CIno": 2,
    "TJan": 3.5,
    "TJul": 13.8,
    "Prec": 1450,
    "Alt": 760,
    "L": 7,
    "F": 5,
    "R": 3,
    "N": 2,
    "S": 1,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 2,
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Hygrohypnum ochraceum",
    "Concept": "Bry_342",
    "Taxon_name": "Hygrohypnum ochraceum",
    "BRC_num": "0820   342",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 23,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 615,
    "IRno": 39,
    "CIno": "",
    "TJan": 2.6,
    "TJul": 13.4,
    "Prec": 1509,
    "Alt": 1200,
    "L": 5,
    "F": 10,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Odontoschisma sphagni",
    "Concept": "Bry_863",
    "Taxon_name": "Odontoschisma sphagni",
    "BRC_num": "0810   863",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 4,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 72,
    "GBno": 615,
    "IRno": 215,
    "CIno": "",
    "TJan": 3.3,
    "TJul": 13.6,
    "Prec": 1436,
    "Alt": 880,
    "L": 8,
    "F": 8,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": 2,
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Racomitrium aquaticum",
    "Concept": "Bry_520",
    "Taxon_name": "Racomitrium aquaticum",
    "BRC_num": "0820   520",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 4,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 72,
    "GBno": 615,
    "IRno": 94,
    "CIno": "",
    "TJan": 2.8,
    "TJul": 13.2,
    "Prec": 1651,
    "Alt": 1200,
    "L": 5,
    "F": 6,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 1,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Zygodon conoideus",
    "Concept": "Bry_650",
    "Taxon_name": "Zygodon conoideus",
    "BRC_num": "0820   650",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 4,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 71,
    "GBno": 609,
    "IRno": 50,
    "CIno": 2,
    "TJan": 3.8,
    "TJul": 15,
    "Prec": 1175,
    "Alt": 350,
    "L": 6,
    "F": 4,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 1,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Syntrichia latifolia",
    "Concept": "Bry_612",
    "Taxon_name": "Syntrichia latifolia",
    "BRC_num": "0820   612",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 607,
    "IRno": 17,
    "CIno": "",
    "TJan": 3.6,
    "TJul": 15.6,
    "Prec": 821,
    "Alt": 480,
    "L": 6,
    "F": 6,
    "R": 7,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Calliergon cordifolium",
    "Concept": "Bry_3",
    "Taxon_name": "Calliergon cordifolium",
    "BRC_num": "0820     3",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": 5,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 606,
    "IRno": 48,
    "CIno": "",
    "TJan": 3.5,
    "TJul": 14.7,
    "Prec": 1066,
    "Alt": 910,
    "L": 5,
    "F": 10,
    "R": 4,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum alpinum",
    "Concept": "Bry_87",
    "Taxon_name": "Bryum alpinum",
    "BRC_num": "0820    87",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 603,
    "IRno": 85,
    "CIno": 6,
    "TJan": 3.2,
    "TJul": 13.3,
    "Prec": 1564,
    "Alt": 920,
    "L": 7,
    "F": 8,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sarmentypnum exannulatum",
    "Concept": "Bry_223",
    "Taxon_name": "Warnstorfia exannulata",
    "BRC_num": "0820   223",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 168,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 5,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 603,
    "IRno": 48,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.7,
    "Prec": 1407,
    "Alt": 1335,
    "L": 8,
    "F": 9,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Warnstorfia fluitans",
    "Concept": "Bry_224",
    "Taxon_name": "Warnstorfia fluitans",
    "BRC_num": "0820   224",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 128,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Ac",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 602,
    "IRno": 26,
    "CIno": "",
    "TJan": 3.1,
    "TJul": 14.2,
    "Prec": 1165,
    "Alt": 870,
    "L": 7,
    "F": 10,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ephemerum serratum",
    "Concept": "Bry_239",
    "Taxon_name": "Ephemerum serratum",
    "BRC_num": "0820   239",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 2.2,
    "Per": "A",
    "LF1": "Tp",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 40,
    "Sp2": 70,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 601,
    "IRno": 66,
    "CIno": "",
    "TJan": 3.8,
    "TJul": 15.2,
    "Prec": 955,
    "Alt": 400,
    "L": 6,
    "F": 6,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 1,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Eucladium verticillatum",
    "Concept": "Bry_243",
    "Taxon_name": "Eucladium verticillatum",
    "BRC_num": "0820   243",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 83,
    "GBno": 600,
    "IRno": 73,
    "CIno": "",
    "TJan": 3.5,
    "TJul": 14.6,
    "Prec": 1115,
    "Alt": 700,
    "L": 2,
    "F": 7,
    "R": 9,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hedwigia ciliata",
    "Concept": "Bry_328",
    "Taxon_name": "Hedwigia ciliata",
    "BRC_num": "0820   328",
    "ML": "M",
    "Ord": "Hedwigiales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 19,
    "Sp2": 35,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 596,
    "IRno": 101,
    "CIno": 3,
    "TJan": 3,
    "TJul": 13.4,
    "Prec": 1487,
    "Alt": 760,
    "L": 8,
    "F": 1,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": 1,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Orthotrichum pulchellum",
    "Concept": "Bry_421",
    "Taxon_name": "Orthotrichum pulchellum",
    "BRC_num": "0820   421",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 3,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 71,
    "GBno": 591,
    "IRno": 54,
    "CIno": 1,
    "TJan": 3.7,
    "TJul": 15,
    "Prec": 1025,
    "Alt": 405,
    "L": 6,
    "F": 5,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": 1,
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Neckera crispa",
    "Concept": "Bry_402",
    "Taxon_name": "Neckera crispa",
    "BRC_num": "0820   402",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "We",
    "LF2": "Fa",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "O",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 580,
    "IRno": 94,
    "CIno": "",
    "TJan": 3,
    "TJul": 14.1,
    "Prec": 1395,
    "Alt": 700,
    "L": 6,
    "F": 4,
    "R": 8,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Fissidens incurvus",
    "Concept": "Bry_266",
    "Taxon_name": "Fissidens incurvus",
    "BRC_num": "0820   266",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "R",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "A",
    "Spbeg": 10,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "(CI)",
    "Elem": 92,
    "GBno": 579,
    "IRno": 15,
    "CIno": "",
    "TJan": 4,
    "TJul": 15.9,
    "Prec": 814,
    "Alt": 490,
    "L": 4,
    "F": 5,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Riccia glauca",
    "Concept": "Bry_910",
    "Taxon_name": "Riccia glauca",
    "BRC_num": "0810   910",
    "ML": "L",
    "Ord": "Ricciales",
    "Stat": "N",
    "Len": 20,
    "Per": "AP",
    "LF1": "St",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 11,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 70,
    "Sp2": 100,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 86,
    "GBno": 574,
    "IRno": 57,
    "CIno": 4,
    "TJan": 3.9,
    "TJul": 15.5,
    "Prec": 934,
    "Alt": 300,
    "L": 7,
    "F": 6,
    "R": 6,
    "N": 6,
    "S": 1,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": 1,
    "SR": 1,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Schistidium rivulare",
    "Concept": "Bry_289",
    "Taxon_name": "Schistidium rivulare",
    "BRC_num": "0820   289",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "At",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 36,
    "GBno": 574,
    "IRno": 37,
    "CIno": "",
    "TJan": 2.7,
    "TJul": 13.6,
    "Prec": 1350,
    "Alt": 1100,
    "L": 7,
    "F": 8,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Scorpidium scorpioides",
    "Concept": "Bry_541",
    "Taxon_name": "Scorpidium scorpioides",
    "BRC_num": "0820   541",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 6,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 574,
    "IRno": 99,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.2,
    "Prec": 1519,
    "Alt": 880,
    "L": 8,
    "F": 10,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cinclidotus fontinaloides",
    "Concept": "Bry_153",
    "Taxon_name": "Cinclidotus fontinaloides",
    "BRC_num": "0820   153",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "At",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 3,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 83,
    "GBno": 572,
    "IRno": 141,
    "CIno": "",
    "TJan": 3.4,
    "TJul": 14.5,
    "Prec": 1135,
    "Alt": 580,
    "L": 7,
    "F": 8,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Barbula convoluta var. sardoa",
    "Concept": "Bry_45.1",
    "Taxon_name": "Barbula convoluta var. sardoa",
    "BRC_num": "0820    45.1",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 66,
    "GBno": 569,
    "IRno": 64,
    "CIno": 3,
    "TJan": 4,
    "TJul": 15.5,
    "Prec": 970,
    "Alt": 510,
    "L": 7,
    "F": 5,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 2,
    "RW": 2,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum moravicum",
    "Concept": "Bry_661",
    "Taxon_name": "Bryum moravicum",
    "BRC_num": "0820   661",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "U",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 13,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 76,
    "GBno": 567,
    "IRno": 1,
    "CIno": "",
    "TJan": 3.4,
    "TJul": 15.7,
    "Prec": 802,
    "Alt": 950,
    "L": 5,
    "F": 5,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": 2,
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Bryum violaceum",
    "Concept": "Bry_672",
    "Taxon_name": "Bryum violaceum",
    "BRC_num": "0820   672",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "NA",
    "Len": 7,
    "Per": "AP",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 11,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 566,
    "IRno": 25,
    "CIno": 1,
    "TJan": 3.7,
    "TJul": 15.5,
    "Prec": 827,
    "Alt": 300,
    "L": 8,
    "F": 4,
    "R": 6,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Campylopus atrovirens",
    "Concept": "Bry_137",
    "Taxon_name": "Campylopus atrovirens",
    "BRC_num": "0820   137",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 130,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "F",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 70,
    "GBno": 566,
    "IRno": 157,
    "CIno": "",
    "TJan": 3,
    "TJul": 13,
    "Prec": 1680,
    "Alt": 940,
    "L": 8,
    "F": 8,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Leptobryum pyriforme",
    "Concept": "Bry_365",
    "Taxon_name": "Leptobryum pyriforme",
    "BRC_num": "0820   365",
    "ML": "M",
    "Ord": "Splachnales",
    "Stat": "N",
    "Len": 20,
    "Per": "PA",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 6,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 66,
    "GBno": 565,
    "IRno": 22,
    "CIno": 2,
    "TJan": 3.6,
    "TJul": 15.4,
    "Prec": 834,
    "Alt": 610,
    "L": 7,
    "F": 6,
    "R": 6,
    "N": 7,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 1,
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Dicranum fuscescens",
    "Concept": "Bry_201",
    "Taxon_name": "Dicranum fuscescens",
    "BRC_num": "0820   201",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 562,
    "IRno": 53,
    "CIno": "",
    "TJan": 2.3,
    "TJul": 13,
    "Prec": 1556,
    "Alt": 1205,
    "L": 6,
    "F": 5,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Tritomaria quinquedentata",
    "Concept": "Bry_960",
    "Taxon_name": "Tritomaria quinquedentata",
    "BRC_num": "0810   960",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "We",
    "Tub": "",
    "Gem": "R",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 6,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 21,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 561,
    "IRno": 64,
    "CIno": "",
    "TJan": 2.4,
    "TJul": 12.9,
    "Prec": 1613,
    "Alt": 1205,
    "L": 5,
    "F": 6,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 1,
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Fissidens osmundoides",
    "Concept": "Bry_269",
    "Taxon_name": "Fissidens osmundoides",
    "BRC_num": "0820   269",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 58,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "U",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 6,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 559,
    "IRno": 86,
    "CIno": "",
    "TJan": 2.7,
    "TJul": 13,
    "Prec": 1650,
    "Alt": 920,
    "L": 7,
    "F": 7,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Leiocolea turbinata",
    "Concept": "Bry_796",
    "Taxon_name": "Leiocolea turbinata",
    "BRC_num": "0810   796",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 1,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 91,
    "GBno": 559,
    "IRno": 63,
    "CIno": "",
    "TJan": 3.7,
    "TJul": 15.1,
    "Prec": 968,
    "Alt": 460,
    "L": 6,
    "F": 7,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Lejeunea lamacerina",
    "Concept": "Bry_801",
    "Taxon_name": "Lejeunea lamacerina",
    "BRC_num": "0810   801",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 2,
    "Spend": 11,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 80,
    "GBno": 558,
    "IRno": 124,
    "CIno": 4,
    "TJan": 3.9,
    "TJul": 14.3,
    "Prec": 1425,
    "Alt": 650,
    "L": 4,
    "F": 6,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": 3,
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Isothecium myosuroides var. myosuroides",
    "Concept": "Bry_362.2",
    "Taxon_name": "Isothecium myosuroides var. myosuroides",
    "BRC_num": "0820   362.2",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "De",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 11,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 52,
    "GBno": 556,
    "IRno": 16,
    "CIno": "",
    "TJan": 3.7,
    "TJul": 14.8,
    "Prec": 1249,
    "Alt": 950,
    "L": 4,
    "F": 6,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Orthotrichum cupulatum",
    "Concept": "Bry_416",
    "Taxon_name": "Orthotrichum cupulatum",
    "BRC_num": "0820   416",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 4,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 74,
    "GBno": 556,
    "IRno": 62,
    "CIno": "",
    "TJan": 3.3,
    "TJul": 14.7,
    "Prec": 1020,
    "Alt": 620,
    "L": 7,
    "F": 4,
    "R": 8,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum fallax",
    "Concept": "Bry_571.2",
    "Taxon_name": "Sphagnum fallax",
    "BRC_num": "0820   571.2",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 8,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 27,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 554,
    "IRno": 32,
    "CIno": 3,
    "TJan": 3.1,
    "TJul": 14.3,
    "Prec": 1306,
    "Alt": 1000,
    "L": 7,
    "F": 9,
    "R": 2,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cephalozia lunulifolia",
    "Concept": "Bry_721",
    "Taxon_name": "Cephalozia lunulifolia",
    "BRC_num": "0810   721",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 2,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 535,
    "IRno": 56,
    "CIno": "",
    "TJan": 3.2,
    "TJul": 14,
    "Prec": 1350,
    "Alt": 650,
    "L": 5,
    "F": 8,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 3,
    "DV": 2,
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Lophozia incisa",
    "Concept": "Bry_819",
    "Taxon_name": "Lophozia incisa",
    "BRC_num": "0810   819",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 5,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 535,
    "IRno": 129,
    "CIno": "",
    "TJan": 2.7,
    "TJul": 13.1,
    "Prec": 1560,
    "Alt": 850,
    "L": 6,
    "F": 6,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 2,
    "RW": "",
    "SR": 2,
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cephalozia connivens",
    "Concept": "Bry_716",
    "Taxon_name": "Cephalozia connivens",
    "BRC_num": "0810   716",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "O",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 3,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 53,
    "GBno": 534,
    "IRno": 138,
    "CIno": 1,
    "TJan": 3.3,
    "TJul": 14.2,
    "Prec": 1274,
    "Alt": 670,
    "L": 6,
    "F": 8,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 2,
    "RW": "",
    "SR": "",
    "SO": 2,
    "PT": 3,
    "GS": "",
    "DW": 2,
    "DV": 3,
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Gymnostomum aeruginosum",
    "Concept": "Bry_321",
    "Taxon_name": "Gymnostomum aeruginosum",
    "BRC_num": "0820   321",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 531,
    "IRno": 64,
    "CIno": "",
    "TJan": 2.6,
    "TJul": 13.2,
    "Prec": 1542,
    "Alt": 1175,
    "L": 5,
    "F": 8,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 2,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Plagiochila spinulosa",
    "Concept": "Bry_874",
    "Taxon_name": "Plagiochila spinulosa",
    "BRC_num": "0810   874",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "We",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "O",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 80,
    "GBno": 531,
    "IRno": 151,
    "CIno": 2,
    "TJan": 3.3,
    "TJul": 13.4,
    "Prec": 1653,
    "Alt": 760,
    "L": 4,
    "F": 6,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Mnium stellare",
    "Concept": "Bry_394",
    "Taxon_name": "Mnium stellare",
    "BRC_num": "0820   394",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 520,
    "IRno": 20,
    "CIno": "",
    "TJan": 2.9,
    "TJul": 14.2,
    "Prec": 1264,
    "Alt": 580,
    "L": 2,
    "F": 6,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Aloina aloides",
    "Concept": "Bry_1077",
    "Taxon_name": "Aloina aloides",
    "BRC_num": "0820  1077",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 83,
    "GBno": 519,
    "IRno": 61,
    "CIno": 4,
    "TJan": 3.9,
    "TJul": 15.5,
    "Prec": 886,
    "Alt": 460,
    "L": 8,
    "F": 3,
    "R": 8,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Microbryum starckeanum",
    "Concept": "Bry_500",
    "Taxon_name": "Microbryum starckeanum",
    "BRC_num": "0820   500",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 2,
    "Per": "A",
    "LF1": "Ts",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 19,
    "Sp2": 42,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 92,
    "GBno": 519,
    "IRno": 21,
    "CIno": 3,
    "TJan": 4,
    "TJul": 15.9,
    "Prec": 803,
    "Alt": 365,
    "L": 8,
    "F": 3,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": 1,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Campyliadelphus chrysophyllus",
    "Concept": "Bry_129",
    "Taxon_name": "Campyliadelphus chrysophyllus",
    "BRC_num": "0820   129",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "(CI)",
    "Elem": 56,
    "GBno": 516,
    "IRno": 58,
    "CIno": "",
    "TJan": 3.7,
    "TJul": 15.1,
    "Prec": 981,
    "Alt": 950,
    "L": 8,
    "F": 2,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Barbilophozia attenuata",
    "Concept": "Bry_693",
    "Taxon_name": "Barbilophozia attenuata",
    "BRC_num": "0810   693",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 46,
    "GBno": 509,
    "IRno": 28,
    "CIno": 1,
    "TJan": 2.7,
    "TJul": 13.7,
    "Prec": 1391,
    "Alt": 600,
    "L": 4,
    "F": 5,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 2,
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Weissia brachycarpa",
    "Concept": "Bry_642",
    "Taxon_name": "Weissia brachycarpa",
    "BRC_num": "0820   642",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 34,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 86,
    "GBno": 507,
    "IRno": 27,
    "CIno": 2,
    "TJan": 3.7,
    "TJul": 15.1,
    "Prec": 1010,
    "Alt": 580,
    "L": 8,
    "F": 4,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Palustriella falcata",
    "Concept": "Bry_161.2",
    "Taxon_name": "Palustriella commutata var. falcata",
    "BRC_num": "0820   161.2",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 505,
    "IRno": 66,
    "CIno": "",
    "TJan": 2.8,
    "TJul": 13.5,
    "Prec": 1389,
    "Alt": 1070,
    "L": 8,
    "F": 9,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Scapania compacta",
    "Concept": "Bry_922",
    "Taxon_name": "Scapania compacta",
    "BRC_num": "0810   922",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "F",
    "Spbeg": 12,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 21,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 92,
    "GBno": 503,
    "IRno": 46,
    "CIno": 9,
    "TJan": 3.5,
    "TJul": 14.1,
    "Prec": 1404,
    "Alt": 780,
    "L": 7,
    "F": 4,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 3,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Mylia taylorii",
    "Concept": "Bry_854",
    "Taxon_name": "Mylia taylorii",
    "BRC_num": "0810   854",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 7,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 17,
    "Sp2": 21,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 42,
    "GBno": 501,
    "IRno": 94,
    "CIno": "",
    "TJan": 2.5,
    "TJul": 12.8,
    "Prec": 1704,
    "Alt": 1226,
    "L": 6,
    "F": 7,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Oligotrichum hercynicum",
    "Concept": "Bry_407",
    "Taxon_name": "Oligotrichum hercynicum",
    "BRC_num": "0820   407",
    "ML": "M",
    "Ord": "Polytrichales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Ts",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 6,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 501,
    "IRno": 54,
    "CIno": "",
    "TJan": 2.2,
    "TJul": 12.8,
    "Prec": 1688,
    "Alt": 1330,
    "L": 7,
    "F": 5,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Marchantia quadrata",
    "Concept": "Bry_887",
    "Taxon_name": "Marchantia quadrata",
    "BRC_num": "0810   887",
    "ML": "L",
    "Ord": "Marchantiales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 11,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 48,
    "Sp2": 70,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 496,
    "IRno": 85,
    "CIno": "",
    "TJan": 2.6,
    "TJul": 13.2,
    "Prec": 1565,
    "Alt": 1175,
    "L": 6,
    "F": 7,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 2,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hygroamblystegium tenax",
    "Concept": "Bry_337",
    "Taxon_name": "Amblystegium tenax",
    "BRC_num": "0820   337",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 76,
    "GBno": 494,
    "IRno": 18,
    "CIno": 1,
    "TJan": 3.5,
    "TJul": 15,
    "Prec": 985,
    "Alt": 440,
    "L": 4,
    "F": 9,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Trichostomum tenuirostre",
    "Concept": "Bry_628",
    "Taxon_name": "Trichostomum tenuirostre",
    "BRC_num": "0820   628",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 45,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "X",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 9,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 493,
    "IRno": 78,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.4,
    "Prec": 1669,
    "Alt": 820,
    "L": 4,
    "F": 7,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Microbryum davallianum",
    "Concept": "Bry_1781",
    "Taxon_name": "Microbryum davallianum",
    "BRC_num": "0820  1781",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 1.3,
    "Per": "A",
    "LF1": "Ts",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 31,
    "Sp2": 40,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 92,
    "GBno": 488,
    "IRno": 19,
    "CIno": 1,
    "TJan": 4,
    "TJul": 15.9,
    "Prec": 794,
    "Alt": 365,
    "L": 8,
    "F": 3,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fissidens viridulus",
    "Concept": "Bry_275",
    "Taxon_name": "Fissidens viridulus",
    "BRC_num": "0820   275",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 6,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 66,
    "GBno": 487,
    "IRno": 23,
    "CIno": "",
    "TJan": 4,
    "TJul": 15.6,
    "Prec": 945,
    "Alt": 700,
    "L": 3,
    "F": 5,
    "R": 7,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 2,
    "RW": 1,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Mylia anomala",
    "Concept": "Bry_852",
    "Taxon_name": "Mylia anomala",
    "BRC_num": "0810   852",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 487,
    "IRno": 98,
    "CIno": "",
    "TJan": 2.9,
    "TJul": 13.6,
    "Prec": 1364,
    "Alt": 1070,
    "L": 7,
    "F": 9,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 2,
    "SO": "",
    "PT": 3,
    "GS": "",
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Jungermannia pumila",
    "Concept": "Bry_944",
    "Taxon_name": "Jungermannia pumila",
    "BRC_num": "0810   944",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 2,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 36,
    "GBno": 484,
    "IRno": 63,
    "CIno": "",
    "TJan": 2.7,
    "TJul": 13.4,
    "Prec": 1503,
    "Alt": 920,
    "L": 4,
    "F": 8,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Aloina aloides s.str.",
    "Concept": "Bry_9",
    "Taxon_name": "Aloina aloides",
    "BRC_num": "0820     9",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": 9,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 92,
    "GBno": 483,
    "IRno": 55,
    "CIno": 3,
    "TJan": 3.9,
    "TJul": 15.5,
    "Prec": 896,
    "Alt": 460,
    "L": 8,
    "F": 3,
    "R": 8,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Archidium alternifolium",
    "Concept": "Bry_35",
    "Taxon_name": "Archidium alternifolium",
    "BRC_num": "0820    35",
    "ML": "M",
    "Ord": "Archidiales",
    "Stat": "N",
    "Len": 20,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "Ts",
    "Tub": "X",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 3,
    "Spend": 6,
    "Spbeg2": 10,
    "Spend2": 10,
    "Sp1": 127,
    "Sp2": 262,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 83,
    "GBno": 480,
    "IRno": 59,
    "CIno": 2,
    "TJan": 3.8,
    "TJul": 14.3,
    "Prec": 1280,
    "Alt": 460,
    "L": 7,
    "F": 8,
    "R": 4,
    "N": 3,
    "S": 2,
    "HM": 2,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Entosthodon obtusus",
    "Concept": "Bry_286",
    "Taxon_name": "Entosthodon obtusus",
    "BRC_num": "0820   286",
    "ML": "M",
    "Ord": "Funariales",
    "Stat": "N",
    "Len": 5,
    "Per": "AP",
    "LF1": "Ts",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 12,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 30,
    "Sp2": 38,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 92,
    "GBno": 480,
    "IRno": 99,
    "CIno": 7,
    "TJan": 3.4,
    "TJul": 13.5,
    "Prec": 1478,
    "Alt": 787,
    "L": 7,
    "F": 7,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Atrichum undulatum var. undulatum",
    "Concept": "Bry_40.3",
    "Taxon_name": "Atrichum undulatum var. undulatum",
    "BRC_num": "0820    40.3",
    "ML": "M",
    "Ord": "Polytrichales",
    "Stat": "N",
    "Len": 70,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M(D)",
    "Fr": "A",
    "Spbeg": 11,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 479,
    "IRno": 12,
    "CIno": "",
    "TJan": 3.6,
    "TJul": 15.1,
    "Prec": 1091,
    "Alt": 1000,
    "L": 4,
    "F": 6,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fissidens crassipes",
    "Concept": "Bry_261",
    "Taxon_name": "Fissidens crassipes",
    "BRC_num": "0820   261",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Ts",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 2,
    "Spend": 2,
    "Spbeg2": 7,
    "Spend2": 11,
    "Sp1": 18,
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 83,
    "GBno": 478,
    "IRno": 30,
    "CIno": "",
    "TJan": 3.6,
    "TJul": 15.4,
    "Prec": 921,
    "Alt": 425,
    "L": 5,
    "F": 9,
    "R": 7,
    "N": 7,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Metzgeria consanguinea",
    "Concept": "Bry_969",
    "Taxon_name": "Metzgeria temperata",
    "BRC_num": "0810   969",
    "ML": "L",
    "Ord": "Metzgeriales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 21,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 72,
    "GBno": 473,
    "IRno": 44,
    "CIno": 1,
    "TJan": 3.9,
    "TJul": 15,
    "Prec": 1257,
    "Alt": 480,
    "L": 5,
    "F": 5,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Gyroweisia tenuis",
    "Concept": "Bry_325",
    "Taxon_name": "Gyroweisia tenuis",
    "BRC_num": "0820   325",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 2.5,
    "Per": "P",
    "LF1": "Tp",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 468,
    "IRno": 30,
    "CIno": "",
    "TJan": 3.5,
    "TJul": 15.3,
    "Prec": 913,
    "Alt": 500,
    "L": 1,
    "F": 6,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 2,
    "SO": "",
    "PT": "",
    "GS": 1,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Diphyscium foliosum",
    "Concept": "Bry_211",
    "Taxon_name": "Diphyscium foliosum",
    "BRC_num": "0820   211",
    "ML": "M",
    "Ord": "Diphysciales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 6,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 13,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 464,
    "IRno": 45,
    "CIno": "",
    "TJan": 2.7,
    "TJul": 13.1,
    "Prec": 1724,
    "Alt": 1205,
    "L": 5,
    "F": 5,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fissidens taxifolius var. taxifolius",
    "Concept": "Bry_274.2",
    "Taxon_name": "Fissidens taxifolius var. taxifolius",
    "BRC_num": "0820   274.2",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 20,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": 1,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 83,
    "GBno": 463,
    "IRno": 4,
    "CIno": "",
    "TJan": 3.8,
    "TJul": 15.4,
    "Prec": 946,
    "Alt": 490,
    "L": 4,
    "F": 5,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 1,
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Polytrichum strictum",
    "Concept": "Bry_480",
    "Taxon_name": "Polytrichum strictum",
    "BRC_num": "0820   480",
    "ML": "M",
    "Ord": "Polytrichales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 461,
    "IRno": 73,
    "CIno": "",
    "TJan": 2.5,
    "TJul": 13.3,
    "Prec": 1533,
    "Alt": 980,
    "L": 8,
    "F": 7,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Syntrichia ruralis var. ruraliformis",
    "Concept": "Bry_618",
    "Taxon_name": "Syntrichia ruraliformis",
    "BRC_num": "0820   618",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 83,
    "GBno": 461,
    "IRno": 46,
    "CIno": 8,
    "TJan": 4.2,
    "TJul": 15,
    "Prec": 955,
    "Alt": 250,
    "L": 8,
    "F": 3,
    "R": 7,
    "N": 3,
    "S": 1,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Blasia pusilla",
    "Concept": "Bry_703",
    "Taxon_name": "Blasia pusilla",
    "BRC_num": "0810   703",
    "ML": "L",
    "Ord": "Blasiales",
    "Stat": "N",
    "Len": 25,
    "Per": "PA",
    "LF1": "St",
    "LF2": "Mt",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 3,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 35,
    "Sp2": 55,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 459,
    "IRno": 63,
    "CIno": "",
    "TJan": 2.5,
    "TJul": 13.2,
    "Prec": 1457,
    "Alt": 1040,
    "L": 6,
    "F": 8,
    "R": 4,
    "N": 4,
    "S": 0,
    "HM": 1,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Campylium protensum",
    "Concept": "Bry_134",
    "Taxon_name": "Campylium stellatum var. protensum",
    "BRC_num": "0820   134",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 459,
    "IRno": 32,
    "CIno": "",
    "TJan": 3.2,
    "TJul": 14.4,
    "Prec": 1203,
    "Alt": 850,
    "L": 7,
    "F": 7,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 1,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Neckera pumila",
    "Concept": "Bry_404",
    "Taxon_name": "Neckera pumila",
    "BRC_num": "0820   404",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Fa",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 72,
    "GBno": 459,
    "IRno": 96,
    "CIno": 1,
    "TJan": 4,
    "TJul": 14.9,
    "Prec": 1280,
    "Alt": 410,
    "L": 5,
    "F": 5,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Cephaloziella hampeana",
    "Concept": "Bry_727",
    "Taxon_name": "Cephaloziella hampeana",
    "BRC_num": "0810   727",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 12,
    "Per": "P",
    "LF1": "Thread",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 11,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 455,
    "IRno": 78,
    "CIno": "",
    "TJan": 3.4,
    "TJul": 14.2,
    "Prec": 1265,
    "Alt": 1175,
    "L": 6,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 2,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ephemerum minutissimum",
    "Concept": "Bry_239.1",
    "Taxon_name": "Ephemerum serratum var. minutissimum",
    "BRC_num": "0820   239.1",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 1.8,
    "Per": "A",
    "LF1": "Tp",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 8,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 50,
    "Sp2": 65,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 453,
    "IRno": 46,
    "CIno": "",
    "TJan": 3.9,
    "TJul": 15.4,
    "Prec": 913,
    "Alt": 300,
    "L": 6,
    "F": 5,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 1,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Metzgeria conjugata",
    "Concept": "Bry_843",
    "Taxon_name": "Metzgeria conjugata",
    "BRC_num": "0810   843",
    "ML": "L",
    "Ord": "Metzgeriales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mt",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 4,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 26,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 453,
    "IRno": 77,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.5,
    "Prec": 1633,
    "Alt": 800,
    "L": 4,
    "F": 5,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 1,
    "SR": 2,
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Fissidens pusillus",
    "Concept": "Bry_267",
    "Taxon_name": "Fissidens pusillus",
    "BRC_num": "0820   267",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 6,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 19,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 83,
    "GBno": 451,
    "IRno": 37,
    "CIno": "",
    "TJan": 3.6,
    "TJul": 15.2,
    "Prec": 1019,
    "Alt": 920,
    "L": 3,
    "F": 6,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 2,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Calliergonella lindbergii",
    "Concept": "Bry_354",
    "Taxon_name": "Hypnum lindbergii",
    "BRC_num": "0820   354",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 36,
    "GBno": 448,
    "IRno": 76,
    "CIno": "",
    "TJan": 3.5,
    "TJul": 14.6,
    "Prec": 1218,
    "Alt": 900,
    "L": 7,
    "F": 7,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 1,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Scapania umbrosa",
    "Concept": "Bry_938",
    "Taxon_name": "Scapania umbrosa",
    "BRC_num": "0810   938",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 3,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 13,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 443,
    "IRno": 82,
    "CIno": "",
    "TJan": 2.6,
    "TJul": 13,
    "Prec": 1612,
    "Alt": 1000,
    "L": 2,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Schistidium crassipilum",
    "Concept": "Bry_1773",
    "Taxon_name": "Schistidium crassipilum",
    "BRC_num": "0820  1773",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 11,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 83,
    "GBno": 440,
    "IRno": 23,
    "CIno": "",
    "TJan": 3.6,
    "TJul": 15.1,
    "Prec": 1023,
    "Alt": 970,
    "L": 7,
    "F": 1,
    "R": 8,
    "N": 4,
    "S": 0,
    "HM": 3,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Anomobryum julaceum",
    "Concept": "Bry_1503",
    "Taxon_name": "Anomobryum julaceum",
    "BRC_num": "0820  1503",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "O",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 4,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 439,
    "IRno": 75,
    "CIno": "",
    "TJan": 2.4,
    "TJul": 12.7,
    "Prec": 1744,
    "Alt": 1100,
    "L": 7,
    "F": 7,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Lejeunea patens",
    "Concept": "Bry_803",
    "Taxon_name": "Lejeunea patens",
    "BRC_num": "0810   803",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 3,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 80,
    "GBno": 437,
    "IRno": 137,
    "CIno": "",
    "TJan": 3.2,
    "TJul": 13.2,
    "Prec": 1677,
    "Alt": 800,
    "L": 4,
    "F": 5,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 1,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": 2,
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Schistidium maritimum",
    "Concept": "Bry_306",
    "Taxon_name": "Schistidium maritimum",
    "BRC_num": "0820   306",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 26,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 51,
    "GBno": 435,
    "IRno": 64,
    "CIno": 6,
    "TJan": 4.2,
    "TJul": 13.7,
    "Prec": 1396,
    "Alt": 90,
    "L": 8,
    "F": 7,
    "R": 5,
    "N": 5,
    "S": 5,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 1,
    "SR": 1,
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Leucodon sciuroides",
    "Concept": "Bry_375",
    "Taxon_name": "Leucodon sciuroides",
    "BRC_num": "0820   375",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "Fa",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 26,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 64,
    "GBno": 432,
    "IRno": 15,
    "CIno": 1,
    "TJan": 3.5,
    "TJul": 15.2,
    "Prec": 996,
    "Alt": 730,
    "L": 6,
    "F": 4,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Loeskeobryum brevirostre",
    "Concept": "Bry_344",
    "Taxon_name": "Hylocomium brevirostre",
    "BRC_num": "0820   344",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 22,
    "Sp2": 26,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "(CI)",
    "Elem": 73,
    "GBno": 431,
    "IRno": 126,
    "CIno": "",
    "TJan": 3.3,
    "TJul": 13.7,
    "Prec": 1620,
    "Alt": 760,
    "L": 4,
    "F": 6,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum girgensohnii",
    "Concept": "Bry_559",
    "Taxon_name": "Sphagnum girgensohnii",
    "BRC_num": "0820   559",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 22,
    "Sp2": 25,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 426,
    "IRno": 12,
    "CIno": "",
    "TJan": 2.1,
    "TJul": 12.8,
    "Prec": 1601,
    "Alt": 1100,
    "L": 6,
    "F": 8,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum magellanicum",
    "Concept": "Bry_562",
    "Taxon_name": "Sphagnum magellanicum",
    "BRC_num": "0820   562",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 8,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 26,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 420,
    "IRno": 125,
    "CIno": "",
    "TJan": 2.9,
    "TJul": 13.4,
    "Prec": 1418,
    "Alt": 1030,
    "L": 8,
    "F": 8,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 1,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Thuidium delicatulum",
    "Concept": "Bry_595",
    "Taxon_name": "Thuidium delicatulum",
    "BRC_num": "0820   595",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 122,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 76,
    "GBno": 420,
    "IRno": 66,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.3,
    "Prec": 1712,
    "Alt": 800,
    "L": 6,
    "F": 6,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Schistidium rivulare s.str.",
    "Concept": "Bry_289.2",
    "Taxon_name": "Schistidium rivulare s.str.",
    "BRC_num": "0820   289.2",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "At",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 36,
    "GBno": 419,
    "IRno": 32,
    "CIno": "",
    "TJan": 2.8,
    "TJul": 13.6,
    "Prec": 1382,
    "Alt": 1100,
    "L": 7,
    "F": 8,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Anomobryum julaceum s.str.",
    "Concept": "Bry_29",
    "Taxon_name": "Anomobryum julaceum var. julaceum",
    "BRC_num": "0820    29",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 417,
    "IRno": 70,
    "CIno": "",
    "TJan": 2.3,
    "TJul": 12.7,
    "Prec": 1752,
    "Alt": 950,
    "L": 7,
    "F": 7,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Blepharostoma trichophyllum",
    "Concept": "Bry_704",
    "Taxon_name": "Blepharostoma trichophyllum",
    "BRC_num": "0810   704",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Thread",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 4,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 414,
    "IRno": 33,
    "CIno": "",
    "TJan": 2.3,
    "TJul": 12.9,
    "Prec": 1686,
    "Alt": 1205,
    "L": 4,
    "F": 8,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Orthotrichum stramineum",
    "Concept": "Bry_428",
    "Taxon_name": "Orthotrichum stramineum",
    "BRC_num": "0820   428",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 5,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 73,
    "GBno": 413,
    "IRno": 3,
    "CIno": "",
    "TJan": 3,
    "TJul": 14.4,
    "Prec": 1168,
    "Alt": 440,
    "L": 6,
    "F": 4,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Frullania fragilifolia",
    "Concept": "Bry_765",
    "Taxon_name": "Frullania fragilifolia",
    "BRC_num": "0810   765",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "F",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 4,
    "Spend": 7,
    "Spbeg2": 10,
    "Spend2": 10,
    "Sp1": 35,
    "Sp2": 50,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 72,
    "GBno": 411,
    "IRno": 46,
    "CIno": 4,
    "TJan": 3.2,
    "TJul": 13.4,
    "Prec": 1649,
    "Alt": 850,
    "L": 5,
    "F": 5,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": 3,
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Sarmentypnum sarmentosum",
    "Concept": "Bry_6",
    "Taxon_name": "Calliergon sarmentosum",
    "BRC_num": "0820     6",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 6,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 403,
    "IRno": 41,
    "CIno": "",
    "TJan": 2.4,
    "TJul": 12.6,
    "Prec": 1764,
    "Alt": 1200,
    "L": 8,
    "F": 9,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Kurzia pauciflora",
    "Concept": "Bry_808",
    "Taxon_name": "Kurzia pauciflora",
    "BRC_num": "0810   808",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Thread",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 6,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 52,
    "GBno": 403,
    "IRno": 141,
    "CIno": 1,
    "TJan": 3.3,
    "TJul": 13.8,
    "Prec": 1404,
    "Alt": 700,
    "L": 7,
    "F": 9,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 2,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": 3,
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Phascum cuspidatum var. cuspidatum",
    "Concept": "Bry_434.2",
    "Taxon_name": "Tortula acaulon var. acaulon",
    "BRC_num": "0820   434.2",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 4.5,
    "Per": "AP",
    "LF1": "Ts",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 3,
    "Spbeg2": 8,
    "Spend2": 12,
    "Sp1": 25,
    "Sp2": 40,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 86,
    "GBno": 403,
    "IRno": 10,
    "CIno": "",
    "TJan": 3.8,
    "TJul": 15.8,
    "Prec": 772,
    "Alt": 185,
    "L": 8,
    "F": 5,
    "R": 7,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fontinalis squamosa",
    "Concept": "Bry_281",
    "Taxon_name": "Fontinalis squamosa",
    "BRC_num": "0820   281",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 400,
    "Per": "P",
    "LF1": "At",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 1,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 72,
    "GBno": 392,
    "IRno": 52,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.7,
    "Prec": 1409,
    "Alt": 830,
    "L": 7,
    "F": 12,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Fossombronia wondraczekii",
    "Concept": "Bry_763",
    "Taxon_name": "Fossombronia wondraczekii",
    "BRC_num": "0810   763",
    "ML": "L",
    "Ord": "Fossombroniales",
    "Stat": "N",
    "Len": 10,
    "Per": "AP",
    "LF1": "Sc",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 34,
    "Sp2": 50,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 391,
    "IRno": 43,
    "CIno": 3,
    "TJan": 3.7,
    "TJul": 14.9,
    "Prec": 1121,
    "Alt": 490,
    "L": 7,
    "F": 7,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fissidens exilis",
    "Concept": "Bry_265",
    "Taxon_name": "Fissidens exilis",
    "BRC_num": "0820   265",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 3,
    "Per": "AP",
    "LF1": "Ts",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "(CI)",
    "Elem": 73,
    "GBno": 388,
    "IRno": 6,
    "CIno": "",
    "TJan": 3.8,
    "TJul": 15.7,
    "Prec": 857,
    "Alt": 290,
    "L": 4,
    "F": 5,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Polytrichastrum alpinum",
    "Concept": "Bry_481",
    "Taxon_name": "Polytrichum alpinum",
    "BRC_num": "0820   481",
    "ML": "M",
    "Ord": "Polytrichales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 387,
    "IRno": 45,
    "CIno": "",
    "TJan": 2.1,
    "TJul": 12.5,
    "Prec": 1733,
    "Alt": 1335,
    "L": 6,
    "F": 5,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Plagiomnium elatum",
    "Concept": "Bry_392",
    "Taxon_name": "Plagiomnium elatum",
    "BRC_num": "0820   392",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 17,
    "Sp2": 25,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 385,
    "IRno": 45,
    "CIno": "",
    "TJan": 2.9,
    "TJul": 14.1,
    "Prec": 1198,
    "Alt": 850,
    "L": 6,
    "F": 9,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Racomitrium heterostichum s.str.",
    "Concept": "Bry_1072",
    "Taxon_name": "Racomitrium heterostichum",
    "BRC_num": "0820  1072",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 3,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 52,
    "GBno": 383,
    "IRno": 33,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.8,
    "Prec": 1505,
    "Alt": 730,
    "L": 7,
    "F": 2,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 1,
    "SO": "",
    "PT": "",
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bazzania trilobata",
    "Concept": "Bry_702",
    "Taxon_name": "Bazzania trilobata",
    "BRC_num": "0810   702",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "We",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "O",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 5,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 17,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 72,
    "GBno": 382,
    "IRno": 41,
    "CIno": 2,
    "TJan": 3,
    "TJul": 13.5,
    "Prec": 1678,
    "Alt": 900,
    "L": 4,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 1,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 2,
    "GS": "",
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Trichocolea tomentella",
    "Concept": "Bry_956",
    "Taxon_name": "Trichocolea tomentella",
    "BRC_num": "0810   956",
    "ML": "L",
    "Ord": "Lepicoleales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 4,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 381,
    "IRno": 40,
    "CIno": "",
    "TJan": 3.3,
    "TJul": 13.9,
    "Prec": 1517,
    "Alt": 700,
    "L": 5,
    "F": 9,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum gemmiferum",
    "Concept": "Bry_662",
    "Taxon_name": "Bryum gemmiferum",
    "BRC_num": "0820   662",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 15,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "U",
    "Gem": "",
    "Bul": "F",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 72,
    "GBno": 378,
    "IRno": 16,
    "CIno": "",
    "TJan": 3.6,
    "TJul": 15.7,
    "Prec": 796,
    "Alt": 350,
    "L": 7,
    "F": 7,
    "R": 7,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": 2,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pohlia lutescens",
    "Concept": "Bry_1015",
    "Taxon_name": "Pohlia lutescens",
    "BRC_num": "0820  1015",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 8,
    "Per": "PA",
    "LF1": "Ts",
    "LF2": "Tf",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 376,
    "IRno": 8,
    "CIno": 2,
    "TJan": 3.8,
    "TJul": 15.1,
    "Prec": 1099,
    "Alt": 500,
    "L": 5,
    "F": 5,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 1,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum quinquefarium",
    "Concept": "Bry_570",
    "Taxon_name": "Sphagnum quinquefarium",
    "BRC_num": "0820   570",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": 8,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 22,
    "Sp2": 25,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 42,
    "GBno": 373,
    "IRno": 44,
    "CIno": "",
    "TJan": 2.7,
    "TJul": 13.1,
    "Prec": 1730,
    "Alt": 760,
    "L": 5,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Scleropodium cespitans",
    "Concept": "Bry_538",
    "Taxon_name": "Scleropodium cespitans",
    "BRC_num": "0820   538",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 72,
    "GBno": 372,
    "IRno": 14,
    "CIno": 7,
    "TJan": 4,
    "TJul": 15.9,
    "Prec": 864,
    "Alt": 300,
    "L": 6,
    "F": 5,
    "R": 7,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Hygroamblystegium fluviatile",
    "Concept": "Bry_336",
    "Taxon_name": "Amblystegium fluviatile",
    "BRC_num": "0820   336",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "At",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": 5,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 53,
    "GBno": 371,
    "IRno": 14,
    "CIno": 1,
    "TJan": 3.3,
    "TJul": 14.5,
    "Prec": 1135,
    "Alt": 380,
    "L": 6,
    "F": 11,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 2,
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Brachythecium glareosum",
    "Concept": "Bry_75",
    "Taxon_name": "Brachythecium glareosum",
    "BRC_num": "0820    75",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "(CI)",
    "Elem": 55,
    "GBno": 370,
    "IRno": 24,
    "CIno": "",
    "TJan": 3.3,
    "TJul": 15,
    "Prec": 1014,
    "Alt": 1065,
    "L": 7,
    "F": 4,
    "R": 8,
    "N": 3,
    "S": 0,
    "HM": 1,
    "RH": 2,
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Lophozia excisa",
    "Concept": "Bry_818",
    "Taxon_name": "Lophozia excisa",
    "BRC_num": "0810   818",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 26,
    "GBno": 370,
    "IRno": 25,
    "CIno": 6,
    "TJan": 3.3,
    "TJul": 14.4,
    "Prec": 1203,
    "Alt": 700,
    "L": 7,
    "F": 5,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 2,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Bartramia ithyphylla",
    "Concept": "Bry_65",
    "Taxon_name": "Bartramia ithyphylla",
    "BRC_num": "0820    65",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 6,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 34,
    "Sp2": 40,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 366,
    "IRno": 12,
    "CIno": "",
    "TJan": 2.1,
    "TJul": 12.8,
    "Prec": 1610,
    "Alt": 1170,
    "L": 4,
    "F": 6,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 2,
    "SR": 2,
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pleuridium subulatum",
    "Concept": "Bry_461",
    "Taxon_name": "Pleuridium subulatum",
    "BRC_num": "0820   461",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 10,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 3,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 28,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 76,
    "GBno": 357,
    "IRno": 23,
    "CIno": 2,
    "TJan": 3.9,
    "TJul": 15.2,
    "Prec": 991,
    "Alt": 360,
    "L": 7,
    "F": 6,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Scapania aspera",
    "Concept": "Bry_920",
    "Taxon_name": "Scapania aspera",
    "BRC_num": "0810   920",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "We",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 5,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 352,
    "IRno": 81,
    "CIno": "",
    "TJan": 2.8,
    "TJul": 13.6,
    "Prec": 1439,
    "Alt": 1040,
    "L": 7,
    "F": 6,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 2,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Plagiomnium cuspidatum",
    "Concept": "Bry_381",
    "Taxon_name": "Plagiomnium cuspidatum",
    "BRC_num": "0820   381",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 4,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 36,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 349,
    "IRno": 19,
    "CIno": "",
    "TJan": 3.3,
    "TJul": 14.5,
    "Prec": 1116,
    "Alt": 650,
    "L": 6,
    "F": 6,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Polytrichum commune var. commune",
    "Concept": "Bry_482.1",
    "Taxon_name": "Polytrichum commune var. commune",
    "BRC_num": "0820   482.1",
    "ML": "M",
    "Ord": "Polytrichales",
    "Stat": "N",
    "Len": 250,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 36,
    "GBno": 349,
    "IRno": 14,
    "CIno": "",
    "TJan": 3.4,
    "TJul": 14.5,
    "Prec": 1349,
    "Alt": 270,
    "L": 6,
    "F": 7,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Dicranum tauricum",
    "Concept": "Bry_210",
    "Taxon_name": "Dicranum tauricum",
    "BRC_num": "0820   210",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "F",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 73,
    "GBno": 347,
    "IRno": "",
    "CIno": "",
    "TJan": 3.2,
    "TJul": 15.4,
    "Prec": 823,
    "Alt": 450,
    "L": 4,
    "F": 4,
    "R": 3,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Lophozia bicrenata",
    "Concept": "Bry_816",
    "Taxon_name": "Lophozia bicrenata",
    "BRC_num": "0810   816",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 347,
    "IRno": 19,
    "CIno": 7,
    "TJan": 3.3,
    "TJul": 14.6,
    "Prec": 1182,
    "Alt": 800,
    "L": 6,
    "F": 4,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 2,
    "RH": "",
    "RS": 2,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pohlia cruda",
    "Concept": "Bry_468",
    "Taxon_name": "Pohlia cruda",
    "BRC_num": "0820   468",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "O",
    "Spbeg": 7,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 343,
    "IRno": 13,
    "CIno": "",
    "TJan": 1.8,
    "TJul": 12.8,
    "Prec": 1631,
    "Alt": 1180,
    "L": 5,
    "F": 6,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tortula modica",
    "Concept": "Bry_497",
    "Taxon_name": "Tortula modica",
    "BRC_num": "0820   497",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 11,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "X",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 10,
    "Spend": 1,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 27,
    "Sp2": 34,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "CI",
    "Elem": 76,
    "GBno": 339,
    "IRno": 11,
    "CIno": 5,
    "TJan": 3.9,
    "TJul": 15.8,
    "Prec": 827,
    "Alt": 290,
    "L": 8,
    "F": 5,
    "R": 6,
    "N": 6,
    "S": 2,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Weissia longifolia",
    "Concept": "Bry_640",
    "Taxon_name": "Weissia longifolia",
    "BRC_num": "0820   640",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "Ts",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 17,
    "Sp2": 23,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 73,
    "GBno": 338,
    "IRno": 5,
    "CIno": "",
    "TJan": 3.9,
    "TJul": 16.1,
    "Prec": 767,
    "Alt": 280,
    "L": 7,
    "F": 4,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Weissia controversa var. controversa",
    "Concept": "Bry_639.2",
    "Taxon_name": "Weissia controversa var. controversa",
    "BRC_num": "0820   639.2",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 66,
    "GBno": 337,
    "IRno": 7,
    "CIno": "",
    "TJan": 4.1,
    "TJul": 15.4,
    "Prec": 1059,
    "Alt": 550,
    "L": 7,
    "F": 4,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 3,
    "RH": "",
    "RS": "",
    "RW": 1,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 2,
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Calliergon giganteum",
    "Concept": "Bry_5",
    "Taxon_name": "Calliergon giganteum",
    "BRC_num": "0820     5",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 328,
    "IRno": 69,
    "CIno": "",
    "TJan": 3.2,
    "TJul": 14.1,
    "Prec": 1141,
    "Alt": 910,
    "L": 7,
    "F": 10,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Philonotis calcarea",
    "Concept": "Bry_437",
    "Taxon_name": "Philonotis calcarea",
    "BRC_num": "0820   437",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 325,
    "IRno": 58,
    "CIno": "",
    "TJan": 2.7,
    "TJul": 13.6,
    "Prec": 1294,
    "Alt": 640,
    "L": 8,
    "F": 9,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 1,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pterogonium gracile",
    "Concept": "Bry_508",
    "Taxon_name": "Pterogonium gracile",
    "BRC_num": "0820   508",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "De",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 1,
    "Spend": 2,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 30,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "CI",
    "Elem": 92,
    "GBno": 325,
    "IRno": 32,
    "CIno": 5,
    "TJan": 3.5,
    "TJul": 14,
    "Prec": 1510,
    "Alt": 700,
    "L": 7,
    "F": 4,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 1,
    "RW": 1,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": 1,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Riccardia palmata",
    "Concept": "Bry_900",
    "Taxon_name": "Riccardia palmata",
    "BRC_num": "0810   900",
    "ML": "L",
    "Ord": "Metzgeriales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D(M)",
    "Fr": "F",
    "Spbeg": 3,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 321,
    "IRno": 76,
    "CIno": "",
    "TJan": 2.8,
    "TJul": 12.9,
    "Prec": 1679,
    "Alt": 600,
    "L": 4,
    "F": 7,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 1,
    "PT": 3,
    "GS": "",
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Orthotrichum tenellum",
    "Concept": "Bry_430",
    "Taxon_name": "Orthotrichum tenellum",
    "BRC_num": "0820   430",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "O",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 6,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 92,
    "GBno": 319,
    "IRno": 26,
    "CIno": 5,
    "TJan": 4.2,
    "TJul": 15.3,
    "Prec": 1123,
    "Alt": 300,
    "L": 6,
    "F": 4,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Polytrichastrum longisetum",
    "Concept": "Bry_484",
    "Taxon_name": "Polytrichum longisetum",
    "BRC_num": "0820   484",
    "ML": "M",
    "Ord": "Polytrichales",
    "Stat": "N",
    "Len": 87,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": 6,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 26,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 319,
    "IRno": 28,
    "CIno": "",
    "TJan": 3.2,
    "TJul": 15,
    "Prec": 960,
    "Alt": 1030,
    "L": 5,
    "F": 6,
    "R": 3,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Orthotrichum striatum",
    "Concept": "Bry_429",
    "Taxon_name": "Orthotrichum striatum",
    "BRC_num": "0820   429",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 12,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 53,
    "GBno": 317,
    "IRno": 34,
    "CIno": 2,
    "TJan": 3.5,
    "TJul": 14.4,
    "Prec": 1343,
    "Alt": 450,
    "L": 6,
    "F": 4,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Encalypta vulgaris",
    "Concept": "Bry_234",
    "Taxon_name": "Encalypta vulgaris",
    "BRC_num": "0820   234",
    "ML": "M",
    "Ord": "Encalyptales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 30,
    "Sp2": 45,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 76,
    "GBno": 310,
    "IRno": 21,
    "CIno": "",
    "TJan": 3.2,
    "TJul": 14.9,
    "Prec": 921,
    "Alt": 730,
    "L": 7,
    "F": 4,
    "R": 8,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tortula marginata",
    "Concept": "Bry_613",
    "Taxon_name": "Tortula marginata",
    "BRC_num": "0820   613",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 3,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 8,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 91,
    "GBno": 308,
    "IRno": 9,
    "CIno": "",
    "TJan": 3.8,
    "TJul": 16.1,
    "Prec": 757,
    "Alt": 210,
    "L": 3,
    "F": 4,
    "R": 8,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Anoectangium aestivum",
    "Concept": "Bry_27",
    "Taxon_name": "Anoectangium aestivum",
    "BRC_num": "0820    27",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 73,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 305,
    "IRno": 33,
    "CIno": "",
    "TJan": 2.2,
    "TJul": 12.5,
    "Prec": 1922,
    "Alt": 1180,
    "L": 6,
    "F": 7,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Solenostoma hyalinum",
    "Concept": "Bry_876",
    "Taxon_name": "Jungermannia hyalina",
    "BRC_num": "0810   876",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 3,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 305,
    "IRno": 42,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.6,
    "Prec": 1533,
    "Alt": 400,
    "L": 5,
    "F": 8,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 1,
    "GS": "",
    "DW": "",
    "DV": 1,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Plagiochila spinulosa s.str.",
    "Concept": "Bry_874.1",
    "Taxon_name": "Plagiochila spinulosa",
    "BRC_num": "0810   874.1",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "We",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "O",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 80,
    "GBno": 305,
    "IRno": 50,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.2,
    "Prec": 1815,
    "Alt": 730,
    "L": 4,
    "F": 6,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum subnitens var. subnitens",
    "Concept": "Bry_568.1",
    "Taxon_name": "Sphagnum subnitens var. subnitens",
    "BRC_num": "0820   568.1",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 26,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 52,
    "GBno": 305,
    "IRno": 11,
    "CIno": "",
    "TJan": 3.3,
    "TJul": 14.1,
    "Prec": 1472,
    "Alt": 200,
    "L": 7,
    "F": 8,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Heterocladium heteropterum var. flaccidum",
    "Concept": "Bry_331.1",
    "Taxon_name": "Heterocladium heteropterum var. flaccidum",
    "BRC_num": "0820   331.1",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 72,
    "GBno": 300,
    "IRno": 34,
    "CIno": 1,
    "TJan": 3.7,
    "TJul": 14.5,
    "Prec": 1361,
    "Alt": 480,
    "L": 3,
    "F": 6,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 2,
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Frullania teneriffae",
    "Concept": "Bry_766",
    "Taxon_name": "Frullania teneriffae",
    "BRC_num": "0810   766",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Fa",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 80,
    "GBno": 299,
    "IRno": 131,
    "CIno": 2,
    "TJan": 3.8,
    "TJul": 13.4,
    "Prec": 1646,
    "Alt": 700,
    "L": 5,
    "F": 5,
    "R": 4,
    "N": 2,
    "S": 2,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Leptodontium flexifolium",
    "Concept": "Bry_368",
    "Taxon_name": "Leptodontium flexifolium",
    "BRC_num": "0820   368",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "R",
    "Bul": "",
    "Bra": "O",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 2,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 71,
    "GBno": 297,
    "IRno": 15,
    "CIno": "",
    "TJan": 2.7,
    "TJul": 13.7,
    "Prec": 1375,
    "Alt": 750,
    "L": 7,
    "F": 4,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Barbilophozia barbata",
    "Concept": "Bry_694",
    "Taxon_name": "Barbilophozia barbata",
    "BRC_num": "0810   694",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 296,
    "IRno": 4,
    "CIno": "",
    "TJan": 1.9,
    "TJul": 12.8,
    "Prec": 1637,
    "Alt": 1150,
    "L": 5,
    "F": 5,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 2,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 1,
    "DV": 2,
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Bryum archangelicum",
    "Concept": "Bry_1765",
    "Taxon_name": "Bryum imbricatum",
    "BRC_num": "0820    99",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 5,
    "Spend": 8,
    "Spbeg2": 11,
    "Spend2": 11,
    "Sp1": 16,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 296,
    "IRno": 30,
    "CIno": 2,
    "TJan": 3.5,
    "TJul": 14.4,
    "Prec": 1155,
    "Alt": 730,
    "L": 8,
    "F": 5,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 2,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pleurozia purpurea",
    "Concept": "Bry_881",
    "Taxon_name": "Pleurozia purpurea",
    "BRC_num": "0810   881",
    "ML": "L",
    "Ord": "Pleuroziales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 41,
    "GBno": 295,
    "IRno": 137,
    "CIno": "",
    "TJan": 3,
    "TJul": 12.7,
    "Prec": 1738,
    "Alt": 915,
    "L": 7,
    "F": 7,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Reboulia hemisphaerica",
    "Concept": "Bry_896",
    "Taxon_name": "Reboulia hemisphaerica",
    "BRC_num": "0810   896",
    "ML": "L",
    "Ord": "Marchantiales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 3,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 56,
    "Sp2": 86,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 86,
    "GBno": 295,
    "IRno": 15,
    "CIno": 5,
    "TJan": 3.5,
    "TJul": 14.5,
    "Prec": 1259,
    "Alt": 590,
    "L": 6,
    "F": 4,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 2,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Didymodon nicholsonii",
    "Concept": "Bry_53",
    "Taxon_name": "Didymodon nicholsonii",
    "BRC_num": "0820    53",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "X",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 72,
    "GBno": 294,
    "IRno": 13,
    "CIno": "",
    "TJan": 4.2,
    "TJul": 15.6,
    "Prec": 993,
    "Alt": 370,
    "L": 6,
    "F": 5,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": 3,
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Plagiochila punctata",
    "Concept": "Bry_873",
    "Taxon_name": "Plagiochila punctata",
    "BRC_num": "0810   873",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "We",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "F",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 80,
    "GBno": 293,
    "IRno": 86,
    "CIno": "",
    "TJan": 3.3,
    "TJul": 13.2,
    "Prec": 1841,
    "Alt": 650,
    "L": 3,
    "F": 6,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 1,
    "SO": 1,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Porella arboris-vitae",
    "Concept": "Bry_883",
    "Taxon_name": "Porella arboris-vitae",
    "BRC_num": "0810   883",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Fa",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 92,
    "GBno": 293,
    "IRno": 30,
    "CIno": 1,
    "TJan": 3.1,
    "TJul": 13.9,
    "Prec": 1545,
    "Alt": 670,
    "L": 6,
    "F": 5,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Syntrichia papillosa",
    "Concept": "Bry_616",
    "Taxon_name": "Syntrichia papillosa",
    "BRC_num": "0820   616",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 291,
    "IRno": 25,
    "CIno": 3,
    "TJan": 3.8,
    "TJul": 15.3,
    "Prec": 914,
    "Alt": 180,
    "L": 6,
    "F": 4,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum teres",
    "Concept": "Bry_580",
    "Taxon_name": "Sphagnum teres",
    "BRC_num": "0820   580",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 26,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 288,
    "IRno": 13,
    "CIno": "",
    "TJan": 2.3,
    "TJul": 13.1,
    "Prec": 1542,
    "Alt": 1050,
    "L": 7,
    "F": 9,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 2,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum caespiticium",
    "Concept": "Bry_91.2",
    "Taxon_name": "Bryum caespiticium",
    "BRC_num": "0820    91.2",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "U",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": 6,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 287,
    "IRno": 4,
    "CIno": "",
    "TJan": 3.5,
    "TJul": 15.6,
    "Prec": 838,
    "Alt": 110,
    "L": 7,
    "F": 4,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tritomaria exsectiformis",
    "Concept": "Bry_958",
    "Taxon_name": "Tritomaria exsectiformis",
    "BRC_num": "0810   958",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 285,
    "IRno": 57,
    "CIno": "",
    "TJan": 2.8,
    "TJul": 13.4,
    "Prec": 1499,
    "Alt": 640,
    "L": 5,
    "F": 5,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Zygodon viridissimus var. stirtonii",
    "Concept": "Bry_653.1",
    "Taxon_name": "Zygodon viridissimus var. stirtonii",
    "BRC_num": "0820   653.1",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 4,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 72,
    "GBno": 285,
    "IRno": 33,
    "CIno": 1,
    "TJan": 4,
    "TJul": 14.7,
    "Prec": 1095,
    "Alt": 560,
    "L": 6,
    "F": 4,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Bazzania tricrenata",
    "Concept": "Bry_701",
    "Taxon_name": "Bazzania tricrenata",
    "BRC_num": "0810   701",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 90,
    "Per": "P",
    "LF1": "We",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 283,
    "IRno": 56,
    "CIno": "",
    "TJan": 2.4,
    "TJul": 12.5,
    "Prec": 1986,
    "Alt": 1220,
    "L": 5,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Nardia compressa",
    "Concept": "Bry_856",
    "Taxon_name": "Nardia compressa",
    "BRC_num": "0810   856",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "At",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 3,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 13,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 42,
    "GBno": 283,
    "IRno": 43,
    "CIno": "",
    "TJan": 2.5,
    "TJul": 13.1,
    "Prec": 1680,
    "Alt": 1150,
    "L": 7,
    "F": 10,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Racomitrium ericoides",
    "Concept": "Bry_1051",
    "Taxon_name": "Racomitrium ericoides",
    "BRC_num": "0820  1051",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 32,
    "GBno": 283,
    "IRno": 33,
    "CIno": "",
    "TJan": 2.9,
    "TJul": 13.5,
    "Prec": 1572,
    "Alt": 1340,
    "L": 7,
    "F": 5,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 2,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fissidens pusillus",
    "Concept": "Bry_267.1",
    "Taxon_name": "Fissidens pusillus",
    "BRC_num": "0820   267.1",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 6,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "A",
    "Spbeg": 7,
    "Spend": 1,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 19,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 83,
    "GBno": 282,
    "IRno": 29,
    "CIno": "",
    "TJan": 3.6,
    "TJul": 14.9,
    "Prec": 1102,
    "Alt": 920,
    "L": 4,
    "F": 6,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 2,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Zygodon rupestris",
    "Concept": "Bry_653.3",
    "Taxon_name": "Zygodon rupestris",
    "BRC_num": "0820   653.3",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 86,
    "GBno": 282,
    "IRno": 13,
    "CIno": "",
    "TJan": 3.4,
    "TJul": 14.6,
    "Prec": 1324,
    "Alt": 500,
    "L": 6,
    "F": 4,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Solenostoma obovatum",
    "Concept": "Bry_877",
    "Taxon_name": "Jungermannia obovata",
    "BRC_num": "0810   877",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 4,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 26,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 280,
    "IRno": 38,
    "CIno": "",
    "TJan": 2.2,
    "TJul": 12.9,
    "Prec": 1662,
    "Alt": 1100,
    "L": 5,
    "F": 9,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum russowii",
    "Concept": "Bry_574",
    "Taxon_name": "Sphagnum russowii",
    "BRC_num": "0820   574",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 27,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 279,
    "IRno": 14,
    "CIno": "",
    "TJan": 2,
    "TJul": 13.1,
    "Prec": 1473,
    "Alt": 1200,
    "L": 6,
    "F": 7,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 2,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tortella flavovirens",
    "Concept": "Bry_602",
    "Taxon_name": "Tortella flavovirens",
    "BRC_num": "0820   602",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 92,
    "GBno": 279,
    "IRno": 44,
    "CIno": 10,
    "TJan": 4.7,
    "TJul": 14.8,
    "Prec": 1089,
    "Alt": 130,
    "L": 9,
    "F": 5,
    "R": 7,
    "N": 4,
    "S": 4,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 2,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": 1,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Anastrepta orcadensis",
    "Concept": "Bry_683",
    "Taxon_name": "Anastrepta orcadensis",
    "BRC_num": "0810   683",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 42,
    "GBno": 277,
    "IRno": 24,
    "CIno": "",
    "TJan": 2.1,
    "TJul": 12.3,
    "Prec": 2036,
    "Alt": 1170,
    "L": 5,
    "F": 5,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Entosthodon attenuatus",
    "Concept": "Bry_282",
    "Taxon_name": "Entosthodon attenuatus",
    "BRC_num": "0820   282",
    "ML": "M",
    "Ord": "Funariales",
    "Stat": "N",
    "Len": 5,
    "Per": "AP",
    "LF1": "Ts",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 91,
    "GBno": 276,
    "IRno": 78,
    "CIno": 2,
    "TJan": 3.7,
    "TJul": 13.4,
    "Prec": 1613,
    "Alt": 700,
    "L": 7,
    "F": 7,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Microbryum rectum",
    "Concept": "Bry_499",
    "Taxon_name": "Microbryum rectum",
    "BRC_num": "0820   499",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 0.9,
    "Per": "A",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 10,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 23,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "(CI)",
    "Elem": 91,
    "GBno": 276,
    "IRno": 15,
    "CIno": "",
    "TJan": 4.2,
    "TJul": 15.9,
    "Prec": 851,
    "Alt": 290,
    "L": 8,
    "F": 3,
    "R": 7,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fossombronia pusilla",
    "Concept": "Bry_762.2",
    "Taxon_name": "Fossombronia pusilla",
    "BRC_num": "0810   762.2",
    "ML": "L",
    "Ord": "Fossombroniales",
    "Stat": "N",
    "Len": 15,
    "Per": "AP",
    "LF1": "Sc",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 38,
    "Sp2": 56,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "(CI)",
    "Elem": 92,
    "GBno": 275,
    "IRno": 20,
    "CIno": "",
    "TJan": 4.1,
    "TJul": 15.3,
    "Prec": 993,
    "Alt": 460,
    "L": 6,
    "F": 7,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 2,
    "RW": "",
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Scapania scandica",
    "Concept": "Bry_935",
    "Taxon_name": "Scapania scandica",
    "BRC_num": "0810   935",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 8,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 6,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 275,
    "IRno": 18,
    "CIno": "",
    "TJan": 2.1,
    "TJul": 12.9,
    "Prec": 1606,
    "Alt": 1220,
    "L": 6,
    "F": 6,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 2,
    "DW": 2,
    "DV": 2,
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Jungermannia exsertifolia",
    "Concept": "Bry_942",
    "Taxon_name": "Jungermannia exsertifolia",
    "BRC_num": "0810   942",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "At",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 5,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 19,
    "Sp2": 26,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 273,
    "IRno": 15,
    "CIno": "",
    "TJan": 1.9,
    "TJul": 12.6,
    "Prec": 1776,
    "Alt": 1100,
    "L": 7,
    "F": 9,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Odontoschisma denudatum",
    "Concept": "Bry_860",
    "Taxon_name": "Odontoschisma denudatum",
    "BRC_num": "0810   860",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 5,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 273,
    "IRno": 99,
    "CIno": "",
    "TJan": 3.3,
    "TJul": 13.8,
    "Prec": 1444,
    "Alt": 490,
    "L": 7,
    "F": 6,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Dicranodontium denudatum",
    "Concept": "Bry_191",
    "Taxon_name": "Dicranodontium denudatum",
    "BRC_num": "0820   191",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "F",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 272,
    "IRno": 40,
    "CIno": "",
    "TJan": 2.4,
    "TJul": 13,
    "Prec": 1862,
    "Alt": 950,
    "L": 4,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 2,
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hennediella heimii",
    "Concept": "Bry_496",
    "Taxon_name": "Hennediella heimii",
    "BRC_num": "0820   496",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 4,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 29,
    "Sp2": 34,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 272,
    "IRno": 17,
    "CIno": 4,
    "TJan": 4.4,
    "TJul": 15,
    "Prec": 969,
    "Alt": 30,
    "L": 9,
    "F": 7,
    "R": 7,
    "N": 6,
    "S": 5,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Taxiphyllum wissgrillii",
    "Concept": "Bry_356",
    "Taxon_name": "Taxiphyllum wissgrillii",
    "BRC_num": "0820   356",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 266,
    "IRno": 15,
    "CIno": "",
    "TJan": 3.5,
    "TJul": 15.2,
    "Prec": 1011,
    "Alt": 380,
    "L": 2,
    "F": 5,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Riccardia latifrons",
    "Concept": "Bry_898",
    "Taxon_name": "Riccardia latifrons",
    "BRC_num": "0810   898",
    "ML": "L",
    "Ord": "Metzgeriales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "",
    "Tub": "",
    "Gem": "R",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 3,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 265,
    "IRno": 100,
    "CIno": 1,
    "TJan": 3.5,
    "TJul": 13.6,
    "Prec": 1419,
    "Alt": 880,
    "L": 7,
    "F": 8,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 1,
    "SO": 1,
    "PT": 3,
    "GS": 1,
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Isopterygiopsis pulchella",
    "Concept": "Bry_359",
    "Taxon_name": "Isopterygiopsis pulchella",
    "BRC_num": "0820   359",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 12.5,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "Thread",
    "Tub": "",
    "Gem": "O",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 263,
    "IRno": 23,
    "CIno": "",
    "TJan": 2.1,
    "TJul": 12.7,
    "Prec": 1809,
    "Alt": 1170,
    "L": 3,
    "F": 6,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": 3,
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Distichium capillaceum",
    "Concept": "Bry_213",
    "Taxon_name": "Distichium capillaceum",
    "BRC_num": "0820   213",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 63,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 8,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 17,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 261,
    "IRno": 22,
    "CIno": "",
    "TJan": 2.1,
    "TJul": 12.7,
    "Prec": 1673,
    "Alt": 1205,
    "L": 6,
    "F": 6,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 2,
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Splachnum sphaericum",
    "Concept": "Bry_583",
    "Taxon_name": "Splachnum sphaericum",
    "BRC_num": "0820   583",
    "ML": "M",
    "Ord": "Splachnales",
    "Stat": "N",
    "Len": 20,
    "Per": "A",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 260,
    "IRno": 47,
    "CIno": "",
    "TJan": 2,
    "TJul": 12.5,
    "Prec": 1725,
    "Alt": 1220,
    "L": 8,
    "F": 8,
    "R": 2,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": 3,
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum algovicum",
    "Concept": "Bry_112",
    "Taxon_name": "Bryum algovicum",
    "BRC_num": "0820   112",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 5,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 22,
    "Sp2": 36,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 255,
    "IRno": 25,
    "CIno": 1,
    "TJan": 3.9,
    "TJul": 14.8,
    "Prec": 992,
    "Alt": 460,
    "L": 9,
    "F": 6,
    "R": 7,
    "N": 4,
    "S": 1,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Andreaea rothii",
    "Concept": "Bry_1067",
    "Taxon_name": "Andreaea rothii",
    "BRC_num": "0820  1067",
    "ML": "M",
    "Ord": "Andreaeales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 36,
    "Sp2": 52,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 254,
    "IRno": 40,
    "CIno": "",
    "TJan": 2.7,
    "TJul": 13.2,
    "Prec": 1731,
    "Alt": 1344,
    "L": 8,
    "F": 4,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ptilium crista-castrensis",
    "Concept": "Bry_512",
    "Taxon_name": "Ptilium crista-castrensis",
    "BRC_num": "0820   512",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 13,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 254,
    "IRno": 1,
    "CIno": "",
    "TJan": 1.6,
    "TJul": 12.3,
    "Prec": 1957,
    "Alt": 915,
    "L": 5,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Oxyrrhynchium speciosum",
    "Concept": "Bry_254",
    "Taxon_name": "Eurhynchium speciosum",
    "BRC_num": "0820   254",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 130,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 12,
    "Spend": 2,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 253,
    "IRno": 11,
    "CIno": 2,
    "TJan": 4.1,
    "TJul": 15.8,
    "Prec": 850,
    "Alt": 200,
    "L": 5,
    "F": 8,
    "R": 7,
    "N": 7,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 1,
    "DW": "",
    "DV": 2,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Cololejeunea calcarea",
    "Concept": "Bry_741",
    "Taxon_name": "Cololejeunea calcarea",
    "BRC_num": "0810   741",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 4,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 52,
    "GBno": 250,
    "IRno": 31,
    "CIno": "",
    "TJan": 2.2,
    "TJul": 12.8,
    "Prec": 1767,
    "Alt": 825,
    "L": 3,
    "F": 6,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": 3,
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Plagiomnium ellipticum",
    "Concept": "Bry_391",
    "Taxon_name": "Plagiomnium ellipticum",
    "BRC_num": "0820   391",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 90,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 40,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 250,
    "IRno": 26,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.9,
    "Prec": 1262,
    "Alt": 700,
    "L": 7,
    "F": 8,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Epipterygium tozeri",
    "Concept": "Bry_242",
    "Taxon_name": "Epipterygium tozeri",
    "BRC_num": "0820   242",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "Tf",
    "Tub": "O",
    "Gem": "",
    "Bul": "F",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 4,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 91,
    "GBno": 249,
    "IRno": 11,
    "CIno": 5,
    "TJan": 4.9,
    "TJul": 15.5,
    "Prec": 1091,
    "Alt": 150,
    "L": 5,
    "F": 6,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 2,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Campylopus brevipilus",
    "Concept": "Bry_138",
    "Taxon_name": "Campylopus brevipilus",
    "BRC_num": "0820   138",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "F",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 13,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 71,
    "GBno": 248,
    "IRno": 57,
    "CIno": 2,
    "TJan": 4.2,
    "TJul": 13.9,
    "Prec": 1290,
    "Alt": 550,
    "L": 8,
    "F": 8,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Leiocolea bantriensis",
    "Concept": "Bry_791",
    "Taxon_name": "Leiocolea bantriensis",
    "BRC_num": "0810   791",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 6,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 248,
    "IRno": 26,
    "CIno": "",
    "TJan": 2.1,
    "TJul": 12.7,
    "Prec": 1686,
    "Alt": 900,
    "L": 7,
    "F": 8,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum sauteri",
    "Concept": "Bry_668",
    "Taxon_name": "Bryum sauteri",
    "BRC_num": "0820   668",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 4,
    "Per": "AP",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D(M)",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "CI",
    "Elem": 73,
    "GBno": 245,
    "IRno": 18,
    "CIno": 3,
    "TJan": 4.3,
    "TJul": 14.9,
    "Prec": 1119,
    "Alt": 525,
    "L": 6,
    "F": 5,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Lophozia sudetica",
    "Concept": "Bry_815",
    "Taxon_name": "Lophozia sudetica",
    "BRC_num": "0810   815",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "We",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 9,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 243,
    "IRno": 16,
    "CIno": "",
    "TJan": 1.8,
    "TJul": 12.7,
    "Prec": 1745,
    "Alt": 1340,
    "L": 6,
    "F": 5,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": 2,
    "RW": "",
    "SR": 3,
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fissidens celticus",
    "Concept": "Bry_1000",
    "Taxon_name": "Fissidens celticus",
    "BRC_num": "0820  1000",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 4.6,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "Tf",
    "Tub": "U",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 71,
    "GBno": 240,
    "IRno": 17,
    "CIno": "",
    "TJan": 4,
    "TJul": 14.6,
    "Prec": 1469,
    "Alt": 335,
    "L": 3,
    "F": 6,
    "R": 3,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ptilidium pulcherrimum",
    "Concept": "Bry_889",
    "Taxon_name": "Ptilidium pulcherrimum",
    "BRC_num": "0810   889",
    "ML": "L",
    "Ord": "Lepicoleales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 4,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 34,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 235,
    "IRno": 1,
    "CIno": "",
    "TJan": 2.8,
    "TJul": 14.7,
    "Prec": 1036,
    "Alt": 600,
    "L": 6,
    "F": 4,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Brachythecium mildeanum",
    "Concept": "Bry_76",
    "Taxon_name": "Brachythecium mildeanum",
    "BRC_num": "0820    76",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": 2,
    "Spend": 2,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "CI",
    "Elem": 76,
    "GBno": 234,
    "IRno": 14,
    "CIno": 1,
    "TJan": 4.2,
    "TJul": 15.5,
    "Prec": 923,
    "Alt": 370,
    "L": 8,
    "F": 6,
    "R": 6,
    "N": 4,
    "S": 1,
    "HM": 1,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Leiocolea collaris",
    "Concept": "Bry_794",
    "Taxon_name": "Leiocolea alpestris",
    "BRC_num": "0810   794",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 5,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 234,
    "IRno": 24,
    "CIno": "",
    "TJan": 2.3,
    "TJul": 12.9,
    "Prec": 1642,
    "Alt": 1175,
    "L": 6,
    "F": 8,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 1,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 1,
    "DW": "",
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Rhynchostegiella teneriffae",
    "Concept": "Bry_530",
    "Taxon_name": "Rhynchostegiella teneriffae",
    "BRC_num": "0820   530",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 10,
    "Spend": 10,
    "Spbeg2": 4,
    "Spend2": 4,
    "Sp1": 13,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 92,
    "GBno": 233,
    "IRno": 20,
    "CIno": 5,
    "TJan": 3.4,
    "TJul": 14.9,
    "Prec": 1086,
    "Alt": 390,
    "L": 2,
    "F": 9,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Hymenostylium recurvirostrum",
    "Concept": "Bry_323",
    "Taxon_name": "Hymenostylium recurvirostrum",
    "BRC_num": "0820   323",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 232,
    "IRno": 24,
    "CIno": "",
    "TJan": 2.5,
    "TJul": 13,
    "Prec": 1656,
    "Alt": 1070,
    "L": 6,
    "F": 8,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 2,
    "RH": 3,
    "RS": 3,
    "RW": 2,
    "SR": 2,
    "SO": 2,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pogonatum nanum",
    "Concept": "Bry_486",
    "Taxon_name": "Pogonatum nanum",
    "BRC_num": "0820   486",
    "ML": "M",
    "Ord": "Polytrichales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Tp",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 17,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 231,
    "IRno": 13,
    "CIno": 3,
    "TJan": 3.5,
    "TJul": 14.5,
    "Prec": 1234,
    "Alt": 750,
    "L": 5,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Antitrichia curtipendula",
    "Concept": "Bry_34",
    "Taxon_name": "Antitrichia curtipendula",
    "BRC_num": "0820    34",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 34,
    "Sp2": 36,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 230,
    "IRno": 9,
    "CIno": "",
    "TJan": 2,
    "TJul": 12.5,
    "Prec": 1764,
    "Alt": 900,
    "L": 6,
    "F": 4,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 1,
    "PT": "",
    "GS": 1,
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Hypnum callichroum",
    "Concept": "Bry_350",
    "Taxon_name": "Hypnum callichroum",
    "BRC_num": "0820   350",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 5,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 229,
    "IRno": 19,
    "CIno": "",
    "TJan": 2.2,
    "TJul": 12.4,
    "Prec": 2045,
    "Alt": 1225,
    "L": 5,
    "F": 6,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tortula lanceola",
    "Concept": "Bry_498",
    "Taxon_name": "Tortula lanceola",
    "BRC_num": "0820   498",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "X",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 21,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 86,
    "GBno": 229,
    "IRno": 4,
    "CIno": "",
    "TJan": 3.7,
    "TJul": 15.7,
    "Prec": 774,
    "Alt": 550,
    "L": 8,
    "F": 3,
    "R": 8,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Aphanorrhegma patens",
    "Concept": "Bry_442",
    "Taxon_name": "Aphanorhegma patens",
    "BRC_num": "0820   442",
    "ML": "M",
    "Ord": "Funariales",
    "Stat": "N",
    "Len": 2.5,
    "Per": "A",
    "LF1": "Ts",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 7,
    "Spend": 11,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 26,
    "Sp2": 32,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 74,
    "GBno": 228,
    "IRno": 22,
    "CIno": "",
    "TJan": 3.9,
    "TJul": 15.7,
    "Prec": 830,
    "Alt": 230,
    "L": 7,
    "F": 8,
    "R": 7,
    "N": 7,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cynodontium bruntonii",
    "Concept": "Bry_169",
    "Taxon_name": "Cynodontium bruntonii",
    "BRC_num": "0820   169",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "U",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 19,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 228,
    "IRno": 11,
    "CIno": 1,
    "TJan": 2.9,
    "TJul": 13.9,
    "Prec": 1381,
    "Alt": 700,
    "L": 5,
    "F": 5,
    "R": 3,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Scapania subalpina",
    "Concept": "Bry_936",
    "Taxon_name": "Scapania subalpina",
    "BRC_num": "0810   936",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 4,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 228,
    "IRno": 15,
    "CIno": "",
    "TJan": 1.8,
    "TJul": 12.5,
    "Prec": 1697,
    "Alt": 1180,
    "L": 7,
    "F": 8,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Entodon concinnus",
    "Concept": "Bry_235",
    "Taxon_name": "Entodon concinnus",
    "BRC_num": "0820   235",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 226,
    "IRno": 40,
    "CIno": "",
    "TJan": 3.4,
    "TJul": 14.5,
    "Prec": 1120,
    "Alt": 1175,
    "L": 8,
    "F": 4,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fissidens bryoides var. caespitans",
    "Concept": "Bry_263",
    "Taxon_name": "Fissidens curnovii",
    "BRC_num": "0820   263",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 11,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "(CI)",
    "Elem": 81,
    "GBno": 226,
    "IRno": 23,
    "CIno": "",
    "TJan": 4.2,
    "TJul": 14.4,
    "Prec": 1490,
    "Alt": 250,
    "L": 4,
    "F": 7,
    "R": 4,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Hylocomiastrum umbratum",
    "Concept": "Bry_347",
    "Taxon_name": "Hylocomium umbratum",
    "BRC_num": "0820   347",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 226,
    "IRno": 28,
    "CIno": "",
    "TJan": 2.2,
    "TJul": 12.4,
    "Prec": 2080,
    "Alt": 1170,
    "L": 4,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Thuidium assimile",
    "Concept": "Bry_597",
    "Taxon_name": "Thuidium philibertii",
    "BRC_num": "0820   597",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 76,
    "GBno": 226,
    "IRno": 29,
    "CIno": "",
    "TJan": 3.4,
    "TJul": 14.5,
    "Prec": 1090,
    "Alt": 900,
    "L": 7,
    "F": 4,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Myriocoleopsis minutissima",
    "Concept": "Bry_742",
    "Taxon_name": "Myriocoleopsis minutissima",
    "BRC_num": "0810   742",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 4,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 17,
    "Sp2": 17,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 80,
    "GBno": 225,
    "IRno": 66,
    "CIno": 7,
    "TJan": 4.8,
    "TJul": 15.3,
    "Prec": 1107,
    "Alt": 245,
    "L": 6,
    "F": 4,
    "R": 6,
    "N": 4,
    "S": 2,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": 2,
    "SR": 2,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Pohlia camptotrachela",
    "Concept": "Bry_1012",
    "Taxon_name": "Pohlia camptotrachela",
    "BRC_num": "0820  1012",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 20,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "Ts",
    "Tub": "",
    "Gem": "",
    "Bul": "F",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 42,
    "GBno": 225,
    "IRno": 21,
    "CIno": "",
    "TJan": 3.2,
    "TJul": 13.9,
    "Prec": 1394,
    "Alt": 390,
    "L": 7,
    "F": 7,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Rhizomnium pseudopunctatum",
    "Concept": "Bry_388",
    "Taxon_name": "Rhizomnium pseudopunctatum",
    "BRC_num": "0820   388",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 93,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 6,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 30,
    "Sp2": 50,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 225,
    "IRno": 16,
    "CIno": "",
    "TJan": 2.5,
    "TJul": 13.5,
    "Prec": 1438,
    "Alt": 970,
    "L": 7,
    "F": 9,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hygroamblystegium varium",
    "Concept": "Bry_20",
    "Taxon_name": "Amblystegium varium",
    "BRC_num": "0820    20",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 76,
    "GBno": 224,
    "IRno": 20,
    "CIno": 1,
    "TJan": 3.7,
    "TJul": 15.7,
    "Prec": 846,
    "Alt": 380,
    "L": 5,
    "F": 9,
    "R": 7,
    "N": 7,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": 2,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Fissidens gracilifolius",
    "Concept": "Bry_267.2",
    "Taxon_name": "Fissidens gracilifolius",
    "BRC_num": "0820   267.2",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 2.5,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 83,
    "GBno": 223,
    "IRno": 12,
    "CIno": "",
    "TJan": 3.5,
    "TJul": 15.7,
    "Prec": 844,
    "Alt": 460,
    "L": 1,
    "F": 5,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 2,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Marchantia polymorpha subsp. ruderalis",
    "Concept": "Bry_827.6",
    "Taxon_name": "Marchantia polymorpha subsp. ruderalis",
    "BRC_num": "0810   827.6",
    "ML": "L",
    "Ord": "Marchantiales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 223,
    "IRno": 9,
    "CIno": "",
    "TJan": 3.6,
    "TJul": 15.4,
    "Prec": 849,
    "Alt": 500,
    "L": 6,
    "F": 7,
    "R": 6,
    "N": 7,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Seligeria recurvata",
    "Concept": "Bry_548",
    "Taxon_name": "Seligeria recurvata",
    "BRC_num": "0820   548",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 3,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 223,
    "IRno": 16,
    "CIno": "",
    "TJan": 2.5,
    "TJul": 13.6,
    "Prec": 1412,
    "Alt": 700,
    "L": 3,
    "F": 6,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 1,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum contortum",
    "Concept": "Bry_555",
    "Taxon_name": "Sphagnum contortum",
    "BRC_num": "0820   555",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 27,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 223,
    "IRno": 26,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.4,
    "Prec": 1601,
    "Alt": 800,
    "L": 8,
    "F": 9,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 2,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Orthotrichum rivulare",
    "Concept": "Bry_422",
    "Taxon_name": "Orthotrichum rivulare",
    "BRC_num": "0820   422",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 5,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 72,
    "GBno": 222,
    "IRno": 16,
    "CIno": "",
    "TJan": 3.2,
    "TJul": 14.4,
    "Prec": 1099,
    "Alt": 400,
    "L": 6,
    "F": 6,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Rhynchostegium megapolitanum",
    "Concept": "Bry_246",
    "Taxon_name": "Rhynchostegium megapolitanum",
    "BRC_num": "0820   246",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 11,
    "Spend": 2,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 92,
    "GBno": 222,
    "IRno": 6,
    "CIno": 6,
    "TJan": 4.5,
    "TJul": 16.1,
    "Prec": 812,
    "Alt": 150,
    "L": 7,
    "F": 4,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Dicranella cerviculata",
    "Concept": "Bry_181",
    "Taxon_name": "Dicranella cerviculata",
    "BRC_num": "0820   181",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 2,
    "Spbeg2": 8,
    "Spend2": 8,
    "Sp1": 16,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 220,
    "IRno": 17,
    "CIno": "",
    "TJan": 3.2,
    "TJul": 14.8,
    "Prec": 1013,
    "Alt": 380,
    "L": 7,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Anastrophyllum minutum",
    "Concept": "Bry_952",
    "Taxon_name": "Anastrophyllum minutum",
    "BRC_num": "0810   952",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 35,
    "Per": "P",
    "LF1": "We",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 6,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 219,
    "IRno": 30,
    "CIno": "",
    "TJan": 2,
    "TJul": 12.5,
    "Prec": 1738,
    "Alt": 1070,
    "L": 4,
    "F": 7,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Orthothecium intricatum",
    "Concept": "Bry_412",
    "Taxon_name": "Orthothecium intricatum",
    "BRC_num": "0820   412",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 28,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 23,
    "GBno": 218,
    "IRno": 26,
    "CIno": "",
    "TJan": 2,
    "TJul": 12.9,
    "Prec": 1733,
    "Alt": 1175,
    "L": 3,
    "F": 6,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Plagiobryum zieri",
    "Concept": "Bry_446",
    "Taxon_name": "Plagiobryum zieri",
    "BRC_num": "0820   446",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 34,
    "Sp2": 40,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 218,
    "IRno": 14,
    "CIno": "",
    "TJan": 1.7,
    "TJul": 12.5,
    "Prec": 1855,
    "Alt": 1205,
    "L": 6,
    "F": 6,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Porella cordaeana",
    "Concept": "Bry_882",
    "Taxon_name": "Porella cordaeana",
    "BRC_num": "0810   882",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Fa",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 9,
    "Spend": 11,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 30,
    "Sp2": 49,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 218,
    "IRno": 15,
    "CIno": "",
    "TJan": 2.4,
    "TJul": 13.6,
    "Prec": 1236,
    "Alt": 1000,
    "L": 5,
    "F": 6,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 1,
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Rhodobryum roseum",
    "Concept": "Bry_527",
    "Taxon_name": "Rhodobryum roseum",
    "BRC_num": "0820   527",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 35,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Ts",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 2,
    "Spend": 2,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 217,
    "IRno": 16,
    "CIno": "",
    "TJan": 3.2,
    "TJul": 14.5,
    "Prec": 1123,
    "Alt": 820,
    "L": 6,
    "F": 5,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Kurzia trichoclados",
    "Concept": "Bry_810",
    "Taxon_name": "Kurzia trichoclados",
    "BRC_num": "0810   810",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "We",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "F",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 11,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 42,
    "GBno": 216,
    "IRno": 67,
    "CIno": "",
    "TJan": 2.6,
    "TJul": 12.7,
    "Prec": 1683,
    "Alt": 1000,
    "L": 4,
    "F": 7,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 2,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Riccia fluitans",
    "Concept": "Bry_909",
    "Taxon_name": "Riccia fluitans",
    "BRC_num": "0810   909",
    "ML": "L",
    "Ord": "Ricciales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Le",
    "LF2": "St",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 8,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 56,
    "Sp2": 75,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 86,
    "GBno": 215,
    "IRno": 13,
    "CIno": "",
    "TJan": 3.8,
    "TJul": 16,
    "Prec": 757,
    "Alt": 214,
    "L": 7,
    "F": 10,
    "R": 7,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": 3
  },
  {
    "Name_new": "Grimmia donniana",
    "Concept": "Bry_298",
    "Taxon_name": "Grimmia donniana",
    "BRC_num": "0820   298",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 4,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 23,
    "GBno": 214,
    "IRno": 15,
    "CIno": "",
    "TJan": 2.2,
    "TJul": 13.1,
    "Prec": 1567,
    "Alt": 1020,
    "L": 7,
    "F": 1,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Solenostoma paroicum",
    "Concept": "Bry_878",
    "Taxon_name": "Jungermannia paroica",
    "BRC_num": "0810   878",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M(D)",
    "Fr": "F",
    "Spbeg": 3,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 71,
    "GBno": 214,
    "IRno": 17,
    "CIno": "",
    "TJan": 2.2,
    "TJul": 12.8,
    "Prec": 1698,
    "Alt": 750,
    "L": 5,
    "F": 8,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Dicranum montanum",
    "Concept": "Bry_204",
    "Taxon_name": "Dicranum montanum",
    "BRC_num": "0820   204",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "O",
    "Lvs": "F",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 56,
    "GBno": 210,
    "IRno": "",
    "CIno": "",
    "TJan": 3.3,
    "TJul": 15.7,
    "Prec": 826,
    "Alt": 300,
    "L": 5,
    "F": 4,
    "R": 3,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 1,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Solenostoma sphaerocarpum",
    "Concept": "Bry_946",
    "Taxon_name": "Jungermannia sphaerocarpa",
    "BRC_num": "0810   946",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 3,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 26,
    "GBno": 209,
    "IRno": 20,
    "CIno": 1,
    "TJan": 2.4,
    "TJul": 13.4,
    "Prec": 1510,
    "Alt": 1000,
    "L": 7,
    "F": 8,
    "R": 3,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 1,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Andreaea rupestris",
    "Concept": "Bry_1068",
    "Taxon_name": "Andreaea rupestris",
    "BRC_num": "0820  1068",
    "ML": "M",
    "Ord": "Andreaeales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 26,
    "Sp2": 32,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 208,
    "IRno": 16,
    "CIno": "",
    "TJan": 2,
    "TJul": 12.6,
    "Prec": 1817,
    "Alt": 1330,
    "L": 7,
    "F": 3,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 1,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Plagiochila bifaria",
    "Concept": "Bry_874.2",
    "Taxon_name": "Plagiochila bifaria",
    "BRC_num": "0810   874.2",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 80,
    "GBno": 207,
    "IRno": 43,
    "CIno": 2,
    "TJan": 3.8,
    "TJul": 13.6,
    "Prec": 1727,
    "Alt": 430,
    "L": 5,
    "F": 6,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Didymodon spadiceus",
    "Concept": "Bry_59",
    "Taxon_name": "Didymodon spadiceus",
    "BRC_num": "0820    59",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 12,
    "Spend": 1,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 206,
    "IRno": 18,
    "CIno": "",
    "TJan": 2.5,
    "TJul": 13.6,
    "Prec": 1209,
    "Alt": 580,
    "L": 6,
    "F": 7,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum imbricatum",
    "Concept": "Bry_560",
    "Taxon_name": "Sphagnum imbricatum",
    "BRC_num": "0820   560",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 42,
    "GBno": 204,
    "IRno": 81,
    "CIno": "",
    "TJan": 2.8,
    "TJul": 12.9,
    "Prec": 1524,
    "Alt": 700,
    "L": 8,
    "F": 9,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Weissia brachycarpa var. obliqua",
    "Concept": "Bry_642.2",
    "Taxon_name": "Weissia brachycarpa var. obliqua",
    "BRC_num": "0820   642.2",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 86,
    "GBno": 204,
    "IRno": 5,
    "CIno": "",
    "TJan": 4.2,
    "TJul": 15.5,
    "Prec": 991,
    "Alt": 580,
    "L": 8,
    "F": 3,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pohlia wahlenbergii var. wahlenbergii",
    "Concept": "Bry_465.1",
    "Taxon_name": "Pohlia wahlenbergii var. wahlenbergii",
    "BRC_num": "0820   465.1",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 60,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 36,
    "GBno": 203,
    "IRno": 2,
    "CIno": "",
    "TJan": 4,
    "TJul": 15.1,
    "Prec": 1185,
    "Alt": 1170,
    "L": 6,
    "F": 7,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": 3,
    "RW": 1,
    "SR": 1,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Anthelia julacea",
    "Concept": "Bry_686",
    "Taxon_name": "Anthelia julacea",
    "BRC_num": "0810   686",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "We",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 5,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 16,
    "GBno": 202,
    "IRno": 34,
    "CIno": "",
    "TJan": 1.9,
    "TJul": 12.1,
    "Prec": 2040,
    "Alt": 1340,
    "L": 7,
    "F": 9,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hygrobiella laxifolia",
    "Concept": "Bry_784",
    "Taxon_name": "Hygrobiella laxifolia",
    "BRC_num": "0810   784",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 5,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 26,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 42,
    "GBno": 201,
    "IRno": 38,
    "CIno": "",
    "TJan": 2.3,
    "TJul": 12.6,
    "Prec": 1819,
    "Alt": 1070,
    "L": 5,
    "F": 8,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 2,
    "PT": "",
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum fuscum",
    "Concept": "Bry_558",
    "Taxon_name": "Sphagnum fuscum",
    "BRC_num": "0820   558",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 27,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 201,
    "IRno": 49,
    "CIno": "",
    "TJan": 2,
    "TJul": 12.5,
    "Prec": 1424,
    "Alt": 1000,
    "L": 8,
    "F": 7,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 2,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Rhabdoweisia crispata",
    "Concept": "Bry_517",
    "Taxon_name": "Rhabdoweisia crispata",
    "BRC_num": "0820   517",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 5,
    "Spbeg2": 10,
    "Spend2": 10,
    "Sp1": 18,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 42,
    "GBno": 200,
    "IRno": 21,
    "CIno": "",
    "TJan": 2.5,
    "TJul": 13.1,
    "Prec": 1896,
    "Alt": 950,
    "L": 4,
    "F": 5,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Andreaea alpina",
    "Concept": "Bry_23",
    "Taxon_name": "Andreaea alpina",
    "BRC_num": "0820    23",
    "ML": "M",
    "Ord": "Andreaeales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 26,
    "Sp2": 38,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 41,
    "GBno": 199,
    "IRno": 28,
    "CIno": "",
    "TJan": 1.9,
    "TJul": 12.2,
    "Prec": 2053,
    "Alt": 1300,
    "L": 7,
    "F": 5,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Orthotrichum rupestre",
    "Concept": "Bry_423",
    "Taxon_name": "Orthotrichum rupestre",
    "BRC_num": "0820   423",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 6,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 199,
    "IRno": 17,
    "CIno": "",
    "TJan": 2.9,
    "TJul": 13,
    "Prec": 1369,
    "Alt": 700,
    "L": 8,
    "F": 2,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Pohlia drummondii",
    "Concept": "Bry_471",
    "Taxon_name": "Pohlia drummondii",
    "BRC_num": "0820   471",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 40,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "Ts",
    "Tub": "",
    "Gem": "",
    "Bul": "F",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 198,
    "IRno": 12,
    "CIno": "",
    "TJan": 2.1,
    "TJul": 12.8,
    "Prec": 1697,
    "Alt": 1220,
    "L": 7,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ulota drummondii",
    "Concept": "Bry_634",
    "Taxon_name": "Ulota drummondii",
    "BRC_num": "0820   634",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 42,
    "GBno": 198,
    "IRno": 13,
    "CIno": 4,
    "TJan": 2.2,
    "TJul": 12.6,
    "Prec": 1656,
    "Alt": 620,
    "L": 5,
    "F": 5,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Lepidozia pearsonii",
    "Concept": "Bry_805",
    "Taxon_name": "Lepidozia pearsonii",
    "BRC_num": "0810   805",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "R",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 70,
    "GBno": 197,
    "IRno": 26,
    "CIno": "",
    "TJan": 2.4,
    "TJul": 12.8,
    "Prec": 1983,
    "Alt": 800,
    "L": 5,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pohlia elongata",
    "Concept": "Bry_1081",
    "Taxon_name": "Pohlia elongata",
    "BRC_num": "0820  1081",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 35,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 197,
    "IRno": 14,
    "CIno": "",
    "TJan": 2,
    "TJul": 12.6,
    "Prec": 1994,
    "Alt": 1050,
    "L": 4,
    "F": 6,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tetraplodon mnioides",
    "Concept": "Bry_591",
    "Taxon_name": "Tetraplodon mnioides",
    "BRC_num": "0820   591",
    "ML": "M",
    "Ord": "Splachnales",
    "Stat": "N",
    "Len": 60,
    "Per": "A",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 6,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 196,
    "IRno": 29,
    "CIno": "",
    "TJan": 2,
    "TJul": 12.7,
    "Prec": 1727,
    "Alt": 1000,
    "L": 7,
    "F": 7,
    "R": 2,
    "N": 6,
    "S": 0,
    "HM": 2,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": 3,
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Dicranum scottianum",
    "Concept": "Bry_207",
    "Taxon_name": "Dicranum scottianum",
    "BRC_num": "0820   207",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 75,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 4,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 25,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 80,
    "GBno": 195,
    "IRno": 59,
    "CIno": 1,
    "TJan": 3.5,
    "TJul": 13.5,
    "Prec": 1672,
    "Alt": 430,
    "L": 3,
    "F": 5,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 2,
    "RW": "",
    "SR": 2,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Leiocolea badensis",
    "Concept": "Bry_790",
    "Taxon_name": "Leiocolea badensis",
    "BRC_num": "0810   790",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 12,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 2,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 195,
    "IRno": 27,
    "CIno": "",
    "TJan": 3,
    "TJul": 14.2,
    "Prec": 1133,
    "Alt": 520,
    "L": 6,
    "F": 7,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 2,
    "RW": 1,
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Phaeoceros laevis",
    "Concept": "Bry_689",
    "Taxon_name": "Phaeoceros laevis",
    "BRC_num": "0810   689",
    "ML": "H",
    "Ord": "Anthocerotales",
    "Stat": "N",
    "Len": 40,
    "Per": "AP",
    "LF1": "Mt",
    "LF2": "St",
    "Tub": "O",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "F",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 30,
    "Sp2": 56,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "(CI)",
    "Elem": 83,
    "GBno": 193,
    "IRno": 77,
    "CIno": 7,
    "TJan": 4.7,
    "TJul": 15.1,
    "Prec": 1133,
    "Alt": 275,
    "L": 7,
    "F": 7,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 2,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Plagiothecium latebricola",
    "Concept": "Bry_451",
    "Taxon_name": "Plagiothecium latebricola",
    "BRC_num": "0820   451",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "We",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": 12,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 13,
    "E": "E",
    "W": "W",
    "Sc": "(S)",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 76,
    "GBno": 193,
    "IRno": 1,
    "CIno": "",
    "TJan": 3.9,
    "TJul": 16,
    "Prec": 828,
    "Alt": 490,
    "L": 2,
    "F": 8,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Mnium marginatum",
    "Concept": "Bry_1080",
    "Taxon_name": "Mnium marginatum",
    "BRC_num": "0820  1080",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M(D)",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 34,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 192,
    "IRno": 11,
    "CIno": "",
    "TJan": 2.3,
    "TJul": 13.3,
    "Prec": 1554,
    "Alt": 1170,
    "L": 3,
    "F": 6,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Entosthodon fascicularis",
    "Concept": "Bry_283",
    "Taxon_name": "Entosthodon fascicularis",
    "BRC_num": "0820   283",
    "ML": "M",
    "Ord": "Funariales",
    "Stat": "N",
    "Len": 10,
    "Per": "A",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 3,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "CI",
    "Elem": 73,
    "GBno": 191,
    "IRno": 9,
    "CIno": 3,
    "TJan": 4.5,
    "TJul": 15.8,
    "Prec": 910,
    "Alt": 245,
    "L": 8,
    "F": 6,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Grimmia hartmanii",
    "Concept": "Bry_302",
    "Taxon_name": "Grimmia hartmanii",
    "BRC_num": "0820   302",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 191,
    "IRno": 11,
    "CIno": "",
    "TJan": 2.6,
    "TJul": 13,
    "Prec": 1742,
    "Alt": 915,
    "L": 3,
    "F": 5,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Dialytrichia mucronata",
    "Concept": "Bry_154",
    "Taxon_name": "Dialytrichia mucronata",
    "BRC_num": "0820   154",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 91,
    "GBno": 189,
    "IRno": "",
    "CIno": "",
    "TJan": 4,
    "TJul": 16.1,
    "Prec": 836,
    "Alt": 125,
    "L": 6,
    "F": 5,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "ZZZ - SYNONYMIZED",
    "Concept": "",
    "Taxon_name": "Tortula subulata var. subulata",
    "BRC_num": "0820   620.4",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 7,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 84,
    "GBno": 187,
    "IRno": 2,
    "CIno": "",
    "TJan": 3.3,
    "TJul": 15.1,
    "Prec": 936,
    "Alt": 270,
    "L": 5,
    "F": 4,
    "R": 7,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Didymodon ferrugineus",
    "Concept": "Bry_55",
    "Taxon_name": "Didymodon ferrugineus",
    "BRC_num": "0820    55",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 186,
    "IRno": 55,
    "CIno": "",
    "TJan": 3.3,
    "TJul": 14.1,
    "Prec": 1241,
    "Alt": 785,
    "L": 7,
    "F": 4,
    "R": 8,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": 1,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Marchesinia mackaii",
    "Concept": "Bry_828",
    "Taxon_name": "Marchesinia mackaii",
    "BRC_num": "0810   828",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 4,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 81,
    "GBno": 185,
    "IRno": 77,
    "CIno": "",
    "TJan": 4.1,
    "TJul": 14.2,
    "Prec": 1440,
    "Alt": 500,
    "L": 3,
    "F": 5,
    "R": 7,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 1,
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Harpalejeunea molleri",
    "Concept": "Bry_779",
    "Taxon_name": "Harpalejeunea molleri",
    "BRC_num": "0810   779",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 12,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "O",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 80,
    "GBno": 184,
    "IRno": 57,
    "CIno": "",
    "TJan": 3.2,
    "TJul": 13.1,
    "Prec": 1954,
    "Alt": 600,
    "L": 4,
    "F": 6,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": 3,
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Douinia ovata",
    "Concept": "Bry_750",
    "Taxon_name": "Douinia ovata",
    "BRC_num": "0810   750",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 4,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 71,
    "GBno": 183,
    "IRno": 17,
    "CIno": "",
    "TJan": 2.1,
    "TJul": 12.5,
    "Prec": 2011,
    "Alt": 915,
    "L": 5,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 2,
    "RW": 2,
    "SR": 3,
    "SO": "",
    "PT": 1,
    "GS": "",
    "DW": 3,
    "DV": 1,
    "DA": "",
    "BR": 1,
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Tetrodontium brownianum",
    "Concept": "Bry_588",
    "Taxon_name": "Tetrodontium brownianum",
    "BRC_num": "0820   588",
    "ML": "M",
    "Ord": "Tetraphidales",
    "Stat": "N",
    "Len": 2,
    "Per": "P",
    "LF1": "Tp",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 9,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 72,
    "GBno": 183,
    "IRno": 15,
    "CIno": "",
    "TJan": 2.5,
    "TJul": 13.4,
    "Prec": 1572,
    "Alt": 850,
    "L": 2,
    "F": 7,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Andreaea rothii subsp. falcata",
    "Concept": "Bry_1067.1",
    "Taxon_name": "Andreaea rothii subsp. falcata",
    "BRC_num": "0820  1067.1",
    "ML": "M",
    "Ord": "Andreaeales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 36,
    "Sp2": 52,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 181,
    "IRno": 35,
    "CIno": "",
    "TJan": 2.7,
    "TJul": 13.2,
    "Prec": 1757,
    "Alt": 800,
    "L": 8,
    "F": 4,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Aphanolejeunea microscopica",
    "Concept": "Bry_691",
    "Taxon_name": "Aphanolejeunea microscopica",
    "BRC_num": "0810   691",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 6,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Thread",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": 6,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 80,
    "GBno": 181,
    "IRno": 46,
    "CIno": "",
    "TJan": 2.9,
    "TJul": 12.9,
    "Prec": 1969,
    "Alt": 610,
    "L": 2,
    "F": 8,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": 3,
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Bryoerythrophyllum ferruginascens",
    "Concept": "Bry_49",
    "Taxon_name": "Bryoerythrophyllum ferruginascens",
    "BRC_num": "0820    49",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 32,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "Nil",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 44,
    "GBno": 181,
    "IRno": 22,
    "CIno": "",
    "TJan": 2.1,
    "TJul": 12.6,
    "Prec": 1880,
    "Alt": 1075,
    "L": 7,
    "F": 6,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Gymnomitrion obtusum",
    "Concept": "Bry_777",
    "Taxon_name": "Gymnomitrion obtusum",
    "BRC_num": "0810   777",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 6,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 179,
    "IRno": 12,
    "CIno": "",
    "TJan": 1.5,
    "TJul": 12.2,
    "Prec": 2005,
    "Alt": 1200,
    "L": 7,
    "F": 5,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pohlia elongata var. elongata",
    "Concept": "Bry_1766",
    "Taxon_name": "Pohlia elongata subsp. elongata",
    "BRC_num": "0820  1766",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 179,
    "IRno": 13,
    "CIno": "",
    "TJan": 2,
    "TJul": 12.6,
    "Prec": 2026,
    "Alt": 1050,
    "L": 4,
    "F": 6,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Metzgeria pubescens",
    "Concept": "Bry_847",
    "Taxon_name": "Metzgeria pubescens",
    "BRC_num": "0810   847",
    "ML": "L",
    "Ord": "Metzgeriales",
    "Stat": "N",
    "Len": 35,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mt",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 19,
    "Sp2": 23,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 178,
    "IRno": 4,
    "CIno": "",
    "TJan": 1.7,
    "TJul": 12.9,
    "Prec": 1457,
    "Alt": 1000,
    "L": 4,
    "F": 5,
    "R": 8,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 1,
    "SR": 3,
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Tortula protobryoides",
    "Concept": "Bry_491",
    "Taxon_name": "Tortula protobryoides",
    "BRC_num": "0820   491",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "Tf",
    "Tub": "X",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 5,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 25,
    "Sp2": 32,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "(IR)",
    "NI": "(NI)",
    "CI": "",
    "Elem": 73,
    "GBno": 177,
    "IRno": "",
    "CIno": "",
    "TJan": 3.6,
    "TJul": 16,
    "Prec": 709,
    "Alt": 365,
    "L": 7,
    "F": 4,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Weissia longifolia var. angustifolia",
    "Concept": "Bry_640.2",
    "Taxon_name": "Weissia longifolia var. angustifolia",
    "BRC_num": "0820   640.2",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "Ts",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 73,
    "GBno": 177,
    "IRno": 3,
    "CIno": "",
    "TJan": 3.9,
    "TJul": 16,
    "Prec": 774,
    "Alt": 280,
    "L": 7,
    "F": 3,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Calypogeia neesiana",
    "Concept": "Bry_708",
    "Taxon_name": "Calypogeia neesiana",
    "BRC_num": "0810   708",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Sc",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": 3,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 174,
    "IRno": 27,
    "CIno": "",
    "TJan": 2.4,
    "TJul": 13.4,
    "Prec": 1365,
    "Alt": 850,
    "L": 3,
    "F": 7,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 2,
    "DV": 2,
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Mnium marginatum var. marginatum",
    "Concept": "Bry_385",
    "Taxon_name": "Mnium marginatum var. marginatum",
    "BRC_num": "0820   385",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 34,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 174,
    "IRno": 11,
    "CIno": "",
    "TJan": 2.2,
    "TJul": 13.1,
    "Prec": 1600,
    "Alt": 480,
    "L": 3,
    "F": 6,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Scleropodium touretii",
    "Concept": "Bry_539",
    "Taxon_name": "Scleropodium tourettii",
    "BRC_num": "0820   539",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "CI",
    "Elem": 91,
    "GBno": 174,
    "IRno": 2,
    "CIno": 10,
    "TJan": 5,
    "TJul": 15.8,
    "Prec": 954,
    "Alt": 490,
    "L": 8,
    "F": 3,
    "R": 6,
    "N": 2,
    "S": 1,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Grimmia ramondii",
    "Concept": "Bry_311",
    "Taxon_name": "Grimmia curvata",
    "BRC_num": "0820   311",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 173,
    "IRno": 19,
    "CIno": "",
    "TJan": 1.8,
    "TJul": 12.3,
    "Prec": 1928,
    "Alt": 1020,
    "L": 6,
    "F": 5,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Splachnum ampullaceum",
    "Concept": "Bry_582",
    "Taxon_name": "Splachnum ampullaceum",
    "BRC_num": "0820   582",
    "ML": "M",
    "Ord": "Splachnales",
    "Stat": "N",
    "Len": 30,
    "Per": "A",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 6,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 7,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 173,
    "IRno": 53,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.4,
    "Prec": 1530,
    "Alt": 915,
    "L": 8,
    "F": 8,
    "R": 4,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": 3,
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tortella nitida",
    "Concept": "Bry_606",
    "Taxon_name": "Tortella nitida",
    "BRC_num": "0820   606",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "F",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 91,
    "GBno": 172,
    "IRno": 38,
    "CIno": 1,
    "TJan": 4.7,
    "TJul": 15.2,
    "Prec": 1209,
    "Alt": 360,
    "L": 8,
    "F": 2,
    "R": 9,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Herbertus aduncus",
    "Concept": "Bry_783",
    "Taxon_name": "Herbertus aduncus",
    "BRC_num": "0810   783",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 25,
    "Sp2": 25,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 41,
    "GBno": 171,
    "IRno": 66,
    "CIno": "",
    "TJan": 2.9,
    "TJul": 12.8,
    "Prec": 2007,
    "Alt": 1040,
    "L": 6,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Lepidozia cupressina",
    "Concept": "Bry_806",
    "Taxon_name": "Lepidozia cupressina",
    "BRC_num": "0810   806",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 80,
    "GBno": 171,
    "IRno": 74,
    "CIno": "",
    "TJan": 3.5,
    "TJul": 13.4,
    "Prec": 1617,
    "Alt": 700,
    "L": 4,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Seligeria calycina",
    "Concept": "Bry_546",
    "Taxon_name": "Seligeria calycina",
    "BRC_num": "0820   546",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 2,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "Tp",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 12,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "NI",
    "CI": "",
    "Elem": 72,
    "GBno": 166,
    "IRno": 1,
    "CIno": "",
    "TJan": 3.7,
    "TJul": 16.2,
    "Prec": 760,
    "Alt": 305,
    "L": 2,
    "F": 5,
    "R": 9,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Radula lindenbergiana",
    "Concept": "Bry_894",
    "Taxon_name": "Radula lindenbergiana",
    "BRC_num": "0810   894",
    "ML": "L",
    "Ord": "Radulales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 2,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 28,
    "Sp2": 38,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 43,
    "GBno": 165,
    "IRno": 15,
    "CIno": 2,
    "TJan": 2.5,
    "TJul": 12.8,
    "Prec": 1899,
    "Alt": 1200,
    "L": 6,
    "F": 5,
    "R": 6,
    "N": 3,
    "S": 1,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 1,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Racomitrium ellipticum",
    "Concept": "Bry_522",
    "Taxon_name": "Racomitrium ellipticum",
    "BRC_num": "0820   522",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 41,
    "GBno": 164,
    "IRno": 31,
    "CIno": 2,
    "TJan": 2.6,
    "TJul": 12.4,
    "Prec": 1985,
    "Alt": 800,
    "L": 6,
    "F": 6,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Frullania microphylla",
    "Concept": "Bry_767",
    "Taxon_name": "Frullania microphylla",
    "BRC_num": "0810   767",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "R",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 1,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 80,
    "GBno": 163,
    "IRno": 35,
    "CIno": "",
    "TJan": 4.2,
    "TJul": 13.8,
    "Prec": 1581,
    "Alt": 610,
    "L": 5,
    "F": 5,
    "R": 4,
    "N": 2,
    "S": 1,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Hygrohypnum eugyrium",
    "Concept": "Bry_339",
    "Taxon_name": "Hygrohypnum eugyrium",
    "BRC_num": "0820   339",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 5,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 42,
    "GBno": 163,
    "IRno": 25,
    "CIno": "",
    "TJan": 2.6,
    "TJul": 12.9,
    "Prec": 1831,
    "Alt": 800,
    "L": 5,
    "F": 9,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum warnstorfii",
    "Concept": "Bry_581",
    "Taxon_name": "Sphagnum warnstorfii",
    "BRC_num": "0820   581",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 26,
    "GBno": 158,
    "IRno": 6,
    "CIno": "",
    "TJan": 1.8,
    "TJul": 12.7,
    "Prec": 1671,
    "Alt": 950,
    "L": 7,
    "F": 8,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cladopodiella fluitans",
    "Concept": "Bry_739",
    "Taxon_name": "Cladopodiella fluitans",
    "BRC_num": "0810   739",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "We",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 5,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 157,
    "IRno": 32,
    "CIno": "",
    "TJan": 3.4,
    "TJul": 14.1,
    "Prec": 1411,
    "Alt": 600,
    "L": 8,
    "F": 9,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": 3
  },
  {
    "Name_new": "Scorpidium revolvens",
    "Concept": "Bry_226.2",
    "Taxon_name": "Drepanocladus revolvens",
    "BRC_num": "0820   226.2",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 157,
    "IRno": 14,
    "CIno": "",
    "TJan": 2.7,
    "TJul": 13.3,
    "Prec": 1598,
    "Alt": 550,
    "L": 8,
    "F": 9,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ulota hutchinsiae",
    "Concept": "Bry_630",
    "Taxon_name": "Ulota hutchinsiae",
    "BRC_num": "0820   630",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 42,
    "GBno": 157,
    "IRno": 46,
    "CIno": "",
    "TJan": 3.1,
    "TJul": 12.7,
    "Prec": 1915,
    "Alt": 600,
    "L": 7,
    "F": 3,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Dicranum fuscescens",
    "Concept": "Bry_201.3",
    "Taxon_name": "Dicranum fuscescens",
    "BRC_num": "0820   201.3",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 75,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 155,
    "IRno": 8,
    "CIno": "",
    "TJan": 2.4,
    "TJul": 13.2,
    "Prec": 1648,
    "Alt": 1000,
    "L": 6,
    "F": 5,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Oxyrrhynchium schleicheri",
    "Concept": "Bry_253",
    "Taxon_name": "Eurhynchium schleicheri",
    "BRC_num": "0820   253",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 92,
    "GBno": 155,
    "IRno": 1,
    "CIno": "",
    "TJan": 3.8,
    "TJul": 16,
    "Prec": 855,
    "Alt": 270,
    "L": 5,
    "F": 5,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Marchantia polymorpha subsp. polymorpha",
    "Concept": "Bry_827.5",
    "Taxon_name": "Marchantia polymorpha subsp. polymorpha",
    "BRC_num": "0810   827.5",
    "ML": "L",
    "Ord": "Marchantiales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "",
    "Tub": "",
    "Gem": "O",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 154,
    "IRno": 8,
    "CIno": "",
    "TJan": 3.1,
    "TJul": 14.7,
    "Prec": 1031,
    "Alt": 630,
    "L": 7,
    "F": 9,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 1,
    "RH": 2,
    "RS": "",
    "RW": 2,
    "SR": 3,
    "SO": 3,
    "PT": 2,
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pohlia bulbifera",
    "Concept": "Bry_467",
    "Taxon_name": "Pohlia bulbifera",
    "BRC_num": "0820   467",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 20,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "Ts",
    "Tub": "",
    "Gem": "",
    "Bul": "F",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 153,
    "IRno": 24,
    "CIno": "",
    "TJan": 2.4,
    "TJul": 13.1,
    "Prec": 1512,
    "Alt": 735,
    "L": 7,
    "F": 7,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Andreaea rupestris var. rupestris",
    "Concept": "Bry_1068.2",
    "Taxon_name": "Andreaea rupestris var. rupestris",
    "BRC_num": "0820  1068.2",
    "ML": "M",
    "Ord": "Andreaeales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 26,
    "Sp2": 32,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 152,
    "IRno": 14,
    "CIno": "",
    "TJan": 2,
    "TJul": 12.6,
    "Prec": 1842,
    "Alt": 1110,
    "L": 7,
    "F": 3,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 1,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum donianum",
    "Concept": "Bry_96",
    "Taxon_name": "Bryum donianum",
    "BRC_num": "0820    96",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "CI",
    "Elem": 91,
    "GBno": 152,
    "IRno": 12,
    "CIno": 5,
    "TJan": 5,
    "TJul": 15.7,
    "Prec": 1013,
    "Alt": 300,
    "L": 6,
    "F": 4,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": 2,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Grimmia torquata",
    "Concept": "Bry_317",
    "Taxon_name": "Grimmia torquata",
    "BRC_num": "0820   317",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 9,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 23,
    "GBno": 152,
    "IRno": 11,
    "CIno": "",
    "TJan": 1.6,
    "TJul": 12.3,
    "Prec": 1953,
    "Alt": 1050,
    "L": 7,
    "F": 4,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Lophocolea fragrans",
    "Concept": "Bry_813",
    "Taxon_name": "Lophocolea fragrans",
    "BRC_num": "0810   813",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 2,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 81,
    "GBno": 152,
    "IRno": 49,
    "CIno": 3,
    "TJan": 4.1,
    "TJul": 14.3,
    "Prec": 1405,
    "Alt": 360,
    "L": 3,
    "F": 7,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum molle",
    "Concept": "Bry_563",
    "Taxon_name": "Sphagnum molle",
    "BRC_num": "0820   563",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 7,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 28,
    "Sp2": 32,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 72,
    "GBno": 150,
    "IRno": 36,
    "CIno": "",
    "TJan": 3.1,
    "TJul": 13.3,
    "Prec": 1614,
    "Alt": 820,
    "L": 8,
    "F": 8,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Colura calyptrifolia",
    "Concept": "Bry_744",
    "Taxon_name": "Colura calyptrifolia",
    "BRC_num": "0810   744",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 4,
    "Spend": 11,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 80,
    "GBno": 149,
    "IRno": 71,
    "CIno": "",
    "TJan": 3.6,
    "TJul": 13.6,
    "Prec": 1738,
    "Alt": 610,
    "L": 4,
    "F": 6,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": 2,
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Marsupella funckii",
    "Concept": "Bry_835",
    "Taxon_name": "Marsupella funckii",
    "BRC_num": "0810   835",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 3,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 7,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 52,
    "GBno": 149,
    "IRno": 13,
    "CIno": 3,
    "TJan": 2.5,
    "TJul": 12.9,
    "Prec": 1815,
    "Alt": 670,
    "L": 7,
    "F": 6,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 2,
    "RH": 1,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Drepanocladus polygamus",
    "Concept": "Bry_133",
    "Taxon_name": "Drepanocladus polygamus",
    "BRC_num": "0820   133",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 148,
    "IRno": 22,
    "CIno": "",
    "TJan": 4,
    "TJul": 14.8,
    "Prec": 1032,
    "Alt": 850,
    "L": 9,
    "F": 8,
    "R": 7,
    "N": 3,
    "S": 3,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Gymnomitrion concinnatum",
    "Concept": "Bry_774",
    "Taxon_name": "Gymnomitrion concinnatum",
    "BRC_num": "0810   774",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 12,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 16,
    "GBno": 147,
    "IRno": 6,
    "CIno": "",
    "TJan": 1.3,
    "TJul": 11.9,
    "Prec": 2036,
    "Alt": 1340,
    "L": 7,
    "F": 5,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": 2,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Anthoceros punctatus",
    "Concept": "Bry_688",
    "Taxon_name": "Anthoceros punctatus",
    "BRC_num": "0810   688",
    "ML": "H",
    "Ord": "Anthocerotales",
    "Stat": "N",
    "Len": 30,
    "Per": "AP",
    "LF1": "St",
    "LF2": "Mt",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 42,
    "Sp2": 62,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 91,
    "GBno": 146,
    "IRno": 28,
    "CIno": 4,
    "TJan": 4.7,
    "TJul": 14.9,
    "Prec": 1152,
    "Alt": 300,
    "L": 7,
    "F": 7,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 2,
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Drepanolejeunea hamatifolia",
    "Concept": "Bry_751",
    "Taxon_name": "Drepanolejeunea hamatifolia",
    "BRC_num": "0810   751",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 80,
    "GBno": 145,
    "IRno": 69,
    "CIno": "",
    "TJan": 3.4,
    "TJul": 13.2,
    "Prec": 1906,
    "Alt": 610,
    "L": 3,
    "F": 7,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": 3,
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Rhabdoweisia fugax",
    "Concept": "Bry_518",
    "Taxon_name": "Rhabdoweisia fugax",
    "BRC_num": "0820   518",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 145,
    "IRno": 6,
    "CIno": "",
    "TJan": 2.4,
    "TJul": 13.1,
    "Prec": 1791,
    "Alt": 800,
    "L": 4,
    "F": 5,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Barbilophozia hatcheri",
    "Concept": "Bry_696",
    "Taxon_name": "Barbilophozia hatcheri",
    "BRC_num": "0810   696",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 9,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 144,
    "IRno": "",
    "CIno": "",
    "TJan": 1.1,
    "TJul": 12.3,
    "Prec": 1287,
    "Alt": 1050,
    "L": 6,
    "F": 5,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": 2,
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Atrichum crispum",
    "Concept": "Bry_38",
    "Taxon_name": "Atrichum crispum",
    "BRC_num": "0820    38",
    "ML": "M",
    "Ord": "Polytrichales",
    "Stat": "AN",
    "Len": 70,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 17,
    "Sp2": 32,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 72,
    "GBno": 143,
    "IRno": 7,
    "CIno": "",
    "TJan": 3,
    "TJul": 14.2,
    "Prec": 1483,
    "Alt": 450,
    "L": 6,
    "F": 8,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ditrichum gracile",
    "Concept": "Bry_1348",
    "Taxon_name": "Ditrichum gracile",
    "BRC_num": "0820  1348",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 110,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 143,
    "IRno": 12,
    "CIno": "",
    "TJan": 3.4,
    "TJul": 14.5,
    "Prec": 1221,
    "Alt": 638,
    "L": 7,
    "F": 5,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 2,
    "RW": 2,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Grimmia funalis",
    "Concept": "Bry_301",
    "Taxon_name": "Grimmia funalis",
    "BRC_num": "0820   301",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 142,
    "IRno": 11,
    "CIno": "",
    "TJan": 1.8,
    "TJul": 12.2,
    "Prec": 1897,
    "Alt": 1205,
    "L": 7,
    "F": 3,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Microbryum curvicollum",
    "Concept": "Bry_433",
    "Taxon_name": "Microbryum curvicolle",
    "BRC_num": "0820   433",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 2,
    "Per": "A",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 3,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 92,
    "GBno": 142,
    "IRno": 1,
    "CIno": "",
    "TJan": 3.7,
    "TJul": 15.9,
    "Prec": 742,
    "Alt": 490,
    "L": 8,
    "F": 3,
    "R": 9,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Calypogeia sphagnicola",
    "Concept": "Bry_709",
    "Taxon_name": "Calypogeia sphagnicola",
    "BRC_num": "0810   709",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Sc",
    "LF2": "Thread",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": 4,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 141,
    "IRno": 51,
    "CIno": "",
    "TJan": 3.1,
    "TJul": 13.7,
    "Prec": 1335,
    "Alt": 670,
    "L": 8,
    "F": 9,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": 2,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum palustre var. palustre",
    "Concept": "Bry_566.2",
    "Taxon_name": "Sphagnum palustre var. palustre",
    "BRC_num": "0820   566.2",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 250,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 26,
    "Sp2": 32,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 52,
    "GBno": 141,
    "IRno": 3,
    "CIno": "",
    "TJan": 4.1,
    "TJul": 15.1,
    "Prec": 1161,
    "Alt": 350,
    "L": 7,
    "F": 8,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Weissia longifolia var. longifolia",
    "Concept": "Bry_640.1",
    "Taxon_name": "Weissia longifolia var. longifolia",
    "BRC_num": "0820   640.1",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "AP",
    "LF1": "Tf",
    "LF2": "Ts",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 73,
    "GBno": 140,
    "IRno": "",
    "CIno": "",
    "TJan": 3.8,
    "TJul": 16.1,
    "Prec": 717,
    "Alt": 250,
    "L": 7,
    "F": 5,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Isothecium holtii",
    "Concept": "Bry_361",
    "Taxon_name": "Isothecium holtii",
    "BRC_num": "0820   361",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "De",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 2,
    "Spend": 2,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 21,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 71,
    "GBno": 139,
    "IRno": 18,
    "CIno": "",
    "TJan": 2.9,
    "TJul": 13.5,
    "Prec": 1776,
    "Alt": 470,
    "L": 4,
    "F": 8,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Radula aquilegia",
    "Concept": "Bry_890",
    "Taxon_name": "Radula aquilegia",
    "BRC_num": "0810   890",
    "ML": "L",
    "Ord": "Radulales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 5,
    "Spend": 11,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 30,
    "Sp2": 56,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 80,
    "GBno": 139,
    "IRno": 51,
    "CIno": "",
    "TJan": 3.1,
    "TJul": 12.9,
    "Prec": 1999,
    "Alt": 920,
    "L": 5,
    "F": 6,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": 1,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Schistostega pennata",
    "Concept": "Bry_537",
    "Taxon_name": "Schistostega pennata",
    "BRC_num": "0820   537",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Tp",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": 4,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "CI",
    "Elem": 52,
    "GBno": 139,
    "IRno": "",
    "CIno": 1,
    "TJan": 4.1,
    "TJul": 15.1,
    "Prec": 1142,
    "Alt": 305,
    "L": 1,
    "F": 7,
    "R": 4,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Acaulon muticum",
    "Concept": "Bry_1",
    "Taxon_name": "Acaulon muticum",
    "BRC_num": "0820     1",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 2,
    "Per": "A",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 11,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 30,
    "Sp2": 50,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "CI",
    "Elem": 83,
    "GBno": 137,
    "IRno": 2,
    "CIno": 2,
    "TJan": 4.1,
    "TJul": 15.7,
    "Prec": 839,
    "Alt": 490,
    "L": 7,
    "F": 5,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Gymnomitrion crenulatum",
    "Concept": "Bry_776",
    "Taxon_name": "Gymnomitrion crenulatum",
    "BRC_num": "0810   776",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 8,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 4,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 41,
    "GBno": 137,
    "IRno": 46,
    "CIno": "",
    "TJan": 2.5,
    "TJul": 12.6,
    "Prec": 1987,
    "Alt": 950,
    "L": 7,
    "F": 4,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Syntrichia virescens",
    "Concept": "Bry_622",
    "Taxon_name": "Syntrichia virescens",
    "BRC_num": "0820   622",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 73,
    "GBno": 137,
    "IRno": "",
    "CIno": 9,
    "TJan": 3.3,
    "TJul": 15.9,
    "Prec": 659,
    "Alt": 150,
    "L": 6,
    "F": 4,
    "R": 6,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": 1,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Dicranella subulata",
    "Concept": "Bry_188",
    "Taxon_name": "Dicranella subulata",
    "BRC_num": "0820   188",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "U",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 135,
    "IRno": 9,
    "CIno": "",
    "TJan": 2.3,
    "TJul": 13,
    "Prec": 1634,
    "Alt": 1000,
    "L": 7,
    "F": 5,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Isothecium myosuroides var. brachythecioides",
    "Concept": "Bry_362.1",
    "Taxon_name": "Isothecium myosuroides var. brachythecioides",
    "BRC_num": "0820   362.1",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 70,
    "GBno": 135,
    "IRno": 26,
    "CIno": "",
    "TJan": 2.7,
    "TJul": 12.4,
    "Prec": 1868,
    "Alt": 980,
    "L": 4,
    "F": 6,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Plagiochila britannica",
    "Concept": "Bry_970",
    "Taxon_name": "Plagiochila britannica",
    "BRC_num": "0810   970",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 70,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 7,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 52,
    "GBno": 135,
    "IRno": 15,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.8,
    "Prec": 1490,
    "Alt": 450,
    "L": 4,
    "F": 6,
    "R": 7,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Leptodon smithii",
    "Concept": "Bry_367",
    "Taxon_name": "Leptodon smithii",
    "BRC_num": "0820   367",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Fa",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "(CI)",
    "Elem": 91,
    "GBno": 132,
    "IRno": 3,
    "CIno": "",
    "TJan": 4.6,
    "TJul": 16.1,
    "Prec": 912,
    "Alt": 190,
    "L": 6,
    "F": 4,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Schistidium strictum",
    "Concept": "Bry_315",
    "Taxon_name": "Schistidium strictum",
    "BRC_num": "0820   315",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 95,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 41,
    "GBno": 132,
    "IRno": 13,
    "CIno": "",
    "TJan": 2,
    "TJul": 12.4,
    "Prec": 1935,
    "Alt": 1000,
    "L": 6,
    "F": 4,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ephemerum serratum s.str.",
    "Concept": "Bry_239.2",
    "Taxon_name": "Ephemerum serratum var. serratum",
    "BRC_num": "0820   239.2",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 2.2,
    "Per": "A",
    "LF1": "Tp",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 3,
    "Spend": 3,
    "Spbeg2": 7,
    "Spend2": 12,
    "Sp1": 65,
    "Sp2": 90,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 131,
    "IRno": 15,
    "CIno": "",
    "TJan": 3.7,
    "TJul": 14.7,
    "Prec": 1154,
    "Alt": 400,
    "L": 7,
    "F": 8,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Metzgeria leptoneura",
    "Concept": "Bry_846",
    "Taxon_name": "Metzgeria leptoneura",
    "BRC_num": "0810   846",
    "ML": "L",
    "Ord": "Metzgeriales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "O",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 80,
    "GBno": 131,
    "IRno": 25,
    "CIno": "",
    "TJan": 2.8,
    "TJul": 12.8,
    "Prec": 2113,
    "Alt": 930,
    "L": 5,
    "F": 7,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 2,
    "PT": 2,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum strictum",
    "Concept": "Bry_576",
    "Taxon_name": "Sphagnum strictum",
    "BRC_num": "0820   576",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 28,
    "Sp2": 30,
    "E": "(E)",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 70,
    "GBno": 131,
    "IRno": 22,
    "CIno": "",
    "TJan": 2.7,
    "TJul": 12.4,
    "Prec": 1998,
    "Alt": 550,
    "L": 7,
    "F": 8,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ctenidium molluscum var. condensatum",
    "Concept": "Bry_166.1",
    "Taxon_name": "Ctenidium molluscum var. condensatum",
    "BRC_num": "0820   166.1",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 130,
    "IRno": 15,
    "CIno": "",
    "TJan": 2.1,
    "TJul": 12.5,
    "Prec": 1795,
    "Alt": 1070,
    "L": 7,
    "F": 6,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Diplophyllum obtusifolium",
    "Concept": "Bry_748",
    "Taxon_name": "Diplophyllum obtusifolium",
    "BRC_num": "0810   748",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 56,
    "GBno": 130,
    "IRno": 8,
    "CIno": "",
    "TJan": 3.2,
    "TJul": 14.2,
    "Prec": 1399,
    "Alt": 480,
    "L": 6,
    "F": 6,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Jubula hutchinsiae",
    "Concept": "Bry_788",
    "Taxon_name": "Jubula hutchinsiae",
    "BRC_num": "0810   788",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Fa",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M(D)",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 80,
    "GBno": 130,
    "IRno": 64,
    "CIno": "",
    "TJan": 3.8,
    "TJul": 13.9,
    "Prec": 1612,
    "Alt": 610,
    "L": 2,
    "F": 9,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": 2,
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum pallescens",
    "Concept": "Bry_111",
    "Taxon_name": "Bryum pallescens",
    "BRC_num": "0820   111",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 129,
    "IRno": 21,
    "CIno": 2,
    "TJan": 3.8,
    "TJul": 14.8,
    "Prec": 1156,
    "Alt": 1205,
    "L": 7,
    "F": 5,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 4,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 1,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hedwigia stellata",
    "Concept": "Bry_1767",
    "Taxon_name": "Hedwigia stellata",
    "BRC_num": "0820  1767",
    "ML": "M",
    "Ord": "Hedwigiales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 4,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 23,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 73,
    "GBno": 129,
    "IRno": 6,
    "CIno": "",
    "TJan": 3.4,
    "TJul": 13.7,
    "Prec": 1520,
    "Alt": 700,
    "L": 8,
    "F": 1,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Leucobryum juniperoideum",
    "Concept": "Bry_1005",
    "Taxon_name": "Leucobryum juniperoideum",
    "BRC_num": "0820  1005",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 105,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "F",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 129,
    "IRno": 10,
    "CIno": "",
    "TJan": 3.9,
    "TJul": 15.2,
    "Prec": 1263,
    "Alt": 400,
    "L": 4,
    "F": 5,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 2,
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum flexuosum",
    "Concept": "Bry_571.1",
    "Taxon_name": "Sphagnum flexuosum",
    "BRC_num": "0820   571.1",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 23,
    "Sp2": 26,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 53,
    "GBno": 129,
    "IRno": 5,
    "CIno": "",
    "TJan": 3.3,
    "TJul": 14.6,
    "Prec": 1205,
    "Alt": 500,
    "L": 6,
    "F": 9,
    "R": 3,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 2,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Molendoa warburgii",
    "Concept": "Bry_655",
    "Taxon_name": "Molendoa warburgii",
    "BRC_num": "0820   655",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 41,
    "GBno": 128,
    "IRno": 1,
    "CIno": "",
    "TJan": 1.7,
    "TJul": 12,
    "Prec": 2179,
    "Alt": 1070,
    "L": 5,
    "F": 8,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Weissia rutilans",
    "Concept": "Bry_645",
    "Taxon_name": "Weissia rutilans",
    "BRC_num": "0820   645",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "AP",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 11,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 22,
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "(CI)",
    "Elem": 73,
    "GBno": 128,
    "IRno": 4,
    "CIno": "",
    "TJan": 4.2,
    "TJul": 15.2,
    "Prec": 1091,
    "Alt": 450,
    "L": 7,
    "F": 6,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cephalozia leucantha",
    "Concept": "Bry_718",
    "Taxon_name": "Cephalozia leucantha",
    "BRC_num": "0810   718",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 4,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 127,
    "IRno": 31,
    "CIno": "",
    "TJan": 2.9,
    "TJul": 12.7,
    "Prec": 1617,
    "Alt": 1000,
    "L": 3,
    "F": 7,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Barbilophozia atlantica",
    "Concept": "Bry_692",
    "Taxon_name": "Barbilophozia atlantica",
    "BRC_num": "0810   692",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 42,
    "GBno": 126,
    "IRno": 1,
    "CIno": "",
    "TJan": 2.2,
    "TJul": 13.3,
    "Prec": 1480,
    "Alt": 900,
    "L": 6,
    "F": 5,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": 3,
    "SO": 2,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Seligeria calcarea",
    "Concept": "Bry_544",
    "Taxon_name": "Seligeria calcarea",
    "BRC_num": "0820   544",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 2,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "Tp",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 18,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 125,
    "IRno": 2,
    "CIno": "",
    "TJan": 3.6,
    "TJul": 16.1,
    "Prec": 730,
    "Alt": 250,
    "L": 3,
    "F": 5,
    "R": 9,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": 3,
    "RW": 1,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cephaloziella rubella",
    "Concept": "Bry_731",
    "Taxon_name": "Cephaloziella rubella",
    "BRC_num": "0810   731",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 8,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 6,
    "Sp2": 9,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 124,
    "IRno": 6,
    "CIno": 1,
    "TJan": 3.1,
    "TJul": 14.7,
    "Prec": 1085,
    "Alt": 900,
    "L": 6,
    "F": 5,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 2,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum bornholmense",
    "Concept": "Bry_658",
    "Taxon_name": "Bryum bornholmense",
    "BRC_num": "0820   658",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "O",
    "Spbeg": 7,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 123,
    "IRno": 5,
    "CIno": 9,
    "TJan": 4,
    "TJul": 15.3,
    "Prec": 1079,
    "Alt": 535,
    "L": 8,
    "F": 5,
    "R": 3,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 1,
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Scorpiurium circinatum",
    "Concept": "Bry_540",
    "Taxon_name": "Scorpiurium circinatum",
    "BRC_num": "0820   540",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "CI",
    "Elem": 91,
    "GBno": 123,
    "IRno": 20,
    "CIno": 6,
    "TJan": 5.1,
    "TJul": 15.9,
    "Prec": 949,
    "Alt": 305,
    "L": 6,
    "F": 3,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Kiaeria blyttii",
    "Concept": "Bry_196",
    "Taxon_name": "Kiaeria blyttii",
    "BRC_num": "0820   196",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 19,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 23,
    "GBno": 122,
    "IRno": 8,
    "CIno": "",
    "TJan": 1.3,
    "TJul": 12,
    "Prec": 2034,
    "Alt": 1344,
    "L": 6,
    "F": 4,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum capillifolium subsp. rubellum",
    "Concept": "Bry_573",
    "Taxon_name": "Sphagnum capillifolium subsp. rubellum",
    "BRC_num": "0820   573",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 27,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 121,
    "IRno": 2,
    "CIno": "",
    "TJan": 3.8,
    "TJul": 14.9,
    "Prec": 1217,
    "Alt": 300,
    "L": 7,
    "F": 7,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Plagiochila exigua",
    "Concept": "Bry_875",
    "Taxon_name": "Plagiochila exigua",
    "BRC_num": "0810   875",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "O",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 80,
    "GBno": 120,
    "IRno": 32,
    "CIno": "",
    "TJan": 3,
    "TJul": 13,
    "Prec": 2045,
    "Alt": 610,
    "L": 4,
    "F": 6,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 2,
    "SO": 1,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Marsupella sprucei",
    "Concept": "Bry_838",
    "Taxon_name": "Marsupella sprucei",
    "BRC_num": "0810   838",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 13,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 119,
    "IRno": 8,
    "CIno": "",
    "TJan": 1.8,
    "TJul": 12.5,
    "Prec": 1900,
    "Alt": 1335,
    "L": 6,
    "F": 8,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Anthoceros agrestis",
    "Concept": "Bry_690",
    "Taxon_name": "Anthoceros agrestis",
    "BRC_num": "0810   690",
    "ML": "H",
    "Ord": "Anthocerotales",
    "Stat": "NA",
    "Len": 15,
    "Per": "A",
    "LF1": "St",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 7,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 42,
    "Sp2": 62,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 118,
    "IRno": 5,
    "CIno": "",
    "TJan": 3.8,
    "TJul": 15.5,
    "Prec": 937,
    "Alt": 226,
    "L": 7,
    "F": 7,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Calypogeia neesiana",
    "Concept": "Bry_708.2",
    "Taxon_name": "Calypogeia neesiana",
    "BRC_num": "0810   708.2",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Sc",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": 3,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 118,
    "IRno": 24,
    "CIno": "",
    "TJan": 2.3,
    "TJul": 12.9,
    "Prec": 1467,
    "Alt": 760,
    "L": 3,
    "F": 7,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 2,
    "PT": 3,
    "GS": "",
    "DW": 2,
    "DV": 2,
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Microbryum floerkeanum",
    "Concept": "Bry_435",
    "Taxon_name": "Microbryum floerkeanum",
    "BRC_num": "0820   435",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 1.2,
    "Per": "A",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 8,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 25,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 73,
    "GBno": 118,
    "IRno": "",
    "CIno": "",
    "TJan": 3.5,
    "TJul": 16.1,
    "Prec": 707,
    "Alt": 220,
    "L": 8,
    "F": 5,
    "R": 8,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tortula viridifolia",
    "Concept": "Bry_494",
    "Taxon_name": "Tortula viridifolia",
    "BRC_num": "0820   494",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 10,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 25,
    "Sp2": 35,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 91,
    "GBno": 117,
    "IRno": 7,
    "CIno": 8,
    "TJan": 5.4,
    "TJul": 15.3,
    "Prec": 998,
    "Alt": 30,
    "L": 8,
    "F": 5,
    "R": 6,
    "N": 4,
    "S": 4,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Orthotrichum sprucei",
    "Concept": "Bry_427",
    "Taxon_name": "Orthotrichum sprucei",
    "BRC_num": "0820   427",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "O",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 7,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 71,
    "GBno": 115,
    "IRno": 5,
    "CIno": "",
    "TJan": 3.6,
    "TJul": 15.2,
    "Prec": 978,
    "Alt": 110,
    "L": 6,
    "F": 5,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Porella obtusata",
    "Concept": "Bry_886",
    "Taxon_name": "Porella obtusata",
    "BRC_num": "0810   886",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 45,
    "Sp2": 50,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 81,
    "GBno": 115,
    "IRno": 30,
    "CIno": 4,
    "TJan": 4.3,
    "TJul": 14,
    "Prec": 1384,
    "Alt": 400,
    "L": 7,
    "F": 5,
    "R": 5,
    "N": 2,
    "S": 1,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Seligeria donniana",
    "Concept": "Bry_545",
    "Taxon_name": "Seligeria donniana",
    "BRC_num": "0820   545",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 2,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 44,
    "GBno": 114,
    "IRno": 12,
    "CIno": "",
    "TJan": 2.2,
    "TJul": 13.5,
    "Prec": 1494,
    "Alt": 730,
    "L": 2,
    "F": 5,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Herbertus stramineus",
    "Concept": "Bry_782",
    "Taxon_name": "Herbertus stramineus",
    "BRC_num": "0810   782",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 41,
    "GBno": 113,
    "IRno": "",
    "CIno": "",
    "TJan": 1.7,
    "TJul": 11.8,
    "Prec": 2259,
    "Alt": 1180,
    "L": 6,
    "F": 6,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Phaeoceros laevis",
    "Concept": "Bry_689.2",
    "Taxon_name": "Phaeoceros laevis",
    "BRC_num": "0810   689.2",
    "ML": "H",
    "Ord": "Anthocerotales",
    "Stat": "N",
    "Len": 40,
    "Per": "AP",
    "LF1": "Mt",
    "LF2": "St",
    "Tub": "O",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 30,
    "Sp2": 46,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "(CI)",
    "Elem": 91,
    "GBno": 112,
    "IRno": 40,
    "CIno": "",
    "TJan": 5,
    "TJul": 15.2,
    "Prec": 1120,
    "Alt": 275,
    "L": 7,
    "F": 7,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 2,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Schistidium apocarpum s.str.",
    "Concept": "Bry_1809",
    "Taxon_name": "Schistidium apocarpum s.str.",
    "BRC_num": "0820  1809",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 54,
    "GBno": 112,
    "IRno": 22,
    "CIno": 3,
    "TJan": 3.5,
    "TJul": 14.1,
    "Prec": 1353,
    "Alt": 880,
    "L": 7,
    "F": 2,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Riccia subbifurca",
    "Concept": "Bry_916",
    "Taxon_name": "Riccia subbifurca",
    "BRC_num": "0810   916",
    "ML": "L",
    "Ord": "Ricciales",
    "Stat": "N",
    "Len": 10,
    "Per": "AP",
    "LF1": "St",
    "LF2": "Mt",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 75,
    "Sp2": 94,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 92,
    "GBno": 111,
    "IRno": 31,
    "CIno": "",
    "TJan": 4.2,
    "TJul": 14.9,
    "Prec": 1170,
    "Alt": 800,
    "L": 7,
    "F": 5,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Scorpidium cossonii",
    "Concept": "Bry_226.1",
    "Taxon_name": "Drepanocladus cossonii",
    "BRC_num": "0820   226.1",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 110,
    "IRno": 4,
    "CIno": "",
    "TJan": 3.3,
    "TJul": 14,
    "Prec": 1323,
    "Alt": 620,
    "L": 8,
    "F": 8,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Kurzia sylvatica",
    "Concept": "Bry_809",
    "Taxon_name": "Kurzia sylvatica",
    "BRC_num": "0810   809",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 5,
    "Spend": 11,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 72,
    "GBno": 110,
    "IRno": 21,
    "CIno": 1,
    "TJan": 3.5,
    "TJul": 14,
    "Prec": 1366,
    "Alt": 600,
    "L": 4,
    "F": 7,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 2,
    "DV": 2,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Racomitrium sudeticum",
    "Concept": "Bry_1076",
    "Taxon_name": "Racomitrium sudeticum",
    "BRC_num": "0820  1076",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 109,
    "IRno": 17,
    "CIno": "",
    "TJan": 2.1,
    "TJul": 12.6,
    "Prec": 1892,
    "Alt": 1344,
    "L": 7,
    "F": 3,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Harpanthus scutatus",
    "Concept": "Bry_781",
    "Taxon_name": "Harpanthus scutatus",
    "BRC_num": "0810   781",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 16,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 5,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 108,
    "IRno": 30,
    "CIno": "",
    "TJan": 3.2,
    "TJul": 13.3,
    "Prec": 1823,
    "Alt": 490,
    "L": 4,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 1,
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Rhabdoweisia crenulata",
    "Concept": "Bry_516",
    "Taxon_name": "Rhabdoweisia crenulata",
    "BRC_num": "0820   516",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 8,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 41,
    "GBno": 108,
    "IRno": 21,
    "CIno": "",
    "TJan": 2.5,
    "TJul": 12.9,
    "Prec": 2076,
    "Alt": 800,
    "L": 3,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Campylopus gracilis",
    "Concept": "Bry_145",
    "Taxon_name": "Campylopus gracilis",
    "BRC_num": "0820   145",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "F",
    "Sex": "Nil",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 42,
    "GBno": 107,
    "IRno": 29,
    "CIno": "",
    "TJan": 2.6,
    "TJul": 12.5,
    "Prec": 2018,
    "Alt": 900,
    "L": 7,
    "F": 8,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 2,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ephemerum recurvifolium",
    "Concept": "Bry_238",
    "Taxon_name": "Ephemerum recurvifolium",
    "BRC_num": "0820   238",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 1.5,
    "Per": "A",
    "LF1": "Tp",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 40,
    "Sp2": 55,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 83,
    "GBno": 107,
    "IRno": "",
    "CIno": "",
    "TJan": 3.6,
    "TJul": 16.1,
    "Prec": 705,
    "Alt": 270,
    "L": 7,
    "F": 4,
    "R": 8,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Seligeria pusilla",
    "Concept": "Bry_547",
    "Taxon_name": "Seligeria pusilla",
    "BRC_num": "0820   547",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 3,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 107,
    "IRno": 8,
    "CIno": "",
    "TJan": 2.5,
    "TJul": 14.1,
    "Prec": 1325,
    "Alt": 470,
    "L": 2,
    "F": 5,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 2,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cephalozia catenulata",
    "Concept": "Bry_715",
    "Taxon_name": "Cephalozia catenulata",
    "BRC_num": "0810   715",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 3,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 106,
    "IRno": 41,
    "CIno": "",
    "TJan": 3.3,
    "TJul": 13.4,
    "Prec": 1673,
    "Alt": 500,
    "L": 3,
    "F": 7,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": 2,
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": 3,
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Nardia geoscyphus",
    "Concept": "Bry_857",
    "Taxon_name": "Nardia geoscyphus",
    "BRC_num": "0810   857",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 105,
    "IRno": 12,
    "CIno": "",
    "TJan": 1.9,
    "TJul": 12.9,
    "Prec": 1522,
    "Alt": 1070,
    "L": 6,
    "F": 7,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 2,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pohlia lescuriana",
    "Concept": "Bry_1014",
    "Taxon_name": "Pohlia lescuriana",
    "BRC_num": "0820  1014",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 5,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "Ts",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 74,
    "GBno": 105,
    "IRno": 3,
    "CIno": "",
    "TJan": 3.6,
    "TJul": 15,
    "Prec": 1040,
    "Alt": 400,
    "L": 6,
    "F": 6,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "ZZZ - SYNONYMIZED",
    "Concept": "",
    "Taxon_name": "Plagiothecium ruthei",
    "BRC_num": "0820   455",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "O",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": 5,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 53,
    "GBno": 103,
    "IRno": "",
    "CIno": "",
    "TJan": 3.9,
    "TJul": 15.5,
    "Prec": 963,
    "Alt": 380,
    "L": 4,
    "F": 6,
    "R": 4,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Adelanthus decipiens",
    "Concept": "Bry_681",
    "Taxon_name": "Adelanthus decipiens",
    "BRC_num": "0810   681",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "O",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 80,
    "GBno": 102,
    "IRno": 45,
    "CIno": "",
    "TJan": 3.3,
    "TJul": 13.3,
    "Prec": 1943,
    "Alt": 610,
    "L": 4,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Campylophyllum calcareum",
    "Concept": "Bry_135",
    "Taxon_name": "Campylophyllum calcareum",
    "BRC_num": "0820   135",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 73,
    "GBno": 102,
    "IRno": 1,
    "CIno": "",
    "TJan": 3.3,
    "TJul": 15.7,
    "Prec": 799,
    "Alt": 500,
    "L": 2,
    "F": 5,
    "R": 8,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Haplomitrium hookeri",
    "Concept": "Bry_778",
    "Taxon_name": "Haplomitrium hookeri",
    "BRC_num": "0810   778",
    "ML": "L",
    "Ord": "Haplomitriales",
    "Stat": "N",
    "Len": 10,
    "Per": "PA",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 6,
    "Spend": 11,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 36,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 102,
    "IRno": 29,
    "CIno": "",
    "TJan": 2.4,
    "TJul": 12.6,
    "Prec": 1615,
    "Alt": 1100,
    "L": 6,
    "F": 8,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Riccardia incurvata",
    "Concept": "Bry_897",
    "Taxon_name": "Riccardia incurvata",
    "BRC_num": "0810   897",
    "ML": "L",
    "Ord": "Metzgeriales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Sc",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 4,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 25,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 102,
    "IRno": 19,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.4,
    "Prec": 1418,
    "Alt": 670,
    "L": 8,
    "F": 8,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Scapania aequiloba",
    "Concept": "Bry_919",
    "Taxon_name": "Scapania aequiloba",
    "BRC_num": "0810   919",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "We",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 23,
    "GBno": 102,
    "IRno": 9,
    "CIno": "",
    "TJan": 1.6,
    "TJul": 12.3,
    "Prec": 1873,
    "Alt": 1175,
    "L": 5,
    "F": 7,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 1,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Abietinella abietina",
    "Concept": "Bry_1353",
    "Taxon_name": "Thuidium abietinum",
    "BRC_num": "0820  1353",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "(CI)",
    "Elem": 26,
    "GBno": 101,
    "IRno": 10,
    "CIno": "",
    "TJan": 3.6,
    "TJul": 15.8,
    "Prec": 846,
    "Alt": 850,
    "L": 8,
    "F": 3,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bartramia halleriana",
    "Concept": "Bry_64",
    "Taxon_name": "Bartramia halleriana",
    "BRC_num": "0820    64",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 43,
    "GBno": 100,
    "IRno": 1,
    "CIno": "",
    "TJan": 1.7,
    "TJul": 12.6,
    "Prec": 2146,
    "Alt": 730,
    "L": 4,
    "F": 6,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Racomitrium affine",
    "Concept": "Bry_1073",
    "Taxon_name": "Racomitrium affine",
    "BRC_num": "0820  1073",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 100,
    "IRno": 8,
    "CIno": "",
    "TJan": 2.8,
    "TJul": 14,
    "Prec": 1426,
    "Alt": 425,
    "L": 7,
    "F": 2,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": 1,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Schistidium platyphyllum",
    "Concept": "Bry_289.1",
    "Taxon_name": "Schistidium platyphyllum",
    "BRC_num": "0820   289.1",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "At",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 99,
    "IRno": 3,
    "CIno": "",
    "TJan": 2.1,
    "TJul": 13.5,
    "Prec": 1203,
    "Alt": 480,
    "L": 7,
    "F": 8,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Leucodon sciuroides var. sciuroides",
    "Concept": "Bry_375.2",
    "Taxon_name": "Leucodon sciuroides var. sciuroides",
    "BRC_num": "0820   375.2",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "Fa",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 64,
    "GBno": 98,
    "IRno": 2,
    "CIno": "",
    "TJan": 3.8,
    "TJul": 15.4,
    "Prec": 1001,
    "Alt": 270,
    "L": 6,
    "F": 4,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Campylopus atrovirens var. atrovirens",
    "Concept": "Bry_137.1",
    "Taxon_name": "Campylopus atrovirens var. atrovirens",
    "BRC_num": "0820   137.1",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 130,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 70,
    "GBno": 95,
    "IRno": 3,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.1,
    "Prec": 1986,
    "Alt": 860,
    "L": 8,
    "F": 8,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pleurochaete squarrosa",
    "Concept": "Bry_462",
    "Taxon_name": "Pleurochaete squarrosa",
    "BRC_num": "0820   462",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 70,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "CI",
    "Elem": 92,
    "GBno": 95,
    "IRno": 5,
    "CIno": 7,
    "TJan": 5,
    "TJul": 15.9,
    "Prec": 933,
    "Alt": 300,
    "L": 8,
    "F": 2,
    "R": 9,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 1,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pohlia flexuosa",
    "Concept": "Bry_1016",
    "Taxon_name": "Pohlia flexuosa",
    "BRC_num": "0820  1016",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 20,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "Ts",
    "Tub": "",
    "Gem": "",
    "Bul": "F",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 42,
    "GBno": 93,
    "IRno": 18,
    "CIno": "",
    "TJan": 2.7,
    "TJul": 13.1,
    "Prec": 1835,
    "Alt": 800,
    "L": 5,
    "F": 7,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Racomitrium elongatum",
    "Concept": "Bry_1050",
    "Taxon_name": "Racomitrium elongatum",
    "BRC_num": "0820  1050",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 11,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 52,
    "GBno": 92,
    "IRno": 1,
    "CIno": "",
    "TJan": 2.4,
    "TJul": 13.4,
    "Prec": 1635,
    "Alt": 1175,
    "L": 8,
    "F": 4,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 2,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Encalypta ciliata",
    "Concept": "Bry_231",
    "Taxon_name": "Encalypta ciliata",
    "BRC_num": "0820   231",
    "ML": "M",
    "Ord": "Encalyptales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 9,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 30,
    "Sp2": 38,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 91,
    "IRno": 2,
    "CIno": "",
    "TJan": 1.4,
    "TJul": 12.3,
    "Prec": 1880,
    "Alt": 1100,
    "L": 4,
    "F": 5,
    "R": 7,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Riccia cavernosa",
    "Concept": "Bry_971",
    "Taxon_name": "Riccia cavernosa",
    "BRC_num": "0810   971",
    "ML": "L",
    "Ord": "Ricciales",
    "Stat": "N",
    "Len": 30,
    "Per": "A",
    "LF1": "St",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 7,
    "Spend": 11,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 60,
    "Sp2": 94,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 76,
    "GBno": 91,
    "IRno": 10,
    "CIno": "",
    "TJan": 3.8,
    "TJul": 15.4,
    "Prec": 848,
    "Alt": 250,
    "L": 7,
    "F": 9,
    "R": 7,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum pseudotriquetrum var. bimum",
    "Concept": "Bry_113.1",
    "Taxon_name": "Bryum pseudotriquetrum var. bimum",
    "BRC_num": "0820   113.1",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "R",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 6,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 25,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 36,
    "GBno": 90,
    "IRno": 12,
    "CIno": 1,
    "TJan": 3.6,
    "TJul": 15.2,
    "Prec": 984,
    "Alt": 75,
    "L": 8,
    "F": 9,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cephaloziella stellulifera",
    "Concept": "Bry_733",
    "Taxon_name": "Cephaloziella stellulifera",
    "BRC_num": "0810   733",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 8,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 2,
    "Spend": 7,
    "Spbeg2": 11,
    "Spend2": 11,
    "Sp1": 9,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "CI",
    "Elem": 92,
    "GBno": 90,
    "IRno": 9,
    "CIno": 7,
    "TJan": 5.2,
    "TJul": 15.3,
    "Prec": 1165,
    "Alt": 400,
    "L": 7,
    "F": 5,
    "R": 5,
    "N": 1,
    "S": 0,
    "HM": 3,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Plagiothecium denticulatum var. obtusifolium",
    "Concept": "Bry_449.2",
    "Taxon_name": "Plagiothecium denticulatum var. obtusifolium",
    "BRC_num": "0820   449.2",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 8,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 90,
    "IRno": 8,
    "CIno": "",
    "TJan": 1.2,
    "TJul": 11.9,
    "Prec": 1983,
    "Alt": 1205,
    "L": 5,
    "F": 6,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Rhynchostegiella curviseta",
    "Concept": "Bry_528",
    "Taxon_name": "Rhynchostegiella curviseta",
    "BRC_num": "0820   528",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 13,
    "Sp2": 16,
    "E": "E",
    "W": "(W)",
    "Sc": "",
    "IR": "(IR)",
    "NI": "NI",
    "CI": "(CI)",
    "Elem": 91,
    "GBno": 90,
    "IRno": 1,
    "CIno": "",
    "TJan": 3.9,
    "TJul": 16.1,
    "Prec": 802,
    "Alt": 200,
    "L": 2,
    "F": 9,
    "R": 7,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Discelium nudum",
    "Concept": "Bry_212",
    "Taxon_name": "Discelium nudum",
    "BRC_num": "0820   212",
    "ML": "M",
    "Ord": "Funariales",
    "Stat": "N",
    "Len": 2,
    "Per": "A",
    "LF1": "Tp",
    "LF2": "",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 89,
    "IRno": 2,
    "CIno": "",
    "TJan": 2.4,
    "TJul": 14.1,
    "Prec": 1208,
    "Alt": 520,
    "L": 7,
    "F": 6,
    "R": 3,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tritomaria exsecta",
    "Concept": "Bry_957",
    "Taxon_name": "Tritomaria exsecta",
    "BRC_num": "0810   957",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 89,
    "IRno": 9,
    "CIno": "",
    "TJan": 2.7,
    "TJul": 12.9,
    "Prec": 2155,
    "Alt": 380,
    "L": 5,
    "F": 5,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": 2,
    "RW": "",
    "SR": "",
    "SO": 2,
    "PT": 2,
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": 1,
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Weissia perssonii",
    "Concept": "Bry_1031",
    "Taxon_name": "Weissia perssonii",
    "BRC_num": "0820  1031",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 71,
    "GBno": 89,
    "IRno": 12,
    "CIno": 2,
    "TJan": 4.9,
    "TJul": 14.5,
    "Prec": 1320,
    "Alt": 300,
    "L": 8,
    "F": 4,
    "R": 6,
    "N": 3,
    "S": 3,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Campyliadelphus elodes",
    "Concept": "Bry_130",
    "Taxon_name": "Campyliadelphus elodes",
    "BRC_num": "0820   130",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 70,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 17,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 88,
    "IRno": 29,
    "CIno": "",
    "TJan": 4,
    "TJul": 14.9,
    "Prec": 994,
    "Alt": 380,
    "L": 8,
    "F": 9,
    "R": 7,
    "N": 3,
    "S": 2,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 1,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fontinalis antipyretica var. gracilis",
    "Concept": "Bry_276.4",
    "Taxon_name": "Fontinalis antipyretica var. gracilis",
    "BRC_num": "0820   276.4",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 400,
    "Per": "P",
    "LF1": "At",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 54,
    "GBno": 88,
    "IRno": 6,
    "CIno": "",
    "TJan": 2.4,
    "TJul": 13.1,
    "Prec": 1424,
    "Alt": 760,
    "L": 7,
    "F": 12,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Platygyrium repens",
    "Concept": "Bry_1011",
    "Taxon_name": "Platygyrium repens",
    "BRC_num": "0820  1011",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 76,
    "GBno": 88,
    "IRno": "",
    "CIno": "",
    "TJan": 3.5,
    "TJul": 16,
    "Prec": 707,
    "Alt": 200,
    "L": 4,
    "F": 4,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Philonotis arnellii",
    "Concept": "Bry_438",
    "Taxon_name": "Philonotis arnellii",
    "BRC_num": "0820   438",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 22,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "CI",
    "Elem": 73,
    "GBno": 87,
    "IRno": 2,
    "CIno": 7,
    "TJan": 3.1,
    "TJul": 13.9,
    "Prec": 1458,
    "Alt": 640,
    "L": 6,
    "F": 6,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Brachydontium trichodes",
    "Concept": "Bry_71",
    "Taxon_name": "Brachydontium trichodes",
    "BRC_num": "0820    71",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 2,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 5,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 72,
    "GBno": 86,
    "IRno": 3,
    "CIno": "",
    "TJan": 2.2,
    "TJul": 13.6,
    "Prec": 1480,
    "Alt": 1000,
    "L": 3,
    "F": 6,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ditrichum zonatum",
    "Concept": "Bry_221",
    "Taxon_name": "Ditrichum zonatum",
    "BRC_num": "0820   221",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "U",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 13,
    "GBno": 86,
    "IRno": 4,
    "CIno": "",
    "TJan": 1.3,
    "TJul": 11.9,
    "Prec": 2161,
    "Alt": 880,
    "L": 7,
    "F": 4,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Leptoscyphus cuneifolius",
    "Concept": "Bry_853",
    "Taxon_name": "Leptoscyphus cuneifolius",
    "BRC_num": "0810   853",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "F",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 80,
    "GBno": 86,
    "IRno": 23,
    "CIno": "",
    "TJan": 2.9,
    "TJul": 12.7,
    "Prec": 2169,
    "Alt": 760,
    "L": 5,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Plagiochila carringtonii",
    "Concept": "Bry_786",
    "Taxon_name": "Plagiochila carringtonii",
    "BRC_num": "0810   786",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 41,
    "GBno": 86,
    "IRno": 2,
    "CIno": "",
    "TJan": 1.7,
    "TJul": 11.6,
    "Prec": 2254,
    "Alt": 1070,
    "L": 5,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Plagiothecium laetum",
    "Concept": "Bry_450",
    "Taxon_name": "Plagiothecium laetum",
    "BRC_num": "0820   450",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 23,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 12,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 86,
    "IRno": 3,
    "CIno": "",
    "TJan": 2.4,
    "TJul": 13.9,
    "Prec": 1185,
    "Alt": 490,
    "L": 3,
    "F": 5,
    "R": 3,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Scapania ornithopodioides",
    "Concept": "Bry_932",
    "Taxon_name": "Scapania ornithopodioides",
    "BRC_num": "0810   932",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "R",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 41,
    "GBno": 86,
    "IRno": 14,
    "CIno": "",
    "TJan": 1.8,
    "TJul": 11.8,
    "Prec": 2207,
    "Alt": 1000,
    "L": 5,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Aloina ambigua",
    "Concept": "Bry_10",
    "Taxon_name": "Aloina ambigua",
    "BRC_num": "0820    10",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": 10,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "CI",
    "Elem": 83,
    "GBno": 85,
    "IRno": 4,
    "CIno": 4,
    "TJan": 3.9,
    "TJul": 16,
    "Prec": 738,
    "Alt": 220,
    "L": 8,
    "F": 4,
    "R": 7,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hamatocaulis vernicosus",
    "Concept": "Bry_229",
    "Taxon_name": "Hamatocaulis vernicosus",
    "BRC_num": "0820   229",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 46,
    "GBno": 85,
    "IRno": 13,
    "CIno": "",
    "TJan": 3.1,
    "TJul": 14,
    "Prec": 1445,
    "Alt": 510,
    "L": 8,
    "F": 9,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum austinii",
    "Concept": "Bry_560.2",
    "Taxon_name": "Sphagnum austinii",
    "BRC_num": "0820   560.2",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 27,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 70,
    "GBno": 84,
    "IRno": 46,
    "CIno": "",
    "TJan": 2.8,
    "TJul": 13.1,
    "Prec": 1417,
    "Alt": 520,
    "L": 8,
    "F": 8,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tortella inflexa",
    "Concept": "Bry_605",
    "Taxon_name": "Tortella inflexa",
    "BRC_num": "0820   605",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 6,
    "Per": "P",
    "LF1": "Tp",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 10,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 91,
    "GBno": 84,
    "IRno": "",
    "CIno": "",
    "TJan": 3.8,
    "TJul": 16.2,
    "Prec": 791,
    "Alt": 250,
    "L": 2,
    "F": 5,
    "R": 9,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Solenostoma subellipticum",
    "Concept": "Bry_879",
    "Taxon_name": "Jungermannia subelliptica",
    "BRC_num": "0810   879",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 4,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 83,
    "IRno": 13,
    "CIno": "",
    "TJan": 1.8,
    "TJul": 12.2,
    "Prec": 1712,
    "Alt": 1070,
    "L": 5,
    "F": 7,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": 1,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Microbryum starckeanum",
    "Concept": "Bry_500.2",
    "Taxon_name": "Microbryum starckeanum",
    "BRC_num": "0820   500.2",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 2,
    "Per": "A",
    "LF1": "Ts",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 11,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 19,
    "Sp2": 42,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "CI",
    "Elem": 92,
    "GBno": 83,
    "IRno": 2,
    "CIno": 2,
    "TJan": 5,
    "TJul": 15.7,
    "Prec": 954,
    "Alt": 360,
    "L": 8,
    "F": 3,
    "R": 7,
    "N": 3,
    "S": 1,
    "HM": 2,
    "RH": "",
    "RS": "",
    "RW": 1,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Orthothecium rufescens",
    "Concept": "Bry_413",
    "Taxon_name": "Orthothecium rufescens",
    "BRC_num": "0820   413",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 83,
    "IRno": 9,
    "CIno": "",
    "TJan": 1.5,
    "TJul": 12.2,
    "Prec": 2001,
    "Alt": 1250,
    "L": 6,
    "F": 7,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Calypogeia azurea",
    "Concept": "Bry_711",
    "Taxon_name": "Calypogeia azurea",
    "BRC_num": "0810   711",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 52,
    "GBno": 82,
    "IRno": 16,
    "CIno": "",
    "TJan": 1.9,
    "TJul": 12.6,
    "Prec": 1658,
    "Alt": 1000,
    "L": 3,
    "F": 7,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 1,
    "DV": 3,
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fossombronia incurva",
    "Concept": "Bry_962",
    "Taxon_name": "Fossombronia incurva",
    "BRC_num": "0810   962",
    "ML": "L",
    "Ord": "Fossombroniales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Sc",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 22,
    "Sp2": 32,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 72,
    "GBno": 82,
    "IRno": 25,
    "CIno": 1,
    "TJan": 3.5,
    "TJul": 14,
    "Prec": 1374,
    "Alt": 500,
    "L": 7,
    "F": 8,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Glyphomitrium daviesii",
    "Concept": "Bry_287",
    "Taxon_name": "Glyphomitrium daviesii",
    "BRC_num": "0820   287",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 40,
    "Sp2": 50,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 81,
    "GBno": 82,
    "IRno": 15,
    "CIno": "",
    "TJan": 3.5,
    "TJul": 12.9,
    "Prec": 1895,
    "Alt": 490,
    "L": 7,
    "F": 4,
    "R": 4,
    "N": 2,
    "S": 2,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Scapania uliginosa",
    "Concept": "Bry_937",
    "Taxon_name": "Scapania uliginosa",
    "BRC_num": "0810   937",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "R",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 6,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 82,
    "IRno": "",
    "CIno": "",
    "TJan": 0.8,
    "TJul": 11.6,
    "Prec": 2136,
    "Alt": 1160,
    "L": 7,
    "F": 9,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Moerckia hibernica agg.",
    "Concept": "Bry_850",
    "Taxon_name": "Moerckia hibernica",
    "BRC_num": "0810   850",
    "ML": "L",
    "Ord": "Metzgeriales",
    "Stat": "N",
    "Len": 35,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 3,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 32,
    "Sp2": 52,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 81,
    "IRno": 20,
    "CIno": "",
    "TJan": 3.1,
    "TJul": 13.9,
    "Prec": 1179,
    "Alt": 800,
    "L": 7,
    "F": 8,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum intermedium",
    "Concept": "Bry_100",
    "Taxon_name": "Bryum intermedium",
    "BRC_num": "0820   100",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 75,
    "GBno": 80,
    "IRno": 1,
    "CIno": "",
    "TJan": 3.5,
    "TJul": 15.2,
    "Prec": 951,
    "Alt": 310,
    "L": 8,
    "F": 6,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Distichium inclinatum",
    "Concept": "Bry_214",
    "Taxon_name": "Distichium inclinatum",
    "BRC_num": "0820   214",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 30,
    "Sp2": 40,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 79,
    "IRno": 13,
    "CIno": "",
    "TJan": 3.4,
    "TJul": 13.4,
    "Prec": 1362,
    "Alt": 950,
    "L": 8,
    "F": 6,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fissidens rufulus",
    "Concept": "Bry_272",
    "Taxon_name": "Fissidens rufulus",
    "BRC_num": "0820   272",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 78,
    "IRno": 9,
    "CIno": "",
    "TJan": 2.8,
    "TJul": 14.2,
    "Prec": 1225,
    "Alt": 365,
    "L": 5,
    "F": 9,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum angustifolium",
    "Concept": "Bry_571.3",
    "Taxon_name": "Sphagnum angustifolium",
    "BRC_num": "0820   571.3",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 22,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 78,
    "IRno": 14,
    "CIno": "",
    "TJan": 2.5,
    "TJul": 13.5,
    "Prec": 1499,
    "Alt": 500,
    "L": 7,
    "F": 8,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Eremonotus myriocarpus",
    "Concept": "Bry_753",
    "Taxon_name": "Eremonotus myriocarpus",
    "BRC_num": "0810   753",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 8,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 6,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 17,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 13,
    "GBno": 77,
    "IRno": 9,
    "CIno": "",
    "TJan": 1.9,
    "TJul": 12.2,
    "Prec": 2176,
    "Alt": 1220,
    "L": 5,
    "F": 8,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hymenostylium recurvirostrum var. recurvirostrum",
    "Concept": "Bry_323.3",
    "Taxon_name": "Hymenostylium recurvirostrum",
    "BRC_num": "0820   323.3",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 63,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 4,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 77,
    "IRno": 8,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.4,
    "Prec": 1589,
    "Alt": 730,
    "L": 6,
    "F": 8,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 2,
    "RH": 3,
    "RS": 3,
    "RW": 2,
    "SR": 2,
    "SO": 2,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cephalozia macrostachya",
    "Concept": "Bry_720",
    "Taxon_name": "Cephalozia macrostachya",
    "BRC_num": "0810   720",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "R",
    "Spbeg": 5,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 42,
    "GBno": 76,
    "IRno": 11,
    "CIno": "",
    "TJan": 3.6,
    "TJul": 14.9,
    "Prec": 1101,
    "Alt": 300,
    "L": 7,
    "F": 8,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": 3,
    "GS": 2,
    "DW": "",
    "DV": 3,
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Plagiopus oederianus",
    "Concept": "Bry_447",
    "Taxon_name": "Plagiopus oederianus",
    "BRC_num": "0820   447",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 25,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 26,
    "GBno": 76,
    "IRno": 1,
    "CIno": "",
    "TJan": 1.3,
    "TJul": 12.6,
    "Prec": 1867,
    "Alt": 950,
    "L": 6,
    "F": 5,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphenolobopsis pearsonii",
    "Concept": "Bry_730",
    "Taxon_name": "Sphenolobopsis pearsonii",
    "BRC_num": "0810   730",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 41,
    "GBno": 76,
    "IRno": 15,
    "CIno": "",
    "TJan": 2.6,
    "TJul": 12.7,
    "Prec": 2154,
    "Alt": 980,
    "L": 5,
    "F": 6,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Ulota calvescens",
    "Concept": "Bry_638",
    "Taxon_name": "Ulota calvescens",
    "BRC_num": "0820   638",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 22,
    "Sp2": 26,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 81,
    "GBno": 76,
    "IRno": 29,
    "CIno": "",
    "TJan": 3.4,
    "TJul": 13.1,
    "Prec": 1887,
    "Alt": 430,
    "L": 6,
    "F": 5,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Hennediella stanfordensis",
    "Concept": "Bry_1003",
    "Taxon_name": "Hennediella stanfordensis",
    "BRC_num": "0820  1003",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "AN",
    "Len": 7,
    "Per": "AP",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 83,
    "GBno": 75,
    "IRno": 1,
    "CIno": "",
    "TJan": 3.9,
    "TJul": 15.8,
    "Prec": 775,
    "Alt": 97,
    "L": 6,
    "F": 5,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 1,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Leptobarbula berica",
    "Concept": "Bry_1053",
    "Taxon_name": "Leptobarbula berica",
    "BRC_num": "0820  1053",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 2,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tp",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 7,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 91,
    "GBno": 75,
    "IRno": 1,
    "CIno": "",
    "TJan": 3.9,
    "TJul": 16.1,
    "Prec": 778,
    "Alt": 270,
    "L": 1,
    "F": 5,
    "R": 8,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Philonotis caespitosa",
    "Concept": "Bry_436",
    "Taxon_name": "Philonotis caespitosa",
    "BRC_num": "0820   436",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 56,
    "GBno": 75,
    "IRno": 10,
    "CIno": 1,
    "TJan": 3.5,
    "TJul": 14.4,
    "Prec": 1237,
    "Alt": 950,
    "L": 8,
    "F": 9,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Campylopus subulatus",
    "Concept": "Bry_147",
    "Taxon_name": "Campylopus subulatus",
    "BRC_num": "0820   147",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 30,
    "Per": "PA",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 72,
    "GBno": 74,
    "IRno": 5,
    "CIno": 1,
    "TJan": 3.2,
    "TJul": 13.4,
    "Prec": 1847,
    "Alt": 850,
    "L": 8,
    "F": 7,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": 1,
    "RW": 1,
    "SR": "",
    "SO": 3,
    "PT": 1,
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hypnum hamulosum",
    "Concept": "Bry_352",
    "Taxon_name": "Hypnum hamulosum",
    "BRC_num": "0820   352",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 74,
    "IRno": "",
    "CIno": "",
    "TJan": 1.1,
    "TJul": 11.8,
    "Prec": 2084,
    "Alt": 1000,
    "L": 6,
    "F": 5,
    "R": 7,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Riccia beyrichiana",
    "Concept": "Bry_903",
    "Taxon_name": "Riccia beyrichiana",
    "BRC_num": "0810   903",
    "ML": "L",
    "Ord": "Ricciales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "St",
    "LF2": "Mt",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 90,
    "Sp2": 130,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 52,
    "GBno": 74,
    "IRno": 20,
    "CIno": 3,
    "TJan": 4.1,
    "TJul": 14.2,
    "Prec": 1402,
    "Alt": 800,
    "L": 8,
    "F": 5,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Aneura mirabilis",
    "Concept": "Bry_746",
    "Taxon_name": "Cryptothallus mirabilis",
    "BRC_num": "0810   746",
    "ML": "L",
    "Ord": "Metzgeriales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "St",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 1,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 38,
    "Sp2": 52,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 73,
    "IRno": 8,
    "CIno": "",
    "TJan": 3.1,
    "TJul": 14.2,
    "Prec": 1341,
    "Alt": 320,
    "L": 0,
    "F": 8,
    "R": 3,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 2,
    "PT": 3,
    "GS": "",
    "DW": 1,
    "DV": 2,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Didymodon acutus",
    "Concept": "Bry_44",
    "Taxon_name": "Didymodon acutus",
    "BRC_num": "0820    44",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Ts",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "(CI)",
    "Elem": 86,
    "GBno": 73,
    "IRno": 4,
    "CIno": "",
    "TJan": 4,
    "TJul": 15.6,
    "Prec": 901,
    "Alt": 600,
    "L": 8,
    "F": 3,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Gymnostomum calcareum",
    "Concept": "Bry_322",
    "Taxon_name": "Gymnostomum calcareum",
    "BRC_num": "0820   322",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 84,
    "GBno": 73,
    "IRno": 24,
    "CIno": "",
    "TJan": 3.4,
    "TJul": 13.8,
    "Prec": 1498,
    "Alt": 560,
    "L": 3,
    "F": 5,
    "R": 9,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": 1,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tortula atrovirens",
    "Concept": "Bry_178",
    "Taxon_name": "Tortula atrovirens",
    "BRC_num": "0820   178",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 4,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 12,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 26,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "CI",
    "Elem": 86,
    "GBno": 73,
    "IRno": 5,
    "CIno": 6,
    "TJan": 5.6,
    "TJul": 15.5,
    "Prec": 949,
    "Alt": 30,
    "L": 8,
    "F": 5,
    "R": 6,
    "N": 4,
    "S": 4,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Dicranodontium uncinatum",
    "Concept": "Bry_192",
    "Taxon_name": "Dicranodontium uncinatum",
    "BRC_num": "0820   192",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 110,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 18,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 42,
    "GBno": 72,
    "IRno": 8,
    "CIno": "",
    "TJan": 2,
    "TJul": 12.1,
    "Prec": 2210,
    "Alt": 750,
    "L": 5,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Jamesoniella autumnalis",
    "Concept": "Bry_785",
    "Taxon_name": "Jamesoniella autumnalis",
    "BRC_num": "0810   785",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 2,
    "Spend": 3,
    "Spbeg2": 8,
    "Spend2": 10,
    "Sp1": 11,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 56,
    "GBno": 72,
    "IRno": "",
    "CIno": "",
    "TJan": 2.3,
    "TJul": 13.1,
    "Prec": 2184,
    "Alt": 360,
    "L": 4,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Herzogiella seligeri",
    "Concept": "Bry_360",
    "Taxon_name": "Herzogiella seligeri",
    "BRC_num": "0820   360",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 53,
    "GBno": 71,
    "IRno": "",
    "CIno": "",
    "TJan": 3.6,
    "TJul": 16.1,
    "Prec": 734,
    "Alt": 270,
    "L": 4,
    "F": 6,
    "R": 3,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 1,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Ricciocarpos natans",
    "Concept": "Bry_917",
    "Taxon_name": "Ricciocarpos natans",
    "BRC_num": "0810   917",
    "ML": "L",
    "Ord": "Ricciales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Le",
    "LF2": "St",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 42,
    "Sp2": 56,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 86,
    "GBno": 71,
    "IRno": 11,
    "CIno": "",
    "TJan": 3.7,
    "TJul": 15.9,
    "Prec": 700,
    "Alt": 150,
    "L": 7,
    "F": 11,
    "R": 7,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": 2,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": 3
  },
  {
    "Name_new": "Amphidium lapponicum",
    "Concept": "Bry_21",
    "Taxon_name": "Amphidium lapponicum",
    "BRC_num": "0820    21",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 35,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 70,
    "IRno": 1,
    "CIno": "",
    "TJan": 1.2,
    "TJul": 12,
    "Prec": 2099,
    "Alt": 1150,
    "L": 6,
    "F": 5,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Calypogeia integristipula",
    "Concept": "Bry_708.1",
    "Taxon_name": "Calypogeia integristipula",
    "BRC_num": "0810   708.1",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Sc",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": 4,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 13,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "(IR)",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 70,
    "IRno": 4,
    "CIno": "",
    "TJan": 2.7,
    "TJul": 14.2,
    "Prec": 1183,
    "Alt": 850,
    "L": 3,
    "F": 7,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cladopodiella francisci",
    "Concept": "Bry_740",
    "Taxon_name": "Cladopodiella francisci",
    "BRC_num": "0810   740",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 8,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 5,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 70,
    "IRno": 5,
    "CIno": "",
    "TJan": 3.6,
    "TJul": 14.7,
    "Prec": 1212,
    "Alt": 500,
    "L": 6,
    "F": 7,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 2,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": 1,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fossombronia foveolata",
    "Concept": "Bry_758",
    "Taxon_name": "Fossombronia foveolata",
    "BRC_num": "0810   758",
    "ML": "L",
    "Ord": "Fossombroniales",
    "Stat": "N",
    "Len": 15,
    "Per": "AP",
    "LF1": "Sc",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 7,
    "Spend": 11,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 35,
    "Sp2": 50,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 70,
    "IRno": 19,
    "CIno": "",
    "TJan": 3.8,
    "TJul": 14.1,
    "Prec": 1314,
    "Alt": 345,
    "L": 7,
    "F": 9,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 2,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Platyhypnidium lusitanicum",
    "Concept": "Bry_244",
    "Taxon_name": "Rhynchostegium alopecuroides",
    "BRC_num": "0820   244",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "At",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": 1,
    "Spend": 2,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 71,
    "GBno": 70,
    "IRno": 14,
    "CIno": "",
    "TJan": 3.6,
    "TJul": 14,
    "Prec": 1569,
    "Alt": 450,
    "L": 5,
    "F": 11,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Weissia brachycarpa var. brachycarpa",
    "Concept": "Bry_642.1",
    "Taxon_name": "Weissia brachycarpa var. brachycarpa",
    "BRC_num": "0820   642.1",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "AP",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 3,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 34,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "NI",
    "CI": "",
    "Elem": 86,
    "GBno": 70,
    "IRno": 1,
    "CIno": "",
    "TJan": 4,
    "TJul": 15.6,
    "Prec": 901,
    "Alt": 170,
    "L": 7,
    "F": 5,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Weissia controversa var. densifolia",
    "Concept": "Bry_639.3",
    "Taxon_name": "Weissia controversa var. densifolia",
    "BRC_num": "0820   639.3",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "(S)",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 83,
    "GBno": 70,
    "IRno": 6,
    "CIno": "",
    "TJan": 4.5,
    "TJul": 14.8,
    "Prec": 1284,
    "Alt": 580,
    "L": 7,
    "F": 4,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 4,
    "RH": "",
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hygroamblystegium humile",
    "Concept": "Bry_18",
    "Taxon_name": "Amblystegium humile",
    "BRC_num": "0820    18",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 35,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 76,
    "GBno": 69,
    "IRno": 2,
    "CIno": "",
    "TJan": 3.7,
    "TJul": 16.1,
    "Prec": 722,
    "Alt": 107,
    "L": 7,
    "F": 9,
    "R": 7,
    "N": 7,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum subsecundum s.str.",
    "Concept": "Bry_578.5",
    "Taxon_name": "Sphagnum subsecundum",
    "BRC_num": "0820   578.5",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 7,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 27,
    "Sp2": 29,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 69,
    "IRno": 5,
    "CIno": "",
    "TJan": 2.8,
    "TJul": 13.7,
    "Prec": 1556,
    "Alt": 740,
    "L": 8,
    "F": 9,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum weigelii",
    "Concept": "Bry_123",
    "Taxon_name": "Bryum weigelii",
    "BRC_num": "0820   123",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 107,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "(IR)",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 68,
    "IRno": "",
    "CIno": "",
    "TJan": 0.7,
    "TJul": 11.7,
    "Prec": 1836,
    "Alt": 1070,
    "L": 7,
    "F": 9,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cololejeunea rossettiana",
    "Concept": "Bry_743",
    "Taxon_name": "Cololejeunea rossettiana",
    "BRC_num": "0810   743",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 4,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 92,
    "GBno": 68,
    "IRno": 15,
    "CIno": "",
    "TJan": 3.6,
    "TJul": 14.8,
    "Prec": 1078,
    "Alt": 400,
    "L": 3,
    "F": 5,
    "R": 7,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 2,
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": 1,
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": 3,
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Pterigynandrum filiforme",
    "Concept": "Bry_511",
    "Taxon_name": "Pterigynandrum filiforme",
    "BRC_num": "0820   511",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "X",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 12,
    "E": "E",
    "W": "(W)",
    "Sc": "S",
    "IR": "(IR)",
    "NI": "(NI)",
    "CI": "",
    "Elem": 46,
    "GBno": 68,
    "IRno": "",
    "CIno": "",
    "TJan": 0.6,
    "TJul": 11.6,
    "Prec": 1773,
    "Alt": 1100,
    "L": 6,
    "F": 5,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Amblyodon dealbatus",
    "Concept": "Bry_13",
    "Taxon_name": "Amblyodon dealbatus",
    "BRC_num": "0820    13",
    "ML": "M",
    "Ord": "Splachnales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Ts",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 40,
    "Sp2": 40,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 67,
    "IRno": 16,
    "CIno": "",
    "TJan": 2.9,
    "TJul": 13.1,
    "Prec": 1346,
    "Alt": 870,
    "L": 8,
    "F": 8,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Anthelia juratzkana",
    "Concept": "Bry_687",
    "Taxon_name": "Anthelia juratzkana",
    "BRC_num": "0810   687",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 6,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 21,
    "E": "",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 16,
    "GBno": 67,
    "IRno": 7,
    "CIno": "",
    "TJan": 1.1,
    "TJul": 11.6,
    "Prec": 2066,
    "Alt": 1340,
    "L": 5,
    "F": 7,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Gymnostomum viridulum",
    "Concept": "Bry_1037",
    "Taxon_name": "Gymnostomum viridulum",
    "BRC_num": "0820  1037",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tp",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 4,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "CI",
    "Elem": 91,
    "GBno": 66,
    "IRno": 15,
    "CIno": 1,
    "TJan": 5.1,
    "TJul": 15.6,
    "Prec": 1057,
    "Alt": 230,
    "L": 6,
    "F": 3,
    "R": 9,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Porella pinnata",
    "Concept": "Bry_884",
    "Taxon_name": "Porella pinnata",
    "BRC_num": "0810   884",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "At",
    "LF2": "Fa",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 30,
    "Sp2": 42,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 81,
    "GBno": 66,
    "IRno": 19,
    "CIno": "",
    "TJan": 4.3,
    "TJul": 14.8,
    "Prec": 1301,
    "Alt": 300,
    "L": 5,
    "F": 9,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Campylopus setifolius",
    "Concept": "Bry_143",
    "Taxon_name": "Campylopus setifolius",
    "BRC_num": "0820   143",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 130,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "R",
    "Lvs": "F",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 70,
    "GBno": 65,
    "IRno": 47,
    "CIno": "",
    "TJan": 3.4,
    "TJul": 13.2,
    "Prec": 1892,
    "Alt": 800,
    "L": 6,
    "F": 9,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 2,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hedwigia integrifolia",
    "Concept": "Bry_329",
    "Taxon_name": "Hedwigia integrifolia",
    "BRC_num": "0820   329",
    "ML": "M",
    "Ord": "Hedwigiales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "O",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 21,
    "Sp2": 27,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 71,
    "GBno": 65,
    "IRno": 8,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.1,
    "Prec": 1982,
    "Alt": 720,
    "L": 7,
    "F": 2,
    "R": 4,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Marsupella sphacelata",
    "Concept": "Bry_837",
    "Taxon_name": "Marsupella sphacelata",
    "BRC_num": "0810   837",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 5,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 23,
    "GBno": 65,
    "IRno": 6,
    "CIno": "",
    "TJan": 1.3,
    "TJul": 11.9,
    "Prec": 2020,
    "Alt": 1225,
    "L": 7,
    "F": 9,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pterygoneurum ovatum",
    "Concept": "Bry_510",
    "Taxon_name": "Pterygoneurum ovatum",
    "BRC_num": "0820   510",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 2,
    "Per": "A",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 40,
    "E": "E",
    "W": "(W)",
    "Sc": "S",
    "IR": "(IR)",
    "NI": "",
    "CI": "",
    "Elem": 86,
    "GBno": 65,
    "IRno": "",
    "CIno": "",
    "TJan": 3.5,
    "TJul": 15.8,
    "Prec": 688,
    "Alt": 305,
    "L": 8,
    "F": 3,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum tenuisetum",
    "Concept": "Bry_670",
    "Taxon_name": "Bryum tenuisetum",
    "BRC_num": "0820   670",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D(M)",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "CI",
    "Elem": 53,
    "GBno": 64,
    "IRno": 2,
    "CIno": 2,
    "TJan": 3.7,
    "TJul": 14.5,
    "Prec": 1300,
    "Alt": 350,
    "L": 8,
    "F": 6,
    "R": 3,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Didymodon umbrosus",
    "Concept": "Bry_1046",
    "Taxon_name": "Didymodon umbrosus",
    "BRC_num": "0820  1046",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "AN",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 81,
    "GBno": 64,
    "IRno": 1,
    "CIno": "",
    "TJan": 4,
    "TJul": 16.2,
    "Prec": 728,
    "Alt": 60,
    "L": 3,
    "F": 6,
    "R": 8,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Brachythecium salebrosum",
    "Concept": "Bry_82",
    "Taxon_name": "Brachythecium salebrosum",
    "BRC_num": "0820    82",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 70,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 36,
    "GBno": 63,
    "IRno": "",
    "CIno": "",
    "TJan": 3.5,
    "TJul": 16.1,
    "Prec": 668,
    "Alt": 300,
    "L": 5,
    "F": 6,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": 2,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Mastigophora woodsii",
    "Concept": "Bry_842",
    "Taxon_name": "Mastigophora woodsii",
    "BRC_num": "0810   842",
    "ML": "L",
    "Ord": "Lepicoleales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "Nil",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 41,
    "GBno": 63,
    "IRno": 13,
    "CIno": "",
    "TJan": 2.3,
    "TJul": 12.1,
    "Prec": 2175,
    "Alt": 1000,
    "L": 5,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fissidens crispus",
    "Concept": "Bry_1036",
    "Taxon_name": "Fissidens limbatus",
    "BRC_num": "0820  1036",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 7,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "A",
    "Spbeg": 12,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "CI",
    "Elem": 91,
    "GBno": 62,
    "IRno": 6,
    "CIno": 1,
    "TJan": 4.9,
    "TJul": 15.3,
    "Prec": 1143,
    "Alt": 175,
    "L": 3,
    "F": 5,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 2,
    "RW": 2,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Anomobryum concinnatum",
    "Concept": "Bry_28",
    "Taxon_name": "Anomobryum julaceum var. concinnatum",
    "BRC_num": "0820    28",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 59,
    "IRno": 11,
    "CIno": "",
    "TJan": 2.4,
    "TJul": 12.9,
    "Prec": 1652,
    "Alt": 1100,
    "L": 7,
    "F": 6,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cephalozia pleniceps",
    "Concept": "Bry_722",
    "Taxon_name": "Cephalozia pleniceps",
    "BRC_num": "0810   722",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 4,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 59,
    "IRno": 11,
    "CIno": "",
    "TJan": 2.6,
    "TJul": 13.1,
    "Prec": 1531,
    "Alt": 1080,
    "L": 4,
    "F": 8,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 2,
    "PT": 2,
    "GS": "",
    "DW": 1,
    "DV": 2,
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Meesia uliginosa",
    "Concept": "Bry_377",
    "Taxon_name": "Meesia uliginosa",
    "BRC_num": "0820   377",
    "ML": "M",
    "Ord": "Splachnales",
    "Stat": "N",
    "Len": 35,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 40,
    "Sp2": 50,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 58,
    "IRno": 1,
    "CIno": "",
    "TJan": 1,
    "TJul": 11.9,
    "Prec": 1717,
    "Alt": 990,
    "L": 8,
    "F": 8,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pohlia filum",
    "Concept": "Bry_473",
    "Taxon_name": "Pohlia filum",
    "BRC_num": "0820   473",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 40,
    "Per": "PA",
    "LF1": "Ts",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "F",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 58,
    "IRno": 6,
    "CIno": "",
    "TJan": 1.6,
    "TJul": 12.5,
    "Prec": 1553,
    "Alt": 330,
    "L": 7,
    "F": 7,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Anastrophyllum donnianum",
    "Concept": "Bry_684",
    "Taxon_name": "Anastrophyllum donnianum",
    "BRC_num": "0810   684",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "We",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 8,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 41,
    "GBno": 57,
    "IRno": "",
    "CIno": "",
    "TJan": 0.7,
    "TJul": 11.1,
    "Prec": 2307,
    "Alt": 1060,
    "L": 5,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Mnium thomsonii",
    "Concept": "Bry_387",
    "Taxon_name": "Mnium thomsonii",
    "BRC_num": "0820   387",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 25,
    "Sp2": 36,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 57,
    "IRno": 8,
    "CIno": "",
    "TJan": 1.1,
    "TJul": 12.1,
    "Prec": 1973,
    "Alt": 1180,
    "L": 4,
    "F": 6,
    "R": 7,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Platydictya jungermannioides",
    "Concept": "Bry_15",
    "Taxon_name": "Platydictya jungermannioides",
    "BRC_num": "0820    15",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Thread",
    "LF2": "",
    "Tub": "",
    "Gem": "O",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 57,
    "IRno": 6,
    "CIno": "",
    "TJan": 2,
    "TJul": 13.2,
    "Prec": 1511,
    "Alt": 1175,
    "L": 3,
    "F": 5,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hypnum imponens",
    "Concept": "Bry_353",
    "Taxon_name": "Hypnum imponens",
    "BRC_num": "0820   353",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 65,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 73,
    "GBno": 56,
    "IRno": "",
    "CIno": "",
    "TJan": 2.8,
    "TJul": 14.4,
    "Prec": 1170,
    "Alt": 600,
    "L": 8,
    "F": 7,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Marsupella emarginata var. aquatica",
    "Concept": "Bry_831.1",
    "Taxon_name": "Marsupella emarginata var. aquatica",
    "BRC_num": "0810   831.1",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "At",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 3,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 56,
    "IRno": 16,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.5,
    "Prec": 1841,
    "Alt": 1070,
    "L": 7,
    "F": 10,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Abietinella abietina var. hystricosa",
    "Concept": "Bry_596",
    "Taxon_name": "Thuidium abietinum subsp. hystricosum",
    "BRC_num": "0820   596",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "(S)",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 25,
    "GBno": 56,
    "IRno": 5,
    "CIno": "",
    "TJan": 3.7,
    "TJul": 16.1,
    "Prec": 819,
    "Alt": 230,
    "L": 8,
    "F": 3,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Campylopus shawii",
    "Concept": "Bry_146",
    "Taxon_name": "Campylopus shawii",
    "BRC_num": "0820   146",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 110,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "F",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 80,
    "GBno": 55,
    "IRno": 8,
    "CIno": "",
    "TJan": 3.7,
    "TJul": 12.8,
    "Prec": 1853,
    "Alt": 455,
    "L": 8,
    "F": 9,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Rhytidium rugosum",
    "Concept": "Bry_535",
    "Taxon_name": "Rhytidium rugosum",
    "BRC_num": "0820   535",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 55,
    "IRno": 2,
    "CIno": "",
    "TJan": 2,
    "TJul": 13.3,
    "Prec": 1552,
    "Alt": 915,
    "L": 8,
    "F": 4,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "ZZZ - SYNONYMIZED",
    "Concept": "",
    "Taxon_name": "Tortula subulata var. graeffii",
    "BRC_num": "0820   620.2",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 83,
    "GBno": 55,
    "IRno": 2,
    "CIno": "",
    "TJan": 1.9,
    "TJul": 13.1,
    "Prec": 1437,
    "Alt": 700,
    "L": 5,
    "F": 4,
    "R": 7,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Arctoa fulvella",
    "Concept": "Bry_36",
    "Taxon_name": "Arctoa fulvella",
    "BRC_num": "0820    36",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 5,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 13,
    "GBno": 54,
    "IRno": 4,
    "CIno": "",
    "TJan": 1.3,
    "TJul": 11.8,
    "Prec": 2203,
    "Alt": 1340,
    "L": 7,
    "F": 5,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 1,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum riparium",
    "Concept": "Bry_666",
    "Taxon_name": "Bryum riparium",
    "BRC_num": "0820   666",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 30,
    "Per": "PA",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 70,
    "GBno": 54,
    "IRno": 8,
    "CIno": "",
    "TJan": 2.4,
    "TJul": 12.7,
    "Prec": 1942,
    "Alt": 760,
    "L": 6,
    "F": 8,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pseudocalliergon trifarium",
    "Concept": "Bry_8",
    "Taxon_name": "Calliergon trifarium",
    "BRC_num": "0820     8",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 95,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 54,
    "IRno": 3,
    "CIno": "",
    "TJan": 1.4,
    "TJul": 11.8,
    "Prec": 2208,
    "Alt": 960,
    "L": 8,
    "F": 9,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Plasteurhynchium striatulum",
    "Concept": "Bry_364",
    "Taxon_name": "Eurhynchium striatulum",
    "BRC_num": "0820   364",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "De",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 92,
    "GBno": 54,
    "IRno": 14,
    "CIno": "",
    "TJan": 4.3,
    "TJul": 15.4,
    "Prec": 1080,
    "Alt": 365,
    "L": 5,
    "F": 4,
    "R": 9,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Plagiochila heterophylla",
    "Concept": "Bry_871",
    "Taxon_name": "Plagiochila atlantica",
    "BRC_num": "0810   871",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "We",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 70,
    "GBno": 54,
    "IRno": 3,
    "CIno": 2,
    "TJan": 2.6,
    "TJul": 12.7,
    "Prec": 2344,
    "Alt": 250,
    "L": 4,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 1,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Phascum cuspidatum var. piliferum",
    "Concept": "Bry_434.3",
    "Taxon_name": "Tortula acaulon var. pilifera",
    "BRC_num": "0820   434.3",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 4.5,
    "Per": "PA",
    "LF1": "Ts",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 2,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 26,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "CI",
    "Elem": 83,
    "GBno": 54,
    "IRno": "",
    "CIno": 1,
    "TJan": 4.6,
    "TJul": 15.9,
    "Prec": 783,
    "Alt": 45,
    "L": 9,
    "F": 4,
    "R": 7,
    "N": 5,
    "S": 1,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fissidens rivularis",
    "Concept": "Bry_271",
    "Taxon_name": "Fissidens rivularis",
    "BRC_num": "0820   271",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 17,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "(CI)",
    "Elem": 91,
    "GBno": 53,
    "IRno": 2,
    "CIno": "",
    "TJan": 4.2,
    "TJul": 15.3,
    "Prec": 1170,
    "Alt": 230,
    "L": 2,
    "F": 9,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": 1,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Leiocolea heterocolpos",
    "Concept": "Bry_793",
    "Taxon_name": "Leiocolea heterocolpos",
    "BRC_num": "0810   793",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "We",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 13,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 53,
    "IRno": 1,
    "CIno": "",
    "TJan": 1.3,
    "TJul": 12.5,
    "Prec": 1742,
    "Alt": 915,
    "L": 4,
    "F": 8,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Abietinella abietina var. abietina",
    "Concept": "Bry_594",
    "Taxon_name": "Thuidium abietinum subsp. abietinum",
    "BRC_num": "0820   594",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "(CI)",
    "Elem": 26,
    "GBno": 53,
    "IRno": 6,
    "CIno": "",
    "TJan": 3.5,
    "TJul": 15.5,
    "Prec": 869,
    "Alt": 850,
    "L": 8,
    "F": 3,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Conostomum tetragonum",
    "Concept": "Bry_159",
    "Taxon_name": "Conostomum tetragonum",
    "BRC_num": "0820   159",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 40,
    "Sp2": 40,
    "E": "E",
    "W": "(W)",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 52,
    "IRno": "",
    "CIno": "",
    "TJan": 0.1,
    "TJul": 11.1,
    "Prec": 2200,
    "Alt": 1335,
    "L": 7,
    "F": 5,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Grimmia orbicularis",
    "Concept": "Bry_309",
    "Taxon_name": "Grimmia orbicularis",
    "BRC_num": "0820   309",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 92,
    "GBno": 52,
    "IRno": 1,
    "CIno": "",
    "TJan": 4.2,
    "TJul": 15,
    "Prec": 1081,
    "Alt": 390,
    "L": 9,
    "F": 1,
    "R": 9,
    "N": 1,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Oedipodium griffithianum",
    "Concept": "Bry_406",
    "Taxon_name": "Oedipodium griffithianum",
    "BRC_num": "0820   406",
    "ML": "M",
    "Ord": "Oedipodiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 41,
    "GBno": 52,
    "IRno": 1,
    "CIno": "",
    "TJan": 1.3,
    "TJul": 12.3,
    "Prec": 2115,
    "Alt": 1200,
    "L": 6,
    "F": 6,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Scapania nimbosa",
    "Concept": "Bry_931",
    "Taxon_name": "Scapania nimbosa",
    "BRC_num": "0810   931",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 70,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "R",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "Nil",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "(W)",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 41,
    "GBno": 52,
    "IRno": 5,
    "CIno": "",
    "TJan": 1.5,
    "TJul": 11.5,
    "Prec": 2298,
    "Alt": 1070,
    "L": 5,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum affine",
    "Concept": "Bry_560.1",
    "Taxon_name": "Sphagnum affine",
    "BRC_num": "0820   560.1",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 42,
    "GBno": 52,
    "IRno": 3,
    "CIno": "",
    "TJan": 2.2,
    "TJul": 12.7,
    "Prec": 2041,
    "Alt": 400,
    "L": 8,
    "F": 9,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Kiaeria starkei",
    "Concept": "Bry_209",
    "Taxon_name": "Kiaeria starkei",
    "BRC_num": "0820   209",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 16,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 51,
    "IRno": "",
    "CIno": "",
    "TJan": 0,
    "TJul": 11.1,
    "Prec": 2236,
    "Alt": 1340,
    "L": 6,
    "F": 5,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Lophocolea semiteres",
    "Concept": "Bry_967",
    "Taxon_name": "Lophocolea semiteres",
    "BRC_num": "0810   967",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "AN",
    "Len": 30,
    "Per": "P",
    "LF1": "We",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": 10,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 19,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "NI",
    "CI": "",
    "Elem": 72,
    "GBno": 51,
    "IRno": 1,
    "CIno": "",
    "TJan": 4,
    "TJul": 15.9,
    "Prec": 806,
    "Alt": 250,
    "L": 5,
    "F": 5,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tomentypnum nitens",
    "Concept": "Bry_127",
    "Taxon_name": "Tomentypnum nitens",
    "BRC_num": "0820   127",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 51,
    "IRno": 11,
    "CIno": "",
    "TJan": 2.1,
    "TJul": 13.4,
    "Prec": 1199,
    "Alt": 840,
    "L": 7,
    "F": 9,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fontinalis squamosa var. squamosa",
    "Concept": "Bry_281.2",
    "Taxon_name": "Fontinalis squamosa var. squamosa",
    "BRC_num": "0820   281.2",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 400,
    "Per": "P",
    "LF1": "At",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 1,
    "Spend": 5,
    "Spbeg2": 9,
    "Spend2": 9,
    "Sp1": 20,
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 72,
    "GBno": 50,
    "IRno": 4,
    "CIno": "",
    "TJan": 4.6,
    "TJul": 14.9,
    "Prec": 1262,
    "Alt": 95,
    "L": 7,
    "F": 12,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Lophozia longidens",
    "Concept": "Bry_820",
    "Taxon_name": "Lophozia longidens",
    "BRC_num": "0810   820",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 8,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 13,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 50,
    "IRno": "",
    "CIno": "",
    "TJan": 0.8,
    "TJul": 11.8,
    "Prec": 1631,
    "Alt": 640,
    "L": 5,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": 3,
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Fissidens fontanus",
    "Concept": "Bry_405",
    "Taxon_name": "Octodiceras fontanum",
    "BRC_num": "0820   405",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "At",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "R",
    "Lvs": "",
    "Sex": "M",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 21,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 73,
    "GBno": 50,
    "IRno": 2,
    "CIno": "",
    "TJan": 3.8,
    "TJul": 15.9,
    "Prec": 777,
    "Alt": 245,
    "L": 5,
    "F": 12,
    "R": 7,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pohlia ludwigii",
    "Concept": "Bry_474",
    "Taxon_name": "Pohlia ludwigii",
    "BRC_num": "0820   474",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 50,
    "IRno": "",
    "CIno": "",
    "TJan": 0,
    "TJul": 11.1,
    "Prec": 2065,
    "Alt": 1340,
    "L": 6,
    "F": 8,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Conocephalum conicum s.str.",
    "Concept": "Bry_2401",
    "Taxon_name": "Conocephalum conicum s.str.",
    "BRC_num": "0810  2401",
    "ML": "L",
    "Ord": "Marchantiales",
    "Stat": "N",
    "Len": 110,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 53,
    "Sp2": 97,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 49,
    "IRno": "",
    "CIno": 2,
    "TJan": 4.2,
    "TJul": 15.3,
    "Prec": 1082,
    "Alt": 550,
    "L": 3,
    "F": 7,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Dicranoweisia crispula",
    "Concept": "Bry_194",
    "Taxon_name": "Dicranoweisia crispula",
    "BRC_num": "0820   194",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 7,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 49,
    "IRno": "",
    "CIno": "",
    "TJan": 0.9,
    "TJul": 11.6,
    "Prec": 2049,
    "Alt": 1335,
    "L": 7,
    "F": 4,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Zygodon conoideus var. conoideus",
    "Concept": "Bry_650.1",
    "Taxon_name": "Zygodon conoideus var. conoideus",
    "BRC_num": "0820   650.1",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 4,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 71,
    "GBno": 49,
    "IRno": "",
    "CIno": "",
    "TJan": 5.9,
    "TJul": 15.7,
    "Prec": 1155,
    "Alt": 350,
    "L": 6,
    "F": 4,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 1,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Kiaeria falcata",
    "Concept": "Bry_199",
    "Taxon_name": "Kiaeria falcata",
    "BRC_num": "0820   199",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 13,
    "GBno": 48,
    "IRno": "",
    "CIno": "",
    "TJan": 0,
    "TJul": 11,
    "Prec": 2181,
    "Alt": 1340,
    "L": 6,
    "F": 6,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Lophozia opacifolia",
    "Concept": "Bry_822",
    "Taxon_name": "Lophozia opacifolia",
    "BRC_num": "0810   822",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 5,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 21,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 48,
    "IRno": 4,
    "CIno": "",
    "TJan": 0.4,
    "TJul": 11.3,
    "Prec": 2116,
    "Alt": 1330,
    "L": 5,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": 1,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pseudobryum cinclidioides",
    "Concept": "Bry_380",
    "Taxon_name": "Pseudobryum cinclidioides",
    "BRC_num": "0820   380",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 90,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 36,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 48,
    "IRno": "",
    "CIno": "",
    "TJan": 2,
    "TJul": 12.4,
    "Prec": 1587,
    "Alt": 1000,
    "L": 6,
    "F": 9,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cynodontium jenneri",
    "Concept": "Bry_172",
    "Taxon_name": "Cynodontium jenneri",
    "BRC_num": "0820   172",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 42,
    "GBno": 47,
    "IRno": 1,
    "CIno": "",
    "TJan": 1.4,
    "TJul": 12.3,
    "Prec": 1600,
    "Alt": 730,
    "L": 5,
    "F": 5,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ditrichum lineare",
    "Concept": "Bry_220",
    "Taxon_name": "Ditrichum lineare",
    "BRC_num": "0820   220",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 15,
    "Per": "PA",
    "LF1": "Tuft",
    "LF2": "Ts",
    "Tub": "U",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 47,
    "IRno": 2,
    "CIno": "",
    "TJan": 1.9,
    "TJul": 12.6,
    "Prec": 1954,
    "Alt": 1040,
    "L": 6,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 2,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 1,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Frullania microphylla var. microphylla",
    "Concept": "Bry_767.1",
    "Taxon_name": "Frullania microphylla var. microphylla",
    "BRC_num": "0810   767.1",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 1,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 80,
    "GBno": 47,
    "IRno": 2,
    "CIno": "",
    "TJan": 5.4,
    "TJul": 14.9,
    "Prec": 1293,
    "Alt": 610,
    "L": 5,
    "F": 5,
    "R": 4,
    "N": 2,
    "S": 1,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Grimmia decipiens",
    "Concept": "Bry_297.1",
    "Taxon_name": "Grimmia decipiens",
    "BRC_num": "0820   297.1",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 92,
    "GBno": 47,
    "IRno": 6,
    "CIno": 1,
    "TJan": 3.5,
    "TJul": 13.8,
    "Prec": 1449,
    "Alt": 550,
    "L": 8,
    "F": 1,
    "R": 4,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Paraleptodontium recurvifolium",
    "Concept": "Bry_370",
    "Taxon_name": "Paraleptodontium recurvifolium",
    "BRC_num": "0820   370",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Ts",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 41,
    "GBno": 47,
    "IRno": 12,
    "CIno": "",
    "TJan": 2.1,
    "TJul": 12.2,
    "Prec": 2150,
    "Alt": 920,
    "L": 6,
    "F": 7,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pylaisia polyantha",
    "Concept": "Bry_515",
    "Taxon_name": "Pylaisia polyantha",
    "BRC_num": "0820   515",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 45,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 13,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "(CI)",
    "Elem": 76,
    "GBno": 47,
    "IRno": 5,
    "CIno": "",
    "TJan": 3.2,
    "TJul": 15,
    "Prec": 876,
    "Alt": 240,
    "L": 6,
    "F": 4,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Trichostomum hibernicum",
    "Concept": "Bry_626",
    "Taxon_name": "Trichostomum hibernicum",
    "BRC_num": "0820   626",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 45,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 70,
    "GBno": 47,
    "IRno": 14,
    "CIno": "",
    "TJan": 2.7,
    "TJul": 12.6,
    "Prec": 2061,
    "Alt": 900,
    "L": 5,
    "F": 8,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Odontoschisma elongatum",
    "Concept": "Bry_861",
    "Taxon_name": "Odontoschisma elongatum",
    "BRC_num": "0810   861",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "R",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 6,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 18,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 46,
    "IRno": 3,
    "CIno": "",
    "TJan": 1.7,
    "TJul": 11.9,
    "Prec": 1970,
    "Alt": 910,
    "L": 7,
    "F": 9,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 1,
    "SO": 3,
    "PT": 3,
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphaerocarpos michelii",
    "Concept": "Bry_949",
    "Taxon_name": "Sphaerocarpos michelii",
    "BRC_num": "0810   949",
    "ML": "L",
    "Ord": "Sphaerocarpales",
    "Stat": "AR",
    "Len": 20,
    "Per": "A",
    "LF1": "St",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 11,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 80,
    "Sp2": 130,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "CI",
    "Elem": 91,
    "GBno": 46,
    "IRno": "",
    "CIno": 5,
    "TJan": 4.1,
    "TJul": 16.3,
    "Prec": 665,
    "Alt": 100,
    "L": 8,
    "F": 6,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Anastrophyllum hellerianum",
    "Concept": "Bry_951",
    "Taxon_name": "Anastrophyllum hellerianum",
    "BRC_num": "0810   951",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 8,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 45,
    "IRno": 2,
    "CIno": "",
    "TJan": 1.6,
    "TJul": 12.4,
    "Prec": 2120,
    "Alt": 360,
    "L": 4,
    "F": 7,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 1,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Dicranum spurium",
    "Concept": "Bry_208",
    "Taxon_name": "Dicranum spurium",
    "BRC_num": "0820   208",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 67,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 24,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 45,
    "IRno": "",
    "CIno": "",
    "TJan": 2.7,
    "TJul": 14.8,
    "Prec": 910,
    "Alt": 490,
    "L": 6,
    "F": 5,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Encalypta rhaptocarpa",
    "Concept": "Bry_232",
    "Taxon_name": "Encalypta rhaptocarpa",
    "BRC_num": "0820   232",
    "ML": "M",
    "Ord": "Encalyptales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 34,
    "Sp2": 50,
    "E": "E",
    "W": "(W)",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 45,
    "IRno": 2,
    "CIno": "",
    "TJan": 1.6,
    "TJul": 12.2,
    "Prec": 1582,
    "Alt": 1190,
    "L": 7,
    "F": 4,
    "R": 7,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fissidens taxifolius var. pallidicaulis",
    "Concept": "Bry_274.1",
    "Taxon_name": "Fissidens taxifolius var. pallidicaulis",
    "BRC_num": "0820   274.1",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 7,
    "Sp2": 11,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 81,
    "GBno": 45,
    "IRno": 9,
    "CIno": "",
    "TJan": 3.2,
    "TJul": 13.4,
    "Prec": 1760,
    "Alt": 200,
    "L": 3,
    "F": 8,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Atrichum tenellum",
    "Concept": "Bry_39",
    "Taxon_name": "Atrichum tenellum",
    "BRC_num": "0820    39",
    "ML": "M",
    "Ord": "Polytrichales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Ts",
    "Tub": "X",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 25,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 44,
    "IRno": 7,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.9,
    "Prec": 1388,
    "Alt": 460,
    "L": 7,
    "F": 8,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Barbilophozia lycopodioides",
    "Concept": "Bry_698",
    "Taxon_name": "Barbilophozia lycopodioides",
    "BRC_num": "0810   698",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 44,
    "IRno": "",
    "CIno": "",
    "TJan": 0.1,
    "TJul": 11,
    "Prec": 2011,
    "Alt": 1200,
    "L": 6,
    "F": 6,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": 3,
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bazzania pearsonii",
    "Concept": "Bry_700",
    "Taxon_name": "Bazzania pearsonii",
    "BRC_num": "0810   700",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 70,
    "Per": "P",
    "LF1": "We",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 41,
    "GBno": 44,
    "IRno": 11,
    "CIno": "",
    "TJan": 2.2,
    "TJul": 12,
    "Prec": 2035,
    "Alt": 1000,
    "L": 5,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cinclidium stygium",
    "Concept": "Bry_152",
    "Taxon_name": "Cinclidium stygium",
    "BRC_num": "0820   152",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 25,
    "Sp2": 35,
    "E": "E",
    "W": "(W)",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 46,
    "GBno": 44,
    "IRno": 6,
    "CIno": 4,
    "TJan": 1.8,
    "TJul": 13,
    "Prec": 1458,
    "Alt": 970,
    "L": 7,
    "F": 9,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Grimmia donniana",
    "Concept": "Bry_298.2",
    "Taxon_name": "Grimmia donniana",
    "BRC_num": "0820   298.2",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 4,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 23,
    "GBno": 44,
    "IRno": 2,
    "CIno": "",
    "TJan": 2.4,
    "TJul": 13.2,
    "Prec": 1738,
    "Alt": 1020,
    "L": 7,
    "F": 1,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 2,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Moerckia blyttii",
    "Concept": "Bry_849",
    "Taxon_name": "Moerckia blyttii",
    "BRC_num": "0810   849",
    "ML": "L",
    "Ord": "Metzgeriales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 7,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 30,
    "Sp2": 46,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 14,
    "GBno": 44,
    "IRno": "",
    "CIno": "",
    "TJan": -0.2,
    "TJul": 10.8,
    "Prec": 2159,
    "Alt": 1220,
    "L": 6,
    "F": 7,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Targionia hypophylla",
    "Concept": "Bry_954",
    "Taxon_name": "Targionia hypophylla",
    "BRC_num": "0810   954",
    "ML": "L",
    "Ord": "Marchantiales",
    "Stat": "NA",
    "Len": 25,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M(D)",
    "Fr": "F",
    "Spbeg": 2,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 54,
    "Sp2": 76,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "(IR)",
    "NI": "(NI)",
    "CI": "CI",
    "Elem": 91,
    "GBno": 44,
    "IRno": "",
    "CIno": 6,
    "TJan": 4.1,
    "TJul": 15,
    "Prec": 1250,
    "Alt": 300,
    "L": 7,
    "F": 4,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hennediella macrophylla",
    "Concept": "Bry_1059",
    "Taxon_name": "Hennediella macrophylla",
    "BRC_num": "0820  1059",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "AN",
    "Len": 25,
    "Per": "AP",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 22,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 72,
    "GBno": 43,
    "IRno": "",
    "CIno": "",
    "TJan": 3.4,
    "TJul": 15.6,
    "Prec": 708,
    "Alt": 168,
    "L": 5,
    "F": 5,
    "R": 6,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Marsupella adusta",
    "Concept": "Bry_829",
    "Taxon_name": "Marsupella adusta",
    "BRC_num": "0810   829",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 6,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 7,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 22,
    "GBno": 43,
    "IRno": 6,
    "CIno": "",
    "TJan": 1.1,
    "TJul": 11.8,
    "Prec": 2145,
    "Alt": 1220,
    "L": 7,
    "F": 5,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Myurium hochstetteri",
    "Concept": "Bry_399",
    "Taxon_name": "Myurium hochstetteri",
    "BRC_num": "0820   399",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "O",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 80,
    "GBno": 43,
    "IRno": 1,
    "CIno": "",
    "TJan": 4,
    "TJul": 12.8,
    "Prec": 1693,
    "Alt": 110,
    "L": 6,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 2,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tetralophozia setiformis",
    "Concept": "Bry_736",
    "Taxon_name": "Tetralophozia setiformis",
    "BRC_num": "0810   736",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "We",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "X",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 13,
    "Sp2": 15,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 43,
    "IRno": "",
    "CIno": "",
    "TJan": -0.3,
    "TJul": 11.2,
    "Prec": 1426,
    "Alt": 1280,
    "L": 6,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 1,
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Cephalozia loitlesbergeri",
    "Concept": "Bry_719",
    "Taxon_name": "Cephalozia loitlesbergeri",
    "BRC_num": "0810   719",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 6,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 42,
    "IRno": 8,
    "CIno": "",
    "TJan": 2.3,
    "TJul": 12.9,
    "Prec": 1513,
    "Alt": 700,
    "L": 7,
    "F": 9,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": 2,
    "GS": "",
    "DW": "",
    "DV": 2,
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Dicranum polysetum",
    "Concept": "Bry_205",
    "Taxon_name": "Dicranum polysetum",
    "BRC_num": "0820   205",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 133,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 27,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 42,
    "IRno": "",
    "CIno": "",
    "TJan": 3.2,
    "TJul": 15.3,
    "Prec": 779,
    "Alt": 110,
    "L": 5,
    "F": 5,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ditrichum flexicaule s.str.",
    "Concept": "Bry_1347",
    "Taxon_name": "Ditrichum flexicaule",
    "BRC_num": "0820  1347",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 7,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 66,
    "GBno": 42,
    "IRno": 1,
    "CIno": "",
    "TJan": 3.2,
    "TJul": 14.6,
    "Prec": 1004,
    "Alt": 1214,
    "L": 7,
    "F": 3,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Scapania cuspiduligera",
    "Concept": "Bry_925",
    "Taxon_name": "Scapania cuspiduligera",
    "BRC_num": "0810   925",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 42,
    "IRno": 2,
    "CIno": "",
    "TJan": 1.7,
    "TJul": 12.8,
    "Prec": 1498,
    "Alt": 1175,
    "L": 6,
    "F": 7,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 2,
    "PT": "",
    "GS": 1,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum platyphyllum",
    "Concept": "Bry_555.2",
    "Taxon_name": "Sphagnum platyphyllum",
    "BRC_num": "0820   555.2",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 32,
    "Sp2": 35,
    "E": "(E)",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 46,
    "GBno": 42,
    "IRno": 4,
    "CIno": "",
    "TJan": 2.8,
    "TJul": 13,
    "Prec": 1842,
    "Alt": 550,
    "L": 8,
    "F": 9,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Drepanocladus sendtneri",
    "Concept": "Bry_227",
    "Taxon_name": "Drepanocladus sendtneri",
    "BRC_num": "0820   227",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 130,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 6,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 40,
    "IRno": 13,
    "CIno": "",
    "TJan": 4.5,
    "TJul": 15,
    "Prec": 1029,
    "Alt": 30,
    "L": 8,
    "F": 9,
    "R": 8,
    "N": 2,
    "S": 1,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Grimmia laevigata",
    "Concept": "Bry_305",
    "Taxon_name": "Grimmia laevigata",
    "BRC_num": "0820   305",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "CI",
    "Elem": 86,
    "GBno": 40,
    "IRno": 1,
    "CIno": 6,
    "TJan": 4.5,
    "TJul": 15.6,
    "Prec": 915,
    "Alt": 350,
    "L": 9,
    "F": 1,
    "R": 4,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Grimmia longirostris",
    "Concept": "Bry_310",
    "Taxon_name": "Grimmia longirostris",
    "BRC_num": "0820   310",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 56,
    "GBno": 40,
    "IRno": 1,
    "CIno": "",
    "TJan": 2.7,
    "TJul": 12.8,
    "Prec": 1665,
    "Alt": 1150,
    "L": 7,
    "F": 1,
    "R": 4,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Harpanthus flotovianus",
    "Concept": "Bry_780",
    "Taxon_name": "Harpanthus flotovianus",
    "BRC_num": "0810   780",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "O",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 5,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 40,
    "IRno": "",
    "CIno": "",
    "TJan": 0.1,
    "TJul": 11,
    "Prec": 2012,
    "Alt": 1130,
    "L": 6,
    "F": 8,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": 2,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Plagiothecium cavifolium",
    "Concept": "Bry_454",
    "Taxon_name": "Plagiothecium cavifolium",
    "BRC_num": "0820   454",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "O",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 40,
    "IRno": 2,
    "CIno": "",
    "TJan": 2.1,
    "TJul": 12.6,
    "Prec": 1820,
    "Alt": 1205,
    "L": 5,
    "F": 6,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 1,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Racomitrium canescens s.str.",
    "Concept": "Bry_1049",
    "Taxon_name": "Racomitrium canescens",
    "BRC_num": "0820  1049",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 26,
    "GBno": 40,
    "IRno": 3,
    "CIno": 1,
    "TJan": 3.2,
    "TJul": 14.4,
    "Prec": 1105,
    "Alt": 1000,
    "L": 8,
    "F": 3,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Coscinodon cribrosus",
    "Concept": "Bry_160",
    "Taxon_name": "Coscinodon cribrosus",
    "BRC_num": "0820   160",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 56,
    "GBno": 39,
    "IRno": "",
    "CIno": "",
    "TJan": 3.4,
    "TJul": 14.1,
    "Prec": 1413,
    "Alt": 915,
    "L": 7,
    "F": 2,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 1,
    "RH": 2,
    "RS": 3,
    "RW": 3,
    "SR": 1,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pohlia wahlenbergii var. glacialis",
    "Concept": "Bry_465.3",
    "Taxon_name": "Pohlia wahlenbergii var. glacialis",
    "BRC_num": "0820   465.3",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 118,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 39,
    "IRno": 1,
    "CIno": "",
    "TJan": 0.3,
    "TJul": 11.3,
    "Prec": 2131,
    "Alt": 1100,
    "L": 7,
    "F": 9,
    "R": 4,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum torquescens",
    "Concept": "Bry_671",
    "Taxon_name": "Bryum torquescens",
    "BRC_num": "0820   671",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Cu",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M(D)",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 91,
    "GBno": 38,
    "IRno": 2,
    "CIno": "",
    "TJan": 4.6,
    "TJul": 15.8,
    "Prec": 894,
    "Alt": 110,
    "L": 8,
    "F": 3,
    "R": 7,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Isopterygiopsis muelleriana",
    "Concept": "Bry_358",
    "Taxon_name": "Isopterygiopsis muelleriana",
    "BRC_num": "0820   358",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "O",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 42,
    "GBno": 38,
    "IRno": 1,
    "CIno": "",
    "TJan": 1.1,
    "TJul": 11.6,
    "Prec": 2331,
    "Alt": 1070,
    "L": 5,
    "F": 8,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Seligeria acutifolia",
    "Concept": "Bry_543",
    "Taxon_name": "Seligeria acutifolia",
    "BRC_num": "0820   543",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 2,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 38,
    "IRno": 7,
    "CIno": "",
    "TJan": 2.5,
    "TJul": 14,
    "Prec": 1421,
    "Alt": 560,
    "L": 2,
    "F": 7,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Aloina rigida",
    "Concept": "Bry_12",
    "Taxon_name": "Aloina rigida",
    "BRC_num": "0820    12",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 2,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 43,
    "GBno": 37,
    "IRno": 1,
    "CIno": "",
    "TJan": 3.2,
    "TJul": 15.4,
    "Prec": 754,
    "Alt": 500,
    "L": 8,
    "F": 3,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Grimmia ovalis",
    "Concept": "Bry_294",
    "Taxon_name": "Grimmia ovalis",
    "BRC_num": "0820   294",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 56,
    "GBno": 37,
    "IRno": "",
    "CIno": "",
    "TJan": 2.8,
    "TJul": 14.3,
    "Prec": 1201,
    "Alt": 500,
    "L": 7,
    "F": 1,
    "R": 4,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Scapania degenii",
    "Concept": "Bry_926",
    "Taxon_name": "Scapania degenii",
    "BRC_num": "0810   926",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 37,
    "IRno": "",
    "CIno": "",
    "TJan": 0.4,
    "TJul": 11.6,
    "Prec": 1934,
    "Alt": 980,
    "L": 6,
    "F": 8,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Dicranella crispa",
    "Concept": "Bry_182",
    "Taxon_name": "Dicranella crispa",
    "BRC_num": "0820   182",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "A",
    "Spbeg": 11,
    "Spend": 11,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "(W)",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 36,
    "IRno": 5,
    "CIno": "",
    "TJan": 2.9,
    "TJul": 13.8,
    "Prec": 1222,
    "Alt": 550,
    "L": 7,
    "F": 6,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Lophozia obtusa",
    "Concept": "Bry_821",
    "Taxon_name": "Lophozia obtusa",
    "BRC_num": "0810   821",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "R",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 23,
    "GBno": 36,
    "IRno": "",
    "CIno": "",
    "TJan": 0.9,
    "TJul": 11.7,
    "Prec": 1895,
    "Alt": 1040,
    "L": 5,
    "F": 6,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Pseudoleskeella catenulata",
    "Concept": "Bry_504",
    "Taxon_name": "Pseudoleskeella catenulata",
    "BRC_num": "0820   504",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 36,
    "IRno": "",
    "CIno": "",
    "TJan": 0.5,
    "TJul": 11.6,
    "Prec": 1763,
    "Alt": 1100,
    "L": 7,
    "F": 5,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Schistidium robustum",
    "Concept": "Bry_291.2",
    "Taxon_name": "Schistidium robustum",
    "BRC_num": "0820   291.2",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 12,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 36,
    "IRno": 2,
    "CIno": "",
    "TJan": 2.1,
    "TJul": 12.3,
    "Prec": 1855,
    "Alt": 720,
    "L": 7,
    "F": 2,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Weissia sterilis",
    "Concept": "Bry_647",
    "Taxon_name": "Weissia sterilis",
    "BRC_num": "0820   647",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 71,
    "GBno": 36,
    "IRno": "",
    "CIno": "",
    "TJan": 3.7,
    "TJul": 16.2,
    "Prec": 761,
    "Alt": 180,
    "L": 8,
    "F": 2,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Dicranum flagellare",
    "Concept": "Bry_200",
    "Taxon_name": "Dicranum flagellare",
    "BRC_num": "0820   200",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 56,
    "GBno": 35,
    "IRno": "",
    "CIno": "",
    "TJan": 3.4,
    "TJul": 16,
    "Prec": 816,
    "Alt": 380,
    "L": 4,
    "F": 4,
    "R": 3,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Ephemerum sessile",
    "Concept": "Bry_240",
    "Taxon_name": "Ephemerum sessile",
    "BRC_num": "0820   240",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 2,
    "Per": "A",
    "LF1": "Tp",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 2,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 60,
    "Sp2": 80,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 83,
    "GBno": 35,
    "IRno": 8,
    "CIno": "",
    "TJan": 4.3,
    "TJul": 15.3,
    "Prec": 1094,
    "Alt": 360,
    "L": 7,
    "F": 7,
    "R": 4,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Herzogiella striatella",
    "Concept": "Bry_457",
    "Taxon_name": "Herzogiella striatella",
    "BRC_num": "0820   457",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "(E)",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 35,
    "IRno": "",
    "CIno": "",
    "TJan": 0.2,
    "TJul": 11.1,
    "Prec": 2124,
    "Alt": 950,
    "L": 5,
    "F": 5,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Marsupella alpina",
    "Concept": "Bry_830",
    "Taxon_name": "Marsupella alpina",
    "BRC_num": "0810   830",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 6,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 11,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 12,
    "GBno": 35,
    "IRno": "",
    "CIno": "",
    "TJan": 0.5,
    "TJul": 11.4,
    "Prec": 2127,
    "Alt": 1340,
    "L": 7,
    "F": 7,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 2,
    "RW": "",
    "SR": "",
    "SO": 1,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Marsupella stableri",
    "Concept": "Bry_839",
    "Taxon_name": "Marsupella stableri",
    "BRC_num": "0810   839",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 8,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 12,
    "GBno": 35,
    "IRno": "",
    "CIno": "",
    "TJan": 0.4,
    "TJul": 11.3,
    "Prec": 2295,
    "Alt": 1200,
    "L": 6,
    "F": 6,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Myurella julacea",
    "Concept": "Bry_397",
    "Taxon_name": "Myurella julacea",
    "BRC_num": "0820   397",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 11,
    "E": "E",
    "W": "(W)",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 35,
    "IRno": 4,
    "CIno": "",
    "TJan": 0.7,
    "TJul": 11.7,
    "Prec": 1837,
    "Alt": 1205,
    "L": 6,
    "F": 5,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum elegans",
    "Concept": "Bry_660",
    "Taxon_name": "Bryum elegans",
    "BRC_num": "0820   660",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "R",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 34,
    "IRno": 2,
    "CIno": "",
    "TJan": 1.3,
    "TJul": 12.8,
    "Prec": 1482,
    "Alt": 915,
    "L": 7,
    "F": 3,
    "R": 8,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fossombronia caespitiformis",
    "Concept": "Bry_4153",
    "Taxon_name": "Fossombronia husnotii",
    "BRC_num": "0810   759",
    "ML": "L",
    "Ord": "Fossombroniales",
    "Stat": "N",
    "Len": 10,
    "Per": "PA",
    "LF1": "Sc",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 8,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 42,
    "Sp2": 56,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "CI",
    "Elem": 91,
    "GBno": 34,
    "IRno": 11,
    "CIno": 3,
    "TJan": 5.7,
    "TJul": 15.5,
    "Prec": 1120,
    "Alt": 245,
    "L": 8,
    "F": 4,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 1,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hageniella micans",
    "Concept": "Bry_551",
    "Taxon_name": "Sematophyllum micans",
    "BRC_num": "0820   551",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 15,
    "E": "E",
    "W": "(W)",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 71,
    "GBno": 34,
    "IRno": 16,
    "CIno": "",
    "TJan": 3,
    "TJul": 12.9,
    "Prec": 2167,
    "Alt": 490,
    "L": 4,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Thuidium recognitum",
    "Concept": "Bry_598",
    "Taxon_name": "Thuidium recognitum",
    "BRC_num": "0820   598",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 90,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 76,
    "GBno": 34,
    "IRno": 9,
    "CIno": "",
    "TJan": 2.2,
    "TJul": 13,
    "Prec": 1566,
    "Alt": 950,
    "L": 6,
    "F": 5,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 1,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Aulacomnium turgidum",
    "Concept": "Bry_43",
    "Taxon_name": "Aulacomnium turgidum",
    "BRC_num": "0820    43",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 11,
    "E": "(E)",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 33,
    "IRno": "",
    "CIno": "",
    "TJan": 0.7,
    "TJul": 11.1,
    "Prec": 2395,
    "Alt": 1000,
    "L": 7,
    "F": 4,
    "R": 4,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Catoscopium nigritum",
    "Concept": "Bry_149",
    "Taxon_name": "Catoscopium nigritum",
    "BRC_num": "0820   149",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 40,
    "Sp2": 45,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 33,
    "IRno": 7,
    "CIno": "",
    "TJan": 2.8,
    "TJul": 12.8,
    "Prec": 1331,
    "Alt": 550,
    "L": 9,
    "F": 9,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Jungermannia borealis",
    "Concept": "Bry_964",
    "Taxon_name": "Jungermannia borealis",
    "BRC_num": "0810   964",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 5,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 28,
    "E": "",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 33,
    "IRno": "",
    "CIno": "",
    "TJan": 1.2,
    "TJul": 11.9,
    "Prec": 2087,
    "Alt": 1205,
    "L": 5,
    "F": 8,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tortella inclinata",
    "Concept": "Bry_604",
    "Taxon_name": "Tortella inclinata",
    "BRC_num": "0820   604",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "O",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 76,
    "GBno": 33,
    "IRno": 4,
    "CIno": "",
    "TJan": 3.9,
    "TJul": 14.8,
    "Prec": 988,
    "Alt": 500,
    "L": 8,
    "F": 3,
    "R": 9,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Amblystegium confervoides",
    "Concept": "Bry_14",
    "Taxon_name": "Amblystegium confervoides",
    "BRC_num": "0820    14",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 32,
    "IRno": 4,
    "CIno": "",
    "TJan": 3.5,
    "TJul": 15.3,
    "Prec": 1030,
    "Alt": 150,
    "L": 3,
    "F": 5,
    "R": 9,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Dicranodontium asperulum",
    "Concept": "Bry_190",
    "Taxon_name": "Dicranodontium asperulum",
    "BRC_num": "0820   190",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 75,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 42,
    "GBno": 32,
    "IRno": 4,
    "CIno": "",
    "TJan": 1.2,
    "TJul": 11.7,
    "Prec": 2116,
    "Alt": 850,
    "L": 5,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Entosthodon muhlenbergii",
    "Concept": "Bry_285",
    "Taxon_name": "Funaria muhlenbergii",
    "BRC_num": "0820   285",
    "ML": "M",
    "Ord": "Funariales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "(S)",
    "IR": "(IR)",
    "NI": "",
    "CI": "",
    "Elem": 92,
    "GBno": 32,
    "IRno": "",
    "CIno": "",
    "TJan": 3.1,
    "TJul": 14.8,
    "Prec": 1144,
    "Alt": 390,
    "L": 7,
    "F": 3,
    "R": 9,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Heterocladium wulfsbergii",
    "Concept": "Bry_1770",
    "Taxon_name": "Heterocladium wulfsbergii",
    "BRC_num": "0820  1770",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 71,
    "GBno": 32,
    "IRno": 10,
    "CIno": "",
    "TJan": 4.2,
    "TJul": 14.2,
    "Prec": 1553,
    "Alt": 165,
    "L": 3,
    "F": 6,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Philonotis seriata",
    "Concept": "Bry_441",
    "Taxon_name": "Philonotis seriata",
    "BRC_num": "0820   441",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 97,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 22,
    "E": "",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 24,
    "GBno": 32,
    "IRno": "",
    "CIno": "",
    "TJan": -0.1,
    "TJul": 11,
    "Prec": 1858,
    "Alt": 1220,
    "L": 7,
    "F": 9,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Diplophyllum taxifolium",
    "Concept": "Bry_749",
    "Taxon_name": "Diplophyllum taxifolium",
    "BRC_num": "0810   749",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 13,
    "Sp2": 15,
    "E": "(E)",
    "W": "(W)",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 31,
    "IRno": "",
    "CIno": "",
    "TJan": -0.5,
    "TJul": 10.7,
    "Prec": 2006,
    "Alt": 1130,
    "L": 6,
    "F": 6,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Grimmia lisae",
    "Concept": "Bry_1808",
    "Taxon_name": "Grimmia lisae",
    "BRC_num": "0820  1808",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 35,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 17,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 83,
    "GBno": 31,
    "IRno": "",
    "CIno": "",
    "TJan": 5.5,
    "TJul": 15.3,
    "Prec": 1105,
    "Alt": 600,
    "L": 7,
    "F": 3,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Marsupella brevissima",
    "Concept": "Bry_841",
    "Taxon_name": "Marsupella brevissima",
    "BRC_num": "0810   841",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 8,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 6,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 15,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 13,
    "GBno": 31,
    "IRno": "",
    "CIno": "",
    "TJan": -0.2,
    "TJul": 10.9,
    "Prec": 2156,
    "Alt": 1335,
    "L": 8,
    "F": 7,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Weissia rostellata",
    "Concept": "Bry_644",
    "Taxon_name": "Weissia rostellata",
    "BRC_num": "0820   644",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 5,
    "Per": "AP",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 22,
    "Sp2": 27,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 31,
    "IRno": 5,
    "CIno": "",
    "TJan": 3.7,
    "TJul": 15.1,
    "Prec": 998,
    "Alt": 245,
    "L": 8,
    "F": 7,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Andreaea mutabilis",
    "Concept": "Bry_1065",
    "Taxon_name": "Andreaea mutabilis",
    "BRC_num": "0820  1065",
    "ML": "M",
    "Ord": "Andreaeales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 21,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 41,
    "GBno": 30,
    "IRno": "",
    "CIno": "",
    "TJan": 0.5,
    "TJul": 11.5,
    "Prec": 2031,
    "Alt": 1300,
    "L": 7,
    "F": 5,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 1,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Campylopus atrovirens var. falcatus",
    "Concept": "Bry_137.2",
    "Taxon_name": "Campylopus atrovirens var. falcatus",
    "BRC_num": "0820   137.2",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 130,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "(E)",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 70,
    "GBno": 30,
    "IRno": 6,
    "CIno": "",
    "TJan": 3.4,
    "TJul": 12.7,
    "Prec": 1943,
    "Alt": 460,
    "L": 8,
    "F": 8,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Campylostelium saxicola",
    "Concept": "Bry_148",
    "Taxon_name": "Campylostelium saxicola",
    "BRC_num": "0820   148",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 2,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 7,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 72,
    "GBno": 30,
    "IRno": 6,
    "CIno": "",
    "TJan": 3,
    "TJul": 14.2,
    "Prec": 1384,
    "Alt": 680,
    "L": 3,
    "F": 6,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "ZZZ - SYNONYMIZED",
    "Concept": "",
    "Taxon_name": "Fossombronia caespitiformis",
    "BRC_num": "0810   755",
    "ML": "L",
    "Ord": "Fossombroniales",
    "Stat": "N",
    "Len": 10,
    "Per": "AP",
    "LF1": "Sc",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 7,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 38,
    "Sp2": 56,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 91,
    "GBno": 30,
    "IRno": "",
    "CIno": "",
    "TJan": 4.9,
    "TJul": 16,
    "Prec": 919,
    "Alt": 135,
    "L": 7,
    "F": 6,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum pulchrum",
    "Concept": "Bry_569",
    "Taxon_name": "Sphagnum pulchrum",
    "BRC_num": "0820   569",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 27,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 52,
    "GBno": 30,
    "IRno": 16,
    "CIno": "",
    "TJan": 3.8,
    "TJul": 14.4,
    "Prec": 1327,
    "Alt": 400,
    "L": 8,
    "F": 10,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Myrinia pulvinata",
    "Concept": "Bry_396",
    "Taxon_name": "Myrinia pulvinata",
    "BRC_num": "0820   396",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 29,
    "IRno": "",
    "CIno": "",
    "TJan": 3.3,
    "TJul": 15.1,
    "Prec": 918,
    "Alt": 150,
    "L": 6,
    "F": 5,
    "R": 7,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Tritomaria polita",
    "Concept": "Bry_959",
    "Taxon_name": "Tritomaria polita",
    "BRC_num": "0810   959",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "We",
    "Tub": "",
    "Gem": "X",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 7,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 19,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 29,
    "IRno": "",
    "CIno": "",
    "TJan": -0.1,
    "TJul": 11.2,
    "Prec": 2172,
    "Alt": 1070,
    "L": 6,
    "F": 8,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Andreaea rothii subsp. rothii",
    "Concept": "Bry_1067.2",
    "Taxon_name": "Andreaea rothii subsp. rothii",
    "BRC_num": "0820  1067.2",
    "ML": "M",
    "Ord": "Andreaeales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 3,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 52,
    "GBno": 28,
    "IRno": 14,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.5,
    "Prec": 1538,
    "Alt": 800,
    "L": 8,
    "F": 4,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum canariense",
    "Concept": "Bry_93",
    "Taxon_name": "Bryum canariense",
    "BRC_num": "0820    93",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "U",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 13,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "(CI)",
    "Elem": 91,
    "GBno": 28,
    "IRno": "",
    "CIno": "",
    "TJan": 4.7,
    "TJul": 15.8,
    "Prec": 902,
    "Alt": 200,
    "L": 9,
    "F": 2,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": 1,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ditrichum pusillum",
    "Concept": "Bry_218",
    "Taxon_name": "Ditrichum pusillum",
    "BRC_num": "0820   218",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 10,
    "Per": "PA",
    "LF1": "Ts",
    "LF2": "Tf",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "(IR)",
    "NI": "(NI)",
    "CI": "",
    "Elem": 56,
    "GBno": 28,
    "IRno": "",
    "CIno": "",
    "TJan": 3.1,
    "TJul": 13.7,
    "Prec": 1470,
    "Alt": 900,
    "L": 7,
    "F": 5,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Radula voluta",
    "Concept": "Bry_895",
    "Taxon_name": "Radula voluta",
    "BRC_num": "0810   895",
    "ML": "L",
    "Ord": "Radulales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "X",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 70,
    "GBno": 28,
    "IRno": 19,
    "CIno": "",
    "TJan": 3.3,
    "TJul": 13.4,
    "Prec": 1926,
    "Alt": 760,
    "L": 4,
    "F": 7,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Sphaerocarpos texanus",
    "Concept": "Bry_950",
    "Taxon_name": "Sphaerocarpos texanus",
    "BRC_num": "0810   950",
    "ML": "L",
    "Ord": "Sphaerocarpales",
    "Stat": "AR",
    "Len": 20,
    "Per": "A",
    "LF1": "St",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 11,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 84,
    "Sp2": 150,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "CI",
    "Elem": 91,
    "GBno": 28,
    "IRno": "",
    "CIno": 5,
    "TJan": 4.4,
    "TJul": 16.3,
    "Prec": 712,
    "Alt": 95,
    "L": 8,
    "F": 6,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Buxbaumia aphylla",
    "Concept": "Bry_124",
    "Taxon_name": "Buxbaumia aphylla",
    "BRC_num": "0820   124",
    "ML": "M",
    "Ord": "Buxbaumiales",
    "Stat": "N",
    "Len": 8,
    "Per": "PA",
    "LF1": "Tp",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 13,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "(IR)",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 27,
    "IRno": "",
    "CIno": "",
    "TJan": 2.1,
    "TJul": 13.7,
    "Prec": 996,
    "Alt": 275,
    "L": 5,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 2,
    "DV": 2,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pseudocalliergon lycopodioides",
    "Concept": "Bry_225",
    "Taxon_name": "Drepanocladus lycopodioides",
    "BRC_num": "0820   225",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 143,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 27,
    "IRno": 13,
    "CIno": "",
    "TJan": 4.1,
    "TJul": 14.6,
    "Prec": 1003,
    "Alt": 520,
    "L": 8,
    "F": 9,
    "R": 7,
    "N": 2,
    "S": 1,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Solenostoma confertissimum",
    "Concept": "Bry_965",
    "Taxon_name": "Jungermannia confertissima",
    "BRC_num": "0810   965",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 4,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 27,
    "IRno": "",
    "CIno": "",
    "TJan": 0.6,
    "TJul": 11.7,
    "Prec": 1901,
    "Alt": 980,
    "L": 6,
    "F": 7,
    "R": 3,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Phascum cuspidatum var. schreberianum",
    "Concept": "Bry_434.4",
    "Taxon_name": "Tortula acaulon var. schreberiana",
    "BRC_num": "0820   434.4",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 9,
    "Per": "A",
    "LF1": "Ts",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 86,
    "GBno": 27,
    "IRno": "",
    "CIno": "",
    "TJan": 3.5,
    "TJul": 16.1,
    "Prec": 626,
    "Alt": 97,
    "L": 8,
    "F": 5,
    "R": 7,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cephaloziella turneri",
    "Concept": "Bry_735",
    "Taxon_name": "Cephaloziella turneri",
    "BRC_num": "0810   735",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 7,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 1,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "CI",
    "Elem": 91,
    "GBno": 26,
    "IRno": 1,
    "CIno": 1,
    "TJan": 5.4,
    "TJul": 15.7,
    "Prec": 1098,
    "Alt": 215,
    "L": 4,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Conardia compacta",
    "Concept": "Bry_16",
    "Taxon_name": "Conardia compacta",
    "BRC_num": "0820    16",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 15,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "(IR)",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 26,
    "IRno": "",
    "CIno": "",
    "TJan": 3.4,
    "TJul": 14.2,
    "Prec": 1065,
    "Alt": 350,
    "L": 1,
    "F": 6,
    "R": 8,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pohlia elongata var. greenii",
    "Concept": "Bry_476",
    "Taxon_name": "Pohlia elongata subsp. polymorpha",
    "BRC_num": "0820   476",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 26,
    "IRno": 2,
    "CIno": "",
    "TJan": 1.1,
    "TJul": 11.7,
    "Prec": 2122,
    "Alt": 1050,
    "L": 4,
    "F": 6,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pseudoleskeella catenulata",
    "Concept": "Bry_504.2",
    "Taxon_name": "Pseudoleskeella catenulata",
    "BRC_num": "0820   504.2",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 26,
    "IRno": "",
    "CIno": "",
    "TJan": 0.3,
    "TJul": 11.7,
    "Prec": 1569,
    "Alt": 1100,
    "L": 7,
    "F": 5,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Riccia crozalsii",
    "Concept": "Bry_907",
    "Taxon_name": "Riccia crozalsii",
    "BRC_num": "0810   907",
    "ML": "L",
    "Ord": "Ricciales",
    "Stat": "N",
    "Len": 14,
    "Per": "AP",
    "LF1": "St",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 64,
    "Sp2": 90,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "CI",
    "Elem": 91,
    "GBno": 26,
    "IRno": "",
    "CIno": 6,
    "TJan": 6.5,
    "TJul": 16,
    "Prec": 1019,
    "Alt": 90,
    "L": 8,
    "F": 5,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Conocephalum salebrosum",
    "Concept": "Bry_2402",
    "Taxon_name": "Conocephalum salebrosum",
    "BRC_num": "0810  2402",
    "ML": "L",
    "Ord": "Marchantiales",
    "Stat": "N",
    "Len": 90,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 53,
    "Sp2": 88,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 56,
    "GBno": 25,
    "IRno": "",
    "CIno": "",
    "TJan": 3.1,
    "TJul": 15,
    "Prec": 1055,
    "Alt": 505,
    "L": 3,
    "F": 6,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Oncophorus virens",
    "Concept": "Bry_408",
    "Taxon_name": "Oncophorus virens",
    "BRC_num": "0820   408",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 57,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 28,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 25,
    "IRno": "",
    "CIno": "",
    "TJan": 0.3,
    "TJul": 11.4,
    "Prec": 2016,
    "Alt": 970,
    "L": 7,
    "F": 8,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Petalophyllum ralfsii",
    "Concept": "Bry_870",
    "Taxon_name": "Petalophyllum ralfsii",
    "BRC_num": "0810   870",
    "ML": "L",
    "Ord": "Fossombroniales",
    "Stat": "N",
    "Len": 15,
    "Per": "PA",
    "LF1": "St",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 3,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 40,
    "Sp2": 56,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 91,
    "GBno": 25,
    "IRno": 11,
    "CIno": "",
    "TJan": 5,
    "TJul": 15.2,
    "Prec": 1108,
    "Alt": 60,
    "L": 9,
    "F": 6,
    "R": 8,
    "N": 2,
    "S": 1,
    "HM": 1,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 2,
    "SO": "",
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Weissia controversa var. crispata",
    "Concept": "Bry_641",
    "Taxon_name": "Weissia controversa var. crispata",
    "BRC_num": "0820   641",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 3,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 83,
    "GBno": 25,
    "IRno": "",
    "CIno": "",
    "TJan": 4.5,
    "TJul": 15.6,
    "Prec": 935,
    "Alt": 250,
    "L": 7,
    "F": 2,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Campylopus pilifer",
    "Concept": "Bry_673",
    "Taxon_name": "Campylopus pilifer",
    "BRC_num": "0820   673",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "F",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 13,
    "Sp2": 17,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "CI",
    "Elem": 81,
    "GBno": 24,
    "IRno": 18,
    "CIno": 9,
    "TJan": 5.5,
    "TJul": 15.2,
    "Prec": 1277,
    "Alt": 100,
    "L": 8,
    "F": 2,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Campylopus schimperi",
    "Concept": "Bry_144",
    "Taxon_name": "Campylopus schimperi",
    "BRC_num": "0820   144",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 70,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "O",
    "Lvs": "F",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 24,
    "IRno": 2,
    "CIno": "",
    "TJan": 1.5,
    "TJul": 11.6,
    "Prec": 2108,
    "Alt": 900,
    "L": 6,
    "F": 5,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Plagiothecium platyphyllum",
    "Concept": "Bry_453",
    "Taxon_name": "Plagiothecium platyphyllum",
    "BRC_num": "0820   453",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 24,
    "IRno": 1,
    "CIno": "",
    "TJan": 1,
    "TJul": 11.5,
    "Prec": 2081,
    "Alt": 860,
    "L": 5,
    "F": 8,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tortella densa",
    "Concept": "Bry_1024",
    "Taxon_name": "Tortella densa",
    "BRC_num": "0820  1024",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 72,
    "GBno": 24,
    "IRno": 10,
    "CIno": "",
    "TJan": 2.8,
    "TJul": 13.4,
    "Prec": 1504,
    "Alt": 580,
    "L": 7,
    "F": 4,
    "R": 9,
    "N": 2,
    "S": 0,
    "HM": 2,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 2,
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Weissia squarrosa",
    "Concept": "Bry_646",
    "Taxon_name": "Weissia squarrosa",
    "BRC_num": "0820   646",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "NA",
    "Len": 10,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 22,
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "(S)",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 72,
    "GBno": 24,
    "IRno": "",
    "CIno": "",
    "TJan": 3.7,
    "TJul": 16.2,
    "Prec": 750,
    "Alt": 160,
    "L": 8,
    "F": 6,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cephaloziella spinigera",
    "Concept": "Bry_734",
    "Taxon_name": "Cephaloziella spinigera",
    "BRC_num": "0810   734",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Thread",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 6,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 7,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 23,
    "IRno": 6,
    "CIno": "",
    "TJan": 3.4,
    "TJul": 14.2,
    "Prec": 1260,
    "Alt": 600,
    "L": 7,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 2,
    "PT": 2,
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fossombronia angulosa",
    "Concept": "Bry_754",
    "Taxon_name": "Fossombronia angulosa",
    "BRC_num": "0810   754",
    "ML": "L",
    "Ord": "Fossombroniales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 1,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 34,
    "Sp2": 52,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "CI",
    "Elem": 91,
    "GBno": 23,
    "IRno": 18,
    "CIno": 6,
    "TJan": 5.5,
    "TJul": 15,
    "Prec": 1243,
    "Alt": 120,
    "L": 6,
    "F": 7,
    "R": 5,
    "N": 4,
    "S": 2,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": 1,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Grimmia montana",
    "Concept": "Bry_307",
    "Taxon_name": "Grimmia montana",
    "BRC_num": "0820   307",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "(CI)",
    "Elem": 76,
    "GBno": 23,
    "IRno": "",
    "CIno": "",
    "TJan": 2.8,
    "TJul": 14,
    "Prec": 1240,
    "Alt": 500,
    "L": 8,
    "F": 1,
    "R": 4,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pedinophyllum interruptum",
    "Concept": "Bry_865",
    "Taxon_name": "Pedinophyllum interruptum",
    "BRC_num": "0810   865",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "We",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": 4,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 23,
    "IRno": 8,
    "CIno": "",
    "TJan": 2.1,
    "TJul": 13.4,
    "Prec": 1583,
    "Alt": 500,
    "L": 4,
    "F": 7,
    "R": 9,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pottiopsis caespitosa",
    "Concept": "Bry_492",
    "Taxon_name": "Pottiopsis caespitosa",
    "BRC_num": "0820   492",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 2,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 12,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 19,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 73,
    "GBno": 23,
    "IRno": "",
    "CIno": "",
    "TJan": 4,
    "TJul": 16.1,
    "Prec": 786,
    "Alt": 220,
    "L": 8,
    "F": 2,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Splachnum vasculosum",
    "Concept": "Bry_584",
    "Taxon_name": "Splachnum vasculosum",
    "BRC_num": "0820   584",
    "ML": "M",
    "Ord": "Splachnales",
    "Stat": "N",
    "Len": 70,
    "Per": "A",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 10,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 23,
    "IRno": "",
    "CIno": "",
    "TJan": 0.2,
    "TJul": 11.6,
    "Prec": 1670,
    "Alt": 930,
    "L": 7,
    "F": 9,
    "R": 5,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": 3,
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tetraplodon angustatus",
    "Concept": "Bry_590",
    "Taxon_name": "Tetraplodon angustatus",
    "BRC_num": "0820   590",
    "ML": "M",
    "Ord": "Splachnales",
    "Stat": "N",
    "Len": 60,
    "Per": "A",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 10,
    "E": "",
    "W": "(W)",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 23,
    "IRno": 1,
    "CIno": "",
    "TJan": 0.6,
    "TJul": 11.5,
    "Prec": 1714,
    "Alt": 915,
    "L": 7,
    "F": 8,
    "R": 2,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": 3,
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tortella bambergeri",
    "Concept": "Bry_1810",
    "Taxon_name": "Tortella bambergeri",
    "BRC_num": "0820  1810",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Cu",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 73,
    "GBno": 23,
    "IRno": 2,
    "CIno": "",
    "TJan": 1.9,
    "TJul": 13.2,
    "Prec": 1646,
    "Alt": 940,
    "L": 7,
    "F": 4,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tortula wilsonii",
    "Concept": "Bry_502",
    "Taxon_name": "Tortula wilsonii",
    "BRC_num": "0820   502",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 19,
    "Sp2": 27,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "CI",
    "Elem": 91,
    "GBno": 23,
    "IRno": 1,
    "CIno": 1,
    "TJan": 5.9,
    "TJul": 15.9,
    "Prec": 982,
    "Alt": 160,
    "L": 8,
    "F": 5,
    "R": 6,
    "N": 4,
    "S": 3,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Dichodontium flavescens",
    "Concept": "Bry_180.2",
    "Taxon_name": "Dichodontium flavescens",
    "BRC_num": "0820   180.2",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 70,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "R",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": 1,
    "Spend": 1,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 22,
    "IRno": 6,
    "CIno": "",
    "TJan": 3.1,
    "TJul": 13.9,
    "Prec": 1520,
    "Alt": 490,
    "L": 5,
    "F": 9,
    "R": 7,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 2,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fissidens polyphyllus",
    "Concept": "Bry_270",
    "Taxon_name": "Fissidens polyphyllus",
    "BRC_num": "0820   270",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "U",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 80,
    "GBno": 22,
    "IRno": 5,
    "CIno": "",
    "TJan": 4.6,
    "TJul": 14.6,
    "Prec": 1534,
    "Alt": 155,
    "L": 2,
    "F": 8,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 1,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Grimmia atrata",
    "Concept": "Bry_292",
    "Taxon_name": "Grimmia atrata",
    "BRC_num": "0820   292",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 42,
    "GBno": 22,
    "IRno": 1,
    "CIno": "",
    "TJan": 1.4,
    "TJul": 12.2,
    "Prec": 1966,
    "Alt": 950,
    "L": 6,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 5,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Grimmia dissimulata",
    "Concept": "Bry_1402",
    "Taxon_name": "Grimmia dissimulata",
    "BRC_num": "0820  1402",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 15,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 83,
    "GBno": 22,
    "IRno": 2,
    "CIno": "",
    "TJan": 3.3,
    "TJul": 15.8,
    "Prec": 784,
    "Alt": 95,
    "L": 7,
    "F": 2,
    "R": 9,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Grimmia incurva",
    "Concept": "Bry_304",
    "Taxon_name": "Grimmia incurva",
    "BRC_num": "0820   304",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 23,
    "GBno": 22,
    "IRno": "",
    "CIno": "",
    "TJan": 2,
    "TJul": 13.1,
    "Prec": 1414,
    "Alt": 950,
    "L": 8,
    "F": 1,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Lophocolea bispinosa",
    "Concept": "Bry_966",
    "Taxon_name": "Lophocolea bispinosa",
    "BRC_num": "0810   966",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "AN",
    "Len": 15,
    "Per": "P",
    "LF1": "We",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 3,
    "Spend": 5,
    "Spbeg2": 8,
    "Spend2": 9,
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "NI",
    "CI": "",
    "Elem": 72,
    "GBno": 22,
    "IRno": 1,
    "CIno": "",
    "TJan": 5.2,
    "TJul": 15.5,
    "Prec": 1132,
    "Alt": 160,
    "L": 6,
    "F": 6,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": 1,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Pallavicinia lyellii",
    "Concept": "Bry_864",
    "Taxon_name": "Pallavicinia lyellii",
    "BRC_num": "0810   864",
    "ML": "L",
    "Ord": "Metzgeriales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 5,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 26,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 82,
    "GBno": 22,
    "IRno": 7,
    "CIno": "",
    "TJan": 4.1,
    "TJul": 15.5,
    "Prec": 999,
    "Alt": 460,
    "L": 4,
    "F": 8,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Polytrichum commune var. perigoniale",
    "Concept": "Bry_482.3",
    "Taxon_name": "Polytrichum commune var. perigoniale",
    "BRC_num": "0820   482.3",
    "ML": "M",
    "Ord": "Polytrichales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 56,
    "GBno": 22,
    "IRno": "",
    "CIno": "",
    "TJan": 3.1,
    "TJul": 14.3,
    "Prec": 1167,
    "Alt": 355,
    "L": 6,
    "F": 7,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Rhizomnium magnifolium",
    "Concept": "Bry_1017",
    "Taxon_name": "Rhizomnium magnifolium",
    "BRC_num": "0820  1017",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 70,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 30,
    "Sp2": 40,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 22,
    "IRno": "",
    "CIno": "",
    "TJan": -0.2,
    "TJul": 11,
    "Prec": 1967,
    "Alt": 1070,
    "L": 6,
    "F": 9,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Scapania calcicola",
    "Concept": "Bry_921",
    "Taxon_name": "Scapania calcicola",
    "BRC_num": "0810   921",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 22,
    "IRno": "",
    "CIno": "",
    "TJan": 0.6,
    "TJul": 11.7,
    "Prec": 2009,
    "Alt": 1150,
    "L": 5,
    "F": 7,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Phascum cuspidatum var. papillosum",
    "Concept": "Bry_434.5",
    "Taxon_name": "Tortula acaulon var. papillosa",
    "BRC_num": "0820   434.5",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 6,
    "Per": "A",
    "LF1": "Ts",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "(W)",
    "Sc": "",
    "IR": "",
    "NI": "NI",
    "CI": "",
    "Elem": 82,
    "GBno": 22,
    "IRno": 1,
    "CIno": 1,
    "TJan": 5.7,
    "TJul": 15.8,
    "Prec": 996,
    "Alt": 30,
    "L": 8,
    "F": 5,
    "R": 7,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Aloina brevirostris",
    "Concept": "Bry_11",
    "Taxon_name": "Aloina brevirostris",
    "BRC_num": "0820    11",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 2,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M(D)",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 22,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 21,
    "IRno": "",
    "CIno": "",
    "TJan": 3.4,
    "TJul": 15.7,
    "Prec": 696,
    "Alt": 225,
    "L": 8,
    "F": 3,
    "R": 9,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Anastrophyllum joergensenii",
    "Concept": "Bry_685",
    "Taxon_name": "Anastrophyllum joergensenii",
    "BRC_num": "0810   685",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "We",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 13,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 41,
    "GBno": 21,
    "IRno": "",
    "CIno": "",
    "TJan": 0.8,
    "TJul": 10.9,
    "Prec": 2059,
    "Alt": 990,
    "L": 5,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 2,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hylocomiastrum pyrenaicum",
    "Concept": "Bry_345",
    "Taxon_name": "Hylocomium pyrenaicum",
    "BRC_num": "0820   345",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 85,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 20,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 21,
    "IRno": "",
    "CIno": "",
    "TJan": 0,
    "TJul": 11,
    "Prec": 2235,
    "Alt": 1180,
    "L": 6,
    "F": 5,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Polytrichastrum sexangulare",
    "Concept": "Bry_487",
    "Taxon_name": "Polytrichum sexangulare",
    "BRC_num": "0820   487",
    "ML": "M",
    "Ord": "Polytrichales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 20,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 13,
    "GBno": 21,
    "IRno": "",
    "CIno": "",
    "TJan": -0.7,
    "TJul": 10.5,
    "Prec": 2047,
    "Alt": 1335,
    "L": 6,
    "F": 5,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Riccia huebeneriana",
    "Concept": "Bry_911",
    "Taxon_name": "Riccia huebeneriana",
    "BRC_num": "0810   911",
    "ML": "L",
    "Ord": "Ricciales",
    "Stat": "N",
    "Len": 10,
    "Per": "A",
    "LF1": "St",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 11,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 54,
    "Sp2": 70,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 73,
    "GBno": 21,
    "IRno": 1,
    "CIno": "",
    "TJan": 3.3,
    "TJul": 14.8,
    "Prec": 1140,
    "Alt": 450,
    "L": 7,
    "F": 9,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum dixonii",
    "Concept": "Bry_95",
    "Taxon_name": "Bryum dixonii",
    "BRC_num": "0820    95",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "U",
    "Gem": "",
    "Bul": "",
    "Bra": "O",
    "Lvs": "",
    "Sex": "Nil",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 42,
    "GBno": 20,
    "IRno": "",
    "CIno": "",
    "TJan": 0.8,
    "TJul": 11.4,
    "Prec": 2117,
    "Alt": 850,
    "L": 6,
    "F": 7,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Calypogeia suecica",
    "Concept": "Bry_710",
    "Taxon_name": "Calypogeia suecica",
    "BRC_num": "0810   710",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Sc",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "R",
    "Spbeg": 4,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 11,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 20,
    "IRno": 4,
    "CIno": "",
    "TJan": 2.3,
    "TJul": 12.3,
    "Prec": 2131,
    "Alt": 300,
    "L": 3,
    "F": 7,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": 1,
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hygrohypnum duriusculum",
    "Concept": "Bry_338",
    "Taxon_name": "Hygrohypnum duriusculum",
    "BRC_num": "0820   338",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 20,
    "IRno": 1,
    "CIno": "",
    "TJan": 1.6,
    "TJul": 12.4,
    "Prec": 1871,
    "Alt": 860,
    "L": 5,
    "F": 10,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Scapania lingulata",
    "Concept": "Bry_972",
    "Taxon_name": "Scapania lingulata",
    "BRC_num": "0810   972",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 8,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 20,
    "IRno": 2,
    "CIno": "",
    "TJan": 2.1,
    "TJul": 12.7,
    "Prec": 1552,
    "Alt": 1220,
    "L": 6,
    "F": 6,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 2,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": 1,
    "DV": 1,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Schistidium trichodon",
    "Concept": "Bry_318",
    "Taxon_name": "Schistidium trichodon",
    "BRC_num": "0820   318",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "(W)",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 20,
    "IRno": 2,
    "CIno": "",
    "TJan": 0.3,
    "TJul": 11.6,
    "Prec": 1709,
    "Alt": 1190,
    "L": 7,
    "F": 5,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Seligeria trifaria",
    "Concept": "Bry_549",
    "Taxon_name": "Seligeria trifaria",
    "BRC_num": "0820   549",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 7,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 32,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 20,
    "IRno": 4,
    "CIno": "",
    "TJan": 1.5,
    "TJul": 12.9,
    "Prec": 1548,
    "Alt": 500,
    "L": 3,
    "F": 9,
    "R": 9,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum riparium",
    "Concept": "Bry_572",
    "Taxon_name": "Sphagnum riparium",
    "BRC_num": "0820   572",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 250,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 25,
    "Sp2": 27,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 20,
    "IRno": "",
    "CIno": "",
    "TJan": 1,
    "TJul": 12.3,
    "Prec": 1395,
    "Alt": 940,
    "L": 7,
    "F": 9,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ulota coarctata",
    "Concept": "Bry_635",
    "Taxon_name": "Ulota coarctata",
    "BRC_num": "0820   635",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 24,
    "E": "E",
    "W": "(W)",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 42,
    "GBno": 20,
    "IRno": 1,
    "CIno": "",
    "TJan": 2.2,
    "TJul": 13,
    "Prec": 1962,
    "Alt": 245,
    "L": 5,
    "F": 5,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Andreaea megistospora",
    "Concept": "Bry_1064",
    "Taxon_name": "Andreaea megistospora",
    "BRC_num": "0820  1064",
    "ML": "M",
    "Ord": "Andreaeales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 50,
    "Sp2": 90,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 70,
    "GBno": 19,
    "IRno": 4,
    "CIno": "",
    "TJan": 2.1,
    "TJul": 12.3,
    "Prec": 2211,
    "Alt": 1100,
    "L": 8,
    "F": 3,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum gemmilucens",
    "Concept": "Bry_663",
    "Taxon_name": "Bryum gemmilucens",
    "BRC_num": "0820   663",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "NA",
    "Len": 10,
    "Per": "PA",
    "LF1": "Tuft",
    "LF2": "Ts",
    "Tub": "",
    "Gem": "",
    "Bul": "F",
    "Bra": "",
    "Lvs": "",
    "Sex": "Nil",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 73,
    "GBno": 19,
    "IRno": "",
    "CIno": "",
    "TJan": 3.6,
    "TJul": 16.1,
    "Prec": 679,
    "Alt": 60,
    "L": 7,
    "F": 5,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum knowltonii",
    "Concept": "Bry_101",
    "Taxon_name": "Bryum knowltonii",
    "BRC_num": "0820   101",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 26,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 19,
    "IRno": 1,
    "CIno": "",
    "TJan": 3.9,
    "TJul": 15.2,
    "Prec": 848,
    "Alt": 60,
    "L": 7,
    "F": 7,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Kiaeria glacialis",
    "Concept": "Bry_202",
    "Taxon_name": "Kiaeria glacialis",
    "BRC_num": "0820   202",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 19,
    "IRno": "",
    "CIno": "",
    "TJan": -0.4,
    "TJul": 10.8,
    "Prec": 2081,
    "Alt": 1330,
    "L": 6,
    "F": 6,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Lophozia perssonii",
    "Concept": "Bry_968",
    "Taxon_name": "Lophozia perssonii",
    "BRC_num": "0810   968",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 4,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 16,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 19,
    "IRno": "",
    "CIno": "",
    "TJan": 3.4,
    "TJul": 15.8,
    "Prec": 665,
    "Alt": 230,
    "L": 6,
    "F": 5,
    "R": 9,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": 3,
    "RW": 1,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pohlia proligera s.str.",
    "Concept": "Bry_1354",
    "Taxon_name": "Pohlia proligera",
    "BRC_num": "0820  1354",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 15,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "Ts",
    "Tub": "",
    "Gem": "",
    "Bul": "F",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 19,
    "IRno": 1,
    "CIno": "",
    "TJan": 0.8,
    "TJul": 12.1,
    "Prec": 1374,
    "Alt": 800,
    "L": 7,
    "F": 6,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pseudoleskea patens",
    "Concept": "Bry_506",
    "Taxon_name": "Pseudoleskea patens",
    "BRC_num": "0820   506",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 19,
    "IRno": "",
    "CIno": "",
    "TJan": -0.4,
    "TJul": 10.8,
    "Prec": 1983,
    "Alt": 1200,
    "L": 6,
    "F": 5,
    "R": 7,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Rhynchostegiella litorea",
    "Concept": "Bry_531.1",
    "Taxon_name": "Rhynchostegiella litorea",
    "BRC_num": "0820   531.1",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 15,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 91,
    "GBno": 19,
    "IRno": "",
    "CIno": "",
    "TJan": 3.8,
    "TJul": 16.4,
    "Prec": 703,
    "Alt": 150,
    "L": 3,
    "F": 4,
    "R": 8,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Weissia condensa",
    "Concept": "Bry_648",
    "Taxon_name": "Weissia condensa",
    "BRC_num": "0820   648",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 24,
    "E": "E",
    "W": "",
    "Sc": "(S)",
    "IR": "",
    "NI": "NI",
    "CI": "",
    "Elem": 92,
    "GBno": 19,
    "IRno": 1,
    "CIno": "",
    "TJan": 4.2,
    "TJul": 16.1,
    "Prec": 854,
    "Alt": 75,
    "L": 8,
    "F": 2,
    "R": 9,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Acrobolbus wilsonii",
    "Concept": "Bry_680",
    "Taxon_name": "Acrobolbus wilsonii",
    "BRC_num": "0810   680",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": 11,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 22,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 80,
    "GBno": 18,
    "IRno": 9,
    "CIno": "",
    "TJan": 3.4,
    "TJul": 13.1,
    "Prec": 1976,
    "Alt": 490,
    "L": 5,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 1,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": 2,
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Andreaea nivalis",
    "Concept": "Bry_24",
    "Taxon_name": "Andreaea nivalis",
    "BRC_num": "0820    24",
    "ML": "M",
    "Ord": "Andreaeales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 33,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 13,
    "GBno": 18,
    "IRno": "",
    "CIno": "",
    "TJan": -0.4,
    "TJul": 10.7,
    "Prec": 2098,
    "Alt": 1340,
    "L": 7,
    "F": 7,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sciuro-hypnum reflexum",
    "Concept": "Bry_79",
    "Taxon_name": "Brachythecium reflexum",
    "BRC_num": "0820    79",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 65,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 18,
    "IRno": "",
    "CIno": "",
    "TJan": -0.1,
    "TJul": 11,
    "Prec": 2070,
    "Alt": 1080,
    "L": 5,
    "F": 6,
    "R": 3,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum creberrimum",
    "Concept": "Bry_86",
    "Taxon_name": "Bryum creberrimum",
    "BRC_num": "0820    86",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 56,
    "GBno": 18,
    "IRno": 1,
    "CIno": "",
    "TJan": 3.2,
    "TJul": 14.8,
    "Prec": 920,
    "Alt": 380,
    "L": 7,
    "F": 5,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": 2,
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum warneum",
    "Concept": "Bry_122",
    "Taxon_name": "Bryum warneum",
    "BRC_num": "0820   122",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 10,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 25,
    "Sp2": 45,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 18,
    "IRno": 3,
    "CIno": "",
    "TJan": 4.1,
    "TJul": 14.9,
    "Prec": 1003,
    "Alt": 5,
    "L": 8,
    "F": 8,
    "R": 8,
    "N": 4,
    "S": 3,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cephalozia macrostachya var. macrostachya",
    "Concept": "Bry_720.1",
    "Taxon_name": "Cephalozia macrostachya var. macrostachya",
    "BRC_num": "0810   720.1",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 5,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 42,
    "GBno": 18,
    "IRno": 2,
    "CIno": "",
    "TJan": 3.8,
    "TJul": 14.9,
    "Prec": 1113,
    "Alt": 275,
    "L": 7,
    "F": 8,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": 3,
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Dicranum undulatum",
    "Concept": "Bry_195",
    "Taxon_name": "Dicranum bergeri",
    "BRC_num": "0820   195",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 18,
    "IRno": 3,
    "CIno": "",
    "TJan": 2.5,
    "TJul": 13.8,
    "Prec": 974,
    "Alt": 350,
    "L": 8,
    "F": 8,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Encalypta alpina",
    "Concept": "Bry_230",
    "Taxon_name": "Encalypta alpina",
    "BRC_num": "0820   230",
    "ML": "M",
    "Ord": "Encalyptales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 28,
    "Sp2": 40,
    "E": "E",
    "W": "(W)",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 18,
    "IRno": 1,
    "CIno": "",
    "TJan": 0.2,
    "TJul": 11.4,
    "Prec": 2051,
    "Alt": 1205,
    "L": 5,
    "F": 5,
    "R": 7,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Leiocolea fitzgeraldiae",
    "Concept": "Bry_1761",
    "Taxon_name": "Leiocolea fitzgeraldiae",
    "BRC_num": "0810  1761",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "We",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 41,
    "GBno": 18,
    "IRno": 4,
    "CIno": "",
    "TJan": 2.2,
    "TJul": 12.4,
    "Prec": 2098,
    "Alt": 900,
    "L": 5,
    "F": 8,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Leiocolea gillmanii",
    "Concept": "Bry_792",
    "Taxon_name": "Leiocolea gillmanii",
    "BRC_num": "0810   792",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 15,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 18,
    "IRno": 2,
    "CIno": "",
    "TJan": 1.7,
    "TJul": 12.4,
    "Prec": 1545,
    "Alt": 900,
    "L": 6,
    "F": 8,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": 2,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Lophozia capitata",
    "Concept": "Bry_817",
    "Taxon_name": "Lophozia capitata",
    "BRC_num": "0810   817",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 4,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 17,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 73,
    "GBno": 18,
    "IRno": "",
    "CIno": "",
    "TJan": 3.8,
    "TJul": 16.3,
    "Prec": 724,
    "Alt": 210,
    "L": 7,
    "F": 7,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pleurocladula albescens",
    "Concept": "Bry_880",
    "Taxon_name": "Pleurocladula albescens",
    "BRC_num": "0810   880",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "R",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 16,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 18,
    "IRno": "",
    "CIno": "",
    "TJan": -0.4,
    "TJul": 10.8,
    "Prec": 2160,
    "Alt": 1335,
    "L": 5,
    "F": 5,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Racomitrium macounii",
    "Concept": "Bry_1075",
    "Taxon_name": "Racomitrium macounii",
    "BRC_num": "0820  1075",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 55,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 18,
    "IRno": 3,
    "CIno": "",
    "TJan": 1.1,
    "TJul": 11.9,
    "Prec": 1839,
    "Alt": 1180,
    "L": 6,
    "F": 6,
    "R": 4,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Scapania paludosa",
    "Concept": "Bry_933",
    "Taxon_name": "Scapania paludosa",
    "BRC_num": "0810   933",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 17,
    "Sp2": 17,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 18,
    "IRno": "",
    "CIno": "",
    "TJan": -0.1,
    "TJul": 11.1,
    "Prec": 2092,
    "Alt": 1150,
    "L": 7,
    "F": 10,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum lindbergii",
    "Concept": "Bry_561",
    "Taxon_name": "Sphagnum lindbergii",
    "BRC_num": "0820   561",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 29,
    "Sp2": 32,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 18,
    "IRno": "",
    "CIno": "",
    "TJan": -0.8,
    "TJul": 10.4,
    "Prec": 1735,
    "Alt": 1150,
    "L": 8,
    "F": 9,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Syntrichia princeps",
    "Concept": "Bry_617",
    "Taxon_name": "Syntrichia princeps",
    "BRC_num": "0820   617",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 73,
    "GBno": 18,
    "IRno": 1,
    "CIno": "",
    "TJan": 2.2,
    "TJul": 13.3,
    "Prec": 1329,
    "Alt": 500,
    "L": 8,
    "F": 4,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 1,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Tortula canescens",
    "Concept": "Bry_608",
    "Taxon_name": "Tortula canescens",
    "BRC_num": "0820   608",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 2,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "(CI)",
    "Elem": 91,
    "GBno": 18,
    "IRno": "",
    "CIno": "",
    "TJan": 5.8,
    "TJul": 15.6,
    "Prec": 1130,
    "Alt": 270,
    "L": 7,
    "F": 4,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Atrichum angustatum",
    "Concept": "Bry_37",
    "Taxon_name": "Atrichum angustatum",
    "BRC_num": "0820    37",
    "ML": "M",
    "Ord": "Polytrichales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "X",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "(W)",
    "Sc": "(S)",
    "IR": "",
    "NI": "NI",
    "CI": "",
    "Elem": 73,
    "GBno": 17,
    "IRno": 1,
    "CIno": "",
    "TJan": 3.8,
    "TJul": 16.2,
    "Prec": 800,
    "Alt": 137,
    "L": 6,
    "F": 7,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 1,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Didymodon tomaculosus",
    "Concept": "Bry_1032",
    "Taxon_name": "Didymodon tomaculosus",
    "BRC_num": "0820  1032",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "NA",
    "Len": 6,
    "Per": "AP",
    "LF1": "Ts",
    "LF2": "Tf",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 72,
    "GBno": 17,
    "IRno": 5,
    "CIno": "",
    "TJan": 4.3,
    "TJul": 15.5,
    "Prec": 872,
    "Alt": 150,
    "L": 8,
    "F": 6,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ditrichum plumbicola",
    "Concept": "Bry_678",
    "Taxon_name": "Ditrichum plumbicola",
    "BRC_num": "0820   678",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "NA",
    "Len": 15,
    "Per": "PA",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "U",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "Nil",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 71,
    "GBno": 17,
    "IRno": "",
    "CIno": "",
    "TJan": 2.9,
    "TJul": 13.5,
    "Prec": 1645,
    "Alt": 460,
    "L": 7,
    "F": 6,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 5,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hymenostylium recurvirostrum var. insigne",
    "Concept": "Bry_323.2",
    "Taxon_name": "Hymenostylium insigne",
    "BRC_num": "0820   323.2",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 41,
    "GBno": 17,
    "IRno": 5,
    "CIno": "",
    "TJan": 2,
    "TJul": 12.3,
    "Prec": 2210,
    "Alt": 860,
    "L": 6,
    "F": 8,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Marchantia polymorpha subsp. montivagans",
    "Concept": "Bry_827.4",
    "Taxon_name": "Marchantia polymorpha subsp. montivagans",
    "BRC_num": "0810   827.4",
    "ML": "L",
    "Ord": "Marchantiales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 17,
    "IRno": 1,
    "CIno": "",
    "TJan": 1.8,
    "TJul": 13.3,
    "Prec": 1126,
    "Alt": 1100,
    "L": 7,
    "F": 8,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Philonotis rigida",
    "Concept": "Bry_440",
    "Taxon_name": "Philonotis rigida",
    "BRC_num": "0820   440",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "F",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 4,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 28,
    "Sp2": 32,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "CI",
    "Elem": 91,
    "GBno": 17,
    "IRno": 9,
    "CIno": 2,
    "TJan": 4.5,
    "TJul": 14.5,
    "Prec": 1387,
    "Alt": 60,
    "L": 7,
    "F": 8,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Physcomitrium sphaericum",
    "Concept": "Bry_444",
    "Taxon_name": "Physcomitrium sphaericum",
    "BRC_num": "0820   444",
    "ML": "M",
    "Ord": "Funariales",
    "Stat": "N",
    "Len": 4,
    "Per": "A",
    "LF1": "Tf",
    "LF2": "Ts",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 32,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "NI",
    "CI": "",
    "Elem": 75,
    "GBno": 17,
    "IRno": 1,
    "CIno": "",
    "TJan": 2.7,
    "TJul": 14.3,
    "Prec": 1193,
    "Alt": 330,
    "L": 8,
    "F": 8,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pseudoleskeella rupestris",
    "Concept": "Bry_504.1",
    "Taxon_name": "Pseudoleskeella rupestris",
    "BRC_num": "0820   504.1",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 12,
    "E": "(E)",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 17,
    "IRno": "",
    "CIno": "",
    "TJan": 0.7,
    "TJul": 11.3,
    "Prec": 1896,
    "Alt": 1100,
    "L": 7,
    "F": 5,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Schistidium confertum",
    "Concept": "Bry_295",
    "Taxon_name": "Schistidium confertum",
    "BRC_num": "0820   295",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "(IR)",
    "NI": "(NI)",
    "CI": "",
    "Elem": 73,
    "GBno": 17,
    "IRno": "",
    "CIno": "",
    "TJan": 1.9,
    "TJul": 13,
    "Prec": 1450,
    "Alt": 550,
    "L": 7,
    "F": 2,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum capillifolium subsp. capillifolium",
    "Concept": "Bry_564.1",
    "Taxon_name": "Sphagnum capillifolium subsp. capillifolium",
    "BRC_num": "0820   564.1",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 27,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 56,
    "GBno": 17,
    "IRno": 1,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.8,
    "Prec": 1497,
    "Alt": 270,
    "L": 7,
    "F": 7,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sciuro-hypnum glaciale",
    "Concept": "Bry_74",
    "Taxon_name": "Brachythecium glaciale",
    "BRC_num": "0820    74",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 16,
    "IRno": "",
    "CIno": "",
    "TJan": -0.6,
    "TJul": 10.7,
    "Prec": 2069,
    "Alt": 1200,
    "L": 5,
    "F": 6,
    "R": 3,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum mildeanum",
    "Concept": "Bry_105",
    "Taxon_name": "Bryum mildeanum",
    "BRC_num": "0820   105",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 16,
    "IRno": "",
    "CIno": "",
    "TJan": 1.6,
    "TJul": 12.5,
    "Prec": 1922,
    "Alt": 850,
    "L": 6,
    "F": 7,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cephaloziella nicholsonii",
    "Concept": "Bry_978",
    "Taxon_name": "Cephaloziella nicholsonii",
    "BRC_num": "0810   978",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "NA",
    "Len": 15,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "(W)",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 72,
    "GBno": 16,
    "IRno": "",
    "CIno": "",
    "TJan": 5.7,
    "TJul": 15.5,
    "Prec": 1271,
    "Alt": 275,
    "L": 6,
    "F": 6,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 5,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": 2,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fissidens monguillonii",
    "Concept": "Bry_268",
    "Taxon_name": "Fissidens monguillonii",
    "BRC_num": "0820   268",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 81,
    "GBno": 16,
    "IRno": 3,
    "CIno": "",
    "TJan": 4.6,
    "TJul": 15.1,
    "Prec": 1297,
    "Alt": 45,
    "L": 6,
    "F": 9,
    "R": 7,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": 3,
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fossombronia fimbriata",
    "Concept": "Bry_961",
    "Taxon_name": "Fossombronia fimbriata",
    "BRC_num": "0810   961",
    "ML": "L",
    "Ord": "Fossombroniales",
    "Stat": "N",
    "Len": 3.5,
    "Per": "AP",
    "LF1": "Sc",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "F",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 24,
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 71,
    "GBno": 16,
    "IRno": 3,
    "CIno": "",
    "TJan": 2.1,
    "TJul": 12.7,
    "Prec": 1809,
    "Alt": 360,
    "L": 7,
    "F": 8,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fossombronia maritima",
    "Concept": "Bry_762.1",
    "Taxon_name": "Fossombronia maritima",
    "BRC_num": "0810   762.1",
    "ML": "L",
    "Ord": "Fossombroniales",
    "Stat": "N",
    "Len": 5,
    "Per": "PA",
    "LF1": "Sc",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 12,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 45,
    "Sp2": 64,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "CI",
    "Elem": 81,
    "GBno": 16,
    "IRno": 3,
    "CIno": 3,
    "TJan": 6.2,
    "TJul": 15.7,
    "Prec": 1057,
    "Alt": 90,
    "L": 8,
    "F": 6,
    "R": 4,
    "N": 3,
    "S": 1,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Habrodon perpusillus",
    "Concept": "Bry_326",
    "Taxon_name": "Habrodon perpusillus",
    "BRC_num": "0820   326",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 91,
    "GBno": 16,
    "IRno": "",
    "CIno": "",
    "TJan": 2.7,
    "TJul": 13.8,
    "Prec": 1584,
    "Alt": 60,
    "L": 6,
    "F": 4,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Marsupella emarginata var. pearsonii",
    "Concept": "Bry_831.2",
    "Taxon_name": "Marsupella emarginata var. pearsonii",
    "BRC_num": "0810   831.2",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 4,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 53,
    "GBno": 16,
    "IRno": 5,
    "CIno": "",
    "TJan": 1.9,
    "TJul": 12.4,
    "Prec": 1940,
    "Alt": 860,
    "L": 8,
    "F": 10,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Oncophorus wahlenbergii",
    "Concept": "Bry_409",
    "Taxon_name": "Oncophorus wahlenbergii",
    "BRC_num": "0820   409",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 28,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 16,
    "IRno": "",
    "CIno": "",
    "TJan": 0.3,
    "TJul": 11.4,
    "Prec": 2353,
    "Alt": 1005,
    "L": 7,
    "F": 8,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pohlia andalusica",
    "Concept": "Bry_1355",
    "Taxon_name": "Pohlia andalusica",
    "BRC_num": "0820  1355",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Ts",
    "Tub": "",
    "Gem": "",
    "Bul": "F",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 24,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 42,
    "GBno": 16,
    "IRno": 2,
    "CIno": "",
    "TJan": 5.5,
    "TJul": 15.3,
    "Prec": 1212,
    "Alt": 600,
    "L": 6,
    "F": 6,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 4,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Scapania curta",
    "Concept": "Bry_924",
    "Taxon_name": "Scapania curta",
    "BRC_num": "0810   924",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 13,
    "Sp2": 15,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 16,
    "IRno": 1,
    "CIno": "",
    "TJan": 3.2,
    "TJul": 14.9,
    "Prec": 1030,
    "Alt": 350,
    "L": 6,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tortula freibergii",
    "Concept": "Bry_1027",
    "Taxon_name": "Tortula freibergii",
    "BRC_num": "0820  1027",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "NA",
    "Len": 2,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 12,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 82,
    "GBno": 16,
    "IRno": "",
    "CIno": "",
    "TJan": 3.8,
    "TJul": 15.4,
    "Prec": 816,
    "Alt": 30,
    "L": 5,
    "F": 3,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "ZZZ - SYNONYMIZED",
    "Concept": "",
    "Taxon_name": "Tortula subulata var. angustata",
    "BRC_num": "0820   620.1",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "E",
    "W": "(W)",
    "Sc": "S",
    "IR": "",
    "NI": "(NI)",
    "CI": "",
    "Elem": 84,
    "GBno": 16,
    "IRno": "",
    "CIno": "",
    "TJan": 3.4,
    "TJul": 15.2,
    "Prec": 751,
    "Alt": 300,
    "L": 5,
    "F": 4,
    "R": 7,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum kunzei",
    "Concept": "Bry_91.3",
    "Taxon_name": "Bryum kunzei",
    "BRC_num": "0820    91.3",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 92,
    "GBno": 15,
    "IRno": "",
    "CIno": "",
    "TJan": 4.7,
    "TJul": 15.8,
    "Prec": 873,
    "Alt": 270,
    "L": 8,
    "F": 2,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hedwigia ciliata s.str.",
    "Concept": "Bry_1769",
    "Taxon_name": "Hedwigia ciliata",
    "BRC_num": "0820  1769",
    "ML": "M",
    "Ord": "Hedwigiales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 19,
    "Sp2": 35,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 56,
    "GBno": 15,
    "IRno": "",
    "CIno": "",
    "TJan": 3.2,
    "TJul": 14.7,
    "Prec": 1216,
    "Alt": 715,
    "L": 8,
    "F": 1,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": 1,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Hypnum bambergeri",
    "Concept": "Bry_349",
    "Taxon_name": "Hypnum bambergeri",
    "BRC_num": "0820   349",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 15,
    "IRno": "",
    "CIno": "",
    "TJan": -0.4,
    "TJul": 11.1,
    "Prec": 2002,
    "Alt": 1180,
    "L": 5,
    "F": 6,
    "R": 7,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Leptodontium gemmascens",
    "Concept": "Bry_369",
    "Taxon_name": "Leptodontium gemmascens",
    "BRC_num": "0820   369",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "NA",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "Nil",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 71,
    "GBno": 15,
    "IRno": "",
    "CIno": "",
    "TJan": 3.7,
    "TJul": 16.1,
    "Prec": 772,
    "Alt": 200,
    "L": 6,
    "F": 5,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": 3,
    "DA": 1,
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Nardia breidleri",
    "Concept": "Bry_855",
    "Taxon_name": "Nardia breidleri",
    "BRC_num": "0810   855",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Sc",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 7,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 15,
    "IRno": "",
    "CIno": "",
    "TJan": -0.5,
    "TJul": 10.8,
    "Prec": 2162,
    "Alt": 1340,
    "L": 8,
    "F": 7,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Palustriella decipiens",
    "Concept": "Bry_162",
    "Taxon_name": "Palustriella decipiens",
    "BRC_num": "0820   162",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 20,
    "E": "(E)",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 23,
    "GBno": 15,
    "IRno": "",
    "CIno": "",
    "TJan": -0.3,
    "TJul": 11.1,
    "Prec": 1883,
    "Alt": 1000,
    "L": 7,
    "F": 9,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Phaeoceros carolinianus",
    "Concept": "Bry_689.1",
    "Taxon_name": "Phaeoceros carolinianus",
    "BRC_num": "0810   689.1",
    "ML": "H",
    "Ord": "Anthocerotales",
    "Stat": "NA",
    "Len": 20,
    "Per": "AP",
    "LF1": "St",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 9,
    "Spend": 12,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 38,
    "Sp2": 56,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 73,
    "GBno": 15,
    "IRno": "",
    "CIno": "",
    "TJan": 3.7,
    "TJul": 15.2,
    "Prec": 1051,
    "Alt": 226,
    "L": 8,
    "F": 7,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Philonotis tomentella",
    "Concept": "Bry_439.4",
    "Taxon_name": "Philonotis tomentella",
    "BRC_num": "0820   439.4",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 24,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 15,
    "IRno": 3,
    "CIno": "",
    "TJan": 1.3,
    "TJul": 11.7,
    "Prec": 1886,
    "Alt": 1125,
    "L": 7,
    "F": 9,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tortula vahliana",
    "Concept": "Bry_621",
    "Taxon_name": "Tortula vahliana",
    "BRC_num": "0820   621",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "(IR)",
    "NI": "",
    "CI": "",
    "Elem": 91,
    "GBno": 15,
    "IRno": "",
    "CIno": "",
    "TJan": 3.9,
    "TJul": 16.4,
    "Prec": 651,
    "Alt": 61,
    "L": 2,
    "F": 4,
    "R": 9,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Barbilophozia kunzeana",
    "Concept": "Bry_697",
    "Taxon_name": "Barbilophozia kunzeana",
    "BRC_num": "0810   697",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "(IR)",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 14,
    "IRno": "",
    "CIno": "",
    "TJan": 1.4,
    "TJul": 12.9,
    "Prec": 1231,
    "Alt": 1250,
    "L": 6,
    "F": 5,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 1,
    "DV": 3,
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cephaloziella massalongi",
    "Concept": "Bry_729",
    "Taxon_name": "Cephaloziella massalongi",
    "BRC_num": "0810   729",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "NA",
    "Len": 6,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 52,
    "GBno": 14,
    "IRno": 3,
    "CIno": "",
    "TJan": 5.2,
    "TJul": 15.1,
    "Prec": 1387,
    "Alt": 670,
    "L": 6,
    "F": 6,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 5,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": 2,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cynodontium tenellum",
    "Concept": "Bry_175",
    "Taxon_name": "Cynodontium tenellum",
    "BRC_num": "0820   175",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 14,
    "IRno": "",
    "CIno": "",
    "TJan": 0.2,
    "TJul": 11.6,
    "Prec": 1262,
    "Alt": 700,
    "L": 5,
    "F": 5,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fissidens curvatus",
    "Concept": "Bry_258",
    "Taxon_name": "Fissidens curvatus",
    "BRC_num": "0820   258",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 3,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 12,
    "Spend": 1,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 13,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 91,
    "GBno": 14,
    "IRno": 2,
    "CIno": "",
    "TJan": 5.5,
    "TJul": 15.5,
    "Prec": 1140,
    "Alt": 290,
    "L": 4,
    "F": 6,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Entosthodon pulchellus",
    "Concept": "Bry_1001",
    "Taxon_name": "Funaria pulchella",
    "BRC_num": "0820  1001",
    "ML": "M",
    "Ord": "Funariales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 4,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 92,
    "GBno": 14,
    "IRno": "",
    "CIno": "",
    "TJan": 4.9,
    "TJul": 15.6,
    "Prec": 950,
    "Alt": 160,
    "L": 7,
    "F": 3,
    "R": 9,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Orthotrichum speciosum",
    "Concept": "Bry_426",
    "Taxon_name": "Orthotrichum speciosum",
    "BRC_num": "0820   426",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 34,
    "Sp2": 36,
    "E": "(E)",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 14,
    "IRno": "",
    "CIno": "",
    "TJan": 0.4,
    "TJul": 12.1,
    "Prec": 1133,
    "Alt": 350,
    "L": 6,
    "F": 4,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Schistidium frigidum",
    "Concept": "Bry_1777",
    "Taxon_name": "Schistidium frigidum",
    "BRC_num": "0820  1777",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 32,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 13,
    "E": "(E)",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 14,
    "IRno": "",
    "CIno": "",
    "TJan": 1.5,
    "TJul": 12.3,
    "Prec": 1720,
    "Alt": 1200,
    "L": 7,
    "F": 2,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryoerythrophyllum caledonicum",
    "Concept": "Bry_1034",
    "Taxon_name": "Bryoerythrophyllum caledonicum",
    "BRC_num": "0820  1034",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Ts",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "Nil",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 41,
    "GBno": 13,
    "IRno": "",
    "CIno": "",
    "TJan": 0.7,
    "TJul": 11.5,
    "Prec": 2428,
    "Alt": 1130,
    "L": 7,
    "F": 9,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum marratii",
    "Concept": "Bry_104",
    "Taxon_name": "Bryum marratii",
    "BRC_num": "0820   104",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Ts",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 26,
    "Sp2": 32,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 43,
    "GBno": 13,
    "IRno": 5,
    "CIno": "",
    "TJan": 4.2,
    "TJul": 14.2,
    "Prec": 1115,
    "Alt": 10,
    "L": 7,
    "F": 9,
    "R": 7,
    "N": 4,
    "S": 4,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Solenostoma caespiticium",
    "Concept": "Bry_941",
    "Taxon_name": "Jungermannia caespiticia",
    "BRC_num": "0810   941",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 3,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 13,
    "IRno": "",
    "CIno": "",
    "TJan": 2.5,
    "TJul": 14.1,
    "Prec": 1302,
    "Alt": 380,
    "L": 6,
    "F": 6,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 1,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Scopelophila cataractae",
    "Concept": "Bry_1070",
    "Taxon_name": "Scopelophila cataractae",
    "BRC_num": "0820  1070",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "NA",
    "Len": 50,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "X",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 13,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 86,
    "GBno": 13,
    "IRno": "",
    "CIno": "",
    "TJan": 5.6,
    "TJul": 15.4,
    "Prec": 1194,
    "Alt": 154,
    "L": 7,
    "F": 6,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 5,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": 1,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tortula cuneifolia",
    "Concept": "Bry_609",
    "Taxon_name": "Tortula cuneifolia",
    "BRC_num": "0820   609",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 4,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "CI",
    "Elem": 91,
    "GBno": 13,
    "IRno": 3,
    "CIno": 2,
    "TJan": 5.6,
    "TJul": 15.9,
    "Prec": 999,
    "Alt": 225,
    "L": 7,
    "F": 5,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Weissia multicapsularis",
    "Concept": "Bry_643",
    "Taxon_name": "Weissia multicapsularis",
    "BRC_num": "0820   643",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": 2,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 21,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 71,
    "GBno": 13,
    "IRno": "",
    "CIno": "",
    "TJan": 5.9,
    "TJul": 15.9,
    "Prec": 1032,
    "Alt": 110,
    "L": 7,
    "F": 6,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Acaulon muticum s.str.",
    "Concept": "Bry_1.2",
    "Taxon_name": "Acaulon muticum var. muticum",
    "BRC_num": "0820     1.2",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 2,
    "Per": "A",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 30,
    "Sp2": 50,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "CI",
    "Elem": 73,
    "GBno": 12,
    "IRno": "",
    "CIno": "",
    "TJan": 5.7,
    "TJul": 15.8,
    "Prec": 966,
    "Alt": 490,
    "L": 7,
    "F": 5,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Anastrophyllum alpinum",
    "Concept": "Bry_2801",
    "Taxon_name": "Anastrophyllum alpinum",
    "BRC_num": "0810  2801",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "We",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 13,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 41,
    "GBno": 12,
    "IRno": "",
    "CIno": "",
    "TJan": 1.4,
    "TJul": 11.1,
    "Prec": 2142,
    "Alt": 990,
    "L": 5,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum calophyllum",
    "Concept": "Bry_92",
    "Taxon_name": "Bryum calophyllum",
    "BRC_num": "0820    92",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 15,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 26,
    "Sp2": 40,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 12,
    "IRno": 2,
    "CIno": 1,
    "TJan": 4.1,
    "TJul": 14.5,
    "Prec": 1004,
    "Alt": 10,
    "L": 8,
    "F": 8,
    "R": 8,
    "N": 4,
    "S": 4,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Dendrocryphaea lamyana",
    "Concept": "Bry_165",
    "Taxon_name": "Cryphaea lamyana",
    "BRC_num": "0820   165",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Fa",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 3,
    "Spend": 4,
    "Spbeg2": 11,
    "Spend2": 11,
    "Sp1": 18,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 81,
    "GBno": 12,
    "IRno": "",
    "CIno": "",
    "TJan": 4.8,
    "TJul": 15.4,
    "Prec": 1184,
    "Alt": 90,
    "L": 5,
    "F": 6,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Ctenidium molluscum var. robustum",
    "Concept": "Bry_166.4",
    "Taxon_name": "Ctenidium molluscum var. robustum",
    "BRC_num": "0820   166.4",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "(E)",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "(NI)",
    "CI": "",
    "Elem": 53,
    "GBno": 12,
    "IRno": "",
    "CIno": "",
    "TJan": 1.6,
    "TJul": 12.1,
    "Prec": 1924,
    "Alt": 790,
    "L": 6,
    "F": 8,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Dicranum leioneuron",
    "Concept": "Bry_676",
    "Taxon_name": "Dicranum leioneuron",
    "BRC_num": "0820   676",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 65,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "O",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 25,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 12,
    "IRno": "",
    "CIno": "",
    "TJan": 2.3,
    "TJul": 13.5,
    "Prec": 1468,
    "Alt": 800,
    "L": 7,
    "F": 8,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 1,
    "SO": 1,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ditrichum subulatum",
    "Concept": "Bry_219",
    "Taxon_name": "Ditrichum subulatum",
    "BRC_num": "0820   219",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 6.5,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "U",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 4,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 91,
    "GBno": 12,
    "IRno": "",
    "CIno": "",
    "TJan": 6.1,
    "TJul": 15.8,
    "Prec": 1127,
    "Alt": 40,
    "L": 6,
    "F": 5,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Gymnomitrion corallioides",
    "Concept": "Bry_775",
    "Taxon_name": "Gymnomitrion corallioides",
    "BRC_num": "0810   775",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 6,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "",
    "W": "(W)",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 12,
    "IRno": 1,
    "CIno": "",
    "TJan": 0.6,
    "TJul": 11.2,
    "Prec": 2069,
    "Alt": 1205,
    "L": 8,
    "F": 5,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hedwigia ciliata var. ciliata",
    "Concept": "Bry_1769.1",
    "Taxon_name": "Hedwigia ciliata var. ciliata",
    "BRC_num": "0820  1769.1",
    "ML": "M",
    "Ord": "Hedwigiales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 25,
    "Sp2": 35,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 56,
    "GBno": 12,
    "IRno": "",
    "CIno": 3,
    "TJan": 3.2,
    "TJul": 14.5,
    "Prec": 1283,
    "Alt": 530,
    "L": 8,
    "F": 1,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": 1,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Scapania gymnostomophila",
    "Concept": "Bry_928",
    "Taxon_name": "Scapania gymnostomophila",
    "BRC_num": "0810   928",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 12,
    "IRno": 3,
    "CIno": "",
    "TJan": 1,
    "TJul": 11.9,
    "Prec": 1793,
    "Alt": 950,
    "L": 6,
    "F": 7,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Aongstroemia longipes",
    "Concept": "Bry_656",
    "Taxon_name": "Aongstroemia longipes",
    "BRC_num": "0820   656",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Ts",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 20,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 11,
    "IRno": 1,
    "CIno": "",
    "TJan": 1.6,
    "TJul": 12.4,
    "Prec": 1847,
    "Alt": 520,
    "L": 8,
    "F": 6,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Barbilophozia quadriloba",
    "Concept": "Bry_699",
    "Taxon_name": "Barbilophozia quadriloba",
    "BRC_num": "0810   699",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "X",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 11,
    "IRno": "",
    "CIno": "",
    "TJan": -0.4,
    "TJul": 11.3,
    "Prec": 1835,
    "Alt": 1175,
    "L": 6,
    "F": 7,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum muehlenbeckii",
    "Concept": "Bry_106",
    "Taxon_name": "Bryum muehlenbeckii",
    "BRC_num": "0820   106",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 70,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 11,
    "IRno": "",
    "CIno": "",
    "TJan": -0.2,
    "TJul": 10.9,
    "Prec": 1920,
    "Alt": 900,
    "L": 7,
    "F": 8,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cephaloziella calyculata",
    "Concept": "Bry_724",
    "Taxon_name": "Cephaloziella calyculata",
    "BRC_num": "0810   724",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 4,
    "Per": "P",
    "LF1": "Sc",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": 3,
    "Spend": 5,
    "Spbeg2": 10,
    "Spend2": 11,
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 81,
    "GBno": 11,
    "IRno": "",
    "CIno": "",
    "TJan": 5.9,
    "TJul": 15.7,
    "Prec": 1090,
    "Alt": 230,
    "L": 7,
    "F": 3,
    "R": 6,
    "N": 1,
    "S": 0,
    "HM": 1,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cephaloziella elachista",
    "Concept": "Bry_726",
    "Taxon_name": "Cephaloziella elachista",
    "BRC_num": "0810   726",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 12,
    "Per": "P",
    "LF1": "Thread",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 11,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 11,
    "IRno": 1,
    "CIno": "",
    "TJan": 3.5,
    "TJul": 15.2,
    "Prec": 892,
    "Alt": 120,
    "L": 7,
    "F": 8,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": 2,
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cynodontium strumiferum",
    "Concept": "Bry_174",
    "Taxon_name": "Cynodontium strumiferum",
    "BRC_num": "0820   174",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 24,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 11,
    "IRno": "",
    "CIno": "",
    "TJan": -0.4,
    "TJul": 11.1,
    "Prec": 1358,
    "Alt": 700,
    "L": 5,
    "F": 5,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Dumortiera hirsuta",
    "Concept": "Bry_752",
    "Taxon_name": "Dumortiera hirsuta",
    "BRC_num": "0810   752",
    "ML": "L",
    "Ord": "Marchantiales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "O",
    "Spbeg": 5,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 23,
    "Sp2": 34,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 81,
    "GBno": 11,
    "IRno": 26,
    "CIno": "",
    "TJan": 4.5,
    "TJul": 14.4,
    "Prec": 1299,
    "Alt": 400,
    "L": 2,
    "F": 8,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Riccia rhenana",
    "Concept": "Bry_914",
    "Taxon_name": "Riccia rhenana",
    "BRC_num": "0810   914",
    "ML": "L",
    "Ord": "Ricciales",
    "Stat": "AN",
    "Len": 20,
    "Per": "P",
    "LF1": "Le",
    "LF2": "St",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "Nil",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 73,
    "GBno": 11,
    "IRno": 1,
    "CIno": "",
    "TJan": 3.9,
    "TJul": 16.3,
    "Prec": 734,
    "Alt": 100,
    "L": 7,
    "F": 10,
    "R": 7,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": 3
  },
  {
    "Name_new": "Sanionia orthothecioides",
    "Concept": "Bry_1358",
    "Taxon_name": "Sanionia orthothecioides",
    "BRC_num": "0820  1358",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "We",
    "LF2": "Mr",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 13,
    "Sp2": 18,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 11,
    "IRno": "",
    "CIno": "",
    "TJan": 4,
    "TJul": 12.4,
    "Prec": 1415,
    "Alt": 300,
    "L": 6,
    "F": 5,
    "R": 4,
    "N": 2,
    "S": 3,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Scapania paludicola",
    "Concept": "Bry_973",
    "Taxon_name": "Scapania paludicola",
    "BRC_num": "0810   973",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 11,
    "IRno": "",
    "CIno": "",
    "TJan": 2.8,
    "TJul": 14.1,
    "Prec": 1552,
    "Alt": 430,
    "L": 7,
    "F": 8,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": 3,
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Timmia norvegica",
    "Concept": "Bry_601",
    "Taxon_name": "Timmia norvegica",
    "BRC_num": "0820   601",
    "ML": "M",
    "Ord": "Timmiales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Ts",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 17,
    "Sp2": 20,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 11,
    "IRno": 2,
    "CIno": "",
    "TJan": 0.5,
    "TJul": 11.6,
    "Prec": 2165,
    "Alt": 1200,
    "L": 7,
    "F": 5,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Amblystegium radicale",
    "Concept": "Bry_654",
    "Taxon_name": "Amblystegium radicale",
    "BRC_num": "0820   654",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 30,
    "Per": "PA",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 6,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 73,
    "GBno": 10,
    "IRno": "",
    "CIno": "",
    "TJan": 4.7,
    "TJul": 14.8,
    "Prec": 1179,
    "Alt": 120,
    "L": 5,
    "F": 9,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Andreaea blyttii",
    "Concept": "Bry_1060",
    "Taxon_name": "Andreaea blyttii",
    "BRC_num": "0820  1060",
    "ML": "M",
    "Ord": "Andreaeales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 13,
    "Sp2": 19,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 10,
    "IRno": "",
    "CIno": "",
    "TJan": -1.1,
    "TJul": 10.3,
    "Prec": 1908,
    "Alt": 1190,
    "L": 6,
    "F": 5,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Didymodon icmadophilus",
    "Concept": "Bry_52",
    "Taxon_name": "Didymodon icmadophilus",
    "BRC_num": "0820    52",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 13,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "(IR)",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 10,
    "IRno": "",
    "CIno": "",
    "TJan": 1,
    "TJul": 11.5,
    "Prec": 1988,
    "Alt": 610,
    "L": 7,
    "F": 6,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Marsupella condensata",
    "Concept": "Bry_833",
    "Taxon_name": "Marsupella condensata",
    "BRC_num": "0810   833",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": 8,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 13,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 13,
    "GBno": 10,
    "IRno": "",
    "CIno": "",
    "TJan": -1.2,
    "TJul": 10.4,
    "Prec": 1794,
    "Alt": 1240,
    "L": 8,
    "F": 7,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Schistidium elegantulum",
    "Concept": "Bry_1775",
    "Taxon_name": "Schistidium elegantulum",
    "BRC_num": "0820  1775",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 75,
    "GBno": 10,
    "IRno": 2,
    "CIno": "",
    "TJan": 3.9,
    "TJul": 14.5,
    "Prec": 1394,
    "Alt": 175,
    "L": 7,
    "F": 2,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Schistidium frigidum var. frigidum",
    "Concept": "Bry_1777.1",
    "Taxon_name": "Schistidium frigidum var. frigidum",
    "BRC_num": "0820  1777.1",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 13,
    "E": "(E)",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 10,
    "IRno": "",
    "CIno": "",
    "TJan": 1.5,
    "TJul": 12.4,
    "Prec": 1549,
    "Alt": 600,
    "L": 7,
    "F": 2,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum dyffrynense",
    "Concept": "Bry_1403",
    "Taxon_name": "Bryum dyffrynense",
    "BRC_num": "0820  1403",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "F",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 71,
    "GBno": 9,
    "IRno": 3,
    "CIno": "",
    "TJan": 4.6,
    "TJul": 15.2,
    "Prec": 1017,
    "Alt": 10,
    "L": 8,
    "F": 8,
    "R": 7,
    "N": 4,
    "S": 1,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cephaloziella baumgartneri",
    "Concept": "Bry_723",
    "Taxon_name": "Cephaloziella baumgartneri",
    "BRC_num": "0810   723",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 7,
    "Per": "P",
    "LF1": "Sc",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 7,
    "Spend": 11,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 12,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 91,
    "GBno": 9,
    "IRno": "",
    "CIno": "",
    "TJan": 4.5,
    "TJul": 16.4,
    "Prec": 776,
    "Alt": 120,
    "L": 6,
    "F": 5,
    "R": 9,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cephaloziella integerrima",
    "Concept": "Bry_728",
    "Taxon_name": "Cephaloziella integerrima",
    "BRC_num": "0810   728",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 4,
    "Per": "P",
    "LF1": "Sc",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": 3,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 6,
    "Sp2": 10,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 42,
    "GBno": 9,
    "IRno": 2,
    "CIno": "",
    "TJan": 5.5,
    "TJul": 15.3,
    "Prec": 1235,
    "Alt": 250,
    "L": 7,
    "F": 5,
    "R": 4,
    "N": 1,
    "S": 0,
    "HM": 3,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 1,
    "SO": 3,
    "PT": "",
    "GS": 1,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Dicranella grevilleana",
    "Concept": "Bry_183",
    "Taxon_name": "Dicranella grevilleana",
    "BRC_num": "0820   183",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 8,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "U",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 22,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 9,
    "IRno": 3,
    "CIno": "",
    "TJan": 1.3,
    "TJul": 12.1,
    "Prec": 1826,
    "Alt": 750,
    "L": 6,
    "F": 7,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Dicranum flexicaule",
    "Concept": "Bry_201.1",
    "Taxon_name": "Dicranum flexicaule",
    "BRC_num": "0820   201.1",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 18,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 9,
    "IRno": "",
    "CIno": "",
    "TJan": 0.5,
    "TJul": 11.4,
    "Prec": 2187,
    "Alt": 610,
    "L": 7,
    "F": 4,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Geocalyx graveolens",
    "Concept": "Bry_769",
    "Taxon_name": "Geocalyx graveolens",
    "BRC_num": "0810   769",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Sc",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 14,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 43,
    "GBno": 9,
    "IRno": 6,
    "CIno": "",
    "TJan": 3.9,
    "TJul": 13.2,
    "Prec": 1723,
    "Alt": 300,
    "L": 4,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 1,
    "SO": 3,
    "PT": 2,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Grimmia elongata",
    "Concept": "Bry_300",
    "Taxon_name": "Grimmia elongata",
    "BRC_num": "0820   300",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 15,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 9,
    "IRno": "",
    "CIno": "",
    "TJan": 1.6,
    "TJul": 12.5,
    "Prec": 2099,
    "Alt": 1085,
    "L": 7,
    "F": 3,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hygrohypnum smithii",
    "Concept": "Bry_343",
    "Taxon_name": "Hygrohypnum smithii",
    "BRC_num": "0820   343",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 20,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 9,
    "IRno": "",
    "CIno": "",
    "TJan": -0.9,
    "TJul": 10.8,
    "Prec": 1796,
    "Alt": 1075,
    "L": 6,
    "F": 10,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Mnium spinosum",
    "Concept": "Bry_393",
    "Taxon_name": "Mnium spinosum",
    "BRC_num": "0820   393",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 28,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 9,
    "IRno": "",
    "CIno": "",
    "TJan": -0.6,
    "TJul": 11,
    "Prec": 2023,
    "Alt": 1100,
    "L": 4,
    "F": 6,
    "R": 7,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Orthodontium gracile",
    "Concept": "Bry_410",
    "Taxon_name": "Orthodontium gracile",
    "BRC_num": "0820   410",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tp",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "(W)",
    "Sc": "S",
    "IR": "",
    "NI": "NI",
    "CI": "",
    "Elem": 81,
    "GBno": 9,
    "IRno": 1,
    "CIno": "",
    "TJan": 3.2,
    "TJul": 14.9,
    "Prec": 998,
    "Alt": 580,
    "L": 3,
    "F": 6,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pohlia scotica",
    "Concept": "Bry_1048",
    "Taxon_name": "Pohlia scotica",
    "BRC_num": "0820  1048",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "Nil",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 42,
    "GBno": 9,
    "IRno": "",
    "CIno": "",
    "TJan": 1,
    "TJul": 11.6,
    "Prec": 2510,
    "Alt": 650,
    "L": 7,
    "F": 6,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Riccia canaliculata",
    "Concept": "Bry_905",
    "Taxon_name": "Riccia canaliculata",
    "BRC_num": "0810   905",
    "ML": "L",
    "Ord": "Ricciales",
    "Stat": "N",
    "Len": 20,
    "Per": "A",
    "LF1": "St",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 7,
    "Spend": 3,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 75,
    "Sp2": 95,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 73,
    "GBno": 9,
    "IRno": "",
    "CIno": "",
    "TJan": 3.1,
    "TJul": 14.6,
    "Prec": 1015,
    "Alt": 245,
    "L": 7,
    "F": 9,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Schistidium agassizii",
    "Concept": "Bry_1018",
    "Taxon_name": "Schistidium agassizii",
    "BRC_num": "0820  1018",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "At",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 9,
    "IRno": 1,
    "CIno": "",
    "TJan": 1.7,
    "TJul": 12.5,
    "Prec": 1712,
    "Alt": 1100,
    "L": 7,
    "F": 9,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum skyense",
    "Concept": "Bry_1058",
    "Taxon_name": "Sphagnum skyense",
    "BRC_num": "0820  1058",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 110,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "Nil",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 70,
    "GBno": 9,
    "IRno": "",
    "CIno": "",
    "TJan": 3.4,
    "TJul": 12.6,
    "Prec": 2128,
    "Alt": 350,
    "L": 6,
    "F": 8,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tortella fragilis",
    "Concept": "Bry_603",
    "Taxon_name": "Tortella fragilis",
    "BRC_num": "0820   603",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "F",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 14,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 9,
    "IRno": 1,
    "CIno": "",
    "TJan": 2.9,
    "TJul": 12.9,
    "Prec": 1091,
    "Alt": 1060,
    "L": 8,
    "F": 6,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum arcticum",
    "Concept": "Bry_88",
    "Taxon_name": "Bryum arcticum",
    "BRC_num": "0820    88",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 28,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 8,
    "IRno": "",
    "CIno": "",
    "TJan": -0.3,
    "TJul": 11.2,
    "Prec": 1757,
    "Alt": 1007,
    "L": 6,
    "F": 6,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 2,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "ZZZ - SYNONYMIZED",
    "Concept": "",
    "Taxon_name": "Fontinalis squamosa var. dixonii",
    "BRC_num": "0820   278",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 400,
    "Per": "P",
    "LF1": "At",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "(S)",
    "IR": "",
    "NI": "NI",
    "CI": "",
    "Elem": 71,
    "GBno": 8,
    "IRno": "",
    "CIno": "",
    "TJan": 2.2,
    "TJul": 13,
    "Prec": 2075,
    "Alt": 490,
    "L": 7,
    "F": 12,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Grimmia arenaria",
    "Concept": "Bry_298.1",
    "Taxon_name": "Grimmia arenaria",
    "BRC_num": "0820   298.1",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 72,
    "GBno": 8,
    "IRno": "",
    "CIno": "",
    "TJan": 2.8,
    "TJul": 13.4,
    "Prec": 2253,
    "Alt": 200,
    "L": 7,
    "F": 1,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 2,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Jamesoniella undulifolia",
    "Concept": "Bry_787",
    "Taxon_name": "Jamesoniella undulifolia",
    "BRC_num": "0810   787",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 15,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 23,
    "GBno": 8,
    "IRno": "",
    "CIno": "",
    "TJan": 3.9,
    "TJul": 14.4,
    "Prec": 1454,
    "Alt": 400,
    "L": 7,
    "F": 8,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Leucodon sciuroides var. morensis",
    "Concept": "Bry_375.1",
    "Taxon_name": "Leucodon sciuroides var. morensis",
    "BRC_num": "0820   375.1",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 83,
    "GBno": 8,
    "IRno": "",
    "CIno": "",
    "TJan": 4.7,
    "TJul": 15.1,
    "Prec": 1110,
    "Alt": 730,
    "L": 6,
    "F": 4,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pseudoleskea incurvata",
    "Concept": "Bry_505",
    "Taxon_name": "Pseudoleskea incurvata",
    "BRC_num": "0820   505",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 8,
    "IRno": "",
    "CIno": "",
    "TJan": -0.7,
    "TJul": 11,
    "Prec": 1506,
    "Alt": 1165,
    "L": 6,
    "F": 5,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Riccia crystallina",
    "Concept": "Bry_908",
    "Taxon_name": "Riccia crystallina",
    "BRC_num": "0810   908",
    "ML": "L",
    "Ord": "Ricciales",
    "Stat": "AN",
    "Len": 25,
    "Per": "A",
    "LF1": "St",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 60,
    "Sp2": 86,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 91,
    "GBno": 8,
    "IRno": "",
    "CIno": "",
    "TJan": 6.4,
    "TJul": 15.6,
    "Prec": 1093,
    "Alt": 75,
    "L": 8,
    "F": 7,
    "R": 5,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Schistidium papillosum",
    "Concept": "Bry_1778",
    "Taxon_name": "Schistidium papillosum",
    "BRC_num": "0820  1778",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 13,
    "E": "",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 8,
    "IRno": "",
    "CIno": "",
    "TJan": 0.4,
    "TJul": 11.7,
    "Prec": 1691,
    "Alt": 630,
    "L": 7,
    "F": 2,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Schistidium pruinosum",
    "Concept": "Bry_1779",
    "Taxon_name": "Schistidium pruinosum",
    "BRC_num": "0820  1779",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "(NI)",
    "CI": "",
    "Elem": 73,
    "GBno": 8,
    "IRno": "",
    "CIno": "",
    "TJan": 1.9,
    "TJul": 12.7,
    "Prec": 1475,
    "Alt": 400,
    "L": 7,
    "F": 2,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sematophyllum substrumulosum",
    "Concept": "Bry_1763",
    "Taxon_name": "Sematophyllum substrumulosum",
    "BRC_num": "0820  1763",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 9,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 81,
    "GBno": 8,
    "IRno": 1,
    "CIno": "",
    "TJan": 6.1,
    "TJul": 15.8,
    "Prec": 1081,
    "Alt": 120,
    "L": 4,
    "F": 5,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Southbya tophacea",
    "Concept": "Bry_975",
    "Taxon_name": "Southbya tophacea",
    "BRC_num": "0810   975",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 6,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 9,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 91,
    "GBno": 8,
    "IRno": 2,
    "CIno": "",
    "TJan": 5,
    "TJul": 15.1,
    "Prec": 1063,
    "Alt": 160,
    "L": 6,
    "F": 7,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Anastrophyllum joergensenii s.str.",
    "Concept": "Bry_2701",
    "Taxon_name": "Anastrophyllum joergensenii s.str.",
    "BRC_num": "0810  2701",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 90,
    "Per": "P",
    "LF1": "We",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 41,
    "GBno": 7,
    "IRno": "",
    "CIno": "",
    "TJan": -0.7,
    "TJul": 10.2,
    "Prec": 1929,
    "Alt": 920,
    "L": 7,
    "F": 6,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 2,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum salinum",
    "Concept": "Bry_117",
    "Taxon_name": "Bryum salinum",
    "BRC_num": "0820   117",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 36,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 23,
    "GBno": 7,
    "IRno": 2,
    "CIno": "",
    "TJan": 4,
    "TJul": 13.8,
    "Prec": 1135,
    "Alt": 10,
    "L": 8,
    "F": 8,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ceratodon conicus",
    "Concept": "Bry_151.1",
    "Taxon_name": "Ceratodon conicus",
    "BRC_num": "0820   151.1",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "NA",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 13,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 92,
    "GBno": 7,
    "IRno": "",
    "CIno": "",
    "TJan": 3.5,
    "TJul": 16.2,
    "Prec": 658,
    "Alt": 210,
    "L": 7,
    "F": 3,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Daltonia splachnoides",
    "Concept": "Bry_176",
    "Taxon_name": "Daltonia splachnoides",
    "BRC_num": "0820   176",
    "ML": "M",
    "Ord": "Hookeriales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 16,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 80,
    "GBno": 7,
    "IRno": 15,
    "CIno": "",
    "TJan": 3.5,
    "TJul": 13.5,
    "Prec": 1703,
    "Alt": 460,
    "L": 5,
    "F": 8,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Lejeunea mandonii",
    "Concept": "Bry_802",
    "Taxon_name": "Lejeunea mandonii",
    "BRC_num": "0810   802",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 12,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": 4,
    "Spend": 5,
    "Spbeg2": 8,
    "Spend2": 9,
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 80,
    "GBno": 7,
    "IRno": 3,
    "CIno": "",
    "TJan": 4.8,
    "TJul": 14.3,
    "Prec": 1558,
    "Alt": 360,
    "L": 3,
    "F": 6,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 2,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": 3,
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Orthotrichum obtusifolium",
    "Concept": "Bry_419",
    "Taxon_name": "Orthotrichum obtusifolium",
    "BRC_num": "0820   419",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 7,
    "IRno": "",
    "CIno": "",
    "TJan": 1.8,
    "TJul": 13.2,
    "Prec": 905,
    "Alt": 290,
    "L": 6,
    "F": 4,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Plagiomnium medium",
    "Concept": "Bry_386",
    "Taxon_name": "Plagiomnium medium",
    "BRC_num": "0820   386",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 19,
    "Sp2": 27,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 7,
    "IRno": "",
    "CIno": "",
    "TJan": -0.2,
    "TJul": 11.1,
    "Prec": 2261,
    "Alt": 1070,
    "L": 6,
    "F": 7,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Acaulon mediterraneum",
    "Concept": "Bry_1.1",
    "Taxon_name": "Acaulon muticum var. mediterraneum",
    "BRC_num": "0820     1.1",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 2,
    "Per": "A",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 11,
    "Spend": 1,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 30,
    "Sp2": 30,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 91,
    "GBno": 6,
    "IRno": "",
    "CIno": "",
    "TJan": 6,
    "TJul": 16,
    "Prec": 1031,
    "Alt": 100,
    "L": 7,
    "F": 5,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Andreaea alpestris",
    "Concept": "Bry_1057",
    "Taxon_name": "Andreaea alpestris",
    "BRC_num": "0820  1057",
    "ML": "M",
    "Ord": "Andreaeales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 22,
    "Sp2": 26,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 6,
    "IRno": "",
    "CIno": "",
    "TJan": -1,
    "TJul": 10.5,
    "Prec": 1678,
    "Alt": 1335,
    "L": 7,
    "F": 4,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Anomodon longifolius",
    "Concept": "Bry_32",
    "Taxon_name": "Anomodon longifolius",
    "BRC_num": "0820    32",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 18,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 55,
    "GBno": 6,
    "IRno": "",
    "CIno": "",
    "TJan": 2.6,
    "TJul": 14.6,
    "Prec": 1023,
    "Alt": 250,
    "L": 5,
    "F": 5,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Aplodon wormskioldii",
    "Concept": "Bry_327",
    "Taxon_name": "Aplodon wormskjoldii",
    "BRC_num": "0820   327",
    "ML": "M",
    "Ord": "Splachnales",
    "Stat": "N",
    "Len": 60,
    "Per": "A",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 15,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 6,
    "IRno": "",
    "CIno": "",
    "TJan": -0.2,
    "TJul": 11.4,
    "Prec": 1586,
    "Alt": 869,
    "L": 8,
    "F": 7,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": 3,
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum cyclophyllum",
    "Concept": "Bry_119",
    "Taxon_name": "Bryum cyclophyllum",
    "BRC_num": "0820   119",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 80,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": 14,
    "E": "(E)",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 6,
    "IRno": "",
    "CIno": "",
    "TJan": 2.3,
    "TJul": 13.2,
    "Prec": 1645,
    "Alt": 250,
    "L": 7,
    "F": 8,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Buxbaumia viridis",
    "Concept": "Bry_125",
    "Taxon_name": "Buxbaumia viridis",
    "BRC_num": "0820   125",
    "ML": "M",
    "Ord": "Buxbaumiales",
    "Stat": "N",
    "Len": 9,
    "Per": "A",
    "LF1": "Tp",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 10,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 6,
    "IRno": "",
    "CIno": "",
    "TJan": 0.7,
    "TJul": 12.3,
    "Prec": 1008,
    "Alt": 350,
    "L": 4,
    "F": 7,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cheilothela chloropus",
    "Concept": "Bry_150",
    "Taxon_name": "Cheilothela chloropus",
    "BRC_num": "0820   150",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "NA",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 12,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 91,
    "GBno": 6,
    "IRno": "",
    "CIno": 9,
    "TJan": 5,
    "TJul": 16.3,
    "Prec": 902,
    "Alt": 35,
    "L": 9,
    "F": 2,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Leptophascum leptophyllum",
    "Concept": "Bry_1028",
    "Taxon_name": "Chenia leptophylla",
    "BRC_num": "0820  1028",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "AN",
    "Len": 3,
    "Per": "A",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "F",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 20,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 81,
    "GBno": 6,
    "IRno": "",
    "CIno": "",
    "TJan": 6.5,
    "TJul": 16.2,
    "Prec": 896,
    "Alt": 110,
    "L": 7,
    "F": 5,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Campylopus subporodictyon",
    "Concept": "Bry_675",
    "Taxon_name": "Dicranum subporodictyon",
    "BRC_num": "0820   675",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 70,
    "GBno": 6,
    "IRno": "",
    "CIno": "",
    "TJan": 1.6,
    "TJul": 11.6,
    "Prec": 2761,
    "Alt": 250,
    "L": 7,
    "F": 8,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fontinalis squamosa var. curnowii",
    "Concept": "Bry_281.1",
    "Taxon_name": "Fontinalis squamosa var. curnowii",
    "BRC_num": "0820   281.1",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 400,
    "Per": "P",
    "LF1": "At",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 3,
    "Spend": 6,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 22,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 71,
    "GBno": 6,
    "IRno": "",
    "CIno": "",
    "TJan": 5.7,
    "TJul": 15.3,
    "Prec": 1297,
    "Alt": 180,
    "L": 7,
    "F": 12,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Grimmia tergestina",
    "Concept": "Bry_1764",
    "Taxon_name": "Grimmia tergestina",
    "BRC_num": "0820  1764",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 85,
    "GBno": 6,
    "IRno": "",
    "CIno": "",
    "TJan": 4.1,
    "TJul": 14.3,
    "Prec": 1574,
    "Alt": 230,
    "L": 8,
    "F": 1,
    "R": 7,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Heterocladium dimorphum",
    "Concept": "Bry_332",
    "Taxon_name": "Heterocladium dimorphum",
    "BRC_num": "0820   332",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 13,
    "Sp2": 15,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 6,
    "IRno": "",
    "CIno": "",
    "TJan": -1.3,
    "TJul": 10.5,
    "Prec": 1770,
    "Alt": 1150,
    "L": 6,
    "F": 5,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Jungermannia polaris",
    "Concept": "Bry_945",
    "Taxon_name": "Jungermannia polaris",
    "BRC_num": "0810   945",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 6,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 6,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 18,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 6,
    "IRno": "",
    "CIno": "",
    "TJan": -0.8,
    "TJul": 11,
    "Prec": 1497,
    "Alt": 950,
    "L": 6,
    "F": 8,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Leiocolea rutheana",
    "Concept": "Bry_795",
    "Taxon_name": "Leiocolea rutheana",
    "BRC_num": "0810   795",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 70,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 4,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 6,
    "IRno": 1,
    "CIno": "",
    "TJan": 3.3,
    "TJul": 15.4,
    "Prec": 786,
    "Alt": 380,
    "L": 7,
    "F": 9,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Mnium lycopodioides",
    "Concept": "Bry_384",
    "Taxon_name": "Mnium ambiguum",
    "BRC_num": "0820   384",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 70,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 22,
    "Sp2": 34,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 6,
    "IRno": "",
    "CIno": "",
    "TJan": -0.4,
    "TJul": 11.2,
    "Prec": 2198,
    "Alt": 1205,
    "L": 4,
    "F": 6,
    "R": 7,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Paraleucobryum longifolium",
    "Concept": "Bry_432",
    "Taxon_name": "Paraleucobryum longifolium",
    "BRC_num": "0820   432",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "R",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 27,
    "Sp2": 34,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 6,
    "IRno": "",
    "CIno": "",
    "TJan": -0.9,
    "TJul": 10.4,
    "Prec": 1689,
    "Alt": 1000,
    "L": 6,
    "F": 5,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Plagiobryum demissum",
    "Concept": "Bry_445",
    "Taxon_name": "Plagiobryum demissum",
    "BRC_num": "0820   445",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 25,
    "Sp2": 30,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 6,
    "IRno": "",
    "CIno": "",
    "TJan": 0,
    "TJul": 11.4,
    "Prec": 2216,
    "Alt": 1150,
    "L": 6,
    "F": 6,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ptychodium plicatum",
    "Concept": "Bry_513",
    "Taxon_name": "Ptychodium plicatum",
    "BRC_num": "0820   513",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 24,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 23,
    "GBno": 6,
    "IRno": "",
    "CIno": "",
    "TJan": -0.9,
    "TJul": 10.8,
    "Prec": 1690,
    "Alt": 1190,
    "L": 6,
    "F": 5,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Seligeria campylopoda",
    "Concept": "Bry_1780",
    "Taxon_name": "Seligeria campylopoda",
    "BRC_num": "0820  1780",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 1.5,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 54,
    "GBno": 6,
    "IRno": "",
    "CIno": "",
    "TJan": 3.6,
    "TJul": 15.7,
    "Prec": 1039,
    "Alt": 350,
    "L": 2,
    "F": 5,
    "R": 8,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum balticum",
    "Concept": "Bry_552",
    "Taxon_name": "Sphagnum balticum",
    "BRC_num": "0820   552",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 26,
    "Sp2": 28,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 6,
    "IRno": "",
    "CIno": "",
    "TJan": 1.7,
    "TJul": 13.4,
    "Prec": 1032,
    "Alt": 650,
    "L": 8,
    "F": 9,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Stegonia latifolia",
    "Concept": "Bry_585",
    "Taxon_name": "Stegonia latifolia",
    "BRC_num": "0820   585",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 2,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 34,
    "Sp2": 40,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 6,
    "IRno": "",
    "CIno": "",
    "TJan": -1.1,
    "TJul": 10.9,
    "Prec": 1246,
    "Alt": 550,
    "L": 7,
    "F": 5,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Acaulon triquetrum",
    "Concept": "Bry_2",
    "Taxon_name": "Acaulon triquetrum",
    "BRC_num": "0820     2",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 1.5,
    "Per": "A",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 30,
    "Sp2": 30,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 92,
    "GBno": 5,
    "IRno": "",
    "CIno": "",
    "TJan": 4.8,
    "TJul": 16.2,
    "Prec": 848,
    "Alt": 120,
    "L": 9,
    "F": 2,
    "R": 9,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Anastrophyllum saxicola",
    "Concept": "Bry_953",
    "Taxon_name": "Anastrophyllum saxicola",
    "BRC_num": "0810   953",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "We",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 5,
    "IRno": "",
    "CIno": "",
    "TJan": 0,
    "TJul": 11.4,
    "Prec": 1397,
    "Alt": 700,
    "L": 5,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Andreaea sinuosa",
    "Concept": "Bry_1069",
    "Taxon_name": "Andreaea sinuosa",
    "BRC_num": "0820  1069",
    "ML": "M",
    "Ord": "Andreaeales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 13,
    "Sp2": 19,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 11,
    "GBno": 5,
    "IRno": "",
    "CIno": "",
    "TJan": -0.8,
    "TJul": 10.5,
    "Prec": 1645,
    "Alt": 1200,
    "L": 6,
    "F": 5,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sciuro-hypnum starkei",
    "Concept": "Bry_83",
    "Taxon_name": "Brachythecium starkei",
    "BRC_num": "0820    83",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 85,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 15,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 5,
    "IRno": "",
    "CIno": "",
    "TJan": -0.5,
    "TJul": 10.8,
    "Prec": 1832,
    "Alt": 1050,
    "L": 6,
    "F": 7,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum gemmiparum",
    "Concept": "Bry_98",
    "Taxon_name": "Bryum gemmiparum",
    "BRC_num": "0820    98",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "X",
    "Gem": "",
    "Bul": "F",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 91,
    "GBno": 5,
    "IRno": 1,
    "CIno": "",
    "TJan": 3.5,
    "TJul": 14.5,
    "Prec": 1307,
    "Alt": 150,
    "L": 7,
    "F": 9,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "ZZZ - SYNONYMIZED",
    "Concept": "",
    "Taxon_name": "Bryum neodamense",
    "BRC_num": "0820   108",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 80,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 46,
    "GBno": 5,
    "IRno": 19,
    "CIno": "",
    "TJan": 4.4,
    "TJul": 14.7,
    "Prec": 1025,
    "Alt": 75,
    "L": 8,
    "F": 9,
    "R": 7,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "ZZZ - SYNONYMIZED",
    "Concept": "",
    "Taxon_name": "Bryum stirtonii",
    "BRC_num": "0820   669",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 5,
    "IRno": "",
    "CIno": "",
    "TJan": -0.5,
    "TJul": 11.2,
    "Prec": 1411,
    "Alt": 1170,
    "L": 6,
    "F": 6,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cephalozia ambigua",
    "Concept": "Bry_713",
    "Taxon_name": "Cephalozia ambigua",
    "BRC_num": "0810   713",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 7,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 12,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 5,
    "IRno": "",
    "CIno": "",
    "TJan": -1.9,
    "TJul": 10,
    "Prec": 1532,
    "Alt": 1200,
    "L": 4,
    "F": 7,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Brachythecium cirrosum",
    "Concept": "Bry_155",
    "Taxon_name": "Cirriphyllum cirrosum",
    "BRC_num": "0820   155",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 83,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 20,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 5,
    "IRno": "",
    "CIno": "",
    "TJan": 0.3,
    "TJul": 11.1,
    "Prec": 2499,
    "Alt": 1170,
    "L": 5,
    "F": 5,
    "R": 7,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cynodontium polycarpon",
    "Concept": "Bry_173",
    "Taxon_name": "Cynodontium polycarpon",
    "BRC_num": "0820   173",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 25,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 5,
    "IRno": "",
    "CIno": "",
    "TJan": 0.8,
    "TJul": 12.1,
    "Prec": 1705,
    "Alt": 880,
    "L": 5,
    "F": 5,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ephemerum cohaerens",
    "Concept": "Bry_236",
    "Taxon_name": "Ephemerum cohaerens",
    "BRC_num": "0820   236",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 1.5,
    "Per": "A",
    "LF1": "Tp",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 60,
    "Sp2": 70,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 73,
    "GBno": 5,
    "IRno": 6,
    "CIno": "",
    "TJan": 3.9,
    "TJul": 15.3,
    "Prec": 883,
    "Alt": 60,
    "L": 7,
    "F": 7,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Eurhynchiastrum pulchellum",
    "Concept": "Bry_250",
    "Taxon_name": "Eurhynchium pulchellum",
    "BRC_num": "0820   250",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "NI",
    "CI": "",
    "Elem": 26,
    "GBno": 5,
    "IRno": 1,
    "CIno": "",
    "TJan": 1.8,
    "TJul": 12.8,
    "Prec": 1571,
    "Alt": 800,
    "L": 6,
    "F": 4,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fissidens serrulatus",
    "Concept": "Bry_273",
    "Taxon_name": "Fissidens serrulatus",
    "BRC_num": "0820   273",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 75,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "U",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 91,
    "GBno": 5,
    "IRno": 2,
    "CIno": "",
    "TJan": 4.7,
    "TJul": 14.8,
    "Prec": 1480,
    "Alt": 130,
    "L": 1,
    "F": 8,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Gongylanthus ericetorum",
    "Concept": "Bry_770",
    "Taxon_name": "Gongylanthus ericetorum",
    "BRC_num": "0810   770",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 10,
    "Per": "AP",
    "LF1": "Sc",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "CI",
    "Elem": 91,
    "GBno": 5,
    "IRno": "",
    "CIno": 4,
    "TJan": 6.9,
    "TJul": 16.3,
    "Prec": 878,
    "Alt": 60,
    "L": 8,
    "F": 4,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 1,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hygrohypnum molle",
    "Concept": "Bry_341",
    "Taxon_name": "Hygrohypnum molle",
    "BRC_num": "0820   341",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 42,
    "GBno": 5,
    "IRno": "",
    "CIno": "",
    "TJan": -1.2,
    "TJul": 10.3,
    "Prec": 1954,
    "Alt": 1260,
    "L": 5,
    "F": 10,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Marsupella profunda",
    "Concept": "Bry_985",
    "Taxon_name": "Marsupella profunda",
    "BRC_num": "0810   985",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 8,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 1,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 81,
    "GBno": 5,
    "IRno": "",
    "CIno": "",
    "TJan": 6.2,
    "TJul": 15.5,
    "Prec": 1191,
    "Alt": 280,
    "L": 7,
    "F": 7,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Orthotrichum pallens",
    "Concept": "Bry_420",
    "Taxon_name": "Orthotrichum pallens",
    "BRC_num": "0820   420",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 16,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 53,
    "GBno": 5,
    "IRno": 1,
    "CIno": "",
    "TJan": 2,
    "TJul": 13.4,
    "Prec": 1256,
    "Alt": 140,
    "L": 6,
    "F": 4,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Physcomitrium eurystomum",
    "Concept": "Bry_1010",
    "Taxon_name": "Physcomitrium eurystomum",
    "BRC_num": "0820  1010",
    "ML": "M",
    "Ord": "Funariales",
    "Stat": "N",
    "Len": 3,
    "Per": "A",
    "LF1": "Tf",
    "LF2": "Ts",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 30,
    "Sp2": 40,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 75,
    "GBno": 5,
    "IRno": "",
    "CIno": "",
    "TJan": 3.2,
    "TJul": 16,
    "Prec": 657,
    "Alt": 40,
    "L": 7,
    "F": 8,
    "R": 7,
    "N": 7,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pohlia wahlenbergii var. calcarea",
    "Concept": "Bry_465.2",
    "Taxon_name": "Pohlia wahlenbergii var. calcarea",
    "BRC_num": "0820   465.2",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 73,
    "GBno": 5,
    "IRno": 3,
    "CIno": "",
    "TJan": 3.4,
    "TJul": 14.2,
    "Prec": 1436,
    "Alt": 250,
    "L": 6,
    "F": 7,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Rhytidiadelphus subpinnatus",
    "Concept": "Bry_1044",
    "Taxon_name": "Rhytidiadelphus subpinnatus",
    "BRC_num": "0820  1044",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 120,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 20,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 5,
    "IRno": 1,
    "CIno": "",
    "TJan": 3.7,
    "TJul": 14.6,
    "Prec": 1610,
    "Alt": 120,
    "L": 5,
    "F": 6,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Riccia nigrella",
    "Concept": "Bry_913",
    "Taxon_name": "Riccia nigrella",
    "BRC_num": "0810   913",
    "ML": "L",
    "Ord": "Ricciales",
    "Stat": "N",
    "Len": 15,
    "Per": "PA",
    "LF1": "St",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 12,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 56,
    "Sp2": 80,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "CI",
    "Elem": 91,
    "GBno": 5,
    "IRno": "",
    "CIno": 5,
    "TJan": 5.5,
    "TJul": 15.8,
    "Prec": 1004,
    "Alt": 230,
    "L": 8,
    "F": 4,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Scapania praetervisa",
    "Concept": "Bry_974",
    "Taxon_name": "Scapania praetervisa",
    "BRC_num": "0810   974",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 8,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 5,
    "IRno": "",
    "CIno": "",
    "TJan": 0.8,
    "TJul": 12.4,
    "Prec": 1210,
    "Alt": 275,
    "L": 5,
    "F": 8,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Schistidium atrofuscum",
    "Concept": "Bry_293",
    "Taxon_name": "Schistidium atrofuscum",
    "BRC_num": "0820   293",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 11,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 5,
    "IRno": "",
    "CIno": "",
    "TJan": -0.8,
    "TJul": 11.1,
    "Prec": 1376,
    "Alt": 700,
    "L": 7,
    "F": 5,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "ZZZ - SYNONYMIZED",
    "Concept": "",
    "Taxon_name": "Schistidium elegantulum subsp. elegantulum",
    "BRC_num": "0820  1775.1",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "(IR)",
    "NI": "NI",
    "CI": "",
    "Elem": 75,
    "GBno": 5,
    "IRno": 1,
    "CIno": "",
    "TJan": 3,
    "TJul": 13.5,
    "Prec": 1701,
    "Alt": 175,
    "L": 7,
    "F": 2,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Schistidium frigidum var. havaasii",
    "Concept": "Bry_1777.2",
    "Taxon_name": "Schistidium frigidum var. havaasii",
    "BRC_num": "0820  1777.2",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 13,
    "E": "(E)",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 42,
    "GBno": 5,
    "IRno": "",
    "CIno": "",
    "TJan": 1.8,
    "TJul": 12.1,
    "Prec": 2132,
    "Alt": 1200,
    "L": 7,
    "F": 2,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum majus",
    "Concept": "Bry_1023",
    "Taxon_name": "Sphagnum majus",
    "BRC_num": "0820  1023",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 250,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 27,
    "Sp2": 38,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 5,
    "IRno": "",
    "CIno": "",
    "TJan": 1.4,
    "TJul": 12.1,
    "Prec": 1786,
    "Alt": 345,
    "L": 8,
    "F": 10,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tayloria lingulata",
    "Concept": "Bry_586",
    "Taxon_name": "Tayloria lingulata",
    "BRC_num": "0820   586",
    "ML": "M",
    "Ord": "Splachnales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 30,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 5,
    "IRno": "",
    "CIno": "",
    "TJan": -0.6,
    "TJul": 11.2,
    "Prec": 1514,
    "Alt": 940,
    "L": 8,
    "F": 9,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tortula cernua",
    "Concept": "Bry_177",
    "Taxon_name": "Tortula cernua",
    "BRC_num": "0820   177",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 7,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 36,
    "Sp2": 40,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 5,
    "IRno": "",
    "CIno": "",
    "TJan": 3.5,
    "TJul": 15.8,
    "Prec": 691,
    "Alt": 55,
    "L": 7,
    "F": 5,
    "R": 8,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tortula solmsii",
    "Concept": "Bry_1042",
    "Taxon_name": "Tortula solmsii",
    "BRC_num": "0820  1042",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 2.5,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 15,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 91,
    "GBno": 5,
    "IRno": "",
    "CIno": "",
    "TJan": 6.7,
    "TJul": 15.9,
    "Prec": 1020,
    "Alt": 85,
    "L": 6,
    "F": 5,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": 3,
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Andreaea frigida",
    "Concept": "Bry_1062",
    "Taxon_name": "Andreaea frigida",
    "BRC_num": "0820  1062",
    "ML": "M",
    "Ord": "Andreaeales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 25,
    "Sp2": 35,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 4,
    "IRno": "",
    "CIno": "",
    "TJan": -1.5,
    "TJul": 10.3,
    "Prec": 2006,
    "Alt": 1200,
    "L": 7,
    "F": 7,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Campylophyllum halleri",
    "Concept": "Bry_131",
    "Taxon_name": "Campylophyllum halleri",
    "BRC_num": "0820   131",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 13,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 4,
    "IRno": "",
    "CIno": "",
    "TJan": -0.9,
    "TJul": 10.8,
    "Prec": 1864,
    "Alt": 1030,
    "L": 7,
    "F": 5,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cinclidotus riparius",
    "Concept": "Bry_1772",
    "Taxon_name": "Cinclidotus riparius",
    "BRC_num": "0820  1772",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "NA",
    "Len": 50,
    "Per": "P",
    "LF1": "At",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 20,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "(IR)",
    "NI": "",
    "CI": "",
    "Elem": 74,
    "GBno": 4,
    "IRno": "",
    "CIno": "",
    "TJan": 3.4,
    "TJul": 15.7,
    "Prec": 752,
    "Alt": 80,
    "L": 7,
    "F": 8,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Homomallium incurvatum",
    "Concept": "Bry_334",
    "Taxon_name": "Homomallium incurvatum",
    "BRC_num": "0820   334",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 14,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 45,
    "GBno": 4,
    "IRno": 1,
    "CIno": "",
    "TJan": 2.1,
    "TJul": 13.6,
    "Prec": 1277,
    "Alt": 80,
    "L": 4,
    "F": 5,
    "R": 8,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": 2,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Liochlaena lanceolata",
    "Concept": "Bry_789",
    "Taxon_name": "Jungermannia leiantha",
    "BRC_num": "0810   789",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "R",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 4,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 15,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 4,
    "IRno": "",
    "CIno": "",
    "TJan": 2,
    "TJul": 13.5,
    "Prec": 1561,
    "Alt": 215,
    "L": 5,
    "F": 7,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Lophozia wenzelii",
    "Concept": "Bry_825",
    "Taxon_name": "Lophozia wenzelii",
    "BRC_num": "0810   825",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 10,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 4,
    "IRno": "",
    "CIno": "",
    "TJan": 0.6,
    "TJul": 11.4,
    "Prec": 2104,
    "Alt": 1100,
    "L": 5,
    "F": 7,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Marsupella boeckii",
    "Concept": "Bry_832",
    "Taxon_name": "Marsupella boeckii",
    "BRC_num": "0810   832",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 7,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 18,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 4,
    "IRno": "",
    "CIno": "",
    "TJan": -0.4,
    "TJul": 10.9,
    "Prec": 2049,
    "Alt": 1100,
    "L": 6,
    "F": 7,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Micromitrium tenerum",
    "Concept": "Bry_400",
    "Taxon_name": "Micromitrium tenerum",
    "BRC_num": "0820   400",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 1.5,
    "Per": "A",
    "LF1": "Tp",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 30,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 72,
    "GBno": 4,
    "IRno": "",
    "CIno": "",
    "TJan": 4.5,
    "TJul": 15.9,
    "Prec": 949,
    "Alt": 125,
    "L": 8,
    "F": 8,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Mielichhoferia elongata",
    "Concept": "Bry_378",
    "Taxon_name": "Mielichhoferia elongata",
    "BRC_num": "0820   378",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "NA",
    "Len": 15,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 17,
    "Sp2": 20,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 42,
    "GBno": 4,
    "IRno": "",
    "CIno": "",
    "TJan": 1.4,
    "TJul": 12.4,
    "Prec": 1246,
    "Alt": 820,
    "L": 4,
    "F": 7,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 5,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Odontoschisma macounii",
    "Concept": "Bry_862",
    "Taxon_name": "Odontoschisma macounii",
    "BRC_num": "0810   862",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "X",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 17,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 4,
    "IRno": "",
    "CIno": "",
    "TJan": 0.3,
    "TJul": 11.2,
    "Prec": 2461,
    "Alt": 1159,
    "L": 5,
    "F": 8,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 1,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pohlia obtusifolia",
    "Concept": "Bry_469",
    "Taxon_name": "Pohlia obtusifolia",
    "BRC_num": "0820   469",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 30,
    "Sp2": 36,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 4,
    "IRno": "",
    "CIno": "",
    "TJan": -0.6,
    "TJul": 10.5,
    "Prec": 2174,
    "Alt": 1100,
    "L": 8,
    "F": 9,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Radula carringtonii",
    "Concept": "Bry_891",
    "Taxon_name": "Radula carringtonii",
    "BRC_num": "0810   891",
    "ML": "L",
    "Ord": "Radulales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 8,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 30,
    "Sp2": 40,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 80,
    "GBno": 4,
    "IRno": 12,
    "CIno": "",
    "TJan": 4.5,
    "TJul": 14,
    "Prec": 1555,
    "Alt": 360,
    "L": 3,
    "F": 6,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sematophyllum demissum",
    "Concept": "Bry_550",
    "Taxon_name": "Sematophyllum demissum",
    "BRC_num": "0820   550",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 10,
    "Spend": 10,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 18,
    "E": "",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 71,
    "GBno": 4,
    "IRno": 16,
    "CIno": "",
    "TJan": 4.4,
    "TJul": 14.2,
    "Prec": 1540,
    "Alt": 330,
    "L": 4,
    "F": 7,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Weissia levieri",
    "Concept": "Bry_1030",
    "Taxon_name": "Weissia levieri",
    "BRC_num": "0820  1030",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 22,
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 91,
    "GBno": 4,
    "IRno": "",
    "CIno": "",
    "TJan": 5.3,
    "TJul": 16.2,
    "Prec": 990,
    "Alt": 50,
    "L": 8,
    "F": 2,
    "R": 9,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Zygodon forsteri",
    "Concept": "Bry_651",
    "Taxon_name": "Zygodon forsteri",
    "BRC_num": "0820   651",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 10,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 82,
    "GBno": 4,
    "IRno": "",
    "CIno": "",
    "TJan": 3.9,
    "TJul": 16.7,
    "Prec": 684,
    "Alt": 50,
    "L": 5,
    "F": 5,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Bartramia stricta",
    "Concept": "Bry_67",
    "Taxon_name": "Bartramia stricta",
    "BRC_num": "0820    67",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 26,
    "Sp2": 32,
    "E": "(E)",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "CI",
    "Elem": 91,
    "GBno": 3,
    "IRno": "",
    "CIno": 2,
    "TJan": 3.8,
    "TJul": 14.9,
    "Prec": 1084,
    "Alt": 245,
    "L": 9,
    "F": 3,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cephalozia macrostachya var. spiniflora",
    "Concept": "Bry_720.2",
    "Taxon_name": "Cephalozia macrostachya var. spiniflora",
    "BRC_num": "0810   720.2",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 35,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 42,
    "GBno": 3,
    "IRno": "",
    "CIno": "",
    "TJan": 2.9,
    "TJul": 13.6,
    "Prec": 968,
    "Alt": 300,
    "L": 7,
    "F": 8,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": 3,
    "GS": 2,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ctenidium procerrimum",
    "Concept": "Bry_167",
    "Taxon_name": "Ctenidium procerrimum",
    "BRC_num": "0820   167",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 140,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 3,
    "IRno": "",
    "CIno": "",
    "TJan": -1.2,
    "TJul": 10.6,
    "Prec": 1526,
    "Alt": 1068,
    "L": 6,
    "F": 6,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cyclodictyon laetevirens",
    "Concept": "Bry_168",
    "Taxon_name": "Cyclodictyon laetevirens",
    "BRC_num": "0820   168",
    "ML": "M",
    "Ord": "Hookeriales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 80,
    "GBno": 3,
    "IRno": 19,
    "CIno": "",
    "TJan": 4.8,
    "TJul": 14.2,
    "Prec": 1366,
    "Alt": 330,
    "L": 2,
    "F": 8,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": 2,
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ditrichum cornubicum",
    "Concept": "Bry_677",
    "Taxon_name": "Ditrichum cornubicum",
    "BRC_num": "0820   677",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "NA",
    "Len": 5,
    "Per": "PA",
    "LF1": "Tuft",
    "LF2": "Ts",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 71,
    "GBno": 3,
    "IRno": "",
    "CIno": "",
    "TJan": 5.4,
    "TJul": 15.3,
    "Prec": 1353,
    "Alt": 260,
    "L": 7,
    "F": 5,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 5,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "ZZZ - DELETED",
    "Concept": "",
    "Taxon_name": "Ephemerum stellatum",
    "BRC_num": "0820   241",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 1.5,
    "Per": "A",
    "LF1": "Tp",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 40,
    "Sp2": 50,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 73,
    "GBno": 3,
    "IRno": 2,
    "CIno": "",
    "TJan": 5,
    "TJul": 16,
    "Prec": 1005,
    "Alt": 5,
    "L": 7,
    "F": 6,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Plasteurhynchium meridionale",
    "Concept": "Bry_247",
    "Taxon_name": "Eurhynchium meridionale",
    "BRC_num": "0820   247",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "NA",
    "Len": 30,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 18,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 91,
    "GBno": 3,
    "IRno": "",
    "CIno": "",
    "TJan": 5.1,
    "TJul": 16.2,
    "Prec": 822,
    "Alt": 160,
    "L": 7,
    "F": 4,
    "R": 9,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Gymnocolea acutiloba",
    "Concept": "Bry_771",
    "Taxon_name": "Gymnocolea acutiloba",
    "BRC_num": "0810   771",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 3,
    "IRno": "",
    "CIno": "",
    "TJan": 1.2,
    "TJul": 12.2,
    "Prec": 1790,
    "Alt": 600,
    "L": 6,
    "F": 5,
    "R": 1,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Gymnomitrion apiculatum",
    "Concept": "Bry_773",
    "Taxon_name": "Gymnomitrion apiculatum",
    "BRC_num": "0810   773",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 6,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 10,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 3,
    "IRno": "",
    "CIno": "",
    "TJan": -1.1,
    "TJul": 10.5,
    "Prec": 1825,
    "Alt": 1340,
    "L": 7,
    "F": 4,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 2,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Marsupella sparsifolia",
    "Concept": "Bry_836",
    "Taxon_name": "Marsupella sparsifolia",
    "BRC_num": "0810   836",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 6,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 3,
    "IRno": "",
    "CIno": "",
    "TJan": -2,
    "TJul": 9.9,
    "Prec": 1386,
    "Alt": 1150,
    "L": 7,
    "F": 9,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Myurella tenerrima",
    "Concept": "Bry_398",
    "Taxon_name": "Myurella tenerrima",
    "BRC_num": "0820   398",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 10,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 3,
    "IRno": "",
    "CIno": "",
    "TJan": -0.1,
    "TJul": 11.5,
    "Prec": 1992,
    "Alt": 1180,
    "L": 6,
    "F": 4,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Orthotrichum pumilum",
    "Concept": "Bry_424",
    "Taxon_name": "Orthotrichum pumilum",
    "BRC_num": "0820   424",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "X",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 3,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 73,
    "GBno": 3,
    "IRno": "",
    "CIno": "",
    "TJan": 2.1,
    "TJul": 13.4,
    "Prec": 923,
    "Alt": 120,
    "L": 6,
    "F": 4,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Riccia bifurca",
    "Concept": "Bry_904",
    "Taxon_name": "Riccia bifurca",
    "BRC_num": "0810   904",
    "ML": "L",
    "Ord": "Ricciales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "St",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 9,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 70,
    "Sp2": 100,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 83,
    "GBno": 3,
    "IRno": "",
    "CIno": "",
    "TJan": 6.7,
    "TJul": 15.9,
    "Prec": 951,
    "Alt": 75,
    "L": 8,
    "F": 5,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Saelania glaucescens",
    "Concept": "Bry_536",
    "Taxon_name": "Saelania glaucescens",
    "BRC_num": "0820   536",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 35,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 16,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 3,
    "IRno": "",
    "CIno": "",
    "TJan": -1.4,
    "TJul": 10.5,
    "Prec": 1379,
    "Alt": 760,
    "L": 7,
    "F": 5,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Scapania parvifolia",
    "Concept": "Bry_934",
    "Taxon_name": "Scapania parvifolia",
    "BRC_num": "0810   934",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": 7,
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 17,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 3,
    "IRno": "",
    "CIno": "",
    "TJan": 0.2,
    "TJul": 11.5,
    "Prec": 2786,
    "Alt": 990,
    "L": 4,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Seligeria brevifolia",
    "Concept": "Bry_1040",
    "Taxon_name": "Seligeria brevifolia",
    "BRC_num": "0820  1040",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 1,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": 9,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 11,
    "Sp2": 13,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 44,
    "GBno": 3,
    "IRno": "",
    "CIno": "",
    "TJan": 1,
    "TJul": 12.3,
    "Prec": 1948,
    "Alt": 700,
    "L": 2,
    "F": 7,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Southbya nigrella",
    "Concept": "Bry_948",
    "Taxon_name": "Southbya nigrella",
    "BRC_num": "0810   948",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 4,
    "Spend": 4,
    "Spbeg2": 9,
    "Spend2": 11,
    "Sp1": 16,
    "Sp2": 24,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 91,
    "GBno": 3,
    "IRno": "",
    "CIno": "",
    "TJan": 5.2,
    "TJul": 16.3,
    "Prec": 798,
    "Alt": 120,
    "L": 6,
    "F": 6,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tortula amplexa",
    "Concept": "Bry_1026",
    "Taxon_name": "Syntrichia amplexa",
    "BRC_num": "0820  1026",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "AN",
    "Len": 6,
    "Per": "A",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 12,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 72,
    "GBno": 3,
    "IRno": "",
    "CIno": "",
    "TJan": 3.4,
    "TJul": 15.9,
    "Prec": 727,
    "Alt": 110,
    "L": 7,
    "F": 5,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Syntrichia norvegica",
    "Concept": "Bry_615",
    "Taxon_name": "Syntrichia norvegica",
    "BRC_num": "0820   615",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 35,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 3,
    "IRno": "",
    "CIno": "",
    "TJan": -1.2,
    "TJul": 10.5,
    "Prec": 1797,
    "Alt": 1050,
    "L": 8,
    "F": 4,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Telaranea murphyae",
    "Concept": "Bry_976",
    "Taxon_name": "Telaranea murphyae",
    "BRC_num": "0810   976",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "AN",
    "Len": 20,
    "Per": "P",
    "LF1": "We",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 71,
    "GBno": 3,
    "IRno": "",
    "CIno": "",
    "TJan": 6.8,
    "TJul": 16.4,
    "Prec": 880,
    "Alt": 22,
    "L": 4,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Timmia austriaca",
    "Concept": "Bry_600",
    "Taxon_name": "Timmia austriaca",
    "BRC_num": "0820   600",
    "ML": "M",
    "Ord": "Timmiales",
    "Stat": "N",
    "Len": 90,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 17,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 3,
    "IRno": 1,
    "CIno": "",
    "TJan": -0.3,
    "TJul": 11.2,
    "Prec": 1519,
    "Alt": 915,
    "L": 7,
    "F": 5,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Zygodon gracilis",
    "Concept": "Bry_652",
    "Taxon_name": "Zygodon gracilis",
    "BRC_num": "0820   652",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 70,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 14,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 73,
    "GBno": 3,
    "IRno": "",
    "CIno": "",
    "TJan": 1.3,
    "TJul": 13,
    "Prec": 1613,
    "Alt": 458,
    "L": 6,
    "F": 5,
    "R": 9,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Andreaea rupestris var. papillosa",
    "Concept": "Bry_1068.1",
    "Taxon_name": "Andreaea rupestris var. papillosa",
    "BRC_num": "0820  1068.1",
    "ML": "M",
    "Ord": "Andreaeales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "(E)",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": 2.5,
    "TJul": 12.9,
    "Prec": 2575,
    "Alt": 500,
    "L": 7,
    "F": 3,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Blindia caespiticia",
    "Concept": "Bry_70",
    "Taxon_name": "Blindia caespiticia",
    "BRC_num": "0820    70",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 13,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": -1,
    "TJul": 10.6,
    "Prec": 1963,
    "Alt": 1175,
    "L": 4,
    "F": 5,
    "R": 7,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "ZZZ - SYNONYMIZED",
    "Concept": "",
    "Taxon_name": "Bryum archangelicum",
    "BRC_num": "0820  1765",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 26,
    "Sp2": 30,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 2,
    "IRno": 2,
    "CIno": "",
    "TJan": 2.4,
    "TJul": 13.8,
    "Prec": 1043,
    "Alt": 700,
    "L": 6,
    "F": 6,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum schleicheri",
    "Concept": "Bry_118",
    "Taxon_name": "Bryum schleicheri",
    "BRC_num": "0820   118",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 87,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": 2.3,
    "TJul": 13.9,
    "Prec": 1417,
    "Alt": 230,
    "L": 7,
    "F": 9,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Calyptrochaeta apiculata",
    "Concept": "Bry_679",
    "Taxon_name": "Calyptrochaeta apiculata",
    "BRC_num": "0820   679",
    "ML": "M",
    "Ord": "Hookeriales",
    "Stat": "AN",
    "Len": 30,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "O",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 81,
    "GBno": 2,
    "IRno": 1,
    "CIno": "",
    "TJan": 5.4,
    "TJul": 15.5,
    "Prec": 1036,
    "Alt": 30,
    "L": 5,
    "F": 5,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cephaloziella dentata",
    "Concept": "Bry_725",
    "Taxon_name": "Cephaloziella dentata",
    "BRC_num": "0810   725",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 8,
    "Per": "P",
    "LF1": "Sc",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 82,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": 6.7,
    "TJul": 15.8,
    "Prec": 970,
    "Alt": 75,
    "L": 7,
    "F": 6,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Dialytrichia saxicola",
    "Concept": "Bry_3201",
    "Taxon_name": "Dialytrichia saxicola",
    "BRC_num": "0820  3201",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 8,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "F",
    "Sex": "",
    "Fr": "",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 91,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": "",
    "TJul": "",
    "Prec": "",
    "Alt": 40,
    "L": 5,
    "F": 4,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Ephemerum hibernicum",
    "Concept": "Bry_2501",
    "Taxon_name": "Ephemerum hibernicum",
    "BRC_num": "0820  2501",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 2.2,
    "Per": "A",
    "LF1": "Tp",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 61,
    "Sp2": 69,
    "E": "",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 70,
    "GBno": 2,
    "IRno": 1,
    "CIno": "",
    "TJan": 4.1,
    "TJul": 15.3,
    "Prec": 1170,
    "Alt": 140,
    "L": 7,
    "F": 7,
    "R": 6,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Frullania microphylla var. deciduifolia",
    "Concept": "Bry_767.2",
    "Taxon_name": "Frullania microphylla var. deciduifolia",
    "BRC_num": "0810   767.2",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "F",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 80,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": 2.5,
    "TJul": 13.9,
    "Prec": 1960,
    "Alt": 610,
    "L": 5,
    "F": 5,
    "R": 4,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Grimmia anodon",
    "Concept": "Bry_290",
    "Taxon_name": "Grimmia anodon",
    "BRC_num": "0820   290",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 10,
    "E": "E",
    "W": "",
    "Sc": "(S)",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 66,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": 3.1,
    "TJul": 14.5,
    "Prec": 1136,
    "Alt": 250,
    "L": 9,
    "F": 1,
    "R": 7,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Grimmia sessitana",
    "Concept": "Bry_288",
    "Taxon_name": "Grimmia sessitana",
    "BRC_num": "0820   288",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 10,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 13,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": 0.7,
    "TJul": 11.9,
    "Prec": 1010,
    "Alt": 410,
    "L": 8,
    "F": 1,
    "R": 5,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Grimmia unicolor",
    "Concept": "Bry_320",
    "Taxon_name": "Grimmia unicolor",
    "BRC_num": "0820   320",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": 1.3,
    "TJul": 11.9,
    "Prec": 1377,
    "Alt": 650,
    "L": 6,
    "F": 7,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hedwigia ciliata var. leucophaea",
    "Concept": "Bry_1769.2",
    "Taxon_name": "Hedwigia ciliata var. leucophaea",
    "BRC_num": "0820  1769.2",
    "ML": "M",
    "Ord": "Hedwigiales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 19,
    "Sp2": 28,
    "E": "E",
    "W": "",
    "Sc": "(S)",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 52,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": 3.5,
    "TJul": 15.5,
    "Prec": 920,
    "Alt": 80,
    "L": 8,
    "F": 1,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Herbertus delavayi",
    "Concept": "Bry_963",
    "Taxon_name": "Herbertus borealis",
    "BRC_num": "0810   963",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 41,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": 1.5,
    "TJul": 11.6,
    "Prec": 2599,
    "Alt": 550,
    "L": 7,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hypnum cupressiforme var. heseleri",
    "Concept": "Bry_351.9",
    "Taxon_name": "Hypnum cupressiforme var. heseleri",
    "BRC_num": "0820   351.9",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 18,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 71,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": 3.2,
    "TJul": 16,
    "Prec": 623,
    "Alt": 65,
    "L": 6,
    "F": 4,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Leiocolea rutheana var. rutheana",
    "Concept": "Bry_795.2",
    "Taxon_name": "Leiocolea rutheana var. rutheana",
    "BRC_num": "0810   795.2",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 4,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": 2.5,
    "TJul": 14.6,
    "Prec": 807,
    "Alt": 380,
    "L": 7,
    "F": 9,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Lejeunea eckloniana",
    "Concept": "Bry_800",
    "Taxon_name": "Lejeunea holtii",
    "BRC_num": "0810   800",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": 5,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 80,
    "GBno": 2,
    "IRno": 18,
    "CIno": "",
    "TJan": 4.8,
    "TJul": 14.4,
    "Prec": 1238,
    "Alt": 330,
    "L": 3,
    "F": 8,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": 1,
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Lophozia herzogiana",
    "Concept": "Bry_982",
    "Taxon_name": "Lophozia herzogiana",
    "BRC_num": "0810   982",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "NA",
    "Len": 10,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 14,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 72,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": 3.1,
    "TJul": 14.6,
    "Prec": 822,
    "Alt": 150,
    "L": 6,
    "F": 6,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": 3,
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Marsupella arctica",
    "Concept": "Bry_1351",
    "Taxon_name": "Marsupella arctica",
    "BRC_num": "0810  1351",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": -1.6,
    "TJul": 10.3,
    "Prec": 1355,
    "Alt": 1120,
    "L": 6,
    "F": 9,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Mielichhoferia mielichhoferiana",
    "Concept": "Bry_1006",
    "Taxon_name": "Mielichhoferia mielichhoferiana",
    "BRC_num": "0820  1006",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "NA",
    "Len": 15,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 15,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": -0.6,
    "TJul": 11,
    "Prec": 2184,
    "Alt": 830,
    "L": 4,
    "F": 6,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 5,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Mnium marginatum var. dioicum",
    "Concept": "Bry_390",
    "Taxon_name": "Mnium marginatum var. dioicum",
    "BRC_num": "0820   390",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "W",
    "Sc": "(S)",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 53,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": 2.7,
    "TJul": 14.2,
    "Prec": 1127,
    "Alt": 230,
    "L": 3,
    "F": 6,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Orthotrichum gymnostomum",
    "Concept": "Bry_1007",
    "Taxon_name": "Orthotrichum gymnostomum",
    "BRC_num": "0820  1007",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 21,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": 0.9,
    "TJul": 12.4,
    "Prec": 999,
    "Alt": 250,
    "L": 6,
    "F": 4,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Philonotis cernua",
    "Concept": "Bry_68",
    "Taxon_name": "Philonotis cernua",
    "BRC_num": "0820    68",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M(D)",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 28,
    "Sp2": 40,
    "E": "",
    "W": "(W)",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 70,
    "GBno": 2,
    "IRno": 3,
    "CIno": "",
    "TJan": 3,
    "TJul": 13,
    "Prec": 1985,
    "Alt": 530,
    "L": 7,
    "F": 7,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 2,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pterygoneurum lamellatum",
    "Concept": "Bry_509",
    "Taxon_name": "Pterygoneurum lamellatum",
    "BRC_num": "0820   509",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 2,
    "Per": "A",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 30,
    "E": "E",
    "W": "",
    "Sc": "(S)",
    "IR": "(IR)",
    "NI": "(NI)",
    "CI": "",
    "Elem": 86,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": 3.3,
    "TJul": 16.3,
    "Prec": 590,
    "Alt": 80,
    "L": 8,
    "F": 3,
    "R": 9,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Racomitrium himalayanum",
    "Concept": "Bry_1074",
    "Taxon_name": "Racomitrium himalayanum",
    "BRC_num": "0820  1074",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 16,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 41,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": -0.2,
    "TJul": 11.3,
    "Prec": 2316,
    "Alt": 1100,
    "L": 7,
    "F": 5,
    "R": 6,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Rhynchostegium rotundifolium",
    "Concept": "Bry_252",
    "Taxon_name": "Rhynchostegium rotundifolium",
    "BRC_num": "0820   252",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "NA",
    "Len": 40,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 16,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 73,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": 3.9,
    "TJul": 16.2,
    "Prec": 829,
    "Alt": 230,
    "L": 5,
    "F": 5,
    "R": 8,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Schistidium dupretii",
    "Concept": "Bry_1774",
    "Taxon_name": "Schistidium dupretii",
    "BRC_num": "0820  1774",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 11,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": -1,
    "TJul": 10.6,
    "Prec": 1963,
    "Alt": 1100,
    "L": 7,
    "F": 2,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "ZZZ - SYNONYMIZED",
    "Concept": "",
    "Taxon_name": "Schistidium elegantulum subsp. wilsonii",
    "BRC_num": "0820  1775.2",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 10,
    "E": "E",
    "W": "W",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 72,
    "GBno": 2,
    "IRno": 1,
    "CIno": "",
    "TJan": 4.4,
    "TJul": 15.8,
    "Prec": 985,
    "Alt": 170,
    "L": 7,
    "F": 2,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pseudocalliergon turgescens",
    "Concept": "Bry_542",
    "Taxon_name": "Scorpidium turgescens",
    "BRC_num": "0820   542",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 218,
    "Per": "P",
    "LF1": "We",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 18,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": 1.5,
    "TJul": 13.1,
    "Prec": 1437,
    "Alt": 990,
    "L": 7,
    "F": 9,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Seligeria diversifolia",
    "Concept": "Bry_1020",
    "Taxon_name": "Seligeria diversifolia",
    "BRC_num": "0820  1020",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 2,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": 2,
    "TJul": 13.4,
    "Prec": 1534,
    "Alt": 400,
    "L": 3,
    "F": 5,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tayloria tenuis",
    "Concept": "Bry_587",
    "Taxon_name": "Tayloria tenuis",
    "BRC_num": "0820   587",
    "ML": "M",
    "Ord": "Splachnales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 12,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "(NI)",
    "CI": "",
    "Elem": 46,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": 1.8,
    "TJul": 12.4,
    "Prec": 1063,
    "Alt": 600,
    "L": 8,
    "F": 9,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Telaranea europaea",
    "Concept": "Bry_955",
    "Taxon_name": "Telaranea nematodes",
    "BRC_num": "0810   955",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "O",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 13,
    "Sp2": 18,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 80,
    "GBno": 2,
    "IRno": 18,
    "CIno": "",
    "TJan": 5,
    "TJul": 14.5,
    "Prec": 1363,
    "Alt": 180,
    "L": 3,
    "F": 7,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 2,
    "DV": 2,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tetrodontium repandum",
    "Concept": "Bry_588.2",
    "Taxon_name": "Tetrodontium repandum",
    "BRC_num": "0820   588.2",
    "ML": "M",
    "Ord": "Tetraphidales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Tp",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "",
    "Sex": "M",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 16,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 42,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": 2.9,
    "TJul": 14.9,
    "Prec": 919,
    "Alt": 300,
    "L": 2,
    "F": 7,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tortula leucostoma",
    "Concept": "Bry_179",
    "Taxon_name": "Tortula leucostoma",
    "BRC_num": "0820   179",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 3,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 26,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 2,
    "IRno": "",
    "CIno": "",
    "TJan": -1.2,
    "TJul": 10.7,
    "Prec": 1280,
    "Alt": 550,
    "L": 7,
    "F": 5,
    "R": 8,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Achrophyllum dentatum",
    "Concept": "Bry_2001",
    "Taxon_name": "Achrophyllum dentatum",
    "BRC_num": "0820  2001",
    "ML": "M",
    "Ord": "Hookeriales",
    "Stat": "AN",
    "Len": 35,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 18,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 70,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 6.8,
    "TJul": 16.2,
    "Prec": 1110,
    "Alt": 50,
    "L": 2,
    "F": 8,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Adelanthus lindenbergianus",
    "Concept": "Bry_682",
    "Taxon_name": "Adelanthus lindenbergianus",
    "BRC_num": "0810   682",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "X",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 13,
    "Sp2": 16,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 41,
    "GBno": 1,
    "IRno": 6,
    "CIno": "",
    "TJan": 3.8,
    "TJul": 13.4,
    "Prec": 1576,
    "Alt": 800,
    "L": 6,
    "F": 6,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 1,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Anomodon attenuatus",
    "Concept": "Bry_31",
    "Taxon_name": "Anomodon attenuatus",
    "BRC_num": "0820    31",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 15,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 56,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 1.5,
    "TJul": 13.2,
    "Prec": 968,
    "Alt": 150,
    "L": 5,
    "F": 5,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Athalamia hyalina",
    "Concept": "Bry_1411",
    "Taxon_name": "Athalamia hyalina",
    "BRC_num": "0810  1411",
    "ML": "L",
    "Ord": "Marchantiales",
    "Stat": "N",
    "Len": 70,
    "Per": "P",
    "LF1": "Mt",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 5,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 45,
    "Sp2": 55,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": -0.8,
    "TJul": 11.1,
    "Prec": 1125,
    "Alt": 530,
    "L": 7,
    "F": 6,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Brachythecium erythrorrhizon",
    "Concept": "Bry_73",
    "Taxon_name": "Brachythecium erythrorrhizon",
    "BRC_num": "0820    73",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 20,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 3.6,
    "TJul": 12.4,
    "Prec": 993,
    "Alt": 10,
    "L": 8,
    "F": 4,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Brachytheciastrum trachypodium",
    "Concept": "Bry_1356",
    "Taxon_name": "Brachythecium trachypodium",
    "BRC_num": "0820  1356",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 1.2,
    "TJul": 12,
    "Prec": 2360,
    "Alt": 1090,
    "L": 6,
    "F": 6,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bruchia vogesiaca",
    "Concept": "Bry_4001",
    "Taxon_name": "Bruchia vogesiaca",
    "BRC_num": "0820  4001",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": "",
    "Per": "",
    "LF1": "",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 72,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": "",
    "TJul": "",
    "Prec": "",
    "Alt": 205,
    "L": 7,
    "F": 7,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "ZZZ - SYNONYMIZED",
    "Concept": "",
    "Taxon_name": "Bryum mamillatum",
    "BRC_num": "0820   103",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 5,
    "Per": "PA",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 36,
    "Sp2": 42,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 3.8,
    "TJul": 15.8,
    "Prec": 661,
    "Alt": 2,
    "L": 8,
    "F": 7,
    "R": 7,
    "N": 5,
    "S": 2,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum uliginosum",
    "Concept": "Bry_121",
    "Taxon_name": "Bryum uliginosum",
    "BRC_num": "0820   121",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 22,
    "Sp2": 30,
    "E": "(E)",
    "W": "(W)",
    "Sc": "S",
    "IR": "IR",
    "NI": "(NI)",
    "CI": "",
    "Elem": 46,
    "GBno": 1,
    "IRno": 3,
    "CIno": "",
    "TJan": 3.7,
    "TJul": 13.9,
    "Prec": 1236,
    "Alt": 150,
    "L": 7,
    "F": 7,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum valparaisense",
    "Concept": "Bry_1814",
    "Taxon_name": "Bryum valparaisense",
    "BRC_num": "0820  1814",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "AN",
    "Len": 2.8,
    "Per": "AP",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "F",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 80,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 7.4,
    "TJul": 15.7,
    "Prec": 1077,
    "Alt": 12,
    "L": 7,
    "F": 5,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Dicranum elongatum",
    "Concept": "Bry_198",
    "Taxon_name": "Dicranum elongatum",
    "BRC_num": "0820   198",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 23,
    "E": "(E)",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": -0.8,
    "TJul": 11.1,
    "Prec": 1125,
    "Alt": 1150,
    "L": 8,
    "F": 5,
    "R": 2,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Didymodon cordatus",
    "Concept": "Bry_46",
    "Taxon_name": "Didymodon cordatus",
    "BRC_num": "0820    46",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 83,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 5.9,
    "TJul": 16,
    "Prec": 1092,
    "Alt": 70,
    "L": 9,
    "F": 2,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Didymodon glaucus",
    "Concept": "Bry_50",
    "Taxon_name": "Didymodon glaucus",
    "BRC_num": "0820    50",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 3,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 73,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 3.3,
    "TJul": 15.9,
    "Prec": 767,
    "Alt": 185,
    "L": 3,
    "F": 5,
    "R": 9,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Fossombronia mittenii",
    "Concept": "Bry_756",
    "Taxon_name": "Fossombronia crozalsii",
    "BRC_num": "0810   756",
    "ML": "L",
    "Ord": "Fossombroniales",
    "Stat": "N",
    "Len": 8,
    "Per": "A",
    "LF1": "Sc",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 7,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 34,
    "Sp2": 41,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 91,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 3.3,
    "TJul": 15.9,
    "Prec": 793,
    "Alt": 150,
    "L": 6,
    "F": 7,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Grimmia alpestris",
    "Concept": "Bry_1412",
    "Taxon_name": "Grimmia alpestris",
    "BRC_num": "0820  1412",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 9,
    "Sp2": 12,
    "E": "",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 2.8,
    "TJul": 13.6,
    "Prec": 2097,
    "Alt": 850,
    "L": 8,
    "F": 1,
    "R": 5,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Grimmia crinita",
    "Concept": "Bry_296",
    "Taxon_name": "Grimmia crinita",
    "BRC_num": "0820   296",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Cu",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 12,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 92,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 5.7,
    "TJul": 15.4,
    "Prec": 1216,
    "Alt": 150,
    "L": 9,
    "F": 1,
    "R": 8,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": 3,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Grimmia elatior",
    "Concept": "Bry_299",
    "Taxon_name": "Grimmia elatior",
    "BRC_num": "0820   299",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 70,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "Tf",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 15,
    "E": "",
    "W": "",
    "Sc": "(S)",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 2.5,
    "TJul": 12.4,
    "Prec": 902,
    "Alt": 500,
    "L": 6,
    "F": 3,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hygrohypnum polare",
    "Concept": "Bry_1002",
    "Taxon_name": "Hygrohypnum polare",
    "BRC_num": "0820  1002",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 35,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 0.2,
    "TJul": 10.4,
    "Prec": 2045,
    "Alt": 670,
    "L": 7,
    "F": 9,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hygrohypnum styriacum",
    "Concept": "Bry_1357",
    "Taxon_name": "Hygrohypnum styriacum",
    "BRC_num": "0820  1357",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 17,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 13,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": -1.5,
    "TJul": 10.4,
    "Prec": 1465,
    "Alt": 1075,
    "L": 5,
    "F": 9,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hypnum revolutum",
    "Concept": "Bry_355",
    "Taxon_name": "Hypnum revolutum",
    "BRC_num": "0820   355",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 55,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 17,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 0.5,
    "TJul": 12,
    "Prec": 2027,
    "Alt": 1050,
    "L": 6,
    "F": 5,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hypnum vaucheri",
    "Concept": "Bry_1004",
    "Taxon_name": "Hypnum vaucheri",
    "BRC_num": "0820  1004",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 20,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": -0.2,
    "TJul": 11.4,
    "Prec": 2093,
    "Alt": 732,
    "L": 6,
    "F": 5,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Leiocolea rutheana var. laxa",
    "Concept": "Bry_795.1",
    "Taxon_name": "Leiocolea rutheana var. laxa",
    "BRC_num": "0810   795.1",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 60,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 4,
    "Spend": 4,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 23,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 3.1,
    "TJul": 15.8,
    "Prec": 687,
    "Alt": 65,
    "L": 7,
    "F": 9,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Lophocolea brookwoodiana",
    "Concept": "Bry_2901",
    "Taxon_name": "Lophocolea brookwoodiana",
    "BRC_num": "0810  2901",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "AN",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 71,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 3.8,
    "TJul": 16.6,
    "Prec": 672,
    "Alt": 45,
    "L": 6,
    "F": 5,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Lophozia longiflora",
    "Concept": "Bry_823",
    "Taxon_name": "Lophozia longiflora",
    "BRC_num": "0810   823",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 8,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": 7,
    "Spend": 7,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 10,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": -1.5,
    "TJul": 10.4,
    "Prec": 1465,
    "Alt": 320,
    "L": 3,
    "F": 7,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Nardia insecta",
    "Concept": "Bry_1762",
    "Taxon_name": "Nardia insecta",
    "BRC_num": "0810  1762",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 22,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 1.9,
    "TJul": 13.7,
    "Prec": 1107,
    "Alt": 300,
    "L": 5,
    "F": 7,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Philonotis marchica",
    "Concept": "Bry_1009",
    "Taxon_name": "Philonotis marchica",
    "BRC_num": "0820  1009",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 25,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 83,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 5,
    "TJul": 16.5,
    "Prec": 789,
    "Alt": 170,
    "L": 6,
    "F": 7,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Plagiochila norvegica",
    "Concept": "Bry_1771",
    "Taxon_name": "Plagiochila norvegica",
    "BRC_num": "0810  1771",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "Nil",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 52,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 4,
    "TJul": 15.7,
    "Prec": 968,
    "Alt": 200,
    "L": 3,
    "F": 5,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pohlia crudoides",
    "Concept": "Bry_1013",
    "Taxon_name": "Pohlia crudoides",
    "BRC_num": "0820  1013",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 35,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": -0.1,
    "TJul": 10.6,
    "Prec": 2831,
    "Alt": 900,
    "L": 5,
    "F": 6,
    "R": 5,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Pseudoleskeella nervosa",
    "Concept": "Bry_372",
    "Taxon_name": "Pseudoleskeella nervosa",
    "BRC_num": "0820   372",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "F",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 17,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": -1.5,
    "TJul": 10.4,
    "Prec": 1435,
    "Alt": 820,
    "L": 7,
    "F": 5,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 1,
    "AQ": ""
  },
  {
    "Name_new": "Schistidium flaccidum",
    "Concept": "Bry_1776",
    "Taxon_name": "Schistidium flaccidum",
    "BRC_num": "0820  1776",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 18,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 8,
    "Sp2": 10,
    "E": "",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 73,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 2.4,
    "TJul": 12.7,
    "Prec": 3130,
    "Alt": 580,
    "L": 7,
    "F": 2,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Schistidium flexipile",
    "Concept": "Bry_1815",
    "Taxon_name": "Schistidium flexipile",
    "BRC_num": "0820  1815",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 15,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": "",
    "TJul": "",
    "Prec": "",
    "Alt": 450,
    "L": 7,
    "F": 2,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Seligeria carniolica",
    "Concept": "Bry_629",
    "Taxon_name": "Seligeria carniolica",
    "BRC_num": "0820   629",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 3,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 27,
    "E": "E",
    "W": "",
    "Sc": "(S)",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 42,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 2.3,
    "TJul": 13.5,
    "Prec": 888,
    "Alt": 230,
    "L": 2,
    "F": 6,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Seligeria patula",
    "Concept": "Bry_1409",
    "Taxon_name": "Seligeria patula",
    "BRC_num": "0820  1409",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 4,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 22,
    "E": "",
    "W": "W",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 1,
    "IRno": 2,
    "CIno": "",
    "TJan": 2.8,
    "TJul": 13.7,
    "Prec": 1393,
    "Alt": 400,
    "L": 3,
    "F": 9,
    "R": 9,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum palustre var. centrale",
    "Concept": "Bry_566.1",
    "Taxon_name": "Sphagnum palustre var. centrale",
    "BRC_num": "0820   566.1",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 250,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 25,
    "Sp2": 30,
    "E": "(E)",
    "W": "W",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 56,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 3.3,
    "TJul": 16.3,
    "Prec": 562,
    "Alt": 300,
    "L": 7,
    "F": 8,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Telaranea tetradactyla",
    "Concept": "Bry_1350",
    "Taxon_name": "Telaranea longii",
    "BRC_num": "0810  1350",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "AN",
    "Len": 20,
    "Per": "P",
    "LF1": "We",
    "LF2": "Ms",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 71,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 3.8,
    "TJul": 16.7,
    "Prec": 679,
    "Alt": 40,
    "L": 4,
    "F": 7,
    "R": 3,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 2,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 3,
    "DV": "",
    "DA": "",
    "BR": 3,
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Thamnobryum angustifolium",
    "Concept": "Bry_593",
    "Taxon_name": "Thamnobryum angustifolium",
    "BRC_num": "0820   593",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 71,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 2.4,
    "TJul": 14.4,
    "Prec": 1136,
    "Alt": 244,
    "L": 3,
    "F": 8,
    "R": 9,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Thamnobryum cataractarum",
    "Concept": "Bry_1349",
    "Taxon_name": "Thamnobryum cataractarum",
    "BRC_num": "0820  1349",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "De",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "Nil",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 71,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 1.5,
    "TJul": 13.2,
    "Prec": 1702,
    "Alt": 210,
    "L": 3,
    "F": 11,
    "R": 7,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Thamnobryum maderense",
    "Concept": "Bry_3801",
    "Taxon_name": "Thamnobryum maderense",
    "BRC_num": "0820  3801",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "NA",
    "Len": 80,
    "Per": "P",
    "LF1": "De",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 15,
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 80,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 3,
    "TJul": 15.4,
    "Prec": 749,
    "Alt": 100,
    "L": 3,
    "F": 9,
    "R": 6,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Timmia megapolitana",
    "Concept": "Bry_1404",
    "Taxon_name": "Timmia megapolitana",
    "BRC_num": "0820  1404",
    "ML": "M",
    "Ord": "Timmiales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 76,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 3.7,
    "TJul": 16.2,
    "Prec": 603,
    "Alt": 0,
    "L": 5,
    "F": 9,
    "R": 7,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Weissia controversa var. wimmeriana",
    "Concept": "Bry_649",
    "Taxon_name": "Weissia controversa var. wimmeriana",
    "BRC_num": "0820   649",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 7,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 17,
    "Sp2": 20,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": -1.3,
    "TJul": 10.7,
    "Prec": 1304,
    "Alt": 530,
    "L": 6,
    "F": 5,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Zygodon conoideus var. lingulatus",
    "Concept": "Bry_650.2",
    "Taxon_name": "Zygodon conoideus var. lingulatus",
    "BRC_num": "0820   650.2",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "Nil",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "E",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 71,
    "GBno": 1,
    "IRno": "",
    "CIno": "",
    "TJan": 3.5,
    "TJul": 16.1,
    "Prec": 855,
    "Alt": 90,
    "L": 6,
    "F": 4,
    "R": 6,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Atrichum undulatum var. gracilisetum",
    "Concept": "Bry_40.1",
    "Taxon_name": "Atrichum undulatum var. gracilisetum",
    "BRC_num": "0820    40.1",
    "ML": "M",
    "Ord": "Polytrichales",
    "Stat": "N",
    "Len": 70,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "(E)",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 56,
    "GBno": "",
    "IRno": "",
    "CIno": "",
    "TJan": "",
    "TJul": "",
    "Prec": "",
    "Alt": 175,
    "L": 4,
    "F": 6,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "ZZZ - SYNONYMIZED",
    "Concept": "",
    "Taxon_name": "Bryum lawersianum",
    "BRC_num": "0820   102",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 5,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 26,
    "Sp2": 32,
    "E": "",
    "W": "",
    "Sc": "(S)",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 42,
    "GBno": "",
    "IRno": "",
    "CIno": "",
    "TJan": "",
    "TJul": "",
    "Prec": "",
    "Alt": 1070,
    "L": 6,
    "F": 6,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Bryum turbinatum",
    "Concept": "Bry_120",
    "Taxon_name": "Bryum turbinatum",
    "BRC_num": "0820   120",
    "ML": "M",
    "Ord": "Bryales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "(E)",
    "W": "(W)",
    "Sc": "(S)",
    "IR": "(IR)",
    "NI": "",
    "CI": "",
    "Elem": 45,
    "GBno": "",
    "IRno": "",
    "CIno": "",
    "TJan": "",
    "TJul": "",
    "Prec": "",
    "Alt": 210,
    "L": 8,
    "F": 7,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Cratoneuron curvicaule",
    "Concept": "Bry_163.1",
    "Taxon_name": "Callialaria curvicaulis",
    "BRC_num": "0820   163.1",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 100,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "(S)",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 15,
    "GBno": "",
    "IRno": "",
    "CIno": "",
    "TJan": "",
    "TJul": "",
    "Prec": "",
    "Alt": 1060,
    "L": 6,
    "F": 7,
    "R": 7,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Calomnion complanatum",
    "Concept": "Bry_2101",
    "Taxon_name": "Calomnion complanatum",
    "BRC_num": "0820  2101",
    "ML": "M",
    "Ord": "Rhizogoniales",
    "Stat": "AN",
    "Len": 10,
    "Per": "P",
    "LF1": "Tp",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 24,
    "E": "",
    "W": "",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 70,
    "GBno": "",
    "IRno": 1,
    "CIno": "",
    "TJan": 5,
    "TJul": 14.4,
    "Prec": 1403,
    "Alt": 20,
    "L": 4,
    "F": 8,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Cephalozia crassifolia",
    "Concept": "Bry_717",
    "Taxon_name": "Cephalozia hibernica",
    "BRC_num": "0810   717",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "F",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 80,
    "GBno": "",
    "IRno": 5,
    "CIno": "",
    "TJan": 4.5,
    "TJul": 14.1,
    "Prec": 1393,
    "Alt": 45,
    "L": 3,
    "F": 7,
    "R": 2,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": 3,
    "GS": "",
    "DW": 3,
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 2,
    "AQ": ""
  },
  {
    "Name_new": "Cynodontium fallax",
    "Concept": "Bry_170",
    "Taxon_name": "Cynodontium fallax",
    "BRC_num": "0820   170",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 40,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 23,
    "E": "",
    "W": "",
    "Sc": "(S)",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 45,
    "GBno": "",
    "IRno": "",
    "CIno": "",
    "TJan": "",
    "TJul": "",
    "Prec": "",
    "Alt": 500,
    "L": 5,
    "F": 5,
    "R": 3,
    "N": 1,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Didymodon maximus",
    "Concept": "Bry_55.2",
    "Taxon_name": "Didymodon maximus",
    "BRC_num": "0820    55.2",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "Nil",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 70,
    "GBno": "",
    "IRno": 5,
    "CIno": "",
    "TJan": 3.3,
    "TJul": 13.7,
    "Prec": 1344,
    "Alt": 490,
    "L": 6,
    "F": 8,
    "R": 9,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": 3,
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Encalypta brevicolla",
    "Concept": "Bry_1035",
    "Taxon_name": "Encalypta brevicollis",
    "BRC_num": "0820  1035",
    "ML": "M",
    "Ord": "Encalyptales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 30,
    "Sp2": 36,
    "E": "",
    "W": "",
    "Sc": "(S)",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": "",
    "IRno": "",
    "CIno": "",
    "TJan": "",
    "TJul": "",
    "Prec": "",
    "Alt": 170,
    "L": 4,
    "F": 5,
    "R": 7,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Ephemerum spinulosum",
    "Concept": "Bry_1406",
    "Taxon_name": "Ephemerum spinulosum",
    "BRC_num": "0820  1406",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 2.2,
    "Per": "A",
    "LF1": "Tp",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 70,
    "Sp2": 110,
    "E": "",
    "W": "",
    "Sc": "",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 71,
    "GBno": "",
    "IRno": 2,
    "CIno": "",
    "TJan": 3.9,
    "TJul": 14,
    "Prec": 1165,
    "Alt": 200,
    "L": 7,
    "F": 7,
    "R": 6,
    "N": 6,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Gyroweisia reflexa",
    "Concept": "Bry_324",
    "Taxon_name": "Gyroweisia reflexa",
    "BRC_num": "0820   324",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 2,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 14,
    "E": "(E)",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 91,
    "GBno": "",
    "IRno": "",
    "CIno": "",
    "TJan": "",
    "TJul": "",
    "Prec": "",
    "Alt": 100,
    "L": 1,
    "F": 5,
    "R": 7,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": 3,
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Helodium blandowii",
    "Concept": "Bry_330",
    "Taxon_name": "Helodium blandowii",
    "BRC_num": "0820   330",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 20,
    "E": "(E)",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": "",
    "IRno": "",
    "CIno": "",
    "TJan": "",
    "TJul": "",
    "Prec": "",
    "Alt": 400,
    "L": 7,
    "F": 8,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Heteroscyphus fissistipus",
    "Concept": "Bry_1901",
    "Taxon_name": "Heteroscyphus fissistipus",
    "BRC_num": "0810  1901",
    "ML": "L",
    "Ord": "Jungermanniales",
    "Stat": "AN",
    "Len": 40,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "F",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 70,
    "GBno": "",
    "IRno": 1,
    "CIno": "",
    "TJan": 5.3,
    "TJul": 14.7,
    "Prec": 1355,
    "Alt": 20,
    "L": 5,
    "F": 6,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hypnum revolutum var. dolomiticum",
    "Concept": "Bry_355.1",
    "Taxon_name": "Hypnum revolutum var. dolomiticum",
    "BRC_num": "0820   355.1",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 13,
    "Sp2": 17,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": "",
    "IRno": "",
    "CIno": "",
    "TJan": "",
    "TJul": "",
    "Prec": "",
    "Alt": 1000,
    "L": 6,
    "F": 5,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hypnum revolutum var. revolutum",
    "Concept": "Bry_355.2",
    "Taxon_name": "Hypnum revolutum var. revolutum",
    "BRC_num": "0820   355.2",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 80,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 15,
    "E": "",
    "W": "",
    "Sc": "S",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 16,
    "GBno": "",
    "IRno": "",
    "CIno": "",
    "TJan": "",
    "TJul": "",
    "Prec": "",
    "Alt": 1050,
    "L": 6,
    "F": 5,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Hypnum uncinulatum",
    "Concept": "Bry_1038",
    "Taxon_name": "Hypnum uncinulatum",
    "BRC_num": "0820  1038",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Mr",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "O",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 12,
    "Sp2": 18,
    "E": "",
    "W": "",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 80,
    "GBno": "",
    "IRno": 1,
    "CIno": "",
    "TJan": 4.8,
    "TJul": 14.4,
    "Prec": 1278,
    "Alt": 100,
    "L": 3,
    "F": 5,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Lejeunea flava",
    "Concept": "Bry_799",
    "Taxon_name": "Lejeunea flava",
    "BRC_num": "0810   799",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "R",
    "Spbeg": "",
    "Spend": 8,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 80,
    "GBno": "",
    "IRno": 17,
    "CIno": "",
    "TJan": 4.7,
    "TJul": 14.3,
    "Prec": 1355,
    "Alt": 300,
    "L": 4,
    "F": 6,
    "R": 3,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": 1,
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": 3,
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Lejeunea hibernica",
    "Concept": "Bry_798",
    "Taxon_name": "Lejeunea hibernica",
    "BRC_num": "0810   798",
    "ML": "L",
    "Ord": "Porellales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "MD",
    "Fr": "R",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 80,
    "GBno": "",
    "IRno": 10,
    "CIno": "",
    "TJan": 4.6,
    "TJul": 14.2,
    "Prec": 1387,
    "Alt": 370,
    "L": 4,
    "F": 6,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": 3,
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Leptotheca gaudichaudii",
    "Concept": "Bry_2201",
    "Taxon_name": "Leptotheca gaudichaudii",
    "BRC_num": "0820  2201",
    "ML": "M",
    "Ord": "Rhizogoniales",
    "Stat": "AN",
    "Len": 10,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 70,
    "GBno": "",
    "IRno": 1,
    "CIno": "",
    "TJan": 5,
    "TJul": 14.4,
    "Prec": 1403,
    "Alt": 20,
    "L": 4,
    "F": 8,
    "R": 5,
    "N": 5,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Lescuraea saxicola",
    "Concept": "Bry_371",
    "Taxon_name": "Lescuraea saxicola",
    "BRC_num": "0820   371",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 10,
    "Sp2": 15,
    "E": "",
    "W": "",
    "Sc": "(S)",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": "",
    "IRno": "",
    "CIno": "",
    "TJan": "",
    "TJul": "",
    "Prec": "",
    "Alt": 950,
    "L": 6,
    "F": 5,
    "R": 7,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Meesia triquetra",
    "Concept": "Bry_376",
    "Taxon_name": "Meesia triquetra",
    "BRC_num": "0820   376",
    "ML": "M",
    "Ord": "Splachnales",
    "Stat": "N",
    "Len": 50,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 33,
    "Sp2": 38,
    "E": "",
    "W": "",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": "",
    "IRno": 1,
    "CIno": "",
    "TJan": 3.9,
    "TJul": 13.6,
    "Prec": 1450,
    "Alt": 90,
    "L": 7,
    "F": 9,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Neckera pennata",
    "Concept": "Bry_403",
    "Taxon_name": "Neckera pennata",
    "BRC_num": "0820   403",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 83,
    "Per": "P",
    "LF1": "Fa",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "O",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 32,
    "E": "",
    "W": "",
    "Sc": "(S)",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": "",
    "IRno": "",
    "CIno": "",
    "TJan": "",
    "TJul": "",
    "Prec": "",
    "Alt": 100,
    "L": 5,
    "F": 5,
    "R": 4,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Orthotrichum consimile",
    "Concept": "Bry_1407",
    "Taxon_name": "Orthotrichum consimile",
    "BRC_num": "0820  1407",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 16,
    "Sp2": 22,
    "E": "(E)",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 71,
    "GBno": "",
    "IRno": "",
    "CIno": "",
    "TJan": "",
    "TJul": "",
    "Prec": "",
    "Alt": 40,
    "L": 6,
    "F": 5,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Orthotrichum shawii",
    "Concept": "Bry_1408",
    "Taxon_name": "Orthotrichum shawii",
    "BRC_num": "0820  1408",
    "ML": "M",
    "Ord": "Orthotrichales",
    "Stat": "N",
    "Len": 30,
    "Per": "P",
    "LF1": "Cu",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 14,
    "Sp2": 17,
    "E": "",
    "W": "",
    "Sc": "(S)",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 91,
    "GBno": "",
    "IRno": "",
    "CIno": "",
    "TJan": "",
    "TJul": "",
    "Prec": "",
    "Alt": 50,
    "L": 6,
    "F": 4,
    "R": 6,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": 3,
    "AQ": ""
  },
  {
    "Name_new": "Paludella squarrosa",
    "Concept": "Bry_431",
    "Taxon_name": "Paludella squarrosa",
    "BRC_num": "0820   431",
    "ML": "M",
    "Ord": "Splachnales",
    "Stat": "N",
    "Len": 150,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Sc",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 15,
    "Sp2": 20,
    "E": "(E)",
    "W": "",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": "",
    "IRno": 1,
    "CIno": "",
    "TJan": 4.1,
    "TJul": 13.9,
    "Prec": 1370,
    "Alt": 70,
    "L": 7,
    "F": 9,
    "R": 6,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Plagiothecium piliferum",
    "Concept": "Bry_452",
    "Taxon_name": "Plagiothecium piliferum",
    "BRC_num": "0820   452",
    "ML": "M",
    "Ord": "Hypnales",
    "Stat": "N",
    "Len": 25,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 13,
    "Sp2": 15,
    "E": "",
    "W": "",
    "Sc": "(S)",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 46,
    "GBno": "",
    "IRno": "",
    "CIno": "",
    "TJan": "",
    "TJul": "",
    "Prec": "",
    "Alt": 740,
    "L": 6,
    "F": 6,
    "R": 6,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Radula holtii",
    "Concept": "Bry_893",
    "Taxon_name": "Radula holtii",
    "BRC_num": "0810   893",
    "ML": "L",
    "Ord": "Radulales",
    "Stat": "N",
    "Len": 20,
    "Per": "P",
    "LF1": "Ms",
    "LF2": "",
    "Tub": "",
    "Gem": "R",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "F",
    "Spbeg": 5,
    "Spend": 9,
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 20,
    "Sp2": 25,
    "E": "",
    "W": "",
    "Sc": "",
    "IR": "IR",
    "NI": "",
    "CI": "",
    "Elem": 80,
    "GBno": "",
    "IRno": 13,
    "CIno": "",
    "TJan": 4.6,
    "TJul": 14.1,
    "Prec": 1399,
    "Alt": 330,
    "L": 2,
    "F": 8,
    "R": 5,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": 1,
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Seligeria oelandica",
    "Concept": "Bry_1021",
    "Taxon_name": "Seligeria oelandica",
    "BRC_num": "0820  1021",
    "ML": "M",
    "Ord": "Grimmiales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Ts",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 22,
    "Sp2": 30,
    "E": "",
    "W": "",
    "Sc": "",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 23,
    "GBno": "",
    "IRno": 4,
    "CIno": "",
    "TJan": 3.4,
    "TJul": 13.7,
    "Prec": 1348,
    "Alt": 305,
    "L": 3,
    "F": 9,
    "R": 9,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": 3,
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum obtusum",
    "Concept": "Bry_565",
    "Taxon_name": "Sphagnum obtusum",
    "BRC_num": "0820   565",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "D",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 23,
    "Sp2": 27,
    "E": "(E)",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 26,
    "GBno": "",
    "IRno": "",
    "CIno": "",
    "TJan": "",
    "TJul": "",
    "Prec": "",
    "Alt": 10,
    "L": 6,
    "F": 9,
    "R": 3,
    "N": 3,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Sphagnum subnitens var. ferrugineum",
    "Concept": "Bry_1041",
    "Taxon_name": "Sphagnum subnitens var. ferrugineum",
    "BRC_num": "0820  1041",
    "ML": "M",
    "Ord": "Sphagnales",
    "Stat": "N",
    "Len": 200,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "Tuft",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "X",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "",
    "IR": "IR",
    "NI": "NI",
    "CI": "",
    "Elem": 41,
    "GBno": "",
    "IRno": 7,
    "CIno": "",
    "TJan": 4,
    "TJul": 13.9,
    "Prec": 1329,
    "Alt": 200,
    "L": 7,
    "F": 8,
    "R": 3,
    "N": 2,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": 3,
    "GS": "",
    "DW": "",
    "DV": 3,
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Tortella limosella",
    "Concept": "Bry_1045",
    "Taxon_name": "Tortella limosella",
    "BRC_num": "0820  1045",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 8,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "Nil",
    "Fr": "Nil",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": "",
    "Sp2": "",
    "E": "",
    "W": "",
    "Sc": "(S)",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 51,
    "GBno": "",
    "IRno": "",
    "CIno": "",
    "TJan": "",
    "TJul": "",
    "Prec": "",
    "Alt": 5,
    "L": 9,
    "F": 5,
    "R": 7,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": "",
    "PT": "",
    "GS": 3,
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Trematodon ambiguus",
    "Concept": "Bry_623",
    "Taxon_name": "Trematodon ambiguus",
    "BRC_num": "0820   623",
    "ML": "M",
    "Ord": "Dicranales",
    "Stat": "N",
    "Len": 10,
    "Per": "P",
    "LF1": "Tuft",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 30,
    "Sp2": 36,
    "E": "",
    "W": "",
    "Sc": "(S)",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 43,
    "GBno": "",
    "IRno": "",
    "CIno": "",
    "TJan": "",
    "TJul": "",
    "Prec": "",
    "Alt": 350,
    "L": 7,
    "F": 7,
    "R": 4,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  },
  {
    "Name_new": "Weissia mittenii",
    "Concept": "Bry_1047",
    "Taxon_name": "Weissia mittenii",
    "BRC_num": "0820  1047",
    "ML": "M",
    "Ord": "Pottiales",
    "Stat": "N",
    "Len": 15,
    "Per": "P",
    "LF1": "Tf",
    "LF2": "",
    "Tub": "",
    "Gem": "",
    "Bul": "",
    "Bra": "",
    "Lvs": "",
    "Sex": "M",
    "Fr": "A",
    "Spbeg": "",
    "Spend": "",
    "Spbeg2": "",
    "Spend2": "",
    "Sp1": 18,
    "Sp2": 20,
    "E": "(E)",
    "W": "",
    "Sc": "",
    "IR": "",
    "NI": "",
    "CI": "",
    "Elem": 71,
    "GBno": "",
    "IRno": "",
    "CIno": "",
    "TJan": "",
    "TJul": "",
    "Prec": "",
    "Alt": 130,
    "L": 7,
    "F": 6,
    "R": 5,
    "N": 4,
    "S": 0,
    "HM": 0,
    "RH": "",
    "RS": "",
    "RW": "",
    "SR": "",
    "SO": 3,
    "PT": "",
    "GS": "",
    "DW": "",
    "DV": "",
    "DA": "",
    "BR": "",
    "EN": "",
    "EW": "",
    "AQ": ""
  }
]